import { r as registerInstance, h, H as Host, g as getElement, c as createEvent } from './index-5059254f.js';
import { G as Ge, V as Ve, Z as Ze, m as me, s as st, X as Xe, K as Ke, t as tt, w as we, z as ze, $ as $t, f as ft, d as dt, p as pt, g as gt, u as ut, J as Je, Y as Ye, Q as Qe } from './index.es-b80b758c.js';
import { i as initLocales } from './index-6b7bdd63.js';
import { t as tooltipPositions, c as classFieldset, a as classReadonly, b as classDisabled, d as classVerticalList, w as widths } from './mg-input.conf-712c7bb6.js';

/**
 * Available menu item status values
 */
const Status$1 = {
    VISIBLE: 'visible',
    HIDDEN: 'hidden',
    DISABLED: 'disabled',
    ACTIVE: 'active',
};
/**
 * List of all possibles target
 */
const targets = ['_blank', '_self', '_parent', '_top'];

/**
 * Menu direction values
 */
const directions$1 = {
    VERTICAL: 'vertical',
    HORIZONTAL: 'horizontal',
};
/**
 * List of all possibles sizes
 */
const sizes$4 = ['medium', 'large', 'xlarge'];

const mgActionMoreCss = ".mg-u-visually-hidden{position:absolute !important;overflow:hidden !important;width:.1rem !important;height:.1rem !important;padding:0 !important;border:0 !important;margin:-0.1rem !important;clip:rect(0.1rem, 0.1rem, 0.1rem, 0.1rem) !important;clip-path:inset(50%) !important;white-space:nowrap !important}*:focus:not(:focus-visible){outline:none}@media (prefers-reduced-motion){*{animation:none !important;transition:none !important}}:host{--mg-c-popover-padding-vertical:var(--mg-b-size-8);--mg-c-popover-padding-horizontal:0;--mg-c-popover-max-width:unset}.mg-c-action-more__divider{--mg-c-divider-spacing-vertical:var(--mg-b-size-4)}.mg-c-action-more__chevron{transition:200ms}.mg-c-action-more__chevron--rotate.mg-c-action-more__chevron{transform:rotate(180deg)}";
const MgActionMoreStyle0 = mgActionMoreCss;

/**
 * MgActionMore['items'] type guard
 * @param prop - commponent items prop
 * @returns return true if type is valid
 */
const isMgActionMoreItems = (prop) => {
    const items = prop;
    return (typeof items === 'object' &&
        items.every(item => (typeof item === 'object' && typeof item.label === 'string' && typeof item.mouseEventHandler === 'function') || isMgActionMoreDivider(item)));
};
/**
 * MgActionMoreDividerType type guard
 * @param item - component item
 * @returns return true if type is valid
 */
const isMgActionMoreDivider = (item) => typeof item === 'object' && item.isDivider;
/**
 * MgActionMore['button'] type guard
 * @param prop - commponent button prop
 * @returns return true if type is valid
 */
const isMgActionMoreButton = (prop) => {
    const button = prop;
    return typeof button === 'object' && typeof button.variant === 'string' && typeof button.isIcon === 'boolean';
};
/**
 * MgActionMore['icon'] type guard
 * @param prop - commponent icon prop
 * @returns return true if type is valid
 */
const isMgActionMoreIcon = (prop) => {
    const icon = prop;
    return typeof icon === 'object' && typeof icon.icon === 'string';
};
const MgActionMore = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        /************
         * Internal *
         ************/
        this.name = 'mg-action-more';
        this.classBase = 'mg-c-action-more';
        this.mgPopoverIdentifier = Ge(this.name);
        /**
         * Define button properties
         */
        this.button = { variant: 'flat', isIcon: true };
        /**
         * Menu expanded state
         */
        this.expanded = false;
        /************
         * Methods *
         ***********/
        /**
         * Toggle expanded props
         */
        this.toggleExpanded = () => {
            this.expanded = !this.expanded;
        };
        /**
         * Handle popover display change value
         * @param event - display change updated value
         */
        this.handleDisplayChange = (event) => {
            this.expanded = event.detail;
        };
        /**
         * Button click handler
         */
        this.handleButton = () => {
            this.toggleExpanded();
        };
        /**
         * Item click handler
         * @param event - click event
         * @param customHandler - item['mouseEventHandler']
         */
        this.handleItemClick = (event, customHandler) => {
            this.expanded = false;
            customHandler(event);
        };
    }
    validateItems(newValue) {
        if (!isMgActionMoreItems(newValue)) {
            throw new Error(`<${this.name}> prop "items" is required and all values must be the same type, MgActionMoreItemType or MgActionMoreDividerType. Passed value: ${Ve(newValue)}.`);
        }
        else if (isMgActionMoreItems(newValue) && newValue.length > 0 && (isMgActionMoreDivider(newValue[0]) || isMgActionMoreDivider(newValue[newValue.length - 1]))) {
            throw new Error(`<${this.name}> prop "items" can’t have a divider at the beginning or the end of the array. Passed value: ${Ve(newValue)}.`);
        }
    }
    validateIcon(newValue) {
        if (newValue && !isMgActionMoreIcon(newValue)) {
            throw new Error(`<${this.name}> prop "icon" must match MgActionMoreIconType. Passed value: ${Ve(newValue)}.`);
        }
        else if ((newValue === null || newValue === void 0 ? void 0 : newValue.icon) === undefined && Boolean(this.button.isIcon)) {
            this.icon = { icon: 'ellipsis' };
        }
    }
    validateButton(newValue) {
        if (newValue && !isMgActionMoreButton(newValue)) {
            throw new Error(`<${this.name}> prop "button" must match MgActionMoreButtonType. Passed value: ${Ve(newValue)}.`);
        }
    }
    validateDisplayChevron(newValue) {
        if (newValue && this.button.isIcon === true) {
            throw new Error(`<${this.name}> prop "displayChevron" can't be used with a 'button" prop "isIcon" attribute.`);
        }
    }
    /*************
     * Lifecycle *
     *************/
    /**
     * Validate props
     */
    componentWillLoad() {
        this.messages = initLocales(this.element).messages.actionMore;
        this.validateItems(this.items);
        this.validateButton(this.button);
        this.validateIcon(this.icon);
        this.validateDisplayChevron(this.displayChevron);
    }
    /**
     * Render
     * @returns HTML Element
     */
    render() {
        const buttonLabel = this.button.label || this.messages.label;
        const buttonContent = [buttonLabel];
        if (!this.button.isIcon && this.displayChevron) {
            buttonContent.push(h("span", { class: {
                    [`${this.classBase}__chevron`]: true,
                    [`${this.classBase}__chevron--rotate`]: this.expanded === true,
                } }, h("mg-icon", { icon: "chevron-down" })));
        }
        return (h(Host, { key: '2bb195242da00b4235d1c7e208d1f7ca72189a94', "data-mg-popover-guard": this.mgPopoverIdentifier }, h("span", { key: 'e9b1e0d8996886aef957f95e5c4276c584f80525', class: this.classBase }, h("mg-popover", { key: '8700af5584bb46e3b04b887b3d42d1660c0ef140', identifier: this.mgPopoverIdentifier, display: this.expanded, "onDisplay-change": this.handleDisplayChange }, h("mg-button", { key: '70442ce629cc40ea412ce3b6c93f8aab3abfa567', variant: this.button.variant, isIcon: this.button.isIcon, disabled: this.button.disabled, type: "button", label: buttonLabel, onClick: this.handleButton }, this.icon && h("mg-icon", Object.assign({ key: '85de555a598ac2097fb6586bbfab4ccda47721d1' }, this.icon)), !this.button.isIcon && buttonContent), h("div", { key: '3881ef2f2453a7f6bb8a16f56fd58899d4a44ab3', slot: "content" }, h("mg-menu", { key: 'ad3fb64141e696c4dfdf19743b035347ea212a39', direction: directions$1.VERTICAL, label: this.messages.label }, this.items.map(item => {
            var _a, _b;
            return isMgActionMoreDivider(item) ? (h("mg-divider", { class: "mg-c-action-more__divider", key: "divider" })) : (h("mg-menu-item", { key: item.label, status: item.status || Status$1.VISIBLE, target: item.target, href: item.href,
                // eslint-disable-next-line react/jsx-no-bind
                onClick: e => this.handleItemClick(e, item.mouseEventHandler) }, ((_a = item.icon) === null || _a === void 0 ? void 0 : _a.icon) && h("mg-icon", { icon: item.icon.icon, variant: item.icon.variant, variantStyle: item.icon.variantStyle, slot: "image" }), h("span", { slot: "label" }, item.label), ((_b = item.badge) === null || _b === void 0 ? void 0 : _b.label) && h("mg-badge", { label: item.badge.label, value: item.badge.value, slot: "information", variant: "text-color" })));
        })))))));
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "items": ["validateItems"],
        "icon": ["validateIcon"],
        "button": ["validateButton"],
        "displayChevron": ["validateDisplayChevron"]
    }; }
};
MgActionMore.style = MgActionMoreStyle0;

/**
 * List of all possibles variants
 */
const variants$4 = ['info', 'primary', 'secondary', 'success', 'warning', 'danger', 'text-color'];

const mgBadgeCss = ".mg-u-visually-hidden{position:absolute !important;overflow:hidden !important;width:.1rem !important;height:.1rem !important;padding:0 !important;border:0 !important;margin:-0.1rem !important;clip:rect(0.1rem, 0.1rem, 0.1rem, 0.1rem) !important;clip-path:inset(50%) !important;white-space:nowrap !important}*:focus:not(:focus-visible){outline:none}@media (prefers-reduced-motion){*{animation:none !important;transition:none !important}}/*!\n * @prop --mg-c-badge-size: Defines the height and minimum width of the badge. The default value is `--mg-b-size-16`.\n * @prop --mg-c-badge-font-size: Defines the font size of the badge. The default value is `--mg-b-font-size-small`.\n * @prop --mg-c-badge-color-text: Defines the font color of the badge when used with the `text-color` variant and without `outline`. The default value is `--mg-b-color-light`.\n */.mg-c-badge{min-width:var(--mg-c-badge-size);height:var(--mg-c-badge-size);box-sizing:border-box;padding:0 var(--mg-b-size-4);border:var(--mg-b-size-border) solid;border-radius:calc(var(--mg-c-badge-size)/2);font-size:var(--mg-c-badge-font-size);font-weight:600;line-height:var(--mg-c-badge-size);text-align:center}.mg-c-badge.mg-c-badge--primary{border-color:var(--mg-b-color-primary);background-color:var(--mg-b-color-primary);color:var(--mg-b-color-text-on-primary)}.mg-c-badge.mg-c-badge--primary.mg-c-badge--outline{background-color:rgba(0,0,0,0);color:var(--mg-b-color-primary)}.mg-c-badge.mg-c-badge--secondary{border-color:var(--mg-b-color-secondary);background-color:var(--mg-b-color-secondary);color:var(--mg-b-color-text-on-secondary)}.mg-c-badge.mg-c-badge--secondary.mg-c-badge--outline{background-color:rgba(0,0,0,0);color:var(--mg-b-color-secondary)}.mg-c-badge.mg-c-badge--danger{border-color:var(--mg-b-color-danger);background-color:var(--mg-b-color-danger);color:var(--mg-b-color-text-on-danger)}.mg-c-badge.mg-c-badge--danger.mg-c-badge--outline{background-color:rgba(0,0,0,0);color:var(--mg-b-color-danger)}.mg-c-badge.mg-c-badge--info{border-color:var(--mg-b-color-info);background-color:var(--mg-b-color-info);color:var(--mg-b-color-text-on-info)}.mg-c-badge.mg-c-badge--info.mg-c-badge--outline{background-color:rgba(0,0,0,0);color:var(--mg-b-color-info)}.mg-c-badge.mg-c-badge--success{border-color:var(--mg-b-color-success);background-color:var(--mg-b-color-success);color:var(--mg-b-color-text-on-success)}.mg-c-badge.mg-c-badge--success.mg-c-badge--outline{background-color:rgba(0,0,0,0);color:var(--mg-b-color-success)}.mg-c-badge.mg-c-badge--warning{border-color:var(--mg-b-color-warning);background-color:var(--mg-b-color-warning);color:var(--mg-b-color-text-on-warning)}.mg-c-badge.mg-c-badge--warning.mg-c-badge--outline{background-color:rgba(0,0,0,0);color:var(--mg-b-color-warning)}.mg-c-badge.mg-c-badge--text-color{border-color:currentcolor;background-color:currentcolor}.mg-c-badge.mg-c-badge--text-color .mg-c-badge__value{color:var(--mg-c-badge-color-text, var(--mg-b-color-light))}.mg-c-badge.mg-c-badge--text-color.mg-c-badge--outline{background-color:rgba(0,0,0,0)}.mg-c-badge.mg-c-badge--text-color.mg-c-badge--outline .mg-c-badge__value{color:currentcolor}.mg-c-badge,mg-badge{display:inline-flex;align-items:center;justify-content:center}";
const MgBadgeStyle0 = mgBadgeCss;

const MgBadge = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        /************
         * Internal *
         ************/
        // Classes
        this.classOutline = `mg-c-badge--outline`;
        /**
         * Define badge variant
         */
        this.variant = variants$4[0]; // info
        /**
         * Component classes
         */
        this.classCollection = new Ze(['mg-c-badge']);
    }
    validateValue(newValue) {
        if (/^[^A-Z]+$/i.exec(`${newValue}`) === null) {
            throw new Error(`<mg-badge> prop "value" is required and must be integer and/or special character. Passed value: ${Ve(newValue)}.`);
        }
    }
    validateLabel(newValue) {
        if (!me(newValue)) {
            throw new Error(`<mg-badge> prop "label" is required and must be a string. Passed value: ${Ve(newValue)}.`);
        }
    }
    validateVariant(newValue, oldValue) {
        if (!variants$4.includes(newValue)) {
            throw new Error(`<mg-badge> prop "variant" must be one of: ${variants$4.join(', ')}. Passed value: ${Ve(newValue)}.`);
        }
        else {
            if (oldValue !== undefined) {
                this.classCollection.delete(`mg-c-badge--${oldValue}`);
            }
            this.classCollection.add(`mg-c-badge--${newValue}`);
        }
    }
    validateOutline(newValue) {
        if (newValue)
            this.classCollection.add(this.classOutline);
        else
            this.classCollection.delete(this.classOutline);
    }
    /**
     * Check if props are well configured on init
     */
    componentWillLoad() {
        this.validateValue(this.value);
        this.validateLabel(this.label);
        this.validateVariant(this.variant);
        this.validateOutline(this.outline);
    }
    /**
     * Render
     * @returns HTML Element
     */
    render() {
        return (h("span", { key: 'db20118c3cfbc79ca65bcbbda1029857211615b2', class: this.classCollection.join() }, h("span", { key: '1898f1b56935c4acdab79f8c794025009f2d943c', class: "mg-c-badge__value" }, this.value), h("span", { key: '2ca8814b685441f11c8a1804c1e98d3e58f26d84', class: "mg-u-visually-hidden" }, this.label)));
    }
    static get watchers() { return {
        "value": ["validateValue"],
        "label": ["validateLabel"],
        "variant": ["validateVariant"],
        "outline": ["validateOutline"]
    }; }
};
MgBadge.style = MgBadgeStyle0;

/**
 * List of all possibles sizes
 */
const sizes$3 = ['medium', 'large'];
/**
 * List of all possibles variants
 */
const variants$3 = ['primary', 'secondary', 'danger', 'danger-alt', 'info', 'flat', 'success', 'link'];

const mgButtonCss = "/*!\n * @prop --mg-c-button-border-radius: Defines the border radius of the button. The default value is `--mg-b-size-radius`.\n * @prop --mg-c-button-border-top-width: Defines the top border width of the button. Unset by default, fallback on `--mg-b-size-border`.\n * @prop --mg-c-button-border-right-width: Defines the right border width of the button. Unset by default, fallback on `--mg-b-size-border`.\n * @prop --mg-c-button-border-bottom-width: Defines the bottom border width of the button. Unset by default, fallback on `--mg-b-size-border`.\n * @prop --mg-c-button-border-left-width: Defines the left border width of the button. Unset by default, fallback on `--mg-b-size-border`.\n * @prop --mg-c-button-border-radius-top-left: Defines the top left border radius of the button. Unset by default, fallback on `--mg-c-button-border-radius`.\n * @prop --mg-c-button-border-radius-top-right: Defines the top right border radius of the button. Unset by default, fallback on `--mg-c-button-border-radius`.\n * @prop --mg-c-button-border-radius-bottom-right: Defines the bottom right border radius of the button. Unset by default, fallback on `--mg-c-button-border-radius`.\n * @prop --mg-c-button-border-radius-bottom-left: Defines the bottom left border radius of the button. Unset by default, fallback on `--mg-c-button-border-radius`.\n * @prop --mg-c-button-font-weight: Defines the font weight of the button. Unset by default, fallback on `normal`.\n * @prop --mg-c-button-icon-border-radius: Defines the border radius of the button in icon mode. The default value is `--mg-b-size-min-height`.\n */:host{display:inline-block;max-width:100%;vertical-align:middle}:host(:hover) .mg-c-button--flat:not(.mg-c-button--disabled){background:color-mix(in srgb, var(--mg-b-color-dark), transparent 90%)}:host([full-width]){display:block}:host([disabled]),:host([aria-disabled=true]){pointer-events:none}.mg-c-button.mg-c-button--primary{/*!\n * @prop --mg-c-button-color-background-primary: Defines the background color for the primary variant button.\n * @prop --mg-c-button-color-border-primary: Defines the border color for the primary variant button.\n * @prop --mg-c-button-color-gradient-primary: Defines the gradient color for the primary variant button.\n * @prop --mg-c-button-color-text-primary: Defines the font color for the primary variant button.\n */border-color:var(--mg-c-button-color-border-primary);background:linear-gradient(to bottom, var(--mg-c-button-color-background-primary), var(--mg-c-button-color-gradient-primary));color:var(--mg-c-button-color-text-primary)}:host(:hover) .mg-c-button.mg-c-button--primary:not(.mg-c-button--disabled){background:var(--mg-c-button-color-background-primary)}.mg-c-button.mg-c-button--secondary{/*!\n * @prop --mg-c-button-color-background-secondary: Defines the background color for the secondary variant button.\n * @prop --mg-c-button-color-border-secondary: Defines the border color for the secondary variant button.\n * @prop --mg-c-button-color-gradient-secondary: Defines the gradient color for the secondary variant button.\n * @prop --mg-c-button-color-text-secondary: Defines the font color for the secondary variant button.\n */border-color:var(--mg-c-button-color-border-secondary);background:linear-gradient(to bottom, var(--mg-c-button-color-background-secondary), var(--mg-c-button-color-gradient-secondary));color:var(--mg-c-button-color-text-secondary)}:host(:hover) .mg-c-button.mg-c-button--secondary:not(.mg-c-button--disabled){background:var(--mg-c-button-color-background-secondary)}.mg-c-button.mg-c-button--danger{/*!\n * @prop --mg-c-button-color-background-danger: Defines the background color for the danger variant button.\n * @prop --mg-c-button-color-border-danger: Defines the border color for the danger variant button.\n * @prop --mg-c-button-color-gradient-danger: Defines the gradient color for the danger variant button.\n * @prop --mg-c-button-color-text-danger: Defines the font color for the danger variant button.\n */border-color:var(--mg-c-button-color-border-danger);background:linear-gradient(to bottom, var(--mg-c-button-color-background-danger), var(--mg-c-button-color-gradient-danger));color:var(--mg-c-button-color-text-danger)}:host(:hover) .mg-c-button.mg-c-button--danger:not(.mg-c-button--disabled){background:var(--mg-c-button-color-background-danger)}.mg-c-button.mg-c-button--info{/*!\n * @prop --mg-c-button-color-background-info: Defines the background color for the info variant button.\n * @prop --mg-c-button-color-border-info: Defines the border color for the info variant button.\n * @prop --mg-c-button-color-gradient-info: Defines the gradient color for the info variant button.\n * @prop --mg-c-button-color-text-info: Defines the font color for the info variant button.\n */border-color:var(--mg-c-button-color-border-info);background:linear-gradient(to bottom, var(--mg-c-button-color-background-info), var(--mg-c-button-color-gradient-info));color:var(--mg-c-button-color-text-info)}:host(:hover) .mg-c-button.mg-c-button--info:not(.mg-c-button--disabled){background:var(--mg-c-button-color-background-info)}.mg-c-button.mg-c-button--success{/*!\n * @prop --mg-c-button-color-background-success: Defines the background color for the success variant button.\n * @prop --mg-c-button-color-border-success: Defines the border color for the success variant button.\n * @prop --mg-c-button-color-gradient-success: Defines the gradient color for the success variant button.\n * @prop --mg-c-button-color-text-success: Defines the font color for the success variant button.\n */border-color:var(--mg-c-button-color-border-success);background:linear-gradient(to bottom, var(--mg-c-button-color-background-success), var(--mg-c-button-color-gradient-success));color:var(--mg-c-button-color-text-success)}:host(:hover) .mg-c-button.mg-c-button--success:not(.mg-c-button--disabled){background:var(--mg-c-button-color-background-success)}.mg-c-button.mg-c-button--warning{/*!\n * @prop --mg-c-button-color-background-warning: Defines the background color for the warning variant button.\n * @prop --mg-c-button-color-border-warning: Defines the border color for the warning variant button.\n * @prop --mg-c-button-color-gradient-warning: Defines the gradient color for the warning variant button.\n * @prop --mg-c-button-color-text-warning: Defines the font color for the warning variant button.\n */border-color:var(--mg-c-button-color-border-warning);background:linear-gradient(to bottom, var(--mg-c-button-color-background-warning), var(--mg-c-button-color-gradient-warning));color:var(--mg-c-button-color-text-warning)}:host(:hover) .mg-c-button.mg-c-button--warning:not(.mg-c-button--disabled){background:var(--mg-c-button-color-background-warning)}.mg-c-button.mg-c-button--danger-alt{/*!\n * @prop --mg-c-button-color-background-danger-alt: Defines the background color for the danger-alt variant button.\n * @prop --mg-c-button-color-border-danger-alt: Defines the border color for the danger-alt variant button.\n * @prop --mg-c-button-color-gradient-danger-alt: Defines the gradient color for the danger-alt variant button.\n * @prop --mg-c-button-color-text-danger-alt: Defines the font color for the danger-alt variant button.\n */border-color:var(--mg-c-button-color-border-danger-alt);background:linear-gradient(to bottom, var(--mg-c-button-color-background-danger-alt), var(--mg-c-button-color-gradient-danger-alt));color:var(--mg-c-button-color-text-danger-alt)}:host(:hover) .mg-c-button.mg-c-button--danger-alt:not(.mg-c-button--disabled){background:var(--mg-c-button-color-background-danger-alt)}.mg-c-button{position:relative;display:inline-flex;min-height:var(--mg-b-size-min-height);box-sizing:border-box;align-items:center;padding:calc((var(--mg-b-size-min-height) - 2*var(--mg-b-size-border) - var(--mg-b-font-size)*var(--mg-b-line-height))/2) var(--mg-b-size-12);border-width:var(--mg-c-button-border-top-width, var(--mg-b-size-border)) var(--mg-c-button-border-right-width, var(--mg-b-size-border)) var(--mg-c-button-border-bottom-width, var(--mg-b-size-border)) var(--mg-c-button-border-left-width, var(--mg-b-size-border));border-style:solid;border-radius:var(--mg-c-button-border-radius-top-left, var(--mg-c-button-border-radius)) var(--mg-c-button-border-radius-top-right, var(--mg-c-button-border-radius)) var(--mg-c-button-border-radius-bottom-right, var(--mg-c-button-border-radius)) var(--mg-c-button-border-radius-bottom-left, var(--mg-c-button-border-radius));background-image:none;column-gap:var(--mg-b-size-8);cursor:pointer;touch-action:manipulation;font-family:inherit;font-size:var(--mg-b-font-size);font-weight:var(--mg-c-button-font-weight, normal);text-align:left;text-decoration:none}.mg-c-button slot,.mg-c-button ::slotted(*:not(mg-icon)){font-family:inherit;font-size:var(--mg-b-font-size);font-weight:var(--mg-c-button-font-weight, normal);text-align:left;text-decoration:none;display:flex;align-items:center;column-gap:var(--mg-b-size-8)}.mg-c-button mg-icon:only-child,.mg-c-button ::slotted(mg-icon){display:inline-flex;flex-shrink:0;margin:auto 0;line-height:1}.mg-c-button.mg-c-button--disabled{cursor:default;opacity:var(--mg-b-opacity-element-disabled)}.mg-c-button.mg-c-button--flat{border:none;background:none}.mg-c-button.mg-c-button--link{min-height:unset;padding:unset;border:unset;border-radius:unset;background:unset;text-decoration:underline}.mg-c-button.mg-c-button--link slot{font-weight:600}.mg-c-button.mg-c-button--link:hover{text-decoration:none}.mg-c-button.mg-c-button--large{padding:calc(var(--mg-b-size-12) - var(--mg-b-size-border)) calc(var(--mg-b-size-24) - var(--mg-b-size-border))}.mg-c-button.mg-c-button--large:not(.mg-c-button--icon){line-height:var(--mg-b-size-24)}.mg-c-button.mg-c-button--large:not(.mg-c-button--icon) slot,.mg-c-button.mg-c-button--large:not(.mg-c-button--icon) ::slotted(*){font-size:var(--mg-b-size-16)}.mg-c-button.mg-c-button--icon{width:var(--mg-b-size-min-height);height:var(--mg-b-size-min-height);justify-content:center;padding:0;border-radius:var(--mg-c-button-border-radius-top-left, var(--mg-c-button-icon-border-radius)) var(--mg-c-button-border-radius-top-right, var(--mg-c-button-icon-border-radius)) var(--mg-c-button-border-radius-bottom-right, var(--mg-c-button-icon-border-radius)) var(--mg-c-button-border-radius-bottom-left, var(--mg-c-button-icon-border-radius));font-size:var(--mg-b-font-size);line-height:var(--mg-b-font-size)}.mg-c-button.mg-c-button--icon.mg-c-button--large{width:unset;height:unset;padding:calc(var(--mg-b-size-12) - var(--mg-b-size-border))}.mg-c-button.mg-c-button--icon.mg-c-button--large ::slotted(*){min-width:var(--mg-b-size-24);min-height:var(--mg-b-size-24);align-items:center;justify-content:center}.mg-c-button.mg-c-button--full-width{display:flex;justify-content:center}.mg-c-button.mg-c-button--loading>mg-icon:first-of-type{position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)}.mg-c-button.mg-c-button--loading .mg-c-button__content{opacity:0}:host(:focus-visible){outline:0}:host(:focus-visible) .mg-c-button{outline-color:-webkit-focus-ring-color;outline-style:auto;outline-width:.2rem}";
const MgButtonStyle0 = mgButtonCss;

const MgButton = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.disabledChange = createEvent(this, "disabled-change", 7);
        /************
         * Internal *
         ************/
        this.onClickElementFn = null;
        this.classDisabled = 'mg-c-button--disabled';
        this.classLoading = 'mg-c-button--loading';
        this.classFullWidth = 'mg-c-button--full-width';
        /**
         * Define button variant
         */
        this.variant = variants$3[0]; // Primary
        /**
         * Define button size
         */
        this.size = sizes$3[0]; // medium
        /**
         * Set button to full-width
         */
        this.fullWidth = false;
        /**
         * Define if button is round.
         * Used for icon button.
         */
        this.isIcon = false;
        /**
         * Option to set input disable on click, in order to prevent multi-click.
         * Parent component have to remove the attribute 'disabled' when the process ends.
         */
        this.disableOnClick = false;
        /**
         * Define if button is loading, default to false.
         * Trigger when button is clicked or key-up ['enter', 'space], then value change to true.
         * It's required to reset to false when action/promise in parent is done to stop the loading state
         */
        this.loading = false;
        /**
         * Component classes
         */
        this.classCollection = new Ze(['mg-c-button']);
        /**
         * Trigger actions onClick event
         * @param event - click event
         */
        this.handleClick = (event) => {
            if (this.disabled)
                event.stopPropagation();
            // Used to prevent multi-click.
            else if (this.disableOnClick) {
                this.loading = true;
                this.disabled = true;
            }
        };
        /**
         * Handle onKeydown event
         * @param event - keyboard event
         */
        this.handleKeydown = (event) => {
            if (!this.disabled && event.key === ' ') {
                event.preventDefault();
            }
            else if (!this.disabled && ['Enter', 'NumpadEnter', 'Space'].includes(event.key)) {
                event.preventDefault();
                this.element.dispatchEvent(new MouseEvent('click', { bubbles: true }));
            }
        };
        /**
         * Handle onKeyup event
         * @param event - keyboard event
         */
        this.handleKeyup = (event) => {
            if (!this.disabled && event.key === ' ') {
                event.preventDefault();
                this.element.dispatchEvent(new MouseEvent('click', { bubbles: true }));
            }
        };
        /**
         * Set child `<mg-icon>` element `size` prop to follow the current `size` prop
         */
        this.setIconSize = () => {
            var _a, _b;
            if (this.size === 'medium') {
                (_a = this.element.querySelector('mg-icon')) === null || _a === void 0 ? void 0 : _a.removeAttribute('size');
            }
            else if (this.isIcon) {
                (_b = this.element.querySelector('mg-icon')) === null || _b === void 0 ? void 0 : _b.setAttribute('size', this.size);
            }
        };
    }
    validateVariant(newValue, oldValue) {
        // validate new value
        if (!variants$3.includes(newValue)) {
            if (newValue === '') {
                // Reactive framework like VUE render with `""` when prop is update to undefined
                this.variant = variants$3[0];
                return;
            }
            throw new Error(`<mg-button> prop "variant" must be one of: ${variants$3.join(', ')}. Passed value: ${Ve(newValue)}.`);
        }
        else {
            if (oldValue !== undefined) {
                this.classCollection.delete(`mg-c-button--${oldValue}`);
            }
            this.classCollection.add(`mg-c-button--${newValue}`);
        }
    }
    validateSize(newValue, oldValue) {
        // validate new value
        if (!sizes$3.includes(newValue)) {
            throw new Error(`<mg-button> prop "size" must be one of: ${sizes$3.join(', ')}. Passed value: ${Ve(newValue)}.`);
        }
        else {
            if (oldValue !== undefined) {
                this.classCollection.delete(`mg-c-button--${oldValue}`);
            }
            this.classCollection.add(`mg-c-button--${newValue}`);
            this.setIconSize();
        }
    }
    validateFullWidth(newValue) {
        if (newValue && this.isIcon) {
            throw new Error('<mg-button> prop "fullWidth" cannot be used with prop "isIcon".');
        }
        else if (newValue) {
            this.classCollection.add(this.classFullWidth);
        }
        else {
            this.classCollection.delete(this.classFullWidth);
        }
    }
    disabledHandler(isDisabled) {
        // Remove loading when enable
        // Will be set back onclick
        if (!isDisabled && this.disableOnClick) {
            this.loading = false;
        }
        // Manage if onclick
        this.element.onclick = isDisabled ? undefined : this.onClickElementFn;
        // apply style
        if (isDisabled) {
            this.classCollection.add(this.classDisabled);
        }
        else {
            this.classCollection.delete(this.classDisabled);
        }
        // emit value update
        this.disabledChange.emit(isDisabled);
    }
    watchIsIcon() {
        this.setIconSize();
    }
    loadingHandler(newValue) {
        // we add loading style if it newvalue is true else we remove it
        if (newValue) {
            this.classCollection.add(this.classLoading);
        }
        else {
            this.classCollection.delete(this.classLoading);
        }
    }
    /**
     * Check if props are well configured on init
     */
    componentWillLoad() {
        this.validateVariant(this.variant);
        this.validateFullWidth(this.fullWidth);
        this.validateSize(this.size);
        this.watchIsIcon();
        if (this.isIcon) {
            this.classCollection.add(`mg-c-button--icon`);
            if (!me(this.label)) {
                throw new Error(`<mg-button> prop "label" is mandatory when prop "isIcon" is set to true.`);
            }
        }
        // Store the onclick fn
        this.onClickElementFn = this.element.onclick;
        this.disabledHandler(this.disabled);
    }
    /**
     * Add listners
     */
    componentDidLoad() {
        st(() => {
            var _a;
            const closestForm = this.element.closest('form') || ((_a = this.element.closest('mg-form')) === null || _a === void 0 ? void 0 : _a.shadowRoot.querySelector('form'));
            // submit buttons should trigger form submition;
            if (closestForm && ['submit', undefined].includes(this.type)) {
                this.element.addEventListener('click', () => {
                    closestForm.dispatchEvent(new SubmitEvent('submit', { bubbles: true, cancelable: true }));
                });
            }
        });
    }
    /**
     * Render component
     * @returns html element
     */
    render() {
        var _a;
        return (h(Host, { key: 'a56efb7c3e49a4aadf6751b10bacb39f20c260df', role: "button", tabIndex: 0, type: this.type, form: this.form, "full-width": this.fullWidth, "aria-label": this.label, "aria-disabled": (_a = this.disabled) === null || _a === void 0 ? void 0 : _a.toString(), onClick: this.handleClick, onKeyup: this.handleKeyup, onKeydown: this.handleKeydown }, h("div", { key: '2d47d068d188161b603b26117256d0e828393348', class: this.classCollection.join() }, this.loading && h("mg-icon", { key: 'ba84820c70834f1e345af506265222340659f8ec', icon: "loader", spin: true }), h("div", { key: 'db6c3437d5de7f828cca7df9d83670de9d3a8ed6', class: "mg-c-button__content" }, h("slot", { key: 'b00f76d92e1e2f9e4dd834bf41419c68c2635d1a' })))));
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "variant": ["validateVariant"],
        "size": ["validateSize"],
        "fullWidth": ["validateFullWidth"],
        "disabled": ["disabledHandler"],
        "isIcon": ["watchIsIcon"],
        "loading": ["loadingHandler"]
    }; }
};
MgButton.style = MgButtonStyle0;

const mgCardCss = "/*!\n * @prop --mg-c-card-overflow: Defines the overflow property for the card. Unset by default, fallback on `--mg-c-card-overflow-default`.\n * @prop --mg-c-card-overflow-default: Defines the default overflow property for the card. Unset by default.\n * @prop --mg-c-card-min-width: Defines the min-width property for the card. Unset by default.\n * @prop --mg-c-card-max-width: Defines the max-width property for the card. Unset by default.\n * @prop --mg-c-card-spacing: Defines the padding property for the card. Unset by default, fallback on `--mg-c-card-spacing-default`.\n * @prop --mg-c-card-spacing-default: Defines the default padding property for the card. Default value: `--mg-b-size-16`.\n * @prop --mg-c-card-border: Defines the border property for the card. Unset by default, fallback on `--mg-c-card-border-default`.\n * @prop --mg-c-card-border-default: Defines the default border property for the card. Default value: `var(--mg-b-size-border) solid color-mix(in srgb, var(--mg-b-color-dark), transparent 95%)`.\n * @prop --mg-c-card-border-radius: Defines the border radius property for the card. Unset by default, fallback on `--mg-c-card-border-radius-default`.\n * @prop --mg-c-card-border-radius-default: Defines the default border radius property for the card. Default value: `--mg-b-size-radius`.\n * @prop --mg-c-card-color-background: Defines the background property for the card. Unset by default, fallback on `--mg-c-card-color-background-default`.\n * @prop --mg-c-card-color-background-default: Defines the default background property for the card. Default value: `--mg-b-color-light`.\n * @prop --mg-c-card-box-shadow: Defines the box shadow property for the card. Unset by default, fallback on `--mg-c-card-box-shadow-default`.\n * @prop --mg-c-card-box-shadow-default: Defines the default box shadow property for the card. Default value: `--mg-b-box-shadow`.\n */.mg-c-card{position:relative;z-index:inherit;overflow:var(--mg-c-card-overflow, var(--mg-c-card-overflow-default));width:100%;min-width:var(--mg-c-card-min-width);max-width:var(--mg-c-card-max-width);box-sizing:border-box;padding:var(--mg-c-card-spacing, var(--mg-c-card-spacing-default));border:var(--mg-c-card-border, var(--mg-c-card-border-default));border-radius:var(--mg-c-card-border-radius, var(--mg-c-card-border-radius-default));background:var(--mg-c-card-color-background, var(--mg-c-card-color-background-default));box-shadow:var(--mg-c-card-box-shadow, var(--mg-c-card-box-shadow-default))}.mg-c-card ::slotted(*:not(mg-panel,mg-message,mg-modal)){--mg-c-card-border:var(--mg-c-card-border-default);--mg-c-card-spacing:var(--mg-c-card-spacing-default);--mg-c-card-border-radius:var(--mg-c-card-border-radius-default);--mg-c-card-color-background:var(--mg-c-card-color-background-default);--mg-c-card-box-shadow:var(--mg-c-card-box-shadow-default);--mg-c-card-max-width:unset;--mg-c-card-min-width:unset}";
const MgCardStyle0 = mgCardCss;

const MgCard = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
    }
    /*************
     * Lifecycle *
     *************/
    /**
     * Render
     * @returns HTML Element
     */
    render() {
        return (h("div", { key: 'e59cabb09dbc28c148770b57de98f130c4479b75', class: "mg-c-card" }, h("slot", { key: 'b6e679317bddd23e73443c601992b7b344d6dc72' })));
    }
};
MgCard.style = MgCardStyle0;

const mgCharacterLeftCss = ".mg-u-visually-hidden.sc-mg-character-left{position:absolute !important;overflow:hidden !important;width:.1rem !important;height:.1rem !important;padding:0 !important;border:0 !important;margin:-0.1rem !important;clip:rect(0.1rem, 0.1rem, 0.1rem, 0.1rem) !important;clip-path:inset(50%) !important;white-space:nowrap !important}*.sc-mg-character-left:focus:not(:focus-visible){outline:none}@media (prefers-reduced-motion){*.sc-mg-character-left{animation:none !important;transition:none !important}}mg-character-left.sc-mg-character-left{display:block}";
const MgCharacterLeftStyle0 = mgCharacterLeftCss;

const MgCharacterLeft = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        /**
         * Sets the characters to count
         */
        this.characters = '';
    }
    watchIdentifier(newValue) {
        if (newValue !== undefined && !Xe(newValue)) {
            console.error(`<mg-character-left> prop "identifier" value is invalid. Passed value: ${Ve(newValue)}.`);
        }
    }
    validateMaxlength(newValue) {
        if (typeof newValue !== 'number') {
            throw new Error(`<mg-character-left> prop "maxlength" is required and must be a number. Passed value: ${Ve(newValue)}.`);
        }
    }
    /*************
     * Lifecycle *
     *************/
    /**
     * Check if props are well configured on init
     */
    componentWillLoad() {
        this.watchIdentifier(this.identifier);
        this.validateMaxlength(this.maxlength);
        this.messages = initLocales(this.element).messages;
    }
    /**
     * Render component
     * @returns HTML Element
     */
    render() {
        return (h("span", { key: '38d0a5617735f7f451d8f07f7e4840ccc2539d6b', id: this.identifier, "aria-live": "polite" }, h("span", { key: '382dc20170c5285afdc0c73a76f5797703ffdf9a', "aria-hidden": "true" }, this.maxlength - this.characters.length, "/", this.maxlength), h("span", { key: '8f57b75c08c3da4353f194dc174dff4a3f7e06e4', class: "mg-u-visually-hidden" }, this.messages.nbCharLeft.replace('{counter}', this.maxlength - this.characters.length))));
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "identifier": ["watchIdentifier"],
        "maxlength": ["validateMaxlength"]
    }; }
};
MgCharacterLeft.style = MgCharacterLeftStyle0;

const mgDetailsCss = ".mg-u-visually-hidden{position:absolute !important;overflow:hidden !important;width:.1rem !important;height:.1rem !important;padding:0 !important;border:0 !important;margin:-0.1rem !important;clip:rect(0.1rem, 0.1rem, 0.1rem, 0.1rem) !important;clip-path:inset(50%) !important;white-space:nowrap !important}*:focus:not(:focus-visible){outline:none}@media (prefers-reduced-motion){*{animation:none !important;transition:none !important}}/*!\n * @prop --mg-c-details-spacing: Defines the spacing between the summary and the details. Default value: `--mg-b-size-8`.\n */.mg-c-details summary{display:flex;align-items:baseline;cursor:pointer;gap:var(--mg-b-size-16)}.mg-c-details summary::-webkit-details-marker{display:none}.mg-c-details__toggle{display:flex;min-height:calc(var(--mg-b-font-size)*var(--mg-b-line-height));flex-shrink:0;align-items:center;align-self:flex-start;gap:var(--mg-b-size-4)}.mg-c-details__toggle-icon.mg-c-details__toggle-icon--reverse{transform:rotate(180deg)}.mg-c-details__details{margin-top:var(--mg-c-details-spacing)}@media (width < 43.75rem){.mg-c-details__toggle>span{position:absolute !important;overflow:hidden !important;width:.1rem !important;height:.1rem !important;padding:0 !important;border:0 !important;margin:-0.1rem !important;clip:rect(0.1rem, 0.1rem, 0.1rem, 0.1rem) !important;clip-path:inset(50%) !important;white-space:nowrap !important}}";
const MgDetailsStyle0 = mgDetailsCss;

const MgDetails = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.expandedChange = createEvent(this, "expanded-change", 7);
        /**
         * Hide summary element
         */
        this.hideSummary = false;
        /**
         * Define if details are diplayed
         */
        this.expanded = false;
        /**
         * Handle details toggle
         */
        this.handleToggle = () => {
            this.expanded = this.details.open;
        };
    }
    validateTitles(newValue) {
        if (!me(newValue)) {
            throw new Error(`<mg-details> prop "toggleClosed" and "toggleOpened" is required and must be a valid string. Passed value: "toggleClosed='${this.toggleClosed}'" and "toggleOpened='${this.toggleOpened}'".`);
        }
    }
    handleExpanded(newValue) {
        this.expandedChange.emit(newValue);
    }
    /*************
     * Lifecycle *
     *************/
    /**
     * Check if component props are well configured on init
     */
    componentWillLoad() {
        this.validateTitles(this.toggleClosed);
        this.validateTitles(this.toggleOpened);
        this.element.addEventListener('click', (event) => {
            if (event.target.closest('[slot="summary"] mg-button, mg-button[slot="summary"]'))
                event.preventDefault();
        });
    }
    /**
     * Render
     * @returns HTML Element
     */
    render() {
        return (h("details", { key: '941fc56c10cd54a7975dc9b8adf5b7e24dfe89ce', class: "mg-c-details", onToggle: this.handleToggle, open: this.expanded, ref: (el) => (this.details = el) }, h("summary", { key: '8e0a1107069245a5920d28dced132ab73b25dcf1' }, h("slot", { key: '9530891ab1e8e60a1725aa146146bbd846bb7869', name: "summary" }), h("span", { key: '60163fa52f9c96bc15d60a016a2f17c3327f2b2f', class: "mg-c-details__toggle" }, h("mg-icon", { key: '69c033059e73b5ab336dfe5aeac122b78c65adbf', icon: "chevron-up", class: { 'mg-c-details__toggle-icon': true, 'mg-c-details__toggle-icon--reverse': !this.expanded } }), h("span", { key: '341d8915d9327cf811c21e4021446ff77b471029', class: { 'mg-u-visually-hidden': this.hideSummary } }, this.expanded ? this.toggleOpened : this.toggleClosed))), h("div", { key: '6681fe531a0076a8c016b55c6223492ac5613da4', class: "mg-c-details__details" }, h("slot", { key: 'a09d6f88af12ee0756c9f86d0adcbf01903461c5', name: "details" }))));
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "toggleClosed": ["validateTitles"],
        "toggleOpened": ["validateTitles"],
        "expanded": ["handleExpanded"]
    }; }
};
MgDetails.style = MgDetailsStyle0;

const mgDividerCss = "/*!\n * @prop --mg-c-divider-color-background: Defines the background color of the divider. The default value is `color-mix(in srgb, var(--mg-b-color-dark), transparent 85%)`.\n * @prop --mg-c-divider-thickness: Defines the thickness of the divider. The default value is `--mg-b-size-border`.\n * @prop --mg-c-divider-spacing-vertical: Defines the vertical spacing of the divider. The default value is `--mg-b-size-40`.\n */.mg-c-divider{width:var(--mg-b-size-120);height:var(--mg-c-divider-thickness);margin:var(--mg-c-divider-spacing-vertical) auto;background-color:var(--mg-c-divider-color-background)}.mg-c-divider.mg-c-divider--full-width{width:100%}";
const MgDividerStyle0 = mgDividerCss;

const MgDivider = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        /**************
         * Decorators *
         **************/
        /**
         * Define component size
         */
        this.fullWidth = false;
    }
    /**
     * Render
     * @returns HTML Element
     */
    render() {
        return (h("div", { key: '60b987cb329c6db14c2cc4a665e7f32b2696a3ee', class: {
                'mg-c-divider': true,
                'mg-c-divider--full-width': this.fullWidth,
            } }));
    }
};
MgDivider.style = MgDividerStyle0;

/**
 * List of all possibles roles
 */
const roles = ['form', 'search', 'none', 'presentation'];
/**
 * List of all possibles required message status
 */
const requiredMessageStatus = ['default', 'hide'];

const mgFormCss = ".mg-u-form-legacy{--mg-c-form-inputs-title-width:calc(100% / 3 - 20px)}.mg-u-is-asterisk{color:var(--mg-b-color-danger)}/*!\n * @prop --mg-c-form-inputs-title-width: Defines the width of the input title. Fallback on `calc(28 * var(--mg-b-size-8))`.\n */.mg-c-form{--mg-c-input-title-width:var(--mg-c-form-inputs-title-width, calc(28 * var(--mg-b-size-8)));--mg-c-input-margin-bottom:var(--mg-b-size-16);--mg-c-input-title-horizontal-space:var(--mg-b-size-32)}.mg-c-form.mg-c-form--all-required{--mg-c-input-title-display:none}.mg-c-form.mg-c-form--label-on-top{--mg-c-input-margin-bottom:var(--mg-b-size-24)}.mg-c-form>p{font-size:var(--mg-b-font-size-small)}";
const MgFormStyle0 = mgFormCss;

const MgForm = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.formValid = createEvent(this, "form-valid", 7);
        this.formSubmit = createEvent(this, "form-submit", 7);
        // Classes
        this.classAllRequired = 'mg-c-form--all-required';
        this.classLabelOnTop = 'mg-c-form--label-on-top';
        /**
         * Identifier is used for the element ID (id is a reserved prop in Stencil.js)
         * If not set, it will be created.
         */
        this.identifier = Ge('mg-form');
        /**
         * Input name
         * If not set the value equals the identifier
         */
        this.name = this.identifier;
        /**
         * Define if form is readonly
         */
        this.readonly = false;
        /**
         * Define if form is disabled
         */
        this.disabled = false;
        /**
         * Component classes
         */
        this.classCollection = new Ze(['mg-c-form']);
        /**
         * Define required message based on mg-inputs required elements
         */
        this.setRequiredMessage = () => {
            // init required message
            this.requiredMessageText = null;
            this.classCollection.delete(this.classAllRequired);
            if (this.requiredMessage === 'hide')
                return;
            else if (this.requiredMessage === 'default') {
                this.requiredMessageText = this.messages.form.required;
                return;
            }
            // If the form is disabled or readonly none of them are required
            // Check if all fields are not editable (readonly or disabled)
            const isEditable = input => !(input.disabled || input.readonly);
            const isMgInputToggle = input => input.nodeName === 'MG-INPUT-TOGGLE';
            if (!this.disabled && !this.readonly && this.mgInputs.some(input => isEditable(input) && !isMgInputToggle(input))) {
                // Get editable inputs
                const editableInputs = this.mgInputs.filter(isEditable);
                // Get required inputs
                // mg-input-toggle can not be required
                const requiredInputs = editableInputs.filter(input => !isMgInputToggle(input) && input.required);
                // All inputs are required
                if ([requiredInputs.length, editableInputs.length].every(length => length === 1) ||
                    (requiredInputs.length > 1 && requiredInputs.length === editableInputs.filter(input => !isMgInputToggle(input)).length)) {
                    this.requiredMessageText = this.getRequiredMessageBasedOnCount(requiredInputs, 'allRequiredSingle', 'allRequired');
                    this.classCollection.add(this.classAllRequired);
                }
                // Some fields are required
                else if (requiredInputs.length > 0) {
                    this.requiredMessageText = this.getRequiredMessageBasedOnCount(requiredInputs, 'requiredSingle', 'required');
                }
            }
        };
        /**
         * Returns a required message based on the count of required inputs.
         * @param requiredInputs - An array of required input elements.
         * @param keySingle - The key for the singular message format.
         * @param keyPlural - The key for the plural message format.
         * @returns The appropriate required message based on the count of required inputs.
         */
        this.getRequiredMessageBasedOnCount = (requiredInputs, keySingle, keyPlural) => this.messages.form[requiredInputs.length === 1 ? keySingle : keyPlural];
        /**
         * Check if form is valid
         */
        this.checkValidity = () => {
            // Update required on input event
            this.setRequiredMessage();
            this.valid = !this.mgInputs.some(input => input.invalid);
            this.invalid = !this.valid;
            // We need to send valid event if it is the same value
            this.formValid.emit(this.valid);
        };
        /**
         * Handle Form Submit
         * @param event - submit event
         */
        this.handleFormSubmit = (event) => {
            event.preventDefault();
            this.formSubmit.emit();
        };
        /**
         * Set mgInputs
         */
        this.setMgInputs = () => {
            // Get slotted mgInputs
            this.mgInputs = Array.from(this.element.querySelectorAll('*')).filter((node) => node.nodeName.startsWith('MG-INPUT'));
            // Set inputs readonly or disabled based on form configuration
            // Othewise listen to events
            this.mgInputs.forEach(input => {
                if (this.labelOnTop) {
                    input.labelOnTop = true;
                }
                if (this.readonly) {
                    input.readonly = true;
                }
                else if (this.disabled) {
                    input.disabled = true;
                }
                else {
                    input.addEventListener('input-valid', this.checkValidity);
                }
            });
        };
    }
    watchIdentifier(newValue) {
        if (!Xe(newValue)) {
            console.error(`<mg-form> prop "identifier" value is invalid. Passed value: ${Ve(newValue)}.`);
        }
    }
    validateRequiredMessage(newValue) {
        if (newValue && !requiredMessageStatus.includes(newValue)) {
            throw new Error(`<mg-form> prop "requiredMessage" must be one of: ${requiredMessageStatus.join(', ')}. Passed value: ${Ve(newValue)}.`);
        }
    }
    validateAriaRole(newValue) {
        if (newValue && !roles.includes(newValue)) {
            throw new Error(`<mg-form> prop "ariaRole" must be one of: ${roles.join(', ')}. Passed value: ${Ve(newValue)}.`);
        }
    }
    handlelabelOnTop(newValue) {
        if (newValue) {
            this.classCollection.add(this.classLabelOnTop);
        }
        else {
            this.classCollection.delete(this.classLabelOnTop);
        }
    }
    handleAttributeChange() {
        this.setMgInputs();
        this.setRequiredMessage();
    }
    /**
     * Display input error if it exists.
     */
    async displayError() {
        if (!this.readonly) {
            this.mgInputs.forEach(input => {
                var _a;
                (_a = input.displayError) === null || _a === void 0 ? void 0 : _a.call(input);
            });
            this.checkValidity();
        }
    }
    /**
     * Reset form inputs values, validity and error state
     */
    async reset() {
        if (!this.readonly) {
            await Promise.all(this.mgInputs.map(async (input) => {
                if (input.reset !== undefined) {
                    await input.reset();
                }
            }));
        }
    }
    /*************
     * Lifecycle *
     *************/
    /**
     * Check if component props are well configured on init
     */
    componentWillLoad() {
        // Get locales
        this.messages = initLocales(this.element).messages;
        this.watchIdentifier(this.identifier);
        this.validateAriaRole(this.ariaRole);
        this.validateRequiredMessage(this.requiredMessage);
        this.handlelabelOnTop(this.labelOnTop);
        // Get slotted mgButtons
        this.mgButtons = Array.from(this.element.querySelectorAll('mg-button'));
        // Set button form identifier
        this.mgButtons.forEach(mgButton => {
            mgButton.setAttribute('form', this.identifier);
        });
        // Set mgInputs
        this.setMgInputs();
        // Check validity when slotted mgInputs are ready
        Promise.all(this.mgInputs.map(async (input) => {
            try {
                await input.componentOnReady();
            }
            catch (_a) { } // prevent error with VueJS first render
        })).then(() => {
            // Define required message and check validity
            this.checkValidity();
        });
    }
    /**
     * Add slot listeners
     */
    componentDidLoad() {
        // Update mgInputs when mgForm content change
        const observerOptions = { childList: true, subtree: true };
        new MutationObserver(mutations => {
            if (mutations.some(mutation => Object.keys(observerOptions).includes(mutation.type))) {
                this.setMgInputs();
                this.checkValidity();
            }
        }).observe(this.element, observerOptions);
    }
    /**
     * Render
     * @returns HTML Element
     */
    render() {
        return (h("form", { key: 'a592ab555ddc0a5132fdf99b3de102d95ef8cc30', class: this.classCollection.join(), id: this.identifier, name: this.name, onSubmit: this.handleFormSubmit, role: this.ariaRole }, this.requiredMessageText && h("p", { key: 'c7a0b19f51394d16bb80de4e0995e22213a6dc17', innerHTML: this.requiredMessageText }), h("slot", { key: 'd6b6c2f15b3a0f1ca93c46506b892bf4bab8f095' }), !this.readonly && !this.disabled && h("slot", { key: 'b758ae4e77d9534b44673494b536134526596651', name: "actions" })));
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "identifier": ["watchIdentifier"],
        "requiredMessage": ["validateRequiredMessage", "handleAttributeChange"],
        "ariaRole": ["validateAriaRole"],
        "labelOnTop": ["handlelabelOnTop"],
        "readonly": ["handleAttributeChange"],
        "disabled": ["handleAttributeChange"]
    }; }
};
MgForm.style = MgFormStyle0;

/**
 * List of all possibles sizes
 */
const sizes$2 = ['small', 'medium', 'large', 'xlarge', 'xxlarge'];
/**
 * List of all possibles variants
 */
const variants$2 = ['success', 'warning', 'danger', 'info', 'app'];
/**
 * List of all possibles variants styles
 */
const variantStyles$1 = ['icon', 'background', 'full'];

const icons = { 'address-card': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M2 2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm11 3h-3v1h3zm-3 2h3v1h-3zM8 6a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-5 5.4A2.4 2.4 0 0 1 5.4 9h1.2A2.4 2.4 0 0 1 9 11.4a.6.6 0 0 1-.6.6H3.6a.6.6 0 0 1-.6-.6" clip-rule="evenodd"/></svg>', 'address-card-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M8 6.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-1 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0" clip-rule="evenodd"/><path fill="currentColor" d="M13 5h-3v1h3zm-3 2h3v1h-3z"/><path fill="currentColor" fill-rule="evenodd" d="M5.4 9A2.4 2.4 0 0 0 3 11.4a.6.6 0 0 0 .6.6h4.8a.6.6 0 0 0 .6-.6A2.4 2.4 0 0 0 6.6 9zm0 1a1.4 1.4 0 0 0-1.342 1h3.884A1.4 1.4 0 0 0 6.6 10z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M2 2a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm12 1H2v10h12z" clip-rule="evenodd"/></svg>', 'align-center': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M4 3h8v1H4zm-2 9h12v1H2zm12-6H2v1h12zM4 9h8v1H4z"/></svg>', 'align-justify': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M2 3h12v1H2zm0 9h12v1H2zm12-6H2v1h12zM2 9h12v1H2z"/></svg>', 'align-left': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M2 3h8v1H2zm0 9h12v1H2zm12-6H2v1h12zM2 9h8v1H2z"/></svg>', 'align-right': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M6 3h8v1H6zm-4 9h12v1H2zm12-6H2v1h12zM6 9h8v1H6z"/></svg>', 'api': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M14.44 11.47h-.02l-.66-.1-.02-.08c-.03-.11-.08-.21-.13-.31l-.04-.07.4-.54v-.02l-.52-.52h-.02l-.54.41-.07-.04c-.1-.05-.2-.09-.31-.13l-.08-.02-.1-.67v-.01h-.73v.02l-.1.66-.08.02c-.11.03-.21.08-.31.13l-.07.04-.55-.41-.52.52v.02l.41.54-.04.07c-.05.1-.09.2-.13.31l-.02.08-.67.1h-.01v.73h.02l.66.1.02.08c.03.1.08.21.13.3l.04.07-.41.55.52.52h.02l.54-.41.07.04c.1.05.2.09.31.13l.08.02.1.67v.01h.73v-.02l.1-.66.08-.02c.11-.03.21-.08.31-.13l.07-.04.55.41.52-.52v-.02l-.4-.54.04-.07c.05-.1.09-.2.13-.31l.02-.08.67-.1h.01v-.73zm-2.46 1.38c-.56 0-1.01-.45-1.01-1.01s.45-1.01 1.01-1.01 1.01.45 1.01 1.01-.45 1.01-1.01 1.01M8.51 5.81c-.11-.09-.27-.14-.5-.14h-.38v1.17h.27c.26 0 .45-.05.58-.15s.19-.25.19-.44-.05-.34-.16-.43zm1.57 5.13-.3-.4c-.1-.1-.09-.27 0-.37l.52-.52c.1-.1.26-.1.37 0l.4.29c.06-.03.13-.06.2-.08l.07-.49c0-.14.12-.25.26-.25h.45a5.44 5.44 0 1 0-10.5-1.99 5.44 5.44 0 0 0 5.44 5.44c.78 0 1.54-.17 2.25-.49v-.6c0-.14.11-.26.26-.26l.49-.07c.02-.07.05-.13.08-.2zm.18-5.96h.84v3.94h-.84zM5.4 8.92l-.29-.94H3.67l-.29.94h-.9l1.39-3.96h1.02l1.4 3.96h-.9zm3.72-1.74c-.26.23-.64.34-1.13.34h-.36v1.4h-.84V4.98h1.26c.48 0 .84.1 1.09.31s.37.51.37.92c0 .42-.13.75-.4.97zM4.4 5.57q-.09.345-.51 1.71h1.03q-.39-1.275-.45-1.44c-.03-.11-.06-.2-.07-.26z"/></svg>', 'archive': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M3 6v6.96c0 .57.46 1.04 1.04 1.04H12c.55 0 1-.45 1-1V6zm7 2H6V7h4zm3-3H3c-.55 0-1-.45-1-1V3c0-.55.45-1 1-1h10c.55 0 1 .45 1 1v1c0 .55-.45 1-1 1"/></svg>', 'archive-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M13 2H3c-.55 0-1 .45-1 1v2c0 .55.45 1 1 1v6.96c0 .57.46 1.04 1.04 1.04H12c.55 0 1-.45 1-1V6c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1m-1 11H4.04S4 12.98 4 12.96V6h8zm1-8H3V3h10zm-3 3H6V7h4z"/></svg>', 'arrow-clock': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="m3.025 3.82-.002-.001.083-.09.063-.066.009-.01q.132-.15.273-.292a4 4 0 0 1 .215-.196q.136-.124.279-.24.108-.086.22-.166l.024-.018q.143-.105.293-.203a7 7 0 0 1 1.198-.607l.029-.01q.126-.05.257-.094a6 6 0 0 1 .375-.108l.067-.019q.105-.029.21-.053c.146-.032.294-.054.442-.075l.092-.015q.072-.013.146-.022A6.47 6.47 0 0 1 13 3.847V1.996h1v4h-4v-1h2.594a5.48 5.48 0 0 0-5.189-2.467l-.124.019-.077.012q-.188.025-.373.064a3 3 0 0 0-.173.044l-.063.017a6 6 0 0 0-.317.09 6 6 0 0 0-.227.084l-.016.006a6 6 0 0 0-.523.232 5.4 5.4 0 0 0-.736.452l-.028.021q-.092.065-.18.135-.12.098-.235.204l-.05.044q-.068.06-.133.122-.117.117-.226.241l-.013.014A5.496 5.496 0 1 0 13.5 7.996h1A6.5 6.5 0 1 1 3.025 3.82"/><path fill="currentColor" d="M9.795 11.746 7 8.95V4.246h1v4.29l2.5 2.505z"/></svg>', 'arrow-down': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M13 10.1h-2.77c-.16 0-.3-.12-.32-.28V.94c0-.17-.14-.3-.31-.29H6.37A.325.325 0 0 0 6 .92v8.89c0 .16-.13.29-.29.29H3c-.17 0-.3.12-.31.29 0 .08.02.16.08.22l5.06 4.58c.13.11.33.11.46 0l5-4.58c.12-.11.12-.29.01-.41h-.01c-.07-.1-.17-.1-.29-.1"/></svg>', 'arrow-down-a-z': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="m6.53 10.9-1.41 1.41-.71.71-2.12-2.12.71-.71.88.88V3.02h1v8.12l.95-.95.71.71zM12.29 6H10.5l-.36 1H9.08l1.79-5h1.05l1.79 5h-1.06zm-.36-1.02-.53-1.49-.53 1.49zm1.79 5.18V9H9.09v1h3.29l-3.29 2.84V14h4.63v-1h-3.29z"/></svg>', 'arrow-down-right': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M12.999 12.292V3.999h1v10h-10v-1h8.292L2 2.707 2.707 2z"/></svg>', 'arrow-left': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M5.88 12.93v-2.75c-.01-.17.11-.31.28-.32H15c.17-.01.3-.16.29-.33V6.32A.31.31 0 0 0 15 6H6.17c-.16-.02-.29-.15-.29-.31V2.93a.295.295 0 0 0-.28-.32c-.09 0-.17.03-.23.09L.79 7.76c-.11.13-.11.33 0 .46l4.58 5c.12.12.31.12.43 0 .06-.08.09-.19.08-.29"/></svg>', 'arrow-right': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M10.12 2.99v2.75c.01.17-.11.31-.28.32H1c-.17.01-.3.16-.29.33V9.6c0 .17.12.31.29.32h8.83c.16.02.29.15.29.31v2.76c-.01.17.11.31.28.32.09 0 .17-.03.23-.09l4.58-5.06c.11-.13.11-.33 0-.46l-4.58-5a.3.3 0 0 0-.43 0c-.06.08-.09.19-.08.29"/></svg>', 'arrow-rotate': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="m3.025 3.82-.002-.001c.046-.055.098-.103.146-.156q.137-.155.282-.302c.069-.068.142-.13.215-.195q.136-.124.279-.241.12-.095.244-.184.143-.105.293-.203a7 7 0 0 1 1.198-.607q.142-.055.286-.104a6 6 0 0 1 .375-.108c.092-.025.184-.052.278-.072a6 6 0 0 1 .441-.075c.08-.012.157-.028.238-.037A6.47 6.47 0 0 1 13 3.847V1.996h1v4h-4v-1h2.594a5.48 5.48 0 0 0-5.188-2.467q-.102.014-.202.031-.188.025-.373.064c-.08.017-.157.04-.236.06a6 6 0 0 0-.317.092q-.122.042-.243.089a6 6 0 0 0-.523.232 5.4 5.4 0 0 0-.736.452q-.106.076-.208.156-.12.098-.235.204-.093.08-.183.166c-.083.081-.16.169-.239.255A5.496 5.496 0 1 0 13.5 7.996h1A6.5 6.5 0 1 1 3.025 3.82"/></svg>', 'arrow-rotate-backward': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="m12.975 3.82.002-.001c-.046-.055-.098-.103-.146-.156-.092-.103-.183-.205-.282-.302-.069-.068-.142-.13-.215-.195q-.135-.124-.279-.241-.12-.095-.244-.184a7 7 0 0 0-.293-.203 7 7 0 0 0-.859-.467 7 7 0 0 0-.339-.14q-.142-.055-.286-.104a6 6 0 0 0-.375-.108c-.092-.025-.184-.052-.278-.072a6 6 0 0 0-.441-.075c-.08-.012-.157-.028-.238-.037A6.47 6.47 0 0 0 3 3.847V1.996H2v4h4v-1H3.406a5.48 5.48 0 0 1 5.189-2.467q.101.014.2.031.19.025.374.064c.08.017.157.04.236.06q.16.042.317.092.122.042.243.089a6 6 0 0 1 .523.232 5.3 5.3 0 0 1 .736.452q.105.076.208.156.12.098.235.204.093.08.183.166c.083.081.16.169.239.255A5.496 5.496 0 1 1 2.5 7.996h-1A6.5 6.5 0 1 0 12.975 3.82"/></svg>', 'arrow-up': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M3.06 5.82h2.75c.16 0 .3.12.32.28V15c.01.17.16.3.33.29h3.21c.16.02.31-.1.33-.27V6.11c0-.17.14-.3.31-.29h2.75c.17 0 .31-.12.32-.28 0-.08-.03-.17-.09-.23L8.23.73a.36.36 0 0 0-.46 0l-5 4.58a.29.29 0 0 0 0 .42c.05.1.15.09.29.09"/></svg>', 'arrow-up-right': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M12.292 3H3.999V2h10v10h-1V3.707L2.707 14 2 13.29z"/></svg>', 'arrow-up-right-square': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M14.33 3v10c0 .73-.6 1.32-1.33 1.33H3c-.73 0-1.32-.6-1.33-1.33V3c0-.73.6-1.32 1.33-1.33h10c.73 0 1.32.6 1.33 1.33m-2.48.46H8.68c-.37 0-.67.29-.68.66v.04c0 .18.07.35.2.47l.91.91-5.53 5.53c-.13.13-.14.33-.01.47h.01l.87.88c.13.13.33.14.47.01h.01l5.53-5.53.91.9c.26.28.7.29.98.02l.02-.02c.12-.13.19-.3.19-.48V4.15c0-.37-.3-.67-.67-.67z"/></svg>', 'arrow-up-z-a': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="m5.82 5.85-.94-.94v8.11h-1V4.96l-.89.89-.71-.71 1.41-1.41.71-.71.71.71 1.41 1.41-.71.71zM12.29 13H10.5l-.36 1H9.08l1.79-5h1.05l1.79 5h-1.06zm-.36-1.02-.53-1.49-.53 1.49zm1.79-8.82V2H9.09v1h3.29L9.09 5.84V7h4.63V6h-3.29z"/></svg>', 'arrows-compare': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M11.705 8.295 9.915 6.5H15v-1H9.915l1.79-1.795L11 3 8 6l3 3zM8 10 5 7l-.705.705L6.085 9.5H1v1h5.085l-1.79 1.795L5 13z"/></svg>', 'arrows-right-down': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="m12.085 4.499-1.79-1.795.705-.705 3 3-3 3-.705-.705 1.79-1.795H9v-1zM8 6.514h.003v5.572l1.795-1.79.705.705-3 3-3-3 .705-.705 1.795 1.79V5.499H2v-1h6z"/></svg>', 'arrows-right-left': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="m11 2 3 3-3 3-.705-.705 1.79-1.795H2v-1h10.085l-1.79-1.795zm-7.085 9.5 1.79 1.795L5 14l-3-3 3-3 .705.705-1.79 1.795H14v1z" clip-rule="evenodd"/></svg>', 'arrows-rotate': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M10 4.997h2.61a5.5 5.5 0 0 0-6.175-2.271A5.5 5.5 0 0 0 2.5 7.993h-1a6.49 6.49 0 0 1 4.289-6.112A6.51 6.51 0 0 1 13 3.838V2h1v3.996h-4zM6 10.99H3.39a5.5 5.5 0 0 0 6.175 2.271A5.5 5.5 0 0 0 13.5 7.993h1a6.49 6.49 0 0 1-4.289 6.113A6.51 6.51 0 0 1 3 12.15v1.838H2V9.991h4z"/></svg>', 'arrows-rotate-backward': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M6 4.997H3.39a5.5 5.5 0 0 1 6.175-2.271A5.5 5.5 0 0 1 13.5 7.993h1a6.49 6.49 0 0 0-4.289-6.112A6.51 6.51 0 0 0 3 3.838V2H2v3.996h4zm4 5.993h2.61a5.5 5.5 0 0 1-6.175 2.271A5.5 5.5 0 0 1 2.5 7.993h-1a6.49 6.49 0 0 0 4.289 6.113A6.51 6.51 0 0 0 13 12.15v1.838h1V9.991h-4z"/></svg>', 'ban': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0m-3.126 4.582a6 6 0 0 1-8.456-8.456zm.707-.708L4.127 3.418a6 6 0 0 1 8.456 8.456" clip-rule="evenodd"/></svg>', 'bell': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M3.97 6a4 4 0 0 1 8 0v2.3l1.507.822c.91.496.558 1.878-.478 1.878H3.002c-1.027 0-1.387-1.362-.494-1.87l1.461-.83zm2.027 6a2 2 0 1 0 4 0z"/></svg>', 'bell-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path stroke="currentColor" d="m11.47 8.597 1.768.964c.455.248.28.939-.239.939H3.002c-.514 0-.694-.681-.247-.935l1.714-.974V6a3.5 3.5 0 0 1 7 0zM7.996 13.5a1.5 1.5 0 0 1-1.415-1h2.83a1.5 1.5 0 0 1-1.415 1Z"/></svg>', 'book': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M3 3a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-2H1.5a.5.5 0 0 1 0-1H3V9H1.5a.5.5 0 0 1 0-1H3V7H1.5a.5.5 0 0 1 0-1H3zm8 0H9v4h2z" clip-rule="evenodd"/></svg>', 'book-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M4 2a1 1 0 0 0-1 1v3H1.5a.5.5 0 0 0 0 1H3v1H1.5a.5.5 0 0 0 0 1H3v1H1.5a.5.5 0 0 0 0 1H3v2a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1zm5 1H4v3h.5a.5.5 0 0 1 0 1H4v1h.5a.5.5 0 0 1 0 1H4v1h.5a.5.5 0 0 1 0 1H4v2h8V3h-1v4H9z" clip-rule="evenodd"/></svg>', 'briefcase': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M5 4v1H2a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-3V4a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1m5 1V4H6v1z" clip-rule="evenodd"/></svg>', 'briefcase-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M5 5V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1h3a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1zm1-1h4v1H6zM2 6v7h12V6z" clip-rule="evenodd"/></svg>', 'building-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M4 2h8v12H9v-1a1 1 0 1 0-2 0v1H4zm4 13h4a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1zM7 4H5v2h2zm2 0h2v2H9zm2 4H9v2h2zM5 8h2v2H5z" clip-rule="evenodd"/></svg>', 'calculator': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M2 2a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm2 1h8v3H4zm2 5H4v2h2zm1 0h2v2H7zm5 0h-2v5h2zm-8 3h2v2H4zm5 0H7v2h2z" clip-rule="evenodd"/></svg>', 'calculator-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M4 3h8v3H4zm2 5H4v2h2zm3 0H7v2h2zm3 0h-2v5h2zm-6 3H4v2h2zm3 0H7v2h2z"/><path fill="currentColor" fill-rule="evenodd" d="M2 2a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm1 0h10v12H3z" clip-rule="evenodd"/></svg>', 'calendar': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M5 1h1v1h4V1h1v1h2a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h2zm8 5H3v7h10z" clip-rule="evenodd"/></svg>', 'calendar-euro': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M12 2.5h1c.6 0 1 .4 1 1v10c0 .6-.4 1-1 1H3c-.6 0-1-.4-1-1v-10c0-.6.4-1 1-1h1v-1h1v1h6v-1h1zm-9 3v8h10v-8zm7.5 6.24-.71-.71c-.35.3-.8.49-1.29.49-.74 0-1.4-.41-1.74-1.02h1.77v-.75H6.51c-.01-.07-.01-.15-.01-.23 0-.09.01-.18.02-.27h2.01V8.5H6.78c.35-.59.99-.98 1.72-.98.49 0 .94.19 1.29.49l.71-.71a2.974 2.974 0 0 0-4.81 1.2H4.5v.75h1.02c-.02.09-.02.18-.02.27 0 .08 0 .16.02.23H4.5v.75h1.17c.4 1.17 1.52 2.02 2.83 2.02.77 0 1.47-.3 2-.78" clip-rule="evenodd"/></svg>', 'calendar-euro-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="m9.79 11.02.71.71a2.976 2.976 0 0 1-4.83-1.24H4.5v-.75h1.01c-.01-.08-.01-.15-.01-.23 0-.09 0-.18.02-.27H4.5v-.75h1.19a2.974 2.974 0 0 1 4.81-1.2L9.79 8c-.35-.3-.8-.49-1.29-.49-.73 0-1.37.39-1.72.98h1.75v.75H6.52c-.01.09-.02.18-.02.27 0 .08 0 .16.01.23h2.02v.75H6.76c.34.61 1 1.02 1.74 1.02.49 0 .94-.19 1.29-.49M13 3.5v1H3v-1zm-1-2h-1v1H5v-1H4v1H3c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h10c.55 0 1-.45 1-1v-10c0-.55-.45-1-1-1h-1zm-9 12v-8h10v8z"/></svg>', 'calendar-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M13 2h-2V1h-1v1H6V1H5v1H3c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V3c0-.55-.45-1-1-1m0 11H3V6h10zm0-8H3V3h2v1h1V3h4v1h1V3h2z"/></svg>', 'check': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M6.77 12.113 15 3.883l-.707-.707-8.23 8.23-4.355-4.355L1 7.76l4.355 4.355-.004.004.707.706.004-.004.003.004.708-.707z"/></svg>', 'check-circle': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1m-1 9.795-2.5-2.5.795-.795L7 9.205 10.705 5.5l.798.793z"/></svg>', 'check-circle-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="m4.5 8.207 2.5 2.5 4.5-4.5-.707-.707L7 9.293 5.207 7.5z"/><path fill="currentColor" fill-rule="evenodd" d="M4.111 2.18a7 7 0 1 1 7.778 11.64A7 7 0 0 1 4.111 2.18m.556 10.809a6 6 0 1 0 6.666-9.978 6 6 0 0 0-6.666 9.978" clip-rule="evenodd"/></svg>', 'chevron-down': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="m8 11.708 6-6L13.293 5 8 10.293 2.708 5 2 5.708z"/></svg>', 'chevron-down-circle': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14M3.706 6 8 10.294 12.294 6l.706.706-5 5-5-5z" clip-rule="evenodd"/></svg>', 'chevron-left': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="m4 8 6 6 .708-.708L5.415 8l5.293-5.292L10 2z"/></svg>', 'chevron-left-circle': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m9-4.294L5.706 8 10 12.294 9.294 13l-5-5 5-5z" clip-rule="evenodd"/></svg>', 'chevron-right': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="m11.708 8-6-6L5 2.708 10.293 8 5 13.293l.708.707z"/></svg>', 'chevron-right-circle': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M15 8A7 7 0 1 0 1 8a7 7 0 0 0 14 0m-9 4.294L10.294 8 6 3.706 6.706 3l5 5-5 5z" clip-rule="evenodd"/></svg>', 'chevron-up': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="m8 4.5-6 6 .708.707L8 5.916l5.293 5.293L14 10.5z"/></svg>', 'chevron-up-circle': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1m4.294 9L8 5.706 3.706 10 3 9.294l5-5 5 5z" clip-rule="evenodd"/></svg>', 'circle': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M8 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>', 'clock': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14m-.5-6.795L10.295 11l.705-.705L8.5 7.79V3.5h-1z" clip-rule="evenodd"/></svg>', 'clock-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="m10.95 10.04-.71.71L7.5 8.01v-4h1V7.6l2.45 2.45zM8 2C4.69 2 2 4.69 2 8s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6m0-1c3.87 0 7 3.13 7 7s-3.13 7-7 7-7-3.13-7-7 3.13-7 7-7"/></svg>', 'code-square-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="m6.32 10.28.73-.73L5.5 8l1.53-1.53-.73-.73-2.27 2.27 2.28 2.28zm3.37 0L11.97 8 9.69 5.72l-.73.73L10.51 8 8.96 9.55zM3.01 14c-.27 0-.5-.1-.7-.3s-.3-.43-.3-.7V3c0-.27.1-.5.3-.7s.43-.3.7-.3h10c.27 0 .5.1.7.3s.3.43.3.7v10c0 .27-.1.5-.3.7s-.43.3-.7.3H3zm0-1h10V3H3v10z"/></svg>', 'cog': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M6.062 2a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1.416c.345.15.67.34.97.56l1.226-.708a1 1 0 0 1 1.366.366l1 1.732a1 1 0 0 1-.366 1.366l-1.227.709a5 5 0 0 1 0 1.119l1.227.708a1 1 0 0 1 .366 1.366l-1 1.732a1 1 0 0 1-1.366.366l-1.227-.708c-.3.22-.624.41-.969.56V14a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-1.416a5 5 0 0 1-.969-.56l-1.227.708a1 1 0 0 1-1.366-.366l-1-1.732a1 1 0 0 1 .366-1.366l1.227-.709a5 5 0 0 1 0-1.118l-1.227-.709A1 1 0 0 1 1.5 5.366l1-1.732a1 1 0 0 1 1.366-.366l1.227.709q.45-.334.97-.561zm2 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4" clip-rule="evenodd"/></svg>', 'cog-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M5.438 8a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0m2.5-1.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M10 3.416V2a1 1 0 0 0-1-1H7a1 1 0 0 0-1 1v1.416c-.345.15-.67.34-.969.56l-1.227-.708a1 1 0 0 0-1.366.366l-1 1.732a1 1 0 0 0 .366 1.366l1.227.709a5 5 0 0 0 0 1.118l-1.227.709a1 1 0 0 0-.366 1.366l1 1.732a1 1 0 0 0 1.366.366l1.227-.708a5 5 0 0 0 .969.56V14a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-1.416c.345-.15.67-.34.969-.56l1.227.708a1 1 0 0 0 1.366-.366l1-1.732a1 1 0 0 0-.366-1.366l-1.227-.709a5 5 0 0 0 0-1.118l1.227-.709a1 1 0 0 0 .366-1.366l-1-1.732a1 1 0 0 0-1.366-.366l-1.227.708c-.3-.22-.624-.41-.97-.56M7 4.07l-.6.262q-.414.182-.775.449l-.527.39-1.794-1.037-1 1.732 1.793 1.035-.072.65a4 4 0 0 0 0 .898l.072.65-1.793 1.035 1 1.732 1.794-1.036.527.39q.361.265.775.448l.6.262V14h2v-2.07l.6-.262q.414-.182.774-.449l.527-.39 1.795 1.037 1-1.732-1.793-1.035.072-.65a4 4 0 0 0 0-.898l-.072-.65 1.793-1.035-1-1.732-1.795 1.036-.527-.39q-.36-.265-.774-.448L9 4.07V2H7z" clip-rule="evenodd"/></svg>', 'comment': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M7.5 2A5.5 5.5 0 0 0 4 11.743V14l3.5-1h1a5.5 5.5 0 1 0 0-11zM5 6h6v1H5zm3 2H5v1h3z" clip-rule="evenodd"/></svg>', 'comment-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M5 6h6v1H5zm0 2h3v1H5z"/><path fill="currentColor" fill-rule="evenodd" d="m4 14 3.5-1h1a5.5 5.5 0 1 0 0-11h-1A5.5 5.5 0 0 0 4 11.743zm1-2.728-.363-.3A4.5 4.5 0 0 1 7.5 3h1a4.5 4.5 0 1 1 0 9H7.36L5 12.674z" clip-rule="evenodd"/></svg>', 'comment-sms': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M8 2.67c-3.37 0-6.1 2.21-6.1 4.95.02 1.18.51 2.3 1.36 3.11-.26.85-.71 1.62-1.3 2.28a.2.2 0 0 0-.04.21c.03.07.1.11.17.11 1.22-.02 2.4-.45 3.34-1.22.82.31 1.68.46 2.56.46 3.37 0 6.1-2.22 6.1-4.95S11.37 2.67 8 2.67M4.95 8.39a.76.76 0 1 1 0-1.52.76.76 0 0 1 0 1.52m3.05 0a.76.76 0 1 1 0-1.52.76.76 0 0 1 0 1.52m3.05 0a.76.76 0 1 1-.02-1.52c.42 0 .77.33.77.75v.01c0 .42-.34.76-.76.76"/></svg>', 'conversation': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M1.01 6.51c0-1.93 2.23-3.5 4.99-3.5s4.99 1.57 4.99 3.5-2.23 3.5-4.99 3.5c-.36 0-.71-.03-1.05-.08l-2.26 1.05c-.06.03-.11.03-.17.03-.27 0-.5-.21-.5-.5V8.6c-.62-.58-1.01-1.3-1.01-2.09m10.48-.01c0-.5-.13-.97-.36-1.41h.01c2.22.36 3.88 1.75 3.88 3.41 0 .79-.39 1.5-1.02 2.09v1.91a.5.5 0 0 1-.67.47l-2.26-1.05c-.34.05-.69.08-1.05.08-1.69 0-3.19-.59-4.09-1.5h.12c3.03 0 5.44-1.81 5.44-4" clip-rule="evenodd"/></svg>', 'conversation-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M10 6.5C10 5.14 8.17 4 6 4l-.01.01c-2.17 0-4 1.14-4 2.5 0 .59.38 1.06.7 1.36l.32.3v1.55l1.51-.7.27-.13.3.04c.31.05.62.07.91.07 2.17 0 4-1.14 4-2.5m-9.01.01c0-1.929 2.237-3.498 4.995-3.5 2.758.002 4.995 1.571 4.995 3.5s-2.24 3.5-5 3.5c-.36 0-.71-.03-1.05-.08l-2.26 1.05c-.06.03-.11.03-.17.03-.26 0-.5-.21-.5-.5V8.6C1.38 8.02.99 7.3.99 6.51m4.995-3.5h.005-.01zm8.005 7.58c.62-.58 1.01-1.3 1.01-2.09q0-.18-.03-.36c-.01-.11-.04-.22-.07-.33a2.3 2.3 0 0 0-.17-.45 3.55 3.55 0 0 0-1.1-1.26c-.1-.07-.19-.13-.3-.2a5 5 0 0 0-.65-.35c-.23-.1-.48-.19-.73-.27a4 4 0 0 1-.19-.06c.14.36.22.74.23 1.13C13.18 6.78 14 7.59 14 8.5c0 .59-.38 1.07-.7 1.36l-.31.3-.01.43v1.12l-1.5-.7-.28-.12-.29.04c-.31.05-.62.07-.91.07-.67 0-1.3-.1-1.86-.29-.51.15-1.06.24-1.64.27.06.05.12.09.18.13l.42.24c.36.18.76.33 1.18.43.15.04.3.08.46.1.02.01.03.01.05.01.17.04.34.07.52.07.22.03.46.04.69.04.36 0 .71-.03 1.05-.08l2.26 1.05q.09.03.18.03c.26 0 .49-.21.5-.5z" clip-rule="evenodd"/></svg>', 'copy': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M4 2h6V1H4a1 1 0 0 0-1 1v9h1z"/><path fill="currentColor" d="M5 4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1z"/></svg>', 'copy-file': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M4 2h6V1H4a1 1 0 0 0-1 1v9h1z"/><path fill="currentColor" d="M6 3h3v4h4v7a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1"/><path fill="currentColor" d="m13 6-3-3v3z"/></svg>', 'copy-file-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="m10 3 3 3v8a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1zm0 1.414V6h1.586zM12 7H9V4H6v10h6z" clip-rule="evenodd"/><path fill="currentColor" d="M4 2h6V1H4a1 1 0 0 0-1 1v9h1z"/></svg>', 'copy-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M10 2H4v9H3V2a1 1 0 0 1 1-1h6z"/><path fill="currentColor" fill-rule="evenodd" d="M5 4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1zm1 0h6v10H6z" clip-rule="evenodd"/></svg>', 'credit-card': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M3 9h3v2H3z"/><path fill="currentColor" fill-rule="evenodd" d="M2 13a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1zm0-9h12v1H2zm12 3v5H2V7z" clip-rule="evenodd"/></svg>', 'cross': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M2 2.707 2.707 2l11.29 11.289-.708.707z"/><path fill="currentColor" d="M2.707 14 2 13.293 13.293 2l.707.708z"/></svg>', 'cross-circle': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M8 1C4.1 1 1 4.1 1 8s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7m2.7 10.5L8 8.8l-2.7 2.7-.8-.8L7.2 8 4.5 5.3l.8-.8L8 7.2l2.7-2.7.8.8L8.8 8l2.7 2.7z"/></svg>', 'cross-circle-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M1 8c0-3.9 3.1-7 7-7s7 3.1 7 7-3.1 7-7 7-7-3.1-7-7m1 0c0 3.3 2.7 6 6 6s6-2.7 6-6-2.7-6-6-6-6 2.7-6 6m6 .8 2.7 2.7.8-.8L8.8 8l2.7-2.7-.8-.8L8 7.2 5.3 4.5l-.8.8L7.2 8l-2.7 2.7.8.8z" clip-rule="evenodd"/></svg>', 'dashboard': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M2 2h6v7H2zm0 8h6v4H2zm7-8h5v4H9zm0 5h5v7H9z"/></svg>', 'dashboard-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M8 2H2v7h6zM7 3H3v5h4zm1 7H2v4h6zm-1 1H3v2h4zm2-9v4h5V2zm4 1h-3v2h3zm1 4H9v7h5zm-1 1h-3v5h3z" clip-rule="evenodd"/></svg>', 'download': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M12.295 6.295 13 7l-5 5-5-5 .705-.705 3.795 3.79V1h1v9.085zM13 14v-2h1v2a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-2h1v2z" clip-rule="evenodd"/></svg>', 'earth': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14m-1.224-2.553-.63 1.261A6.003 6.003 0 0 1 4.501 3.126l1.6.4a1 1 0 0 1 .742 1.14L6.41 7.19a1 1 0 0 1-.986.83H4.47a1 1 0 0 0-.77.362l-.185.223A1 1 0 0 0 3.5 9.862l.273.348a1 1 0 0 0 .59.362l1.658.332a1 1 0 0 1 .699.533l.057.116a1 1 0 0 1 0 .894m3.543-9.983V4.53a1 1 0 0 0 1 1h1.234a1 1 0 0 0 .664-.252l.09-.08a6.02 6.02 0 0 0-2.988-2.733m3.612 4.622-.012-.075h-3.05a1 1 0 0 0-.884.535l-.773 1.469a1 1 0 0 0-.115.465v.964a1 1 0 0 0 .408.806l.353.259a1 1 0 0 1 .408.806v1.242a6 6 0 0 0 3.665-6.47" clip-rule="evenodd"/></svg>', 'earth-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14m0-1a6 6 0 0 0 1.766-.264v-1.421a.5.5 0 0 0-.204-.403l-.353-.26a1.5 1.5 0 0 1-.612-1.208V9.48c0-.243.06-.483.173-.698l.772-1.469a1.5 1.5 0 0 1 1.328-.802h2.944a6 6 0 0 0-.284-.844 1.5 1.5 0 0 1-.977.362h-1.235a1.5 1.5 0 0 1-1.5-1.5V2.28A6 6 0 0 0 8 2a6 6 0 0 0-2.918.756l1.14.286A1.5 1.5 0 0 1 7.336 4.75l-.433 2.525a1.5 1.5 0 0 1-1.479 1.247H4.47a.5.5 0 0 0-.385.18l-.185.223a.5.5 0 0 0-.008.628l.273.348a.5.5 0 0 0 .295.181l1.658.332a1.5 1.5 0 0 1 1.048.8l.058.115a1.5 1.5 0 0 1 0 1.342l-.587 1.174A6 6 0 0 0 8 14m6-6q0-.247-.02-.489h-3.11a.5.5 0 0 0-.443.268l-.772 1.468a.5.5 0 0 0-.058.233v.964a.5.5 0 0 0 .204.403l.353.259a1.5 1.5 0 0 1 .612 1.209v1.01A6 6 0 0 0 14 8m-8.402 5.5h.093l.638-1.276a.5.5 0 0 0 0-.448l-.057-.115a.5.5 0 0 0-.35-.267l-1.658-.331a1.5 1.5 0 0 1-.885-.545l-.273-.347a1.5 1.5 0 0 1 .025-1.884l.184-.223a1.5 1.5 0 0 1 1.155-.542h.954a.5.5 0 0 0 .493-.416l.433-2.525a.5.5 0 0 0-.37-.57l-1.95-.487-.046.018A6.002 6.002 0 0 0 5.598 13.5m7.287-8.597.164-.146a6 6 0 0 0-1.458-1.564 6 6 0 0 0-.772-.457V4.53a.5.5 0 0 0 .5.5h1.234a.5.5 0 0 0 .332-.126" clip-rule="evenodd"/></svg>', 'ellipsis': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M3 8a1 1 0 1 1 2 0 1 1 0 0 1-2 0m4 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0m4 0a1 1 0 1 1 2 0 1 1 0 0 1-2 0"/></svg>', 'ellipsis-vertical': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M8 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0 4a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0 4a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/></svg>', 'euro': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="m12.08 11.02 1.42 1.42a5.95 5.95 0 0 1-4 1.56c-2.6 0-4.8-1.64-5.62-3.94H1.5v-1.5h2.04C3.5 8.38 3.5 8.18 3.5 8c0-.16 0-.34.04-.5H1.5V6h2.36c.8-2.34 3.02-4 5.64-4 1.54 0 2.94.6 4 1.56l-1.42 1.42c-.7-.6-1.6-.98-2.58-.98-1.48 0-2.76.8-3.46 2h3.52v1.5H5.54c-.02.16-.04.32-.04.5 0 .2.02.38.04.56h4.02v1.5H6.08C6.78 11.22 8.06 12 9.5 12c.98 0 1.88-.38 2.58-.98"/></svg>', 'euro-circle': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill="currentColor" d="M8 .67C3.95.67.67 3.95.67 8S3.95 15.33 8 15.33s7.33-3.28 7.33-7.33S12.05.67 8 .67m2.27 11.4c-.38.09-.76.14-1.15.14a4.04 4.04 0 0 1-3.99-2.92h-.58c-.12 0-.23-.09-.23-.22v-.54c0-.12.11-.22.23-.22h.41a5 5 0 0 1 0-.8h-.41c-.12 0-.23-.09-.23-.22v-.58c0-.12.1-.22.23-.22h.63c.6-1.65 2.18-2.74 3.94-2.71.34 0 .68.03 1.02.1.12.03.19.16.16.28l-.23.84c-.03.12-.15.19-.27.17-.24-.05-.48-.08-.73-.08A2.42 2.42 0 0 0 6.81 6.5h2.71c.12.03.2.15.17.27l-.13.58c-.02.1-.11.18-.22.18H6.52c-.03.27-.03.53 0 .8h2.63c.12.03.2.15.17.27l-.11.52c-.03.1-.12.17-.22.18H6.8c.36.96 1.28 1.6 2.31 1.61.3 0 .59-.04.88-.1.12-.02.24.06.27.18l.17.84c.02.12-.05.24-.17.27v-.03z"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>', 'exclamation-circle': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M1 8a7 7 0 1 1 14 0A7 7 0 0 1 1 8m7.75-4v5h-1.5V4zm0 8v-1.5h-1.5V12z" clip-rule="evenodd"/></svg>', 'exclamation-circle-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M8.75 4v5h-1.5V4zm0 8v-1.5h-1.5V12z"/><path fill="currentColor" fill-rule="evenodd" d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1M2 8a6 6 0 1 0 12 0A6 6 0 0 0 2 8" clip-rule="evenodd"/></svg>', 'exclamation-stamp': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="m15 8-1.55-1.86.22-2.46-2.3-.55L10.17 1 8 1.98 5.84 1 4.63 3.13l-2.29.54.22 2.46L1.01 8l1.55 1.86-.22 2.47 2.3.55 1.2 2.13L8 14.03l2.17.98 1.2-2.13 2.3-.55-.22-2.46L15 8.01zm-6.36 3.35H7.36v-1.34h1.28zm0-2.67H7.36V4.67h1.28z"/></svg>', 'exclamation-triangle': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="m8 2 7 12H1zm-.75 4.5h1.5V10h-1.5zm1.5 6V11h-1.5v1.5z" clip-rule="evenodd"/></svg>', 'exclamation-triangle-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M8.75 6.5V10h-1.5V6.5zm0 6V11h-1.5v1.5z"/><path fill="currentColor" fill-rule="evenodd" d="M8 2 1 14h14zm0 1.985L2.741 13h10.518z" clip-rule="evenodd"/></svg>', 'eye': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M8 10a2 2 0 1 0 0-4 2 2 0 0 0 0 4"/><path fill="currentColor" fill-rule="evenodd" d="M15 8s-3.134 5-7 5-7-5-7-5 3.134-5 7-5 7 5 7 5m-7 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6" clip-rule="evenodd"/></svg>', 'eye-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-1a2 2 0 1 0 0-4 2 2 0 0 0 0 4" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M1 8s3.134 5 7 5 7-5 7-5-3.134-5-7-5-7 5-7 5m1.215 0 .133.178a15 15 0 0 0 1.405 1.61C4.974 10.994 6.478 12 8 12s3.026-1.006 4.247-2.212A15 15 0 0 0 13.785 8l-.133-.178a15 15 0 0 0-1.405-1.61C11.026 5.006 9.522 4 8 4S4.974 5.006 3.753 6.212A15 15 0 0 0 2.215 8" clip-rule="evenodd"/></svg>', 'eye-slash': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="m1 1.7.7-.7L15 14.302l-.7.7-3.084-3.085c-.963.63-2.057 1.08-3.216 1.08-3.866 0-7-5-7-5S2.174 6.124 3.97 4.67zm4.556 4.557A3 3 0 0 0 9.74 10.44l-.722-.722a2 2 0 0 1-2.74-2.74z" clip-rule="evenodd"/><path fill="currentColor" d="m5.67 3.572 1.532 1.532a3.003 3.003 0 0 1 3.69 3.691l1.877 1.877C14.142 9.366 15 7.997 15 7.997s-3.134-5-7-5c-.817 0-1.6.223-2.33.575"/><path fill="currentColor" d="M9.998 7.9 8.097 6a2 2 0 0 1 1.9 1.901"/></svg>', 'eye-slash-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="m1 1.7.7-.7L15 14.302l-.7.7-3.084-3.085c-.963.63-2.057 1.08-3.216 1.08-3.866 0-7-5-7-5S2.174 6.124 3.97 4.67zm3.682 3.683c-.324.256-.635.535-.93.826a15 15 0 0 0-1.537 1.788l.133.178c.334.442.815 1.028 1.405 1.61C4.974 10.99 6.478 11.997 8 11.997c.852 0 1.698-.315 2.492-.804l-.752-.752a3 3 0 0 1-4.184-4.184zm1.596 1.596a2 2 0 0 0 2.74 2.74z" clip-rule="evenodd"/><path fill="currentColor" d="m5.67 3.572.757.757A4.2 4.2 0 0 1 8 3.997c1.522 0 3.026 1.006 4.247 2.212a15 15 0 0 1 1.538 1.788q-.061.085-.133.178a15 15 0 0 1-1.531 1.733l-.06.057.708.707C14.142 9.366 15 7.997 15 7.997s-3.134-5-7-5c-.817 0-1.6.223-2.33.575"/><path fill="currentColor" d="m8.097 6-.895-.896a3.003 3.003 0 0 1 3.69 3.691L9.999 7.9A2 2 0 0 0 8.097 6"/></svg>', 'fax': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M13 14H6V2h7v3a1 1 0 0 1 1 1v7a1 1 0 0 1-1 1M7 3h5v2H7zm0 4h5v1H7zm1 2H7v1h1zm-1 2h1v1H7zm3-2H9v1h1zm-1 2h1v1H9zm3-2h-1v1h1zm-1 2h1v1h-1z" clip-rule="evenodd"/><path fill="currentColor" d="M2 5a1 1 0 0 1 1-1h1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z"/></svg>', 'fax-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M12 3H7v2h5zM6 3v2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1V2H6zm6 3h1v7H6V6zM3 5h2v8H3zm9 2H7v1h5zM7 9h1v1H7zm1 2H7v1h1zm1-2h1v1H9zm1 2H9v1h1zm1-2h1v1h-1zm1 2h-1v1h1z" clip-rule="evenodd"/></svg>', 'file': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M9 5V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V5zm1-1V1l3 3z" clip-rule="evenodd"/></svg>', 'file-cog': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M9 10.06c-.03.53-.47.94-1 .94-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1zm.55-4.81h3.76v9.4a.68.68 0 0 1-.66.66h-9.3c-.37 0-.67-.31-.66-.68V1.33c.01-.36.3-.65.66-.66h5.54v3.89c-.01.37.28.68.65.69zM10 8l-.51.29c-.21-.18-.46-.32-.72-.41v-.57c0-.06-.05-.12-.11-.14-.43-.09-.87-.09-1.3 0a.14.14 0 0 0-.12.14v.59q-.405.135-.72.42L6 8a.135.135 0 0 0-.17 0c-.3.32-.52.71-.65 1.13-.02.06 0 .13.06.16l.51.29q-.075.42 0 .84l-.51.29c-.05.03-.08.1-.06.16.13.42.35.81.65 1.13.05.04.12.04.17 0l.51-.29c.22.18.46.32.73.41v.59c0 .07.04.13.11.14.43.09.87.09 1.3 0 .07-.01.12-.07.11-.14v-.51c.27-.09.51-.23.73-.41l.51.29c.05.04.12.04.17 0 .3-.32.52-.71.65-1.13.02-.06 0-.13-.06-.16l-.5-.3c.05-.27.05-.56 0-.83l.5-.3c.06-.03.09-.1.07-.16a2.9 2.9 0 0 0-.65-1.13A.16.16 0 0 0 10 8m3.12-4.33L10.41.87a.63.63 0 0 0-.47-.2h-.17v3.66h3.54v-.17c0-.18-.06-.36-.19-.49"/></svg>', 'file-download': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="m10.41.87 2.71 2.8a.7.7 0 0 1 .19.49v.17H9.77V.67h.17a.63.63 0 0 1 .47.2m2.9 4.38v9.42a.67.67 0 0 1-.66.66h-9.3a.67.67 0 0 1-.66-.68V1.33a.67.67 0 0 1 .66-.66h5.54v3.9a.67.67 0 0 0 .66.68zm-5.45 7.69 2.54-2.53a.19.19 0 0 0 .01-.27.16.16 0 0 0-.14-.06H8.93a.2.2 0 0 1-.2-.2v-2.6a.18.18 0 0 0-.18-.19H6.92a.19.19 0 0 0-.19.18v2.61a.2.2 0 0 1-.2.2H5.19a.18.18 0 0 0-.19.18.2.2 0 0 0 .06.15l2.54 2.53a.18.18 0 0 0 .26 0" clip-rule="evenodd"/></svg>', 'file-excel': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M9 5V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V5zm-.018 7h1.335L8.776 9.48l1.5-2.48H9.02l-.795 1.485a5 5 0 0 0-.157.436h-.014a2.6 2.6 0 0 0-.15-.422L7.19 7H5.82l1.457 2.5L5.683 12h1.342l.865-1.614q.09-.234.115-.349h.014q.053.244.101.335z" clip-rule="evenodd"/><path fill="currentColor" d="M10 4V1l3 3z"/></svg>', 'file-excel-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M8.982 12h1.335L8.776 9.48l1.5-2.48H9.02l-.795 1.485a5 5 0 0 0-.157.436h-.014a2.6 2.6 0 0 0-.15-.422L7.19 7H5.82l1.457 2.5L5.683 12h1.342l.865-1.614q.09-.234.115-.349h.014q.053.244.101.335z"/><path fill="currentColor" fill-rule="evenodd" d="M4 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4l-3-3zm6 3V2.537L11.254 4zm2 1v9H4V2h5v3z" clip-rule="evenodd"/></svg>', 'file-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="m10 1 3 3v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zm0 1.415V4h1.585zM12 5H9V2H4v12h8z" clip-rule="evenodd"/></svg>', 'file-pdf': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M6.464 11.274a4 4 0 0 0-.393.207c-.223.137-.37.27-.444.387-.072.11-.073.19-.03.273l.019.034.027-.01c.103-.042.268-.177.48-.433q.18-.22.34-.458m1.243-1.007q.378-.09.764-.146a9 9 0 0 1-.386-.65 16 16 0 0 1-.378.796m1.873.363a3 3 0 0 0 .341.314c.164.123.28.165.344.168a.1.1 0 0 0 .053-.012.23.23 0 0 0 .07-.094.3.3 0 0 0 .045-.152.07.07 0 0 0-.02-.047c-.039-.047-.15-.116-.391-.159a3 3 0 0 0-.463-.04zM8.051 7.952q.096-.308.151-.626.035-.213.029-.352a.5.5 0 0 0-.024-.15.4.4 0 0 0-.11.03c-.066.027-.12.08-.148.215l-.01.057q-.029.213.044.565.027.126.068.26"/><path fill="currentColor" fill-rule="evenodd" d="M9 1v4h4v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM5.42 12.713a.6.6 0 0 1-.332-.318c-.147-.294-.098-.588.06-.834.15-.233.4-.43.68-.596a6 6 0 0 1 1.122-.489q.454-.817.804-1.686a5.6 5.6 0 0 1-.326-.98c-.065-.303-.09-.603-.034-.86.056-.268.207-.509.492-.623l.055-.02a.75.75 0 0 1 .4-.038.53.53 0 0 1 .362.276c.066.124.09.27.096.407.005.142-.01.3-.036.465-.063.386-.204.859-.394 1.358q.316.672.742 1.277a4.5 4.5 0 0 1 1.01.038c.276.049.556.147.727.352a.64.64 0 0 1 .151.392.9.9 0 0 1-.104.426.8.8 0 0 1-.312.341.65.65 0 0 1-.342.078c-.25-.01-.495-.148-.706-.315l-.095-.081a4.3 4.3 0 0 1-.595-.638 9 9 0 0 0-1.512.307 8.6 8.6 0 0 1-.773 1.143c-.22.265-.46.496-.701.596a.6.6 0 0 1-.44.022" clip-rule="evenodd"/><path fill="currentColor" d="M10 1v3h3z"/></svg>', 'file-pdf-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M5.42 12.713a.6.6 0 0 1-.332-.318c-.147-.294-.098-.588.06-.834.15-.233.4-.43.68-.596a6 6 0 0 1 1.122-.489q.454-.817.804-1.686a5.5 5.5 0 0 1-.326-.98c-.065-.303-.09-.603-.034-.86.056-.268.207-.509.492-.623.145-.058.303-.09.455-.058a.53.53 0 0 1 .362.276c.066.124.09.27.096.407.005.142-.01.3-.036.465-.063.386-.204.859-.394 1.358q.316.672.742 1.277a4.4 4.4 0 0 1 1.01.038c.276.049.556.147.727.352a.64.64 0 0 1 .151.392.9.9 0 0 1-.104.426.8.8 0 0 1-.268.315.65.65 0 0 1-.386.104c-.25-.01-.495-.148-.706-.315a4.3 4.3 0 0 1-.69-.72 9 9 0 0 0-1.512.308 8.6 8.6 0 0 1-.773 1.143c-.22.265-.46.496-.701.596a.6.6 0 0 1-.44.022m1.044-1.44a4 4 0 0 0-.348.18c-.248.148-.41.29-.49.415-.07.11-.072.19-.03.273l.02.034.027-.01c.103-.042.268-.177.48-.433q.18-.22.34-.458m1.242-1.006q.378-.09.764-.146a9 9 0 0 1-.386-.65 16 16 0 0 1-.378.796m2.18.65a3 3 0 0 1-.328-.309q.233.002.463.04c.24.043.352.112.392.159q.019.02.02.047a.3.3 0 0 1-.045.152.23.23 0 0 1-.071.094.1.1 0 0 1-.053.012c-.07-.003-.196-.05-.377-.194m-1.684-3.59q-.056.316-.15.625a3 3 0 0 1-.069-.26c-.057-.268-.065-.478-.034-.623.028-.134.082-.188.148-.214a.4.4 0 0 1 .11-.03.5.5 0 0 1 .024.15q.006.138-.029.351" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M3 2a1 1 0 0 1 1-1h6l3 3v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zm7 .537V4h1.254zM12 14V5H9V2H4v12z" clip-rule="evenodd"/></svg>', 'file-text': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M9 5V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V5zm2 2H5v1h6zM5 9h6v1H5zm6 2H5v1h6z" clip-rule="evenodd"/><path fill="currentColor" d="M10 4V1l3 3z"/></svg>', 'file-text-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M11 7H5v1h6zM5 9h6v1H5zm6 2H5v1h6z"/><path fill="currentColor" fill-rule="evenodd" d="m13 4-3-3H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1zm-3 0V2.415L11.585 4zM9 5h3v9H4V2h5z" clip-rule="evenodd"/></svg>', 'file-upload': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M13.12 3.67 10.41.87a.63.63 0 0 0-.47-.2h-.17v3.66h3.54v-.17c0-.18-.06-.36-.19-.49m.19 11V5.25H9.55c-.37 0-.67-.31-.66-.68V.67H3.35a.68.68 0 0 0-.66.66v13.32c0 .37.29.67.66.68h9.3c.36-.01.65-.3.66-.66m-3-4.64H8.93c-.1 0-.19.07-.2.18v2.61c0 .1-.09.18-.19.18H6.91a.18.18 0 0 1-.18-.18V10.2c0-.1-.07-.19-.18-.2H5.19s-.09.01-.14 0a.19.19 0 0 1 0-.27L7.6 7.14c.07-.07.19-.07.26 0l2.54 2.54s.06.09.06.14c0 .1-.09.18-.19.18z"/></svg>', 'file-word': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M9 5V1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V5zM5 7l1.091 5h1.002L8 8.262 8.91 12h.98L11 7h-.93l-.701 3.492L8.568 7H7.47l-.836 3.435L5.944 7z" clip-rule="evenodd"/><path fill="currentColor" d="M10 4V1l3 3z"/></svg>', 'file-word-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="m5 7 1.091 5h1.002L8 8.262 8.91 12h.98L11 7h-.93l-.701 3.492L8.568 7H7.47l-.836 3.435L5.944 7z"/><path fill="currentColor" fill-rule="evenodd" d="M4 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4l-3-3zm6 3V2.537L11.254 4zm2 1v9H4V2h5v3z" clip-rule="evenodd"/></svg>', 'filter': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M3 2a1 1 0 0 0-1 1v1.586a1 1 0 0 0 .293.707L6 9v2.5a1 1 0 0 0 .4.8l2 1.5A1 1 0 0 0 10 13V9l3.707-3.707A1 1 0 0 0 14 4.586V3a1 1 0 0 0-1-1z" clip-rule="evenodd"/></svg>', 'filter-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M3 3h10v1.586l-4 4V13l-2-1.5V8.586l-4-4zm3 7V9L2.293 5.293A1 1 0 0 1 2 4.586V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v1.586a1 1 0 0 1-.293.707L10 9v4a1 1 0 0 1-1.6.8l-2-1.5a1 1 0 0 1-.4-.8z" clip-rule="evenodd"/></svg>', 'floppy-disk': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M2 3a1 1 0 0 1 1-1h7.586a1 1 0 0 1 .707.293l2.414 2.414a1 1 0 0 1 .293.707V13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm2 0h6v3H4zm4 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4" clip-rule="evenodd"/></svg>', 'floppy-disk-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M6 10a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2 1a1 1 0 1 1 0-2 1 1 0 0 1 0 2" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M10.586 2a1 1 0 0 1 .707.293l2.414 2.414a1 1 0 0 1 .293.707V13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1zM3 3v10h10V5.414L10.586 3H10v3H4V3zm2 0h4v2H5z" clip-rule="evenodd"/></svg>', 'folder': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M7 4h7c.55 0 1 .45 1 1v7c0 .55-.45 1-1 1H2c-.55 0-1-.45-1-1V4c0-.55.45-1 1-1h4z"/></svg>', 'folder-check': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M14 4H7L6 3H2c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1M5.705 8.185 7 9.48l3.295-3.295.705.705-4 4-2-2z" clip-rule="evenodd"/></svg>', 'folder-check-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M5.705 8.185 7 9.48l3.295-3.295.705.705-4 4-2-2z"/><path fill="currentColor" fill-rule="evenodd" d="m6 3 1 1.001h7c.55 0 1 .45 1 1.001v6.997c0 .55-.45 1.001-1 1.001H2c-.55 0-1-.45-1-1.001V4.001C1 3.451 1.45 3 2 3zm-.41 1.001H2v8.008h12V5.002H6.59z" clip-rule="evenodd"/></svg>', 'folder-lines': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M14 4H7L6 3H2c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1m-5 6H4V9h5zm3-2H4V7h8z"/></svg>', 'folder-lines-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M12 8.005H4V7.004h8zM9 9.006H4v1.001h5zM5.59 4.001H2v8.008h12V5.002H6.59l-.29-.29zM6 3l1 1.001h7c.55 0 1 .45 1 1.001v6.997c0 .55-.45 1.001-1 1.001H2c-.55 0-1-.45-1-1.001V4.001C1 3.451 1.45 3 2 3z"/></svg>', 'folder-link': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M14 4.44H8.46L6.62 2.67H2C1.27 2.67.68 3.27.67 4v8c0 .73.6 1.32 1.33 1.33h12c.73 0 1.32-.6 1.33-1.33V5.78c0-.73-.6-1.33-1.33-1.34m-6.82 6.88H5.65c-1.34 0-2.42-1.08-2.42-2.42s1.08-2.42 2.42-2.42h.84c.14 0 .25.11.25.25 0 .06-.02.13-.06.17-.2.21-.36.45-.49.71-.04.07-.11.13-.19.14h-.33c-.62-.15-1.24.22-1.39.84s.22 1.24.84 1.39c.15.04.31.04.47.02h1.58c.62 0 1.12-.48 1.15-1.1v-.22c-.02-.08 0-.16.06-.22.12-.13.29-.2.47-.2h.45c.12 0 .23.09.25.21.02.14.02.29 0 .43 0 1.32-1.05 2.39-2.37 2.42m3.17 0h-.84c-.06 0-.13-.02-.17-.07-.1-.1-.1-.25 0-.35.2-.21.36-.45.49-.71.02-.09.08-.16.17-.19h.36c.63.04 1.18-.43 1.23-1.07.04-.63-.43-1.18-1.07-1.23H8.83c-.64 0-1.15.51-1.15 1.15v.25c.02.08 0 .16-.06.22-.12.13-.29.21-.47.21H6.7c-.13 0-.24-.09-.26-.22-.01-.14-.01-.27 0-.41a2.41 2.41 0 0 1 2.38-2.43h1.52c1.34 0 2.42 1.07 2.43 2.41 0 1.34-1.09 2.42-2.42 2.43z"/></svg>', 'folder-link-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="m6.22 3.67 1.55 1.49.29.28h5.93c.19 0 .34.16.34.34v6.21c0 .18-.15.34-.33.34H2.01c-.18 0-.34-.15-.34-.33V4.01c0-.18.15-.34.33-.34zm.4-1H2C1.27 2.67.68 3.27.67 4v8c0 .73.6 1.32 1.33 1.33h12c.73 0 1.32-.6 1.33-1.33V5.78c0-.73-.6-1.33-1.33-1.34H8.46z"/><path fill="currentColor" d="M9.555 8.848a2.37 2.37 0 0 1-2.372 2.372l-1.486.006a2.366 2.366 0 0 1-2.37-2.37 2.38 2.38 0 0 1 2.376-2.377h.82c.135 0 .25.106.25.249q-.001.094-.062.17a3 3 0 0 0-.474.687.26.26 0 0 1-.223.143h-.286a1.13 1.13 0 0 0-1.165 1.086 1.123 1.123 0 0 0 1.082 1.163c.023.005.045 0 .063 0l1.481-.002A1.123 1.123 0 0 0 8.292 8.64a.25.25 0 0 1 .063-.214.62.62 0 0 1 .46-.201l.464-.001c.125 0 .223.089.245.21q.034.206.035.419zm3.11.001a2.365 2.365 0 0 0-2.371-2.37l-1.481.001a2.387 2.387 0 0 0-2.337 2.8c.022.12.125.205.245.21l.464-.001a.6.6 0 0 0 .46-.201.24.24 0 0 0 .063-.214 1.123 1.123 0 0 1 1.104-1.335l1.48-.002a1.12 1.12 0 0 1 1.15 1.096 1.13 1.13 0 0 1-1.099 1.152c-.022.004-.045 0-.062 0h-.286a.25.25 0 0 0-.223.143c-.125.25-.286.482-.474.688a.244.244 0 0 0 .013.352.24.24 0 0 0 .17.063l.82-.001a2.38 2.38 0 0 0 2.377-2.376z"/></svg>', 'folder-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M7 4.001 6 3H2c-.55 0-1 .45-1 1.001v7.998C1 12.549 1.45 13 2 13h12c.55 0 1-.45 1-1.001V5.002c0-.55-.45-1.001-1-1.001zm-5 0h3.59l1 1.001H14v7.007H2z" clip-rule="evenodd"/></svg>', 'folder-star': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M14 4.44H8.46L6.62 2.67H2A1.35 1.35 0 0 0 .67 4v8A1.35 1.35 0 0 0 2 13.33h12A1.35 1.35 0 0 0 15.33 12V5.78A1.36 1.36 0 0 0 14 4.44m-.2 3.89L12 9.66l.69 2a.22.22 0 0 1-.08.27.26.26 0 0 1-.13.06.4.4 0 0 1-.15-.06l-1.77-1.26L8.75 12a.34.34 0 0 1-.15 0 .3.3 0 0 1-.13 0 .23.23 0 0 1-.08-.27l.69-2-1.81-1.35a.23.23 0 0 1-.1-.17.24.24 0 0 1 .24-.24h2.21l.67-2a.26.26 0 0 1 .243-.156.24.24 0 0 1 .217.156l.67 2h2.2a.26.26 0 0 1 .26.24.3.3 0 0 1-.08.12"/></svg>', 'folders': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M9 3h4c.55 0 1 .45 1 1v5c0 .55-.45 1-1 1h-1V8a2 2 0 0 0-2-2H6.414l-1-1H5V3c0-.55.45-1 1-1h2z"/><path fill="currentColor" d="M10 7a1 1 0 0 1 1 1v5c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1h2l1 1z"/></svg>', 'folders-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M9 3 8 2H6c-.55 0-1 .45-1 1v2h1V3h1.59l1 1H13v5.01h-1V10h1c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"/><path fill="currentColor" fill-rule="evenodd" d="m5 6 1 1h4c.55 0 1 .45 1 1v5c0 .55-.45 1-1 1H3c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1zm-.41 1H3v6.01h7V8H5.59z" clip-rule="evenodd"/></svg>', 'gavel': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M5.908 5.012a.59.59 0 0 0 .59 1.02l.138-.08.59 1.02-5.892 3.402a.59.59 0 0 0 .589 1.02l5.892-3.4.589 1.02-.14.08a.59.59 0 0 0 .59 1.02l3.31-1.91a.59.59 0 0 0-.59-1.02l-.139.08-1.768-3.062.14-.08a.59.59 0 0 0-.59-1.021zm3.631 7.01a.5.5 0 1 0 0 1h5a.5.5 0 0 0 0-1z"/></svg>', 'gavel-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M5.869 4.99a.59.59 0 0 0 .59 1.02l.138-.08.59 1.02-5.892 3.402a.59.59 0 1 0 .589 1.02l5.892-3.4.59 1.02-.14.08a.59.59 0 0 0 .589 1.02l3.31-1.91a.59.59 0 0 0-.59-1.02l-.139.08L9.628 4.18l.14-.08a.59.59 0 0 0-.59-1.021zm1.594.44 1.3-.75 1.767 3.062-1.299.75z" clip-rule="evenodd"/><path fill="currentColor" d="M9.5 12a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1z"/></svg>', 'graduation-cap': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="m1 6 7-3 7 3v5h-1V6.429L8 9z"/><path fill="currentColor" d="M3 7.945V11l5 2 5-2V7.945l-5 2.143z"/></svg>', 'graduation-cap-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="m1 6 2 .857V11l5 2 5-2V6.857l1-.428V11h1V6L8 3zm3 4.323V7.286L8 9l4-1.714v3.037l-4 1.6zM3.539 6 8 7.912 12.461 6 8 4.088z" clip-rule="evenodd"/></svg>', 'hand-euro': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M14.91 7.11c-.581.55-1.362.89-2.213.89h-.01c-1.357 0-2.527-.86-3.043-2.09H8v-1h1.385a4 4 0 0 1-.02-.554l.002-.043q.005-.113.017-.223H8v-1h1.642C10.156 1.86 11.322 1 12.687 1c.901 0 1.712.37 2.313.98l-.711.71c-.42-.43-.991-.69-1.602-.69-.774 0-1.492.422-1.92 1.09h1.239v1h-1.612a2.7 2.7 0 0 0 0 .82h1.612v1h-1.241C11.19 6.578 11.907 7 12.687 7c.57 0 1.101-.22 1.512-.6zM3 7H1v7h2zm9.81 4.5h-2.06c-.09.18-.2.34-.35.49-.37.37-.87.58-1.39.58s-1.02-.2-1.39-.58l-1.04-1.04c-.2-.2-.2-.51 0-.71s.51-.2.71 0l1.04 1.04c.36.36 1 .37 1.36 0 .18-.18.28-.42.28-.68s-.1-.5-.28-.68L8.44 8.67c-.2-.2-.44-.36-.71-.48-.3-.12-.62-.18-.94-.18h-2.8v4.8h.02l.29-.02 1.94 1.63c.45.38 1.02.58 1.6.58h5.81c.74 0 1.33-.6 1.33-1.33 0-1.2-.97-2.17-2.17-2.17"/></svg>', 'hand-euro-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M14.91 7.11c-.581.55-1.362.89-2.213.89h-.01c-1.357 0-2.527-.86-3.043-2.09H8v-1h1.385a3.7 3.7 0 0 1 0-.82H8v-1h1.642C10.156 1.86 11.322 1 12.687 1c.901 0 1.712.37 2.313.98l-.711.71c-.42-.43-.991-.69-1.602-.69-.774 0-1.492.422-1.92 1.09h1.239v1h-1.612a2.7 2.7 0 0 0 0 .82h1.612v1h-1.241C11.19 6.578 11.907 7 12.687 7c.57 0 1.101-.22 1.512-.6z"/><path fill="currentColor" fill-rule="evenodd" d="M1 7h3v1h2.798a2.5 2.5 0 0 1 1.77.731L9.73 9.896a1.56 1.56 0 0 1 .376 1.603h2.726c1.197 0 2.167.971 2.167 2.167 0 .737-.599 1.333-1.334 1.333H7.852a2.5 2.5 0 0 1-1.599-.578L4 12.566V14H1zm1 1h1v5H2zm2 1v2.27l2.892 2.382c.27.224.61.347.96.347h5.814c.185 0 .334-.15.334-.333 0-.644-.522-1.167-1.167-1.167h-3.77a1.56 1.56 0 0 1-1.539-.395l-.75-.75a.5.5 0 1 1 .707-.707l.75.75a.56.56 0 0 0 .397.164h.021a.56.56 0 0 0 .375-.957L7.861 9.439A1.5 1.5 0 0 0 6.799 9z" clip-rule="evenodd"/></svg>', 'hand-up': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M12.75 3.5c-.41 0-.75.34-.75.75v3.5c0 .14-.11.25-.25.25s-.25-.11-.25-.25v-4c0-.41-.34-.75-.75-.75s-.75.34-.75.75v4c0 .14-.11.25-.25.25s-.25-.11-.25-.25v-5c0-.41-.34-.75-.75-.75S8 2.34 8 2.75v5c0 .14-.11.25-.25.25s-.25-.11-.25-.25v-4c0-.41-.34-.75-.75-.75S6 3.34 6 3.75V11L3.97 9.54a.845.845 0 0 0-1.21 0c-.33.34-.34.88 0 1.21l2.22 2.22c.66.66 1.55 1.03 2.47 1.03H11a2.5 2.5 0 0 0 2.5-2.5V4.25c0-.41-.34-.75-.75-.75"/></svg>', 'history': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="m12.975 3.82.002-.001-.083-.09-.063-.066-.009-.01-.001-.002a6 6 0 0 0-.272-.29q-.076-.074-.157-.144l-.058-.052-.004-.003a6 6 0 0 0-.275-.237 6 6 0 0 0-.22-.166l-.024-.018a7 7 0 0 0-.293-.203 7 7 0 0 0-.859-.467 7 7 0 0 0-.339-.14l-.03-.011a6 6 0 0 0-.255-.093 7 7 0 0 0-.376-.108L9.592 1.7a4 4 0 0 0-.652-.128l-.092-.015q-.072-.013-.146-.022A6.47 6.47 0 0 0 3 3.847V1.996H2v4h4v-1H3.406a5.48 5.48 0 0 1 5.189-2.467q.061.008.124.019l.077.012q.188.025.373.064.088.02.173.044l.063.017q.16.041.317.09.115.04.227.084l.016.006a6 6 0 0 1 .523.232 5.4 5.4 0 0 1 .736.452l.03.022q.09.066.178.134.12.098.235.204l.05.044a4 4 0 0 1 .36.364l.012.013A5.496 5.496 0 1 1 2.5 7.996h-1A6.5 6.5 0 1 0 12.975 3.82"/><path fill="currentColor" d="M10.088 11.746 7.293 8.95V4.246h1v4.29l2.5 2.505z"/></svg>', 'home': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="m13.55 5.5-5-3.33C8.38 2.06 8.19 2 7.99 2s-.39.06-.56.17L2.45 5.5c-.28.19-.45.5-.45.83v6.66c0 .55.45 1 1 1h4V12c0-.56.45-1.01 1-1.01s1 .45 1 1.01v1.99h4c.55 0 1-.45 1-1V6.33c0-.33-.17-.65-.45-.83"/></svg>', 'home-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="m13.55 5.5-5-3.33C8.38 2.06 8.19 2 7.99 2s-.39.06-.56.17L2.45 5.5c-.28.19-.45.5-.45.83v6.66c0 .55.45 1 1 1h10c.55 0 1-.45 1-1V6.33c0-.33-.17-.65-.45-.83m-.56 7.5h-4v-1c0-.55-.45-1-1-1s-1 .45-1 1v1H3V6.33L8 3l5 3.33V13z"/></svg>', 'info-circle': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0m-7.75 4V7h1.5v5zm0-8v1.5h1.5V4z" clip-rule="evenodd"/></svg>', 'info-circle-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M7.25 12V7h1.5v5zm0-8v1.5h1.5V4z"/><path fill="currentColor" fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14m6-7A6 6 0 1 0 2 8a6 6 0 0 0 12 0" clip-rule="evenodd"/></svg>', 'interrogation-circle': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M15.039 8.146a7 7 0 1 1-14 0 7 7 0 0 1 14 0m-6.974-.5a1 1 0 1 0-.942-1.335l-1.43-.458A2.501 2.501 0 1 1 8.79 9.04v.606h-1.5v-2zm-.026 3a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/></svg>', 'interrogation-circle-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M7.824 7.646a1 1 0 1 0-.943-1.335l-1.429-.458A2.501 2.501 0 1 1 8.548 9.04v.606h-1.5v-2zm-.776 3.75a.75.75 0 1 1 1.5 0 .75.75 0 0 1-1.5 0"/><path fill="currentColor" fill-rule="evenodd" d="M7.798 15.146a7 7 0 1 0 0-14 7 7 0 0 0 0 14m0-1a6 6 0 1 0 0-12 6 6 0 0 0 0 12" clip-rule="evenodd"/></svg>', 'key': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M8.44 6.67a3.994 3.994 0 0 0-5.1-2.44A3.986 3.986 0 0 0 .9 9.33 3.994 3.994 0 0 0 6 11.77c1.14-.4 2.04-1.3 2.44-2.44h2.89V12H14V9.33h1.33V6.67zM4.67 9.33c-.73 0-1.33-.6-1.33-1.33s.6-1.33 1.33-1.33S6 7.27 6 8s-.58 1.32-1.31 1.33z"/></svg>', 'laptop': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M6.5 5a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1z"/><path fill="currentColor" fill-rule="evenodd" d="M3 3a1 1 0 0 0-1 1v7a1 1 0 0 0 1 1H1a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1h-2a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1zm10 1H3v7h10z" clip-rule="evenodd"/></svg>', 'layers': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M7.763 8.94a.5.5 0 0 0 .474 0l6.5-3.5a.5.5 0 0 0 0-.88l-6.5-3.5a.5.5 0 0 0-.474 0l-6.5 3.5a.5.5 0 0 0 0 .88zM8 7.932 2.555 5 8 2.068 13.445 5zM8 12a.5.5 0 0 1-.237-.06l-6.5-3.5.474-.88L8 10.932l6.263-3.372.474.88-6.5 3.5A.5.5 0 0 1 8 12m0 3a.5.5 0 0 1-.237-.06l-6.5-3.5.474-.88L8 13.932l6.263-3.372.474.88-6.5 3.5A.5.5 0 0 1 8 15" clip-rule="evenodd"/></svg>', 'life-ring': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M8 15a6.97 6.97 0 0 0 4.192-1.394 7 7 0 0 0 1.315-1.284A6.97 6.97 0 0 0 15 8a6.97 6.97 0 0 0-1.394-4.192 7 7 0 0 0-1.414-1.414A6.97 6.97 0 0 0 8 1a6.97 6.97 0 0 0-4.192 1.394 7 7 0 0 0-1.414 1.414A6.97 6.97 0 0 0 1 8a6.97 6.97 0 0 0 1.394 4.192c.368.493.8.935 1.284 1.315A6.97 6.97 0 0 0 8 15m3.446-4.968 1.445 1.444a6 6 0 0 1-1.415 1.415l-1.444-1.445a4 4 0 0 0 1.414-1.414m-6.892 0a4 4 0 0 0 1.414 1.414l-1.445 1.445a6 6 0 0 1-1.414-1.415zm1.414-5.478a4 4 0 0 0-1.414 1.414L3.109 4.523A6 6 0 0 1 4.523 3.11zm5.509-1.445-1.445 1.445a4 4 0 0 1 1.414 1.414l1.445-1.445a6 6 0 0 0-1.415-1.414M8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6" clip-rule="evenodd"/></svg>', 'lines-rectangle': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M3 2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zm2 4h6v1H5zm4 3H5v1h4z" clip-rule="evenodd"/></svg>', 'lines-rectangle-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M5 6h6v1H5zm4 3H5v1h4z"/><path fill="currentColor" fill-rule="evenodd" d="M4 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zm8 1H4v12h8z" clip-rule="evenodd"/></svg>', 'link': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M13.65 2.727a3 3 0 0 1 .975.653 3 3 0 0 1 .01 4.24l-4 4a3 3 0 0 1-2.135.88 3 3 0 0 1-2.125-.865 3 3 0 0 1 0-4.25l.71-.71.705.71-.705.71a2.003 2.003 0 1 0 2.835 2.83l4-4a2.006 2.006 0 0 0-.65-3.27 2.005 2.005 0 0 0-2.185.435l-.71-.71a3 3 0 0 1 3.275-.653M1.66 11.76a2 2 0 0 0 .435.65 2 2 0 0 0 2.835 0l.71.71A3.04 3.04 0 0 1 3.5 14a3 3 0 0 1-2.13-.85 3 3 0 0 1 0-4.255l4-4A3.009 3.009 0 0 1 9.625 9.15l-1.06 1.06-.71-.71 1.06-1.075A2 2 0 0 0 9.5 7a1.97 1.97 0 0 0-1.22-1.86 2 2 0 0 0-2.185.435l-4 4a2 2 0 0 0-.436 2.185" clip-rule="evenodd"/></svg>', 'list': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M5 3h9v1H5zm0 9h9v1H5zm9-4.5H5v1h9zm-12 0h1v1H2zM3 3H2v1h1zm-1 9h1v1H2z" clip-rule="evenodd"/></svg>', 'loader': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-opacity=".2" d="M13.657 8A5.657 5.657 0 1 1 2.343 8a5.657 5.657 0 0 1 11.314 0M3.475 8a4.526 4.526 0 1 0 9.05 0 4.526 4.526 0 0 0-9.05 0"/><path fill="currentColor" d="M2.343 8A5.657 5.657 0 0 1 8 2.343v1.132A4.525 4.525 0 0 0 3.475 8z"/></svg>', 'location': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M8 14.997c2.5-2.5 5-6.236 5-8.997A5 5 0 0 0 3 6c0 2.761 2.5 6.496 5 8.997m0-7.499a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" clip-rule="evenodd"/></svg>', 'location-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M10 6.002a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-1 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M13 6.002c0 2.506-2.06 5.814-4.309 8.273q-.344.376-.691.723a23 23 0 0 1-.691-.723C5.059 11.816 3 8.508 3 6.002a5 5 0 0 1 10 0m-1 0c0 1.116-.52 2.554-1.424 4.088A21.5 21.5 0 0 1 8 13.55a21.5 21.5 0 0 1-2.576-3.459C4.52 8.556 4 7.118 4 6.002a4 4 0 1 1 8 0" clip-rule="evenodd"/></svg>', 'lock': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M5 4v3H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-1V4a3 3 0 0 0-6 0m5 3V4a2 2 0 1 0-4 0v3zm-2 3a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/></svg>', 'lock-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M8 10a1 1 0 1 0 0 2 1 1 0 0 0 0-2"/><path fill="currentColor" fill-rule="evenodd" d="M5 4v3H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-1V4a3 3 0 0 0-6 0m5 3V4a2 2 0 1 0-4 0v3zm2 1v6H4V8z" clip-rule="evenodd"/></svg>', 'log-in': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M8 13v1h5a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H8v1h5v10z"/><path fill="currentColor" d="m9.086 8.5-1.793 1.793L8 11l3-3-3-3-.707.707L9.086 7.5H2v1z"/></svg>', 'log-out': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="m12.086 8.5-1.793 1.793L11 11l3-3-3-3-.707.707L12.086 7.5H5v1z"/><path fill="currentColor" d="M8 3V2H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h5v-1H3V3z"/></svg>', 'magnifying-glass': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M2 7a5 5 0 1 1 8.872 3.164l3.127 3.128-.707.707-3.128-3.128A5 5 0 0 1 2 7m5 4a4 4 0 1 1 0-8 4 4 0 0 1 0 8" clip-rule="evenodd"/></svg>', 'mail': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M1.007 4.002v8.011a1 1 0 0 0 1 1h11.997a1 1 0 0 0 1-1V4l-7 5z"/><path fill="currentColor" d="m1.52 3.14 6.484 4.63 6.485-4.632a1 1 0 0 0-.486-.126H2.008a1 1 0 0 0-.487.127"/></svg>', 'mail-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M1 3.999v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-8A1 1 0 0 0 14.001 3H2a1 1 0 0 0-1 .999m13 .713-6 4.28-6-4.28V12h12zM2.724 4 8 7.764 13.276 4z" clip-rule="evenodd"/></svg>', 'messages-square': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M12 10v1.017a1 1 0 0 1-1.006 1L8 12l-4 2v-1.978H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1V4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1zm1-6H5v1h6a1 1 0 0 1 1 1v3h1zm-3 3H4v1h6zM4 9h3v1H4z" clip-rule="evenodd"/></svg>', 'messages-square-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M4 7h6v1H4zm0 2h3v1H4z"/><path fill="currentColor" fill-rule="evenodd" d="M12 10v1.017a1 1 0 0 1-1.006 1L8 12l-4 2v-1.978H3a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1h1V4a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v5a1 1 0 0 1-1 1zm1-6H5v1h6a1 1 0 0 1 1 1v3h1zm-5.233 6.999L5 12.382v-1.36H3V6h8v5.017z" clip-rule="evenodd"/></svg>', 'mobile': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M3 2a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zm4 10a1 1 0 1 1 2 0 1 1 0 0 1-2 0M6 3.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5" clip-rule="evenodd"/></svg>', 'mobile-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M7 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0M6 3.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5"/><path fill="currentColor" fill-rule="evenodd" d="M4 1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1zm8 1H4v12h8z" clip-rule="evenodd"/></svg>', 'notes': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M13 4h-1V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h1v1a1 1 0 0 0 1 1h5v-4h4V5a1 1 0 0 0-1-1M3 3h8v1H5a1 1 0 0 0-1 1v6H3zm9 4H6v1h6zM6 9h3v1H6z" clip-rule="evenodd"/><path fill="currentColor" d="m11 14 3-3h-3z"/></svg>', 'notes-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M12 7H6v1h6zM9 9H6v1h3z"/><path fill="currentColor" fill-rule="evenodd" d="M13 4h-1V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h1v1a1 1 0 0 0 1 1h6l3-3V5a1 1 0 0 0-1-1M3 3h8v1H5a1 1 0 0 0-1 1v6H3zm10 2H5v8h5v-3h3zm-.414 6L11 12.586V11z" clip-rule="evenodd"/></svg>', 'paper-plane': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M13.855 2.145a.5.5 0 0 0-.525-.115l-11 4a.5.5 0 0 0 0 .935L6.625 8.68l3.17-3.18.705.705L7.315 9.39l1.72 4.295A.5.5 0 0 0 9.5 14a.5.5 0 0 0 .46-.33l4-11a.5.5 0 0 0-.105-.525"/></svg>', 'paper-plane-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M13.855 2.145a.5.5 0 0 0-.525-.115l-11 4a.5.5 0 0 0 0 .935l4.8 1.92 1.92 4.8A.5.5 0 0 0 9.5 14a.5.5 0 0 0 .46-.33l4-11a.5.5 0 0 0-.105-.525M9.5 12.1 8.105 8.6 10.5 6.205 9.795 5.5 7.38 7.915 3.9 6.5l8.765-3.165z"/></svg>', 'paper-plane-slash': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M1.705 1 15 14.295l-.7.705-4-4-1.34 3.67a.5.5 0 0 1-.46.33.5.5 0 0 1-.465-.315l-1.72-4.295L8 8.705 7.295 8l-1.67 1.68L1.33 7.965a.5.5 0 0 1 0-.935L5 5.705l-4-4zM12.97 3.67l-1.725 4.745-3.66-3.66L12.33 3.03a.5.5 0 0 1 .64.64" clip-rule="evenodd"/></svg>', 'paper-plane-slash-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M1.705 1 15 14.295l-.7.705-4-4-1.34 3.67a.5.5 0 0 1-.46.33.5.5 0 0 1-.45-.315l-1.92-4.8-4.8-1.92a.5.5 0 0 1 0-.935L5 5.705l-4-4zM5.77 6.5l-2.87 1 3.48 1.415L7.295 8zm1.335 3.1L8.5 13.1l1-2.87L8 8.705zm4.56-5.265-3.82 1.39-.78-.78L12.33 3.03a.5.5 0 0 1 .64.64l-1.915 5.265-.78-.78z" clip-rule="evenodd"/></svg>', 'paperclip': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="m6.57 12.358 6.09-6.09a1.035 1.035 0 1 0-1.465-1.463l-5.32 5.32-.733-.731 5.321-5.321A2.07 2.07 0 1 1 13.391 7l-5.339 5.34-.006.006-.744.744A3.106 3.106 0 0 1 2.91 8.698L9.608 2l.732.732L3.642 9.43a2.07 2.07 0 1 0 2.928 2.928"/></svg>', 'pen': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M10.88 2.293a1 1 0 0 1 1.415 0l1.414 1.414a1 1 0 0 1 0 1.414l-1.414 1.415-2.828-2.829zm.705 4.953L8.756 4.417 2 11.174l.003 2.825 2.825.003z"/></svg>', 'pen-circle': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14m-3.692-3.307v-1.54l4.538-4.539 1.54 1.54-4.538 4.539zm7.268-6.312a.42.42 0 0 1 0 .583l-.753.753-1.54-1.54.747-.753a.42.42 0 0 1 .583 0z" clip-rule="evenodd"/></svg>', 'pen-fancy': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M3.63 8.65c-.24.07-.43.26-.5.5l-1.46 4.37.11.12 2.3-2.3v-.19c0-.44.35-.8.79-.81.44 0 .8.35.81.79 0 .44-.35.8-.79.81h-.21l-2.3 2.3.12.11 4.37-1.46c.24-.07.43-.26.5-.5l.82-2.08L5.7 7.83zm7.17-6.3L6.27 7.28 8.69 9.7l4.94-4.52c2.1-1.86-.99-4.92-2.83-2.83"/></svg>', 'pen-fancy-files-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M12 2H6v10h6V8.946l.023-.058.085-.078.892-.813V12a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v.112a2.3 2.3 0 0 0-.974.66L12 2.8zm1 4.643-1 .913-.566.515-1.528-1.524L12 4.275l.767-.832q.113-.127.233-.215c1.167-.857 2.797.9 1.555 1.997zM4 3H3v11.5a.5.5 0 0 0 .5.5H11v-1H4zm4.238 4.41a.47.47 0 0 0-.316.315L7 10.477l.07.076 1.452-1.449v-.12a.51.51 0 0 1 .5-.51.51.51 0 0 1 .511.498.51.51 0 0 1-.499.51h-.133L7.45 10.931l.075.069 2.76-.92a.47.47 0 0 0 .317-.314l.518-1.31-1.573-1.562z" clip-rule="evenodd"/></svg>', 'pen-fancy-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M12.24 1.67c-.49 0-1 .21-1.44.7L6.27 7.3l2.42 2.42 4.94-4.52c1.6-1.42.19-3.53-1.39-3.53M8.72 8.34 7.66 7.28l3.9-4.24c.22-.24.44-.36.69-.36.41 0 .87.34 1.03.78.14.37.04.7-.32 1.02L8.73 8.36zM5.7 7.86l-2.08.82c-.24.08-.42.26-.5.5l-1.46 4.37.12.12.56.56.12.12 4.37-1.46c.24-.08.42-.26.5-.5l.81-2.08L5.7 7.87zm-2.57 4.46L4 9.72c.03-.08.09-.15.17-.18l1.29-.51 1.52 1.52-.5 1.29c-.03.08-.1.15-.19.18l-2.6.87.95-.95c.06.02.12.04.19.04.44 0 .79-.35.79-.79s-.35-.79-.79-.79-.79.35-.79.79c0 .07.02.13.04.19l-.95.95z"/></svg>', 'pen-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M12.295 2.293a1 1 0 0 0-1.414 0L9.467 3.707l2.828 2.829 1.414-1.415a1 1 0 0 0 0-1.414z"/><path fill="currentColor" fill-rule="evenodd" d="m2.003 13.999 2.825.003 6.757-6.756-2.829-2.829L2 11.174zM3 11.587l5.756-5.755 1.414 1.414-5.755 5.756L3.002 13z" clip-rule="evenodd"/></svg>', 'phone': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="m10 10.53 1.034-1.035a1.01 1.01 0 0 1 1.08-.221l1.259.503A1.01 1.01 0 0 1 14 10.7v2.308a1 1 0 0 1-1.052.992C4.124 13.45 2.343 5.974 2.006 3.112A1.002 1.002 0 0 1 3.007 2h2.228a1 1 0 0 1 .923.628l.503 1.26a1 1 0 0 1-.217 1.08L5.41 6.002s.595 4.029 4.59 4.527"/></svg>', 'phone-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M12.62 14h-.079C3.472 13.479 2.184 5.826 2.004 3.49A1.384 1.384 0 0 1 3.278 2h2.543a.92.92 0 0 1 .859.582l.701 1.726a.92.92 0 0 1-.203.997l-.983.992a4.325 4.325 0 0 0 3.499 3.508l1.001-.993a.92.92 0 0 1 1.002-.189l1.74.697a.92.92 0 0 1 .567.858v2.437A1.385 1.385 0 0 1 12.62 14M3.389 2.923a.46.46 0 0 0-.462.462v.037c.213 2.732 1.574 9.193 9.665 9.655a.46.46 0 0 0 .49-.434v-2.465l-1.74-.696-1.325 1.315-.222-.028c-4.015-.503-4.56-4.518-4.56-4.56l-.028-.221 1.311-1.325-.692-1.74z"/></svg>', 'picture': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M14 3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1zM4 5a1 1 0 1 0 2 0 1 1 0 0 0-2 0m7.134 2.514L13 10.023V13H3v-2.494l.896-1.064c.203-.242.305-.362.425-.408a.5.5 0 0 1 .358 0c.12.046.222.166.425.408l1.767 2.098 2.995-4.026c.21-.282.316-.423.444-.476a.5.5 0 0 1 .38 0c.129.053.234.194.444.476" clip-rule="evenodd"/></svg>', 'picture-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M5 6a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/><path fill="currentColor" fill-rule="evenodd" d="M14 13a1 1 0 0 1-1 1H2h.994A1 1 0 0 1 2 13V3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1zM3 3h10v5.315l-1.069-1.43a6 6 0 0 0-.29-.368 1.5 1.5 0 0 0-.555-.41 1.5 1.5 0 0 0-1.14-.001c-.27.11-.448.288-.556.408-.098.11-.2.246-.291.366L6.822 9.911l-.974-1.14a5 5 0 0 0-.283-.314 1.5 1.5 0 0 0-.53-.353 1.5 1.5 0 0 0-1.064 0c-.248.094-.42.245-.529.352a5 5 0 0 0-.283.314L3 8.956zm0 10v-2.506l.903-1.055c.202-.237.303-.355.423-.4a.5.5 0 0 1 .355 0c.12.045.22.164.422.4l1.769 2.07 3.01-4.006c.21-.28.315-.42.443-.472a.5.5 0 0 1 .38 0c.127.053.232.193.441.474L13 9.985V13z" clip-rule="evenodd"/></svg>', 'play-circle': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1m3.724 7.447-6 3A.5.5 0 0 1 5 11V5a.5.5 0 0 1 .724-.447l6 3a.5.5 0 0 1 0 .894"/></svg>', 'plus': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M9 2H7v5H2v2h5v5h2V9h5V7H9z"/></svg>', 'plus-circle': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14M7 7V4h2v3h3v2H9v3H7V9H4V7z" clip-rule="evenodd"/></svg>', 'share': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M14 4.5a2.5 2.5 0 0 1-4.467 1.543L6.915 7.35a2.5 2.5 0 0 1 0 1.298l2.618 1.308a2.5 2.5 0 1 1-.448.894L6.467 9.544a2.5 2.5 0 1 1 0-3.085l2.618-1.31A2.503 2.503 0 0 1 11.5 2 2.5 2.5 0 0 1 14 4.5"/></svg>', 'share-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M13 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m1 0a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0M6 8a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m.623 1.32a2.5 2.5 0 1 1-.156-2.863L9.085 5.15c.088.33.243.633.448.894L6.915 7.35a2.5 2.5 0 0 1 0 1.298l2.618 1.308a2.5 2.5 0 1 1-.448.894L6.467 9.544q.084-.107.156-.223M11.5 13a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" clip-rule="evenodd"/></svg>', 'shuffle': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="m11.295 9.705 1.79 1.795h-3.31L7.59 8l2.185-3.5h3.31l-1.79 1.795L12 7l3-3-3-3-.705.705 1.79 1.795h-3.31a1 1 0 0 0-.845.47L7 7.055 5.07 3.97a1 1 0 0 0-.845-.47H1v1h3.225L6.41 8l-2.185 3.5H1v1h3.225a1 1 0 0 0 .845-.47L7 8.945l1.93 3.085a1 1 0 0 0 .845.47h3.31l-1.79 1.795L12 15l3-3-3-3z"/></svg>', 'sitemap': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M3.33 10h-2c-.37 0-.66.3-.66.67v2c0 .36.3.65.66.66h2c.37 0 .66-.29.67-.66v-2c0-.37-.3-.67-.67-.67m-.5-1.67H7.5v1h1v-1h4.67v1h1v-1.2c0-.44-.36-.8-.8-.8H8.5V6h.83c.37 0 .67-.3.67-.67v-2c0-.37-.3-.66-.67-.66H6.67c-.37 0-.66.29-.67.66v2c0 .37.3.67.67.67h.83v1.33H2.63c-.44 0-.8.36-.8.8v1.2h1zM9 10H7c-.37 0-.67.3-.67.67v2c0 .37.3.66.67.66h2c.37 0 .66-.29.67-.66v-2c0-.37-.3-.67-.67-.67m5.67 0h-2c-.37 0-.67.3-.67.67v2c0 .37.3.66.67.66h2c.36 0 .65-.3.66-.66v-2c0-.37-.29-.66-.66-.67"/></svg>', 'sliders': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M12.95 4H15v1h-2.05v.002a2.5 2.5 0 0 1-2.672 1.988A2.52 2.52 0 0 1 8.05 5.002V5H1V4h7.05v-.002a2.5 2.5 0 0 1 2.672-1.988 2.52 2.52 0 0 1 2.228 1.988zm-9.9 8H1v-1h2.05v-.002A2.52 2.52 0 0 1 5.5 9a2.5 2.5 0 0 1 2.45 1.999V11H15v1H7.95v.002A2.52 2.52 0 0 1 5.5 14a2.5 2.5 0 0 1-2.45-1.998z"/></svg>', 'sliders-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M12.95 4H15v1h-2.05c-.25 1.15-1.25 2-2.45 2s-2.2-.85-2.45-2H1V4h7.05C8.3 2.85 9.3 2 10.5 2s2.2.85 2.45 2M9 4.5c0 .85.65 1.5 1.5 1.5S12 5.35 12 4.5 11.35 3 10.5 3 9 3.65 9 4.5M3.05 12H1v-1h2.05C3.3 9.85 4.3 9 5.5 9s2.2.85 2.45 2H15v1H7.95c-.25 1.15-1.25 2-2.45 2s-2.2-.85-2.45-2M7 11.5c0-.85-.65-1.5-1.5-1.5S4 10.65 4 11.5 4.65 13 5.5 13 7 12.35 7 11.5" clip-rule="evenodd"/></svg>', 'squares': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M2 3a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1zm7 0a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1zm0 7a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1zm-7 0a1 1 0 0 1 1-1h3a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1z"/></svg>', 'star': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" stroke="currentColor" d="m8 2.472 1.715 3.475.116.235.26.038 3.835.557-2.775 2.705-.188.183.044.26.655 3.818-3.43-1.803L8 11.818l-.233.122-3.43 1.803.656-3.818.044-.26-.188-.183-2.775-2.705L5.91 6.22l.26-.038.116-.235z"/></svg>', 'star-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path stroke="currentColor" d="m8 2.472 1.715 3.475.116.235.26.038 3.835.557-2.775 2.705-.188.183.044.26.655 3.818-3.43-1.803L8 11.818l-.233.122-3.43 1.803.656-3.818.044-.26-.188-.183-2.775-2.705L5.91 6.22l.26-.038.116-.235z"/></svg>', 'table': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M2 13a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1zm1-3v3h3v-3zm4 0v3h6v-3zm6-1H7V6h6zM6 9H3V6h3zM3 5V3h10v2z" clip-rule="evenodd"/></svg>', 'tag': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M2 7.43c0 .275.11.538.303.732l5.535 5.535c.404.404 1.06.404 1.464 0l4.395-4.395a1.036 1.036 0 0 0 0-1.464L8.162 2.303A1.04 1.04 0 0 0 7.43 2H3.036C2.464 2 2 2.464 2 3.036zM5.5 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" clip-rule="evenodd"/></svg>', 'tag-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M5.5 7a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m0-1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M2 7.43c0 .275.11.538.303.732l5.535 5.535c.404.404 1.06.404 1.464 0l4.395-4.395a1.036 1.036 0 0 0 0-1.464L8.162 2.303A1.04 1.04 0 0 0 7.43 2H3.036C2.464 2 2 2.464 2 3.036zm1 0q0 .016.01.025l5.535 5.534a.036.036 0 0 0 .05 0l4.394-4.394a.036.036 0 0 0 0-.05L7.456 3.01A.04.04 0 0 0 7.43 3H3.036A.036.036 0 0 0 3 3.036z" clip-rule="evenodd"/></svg>', 'tags': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M13.855 6.645 8.5 1.295A1 1 0 0 0 7.795 1H4a1 1 0 0 0-1 1v1h1V2h3.795l5 5-.65.645.71.71 1-1a.5.5 0 0 0 0-.71"/><path fill="currentColor" fill-rule="evenodd" d="M2 8.978c0 .251.1.493.278.67l5.073 5.074a.95.95 0 0 0 1.343 0l4.028-4.028a.95.95 0 0 0 0-1.343L7.649 4.278A.95.95 0 0 0 6.978 4H2.949A.95.95 0 0 0 2 4.95zM5.5 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3" clip-rule="evenodd"/></svg>', 'tags-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="m8.5 1.295 5.355 5.35a.5.5 0 0 1 0 .71l-1 1-.71-.71.65-.645-5-5H4v1H3V2a1 1 0 0 1 1-1h3.795a1 1 0 0 1 .705.295"/><path fill="currentColor" fill-rule="evenodd" d="M5.5 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3m0-1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M2.278 9.649A.95.95 0 0 1 2 8.978V4.949A.95.95 0 0 1 2.95 4h4.028c.251 0 .493.1.67.278l5.074 5.073a.95.95 0 0 1 0 1.343l-4.028 4.028a.95.95 0 0 1-1.343 0zm5.744 4.33L3 8.957V5h3.957l5.022 5.022z" clip-rule="evenodd"/></svg>', 'thumb-down': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M11.202 11.934a1.506 1.506 0 0 1-2.438 1.651L5.5 10.461v-8.46h4.922c1.081 0 2.058.714 2.484 1.817l.944 3.394c.51 1.32-.362 2.788-1.656 2.788h-1.772zM4.5 10H2V2h2.5z"/></svg>', 'thumb-down-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M11.204 11.934 10.424 10h1.772c1.294 0 2.166-1.468 1.656-2.788l-.944-3.394C12.484 2.715 11.507 2 10.426 2H5v.003H2v8h3.023l3.744 3.582a1.506 1.506 0 0 0 2.437-1.651m.755-7.797C11.657 3.4 11.033 3 10.425 3H6.002l.017 6.572 3.439 3.29a.506.506 0 0 0 .819-.554L8.943 9h3.253c.24 0 .48-.131.645-.41.167-.28.218-.657.079-1.018l-.018-.045zM3 9.003h2v-6H3z" clip-rule="evenodd"/></svg>', 'thumb-up': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M11.202 4.069a1.506 1.506 0 0 0-2.438-1.651L5.5 5.542v8.46h4.922c1.081 0 2.058-.714 2.484-1.817l.944-3.394c.51-1.32-.362-2.788-1.656-2.788h-1.772zM4.5 6.003H2v8h2.5z"/></svg>', 'thumb-up-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="m11.204 4.069-.78 1.934h1.772c1.294 0 2.166 1.468 1.656 2.788l-.944 3.394c-.425 1.103-1.402 1.818-2.483 1.818H5V14H2V6h3.023l3.744-3.582a1.506 1.506 0 0 1 2.437 1.65m.755 7.797c-.302.738-.926 1.137-1.534 1.137H6.002L6.02 6.43l3.439-3.29a.506.506 0 0 1 .819.554L8.943 7.003h3.253c.24 0 .48.13.645.41.167.28.218.657.079 1.018l-.018.045zM3 7h2v6H3z" clip-rule="evenodd"/></svg>', 'thumbtack': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="m8.91 2-1.2 3.594L2.364 7.09 5.274 10l-.707.706-1.687 1.687-.264.264-.09.09-.209.498L2 14l.755-.317.498-.21.09-.089.264-.264 1.687-1.687.706-.706 2.91 2.908 1.496-5.347L14 7.09z" clip-rule="evenodd"/></svg>', 'thumbtack-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="m5.273 10-2.91 2.91L2 14l1.09-.364L6 10.727l2.91 2.91 1.496-5.348L14 7.09 8.91 2l-1.2 3.594L2.364 7.09zm3.241-3.563-4.18 1.17 4.059 4.059 1.17-4.18 2.533-.845-2.737-2.737z" clip-rule="evenodd"/></svg>', 'trash': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M11 2v1h3v1h-1v10a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V4H2V3h3V2a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1M6 3V2h4v1zm1 3H6v6h1zm2 0h1v6H9z" clip-rule="evenodd"/></svg>', 'trash-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M7 6H6v6h1zm2 0h1v6H9z"/><path fill="currentColor" fill-rule="evenodd" d="M11 3V2a1 1 0 0 0-1-1H6a1 1 0 0 0-1 1v1H2v1h1v10a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V4h1V3zM6 2v1h4V2zm6 2v10H4V4z" clip-rule="evenodd"/></svg>', 'universal-access': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M15 8A7 7 0 1 1 1 8a7 7 0 0 1 14 0m-3.5-1V6h-7v1H7v1.367l-1.934 3.385.868.496L7.79 9h.42l1.856 3.248.868-.496L9 8.367V7zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" clip-rule="evenodd"/></svg>', 'universal-access-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M4.111 13.82A7 7 0 0 0 8 15a7.01 7.01 0 0 0 7-7 7 7 0 1 0-10.889 5.82m.556-10.809A6 6 0 0 1 8 2a6.007 6.007 0 0 1 6 6 6 6 0 1 1-9.333-4.989M8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2M11.5 7V6h-7v1H7v1.367l-1.934 3.385.868.496L7.79 9h.42l1.856 3.248.868-.496L9 8.367V7z" clip-rule="evenodd"/></svg>', 'unlink': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M6.5 1h-1v2h1zM1.792 2.501l.707-.707L4.207 3.5l-.707.707zm9.998 9.995.708-.707 1.707 1.708-.707.707zM1 5.5h2v1H1zm14 4h-2v1h2zM9.5 13h1v2h-1zm-1.21-2.465-1.855 1.86a2.002 2.002 0 0 1-2.83-2.83l1.86-1.86L4.755 7 2.9 8.86a3 3 0 0 0-.03 4.27A3 3 0 0 0 5 14a3.04 3.04 0 0 0 2.16-.9L9 11.245zm1.275-6.93-1.86 1.86L7 4.755 8.84 2.9A3.04 3.04 0 0 1 11 2a3 3 0 0 1 2.13.87 3 3 0 0 1-.03 4.27L11.245 9l-.71-.705 1.86-1.86a2.002 2.002 0 0 0-2.83-2.83"/></svg>', 'unlock': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M10 7V4a2 2 0 1 0-4 0v1H5V4a3 3 0 0 1 6 0v3h1a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1zm-3 4a1 1 0 1 1 2 0 1 1 0 0 1-2 0" clip-rule="evenodd"/></svg>', 'unlock-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M8 10a1 1 0 1 0 0 2 1 1 0 0 0 0-2"/><path fill="currentColor" fill-rule="evenodd" d="M10 4v3H4a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V8a1 1 0 0 0-1-1h-1V4a3 3 0 0 0-6 0v1h1V4a2 2 0 1 1 4 0m2 4v6H4V8z" clip-rule="evenodd"/></svg>', 'upload': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M3.706 6.703 3 6l5-5 5 5-.704.702L8.5 2.912V12h-1V2.913zM13 14v-2h1v2a1 1 0 0 1-1 1H3a1 1 0 0 1-.996-1.002L2 14v-2h1v2z" clip-rule="evenodd"/></svg>', 'user': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6M6 9a4 4 0 0 0-4 4 1 1 0 0 0 1 1h10a1 1 0 0 0 1-1 4 4 0 0 0-4-4z" clip-rule="evenodd"/></svg>', 'user-circle': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M8.01 1C4.146.99 1.01 4.128 1 7.99c0 3.863 3.128 7 6.99 7.01 3.853 0 6.99-3.109 7.01-6.962C15.019 4.176 11.9 1.02 8.038 1zm0 .715a6.28 6.28 0 0 1 6.275 6.295v.028a6.2 6.2 0 0 1-1.135 3.586 2.59 2.59 0 0 0-2.537-2.26H9.478a3.44 3.44 0 0 1-2.937 0H5.415a2.573 2.573 0 0 0-2.546 2.26 6.2 6.2 0 0 1-1.135-3.586 6.284 6.284 0 0 1 6.247-6.323zM5.147 5.778a2.914 2.914 0 0 1 2.91-2.909 2.914 2.914 0 0 1 2.908 2.909 2.914 2.914 0 0 1-2.909 2.909H8.01a2.917 2.917 0 0 1-2.86-2.91"/></svg>', 'user-group': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M12.95 4.066a1.42 1.42 0 0 0-1.426 1.406c0 .789.626 1.415 1.406 1.425s1.415-.626 1.425-1.406a1.42 1.42 0 0 0-1.406-1.425m-9.668.01a1.415 1.415 0 0 0-1.521 1.53 1.415 1.415 0 0 0 2.821 0 1.43 1.43 0 0 0-1.3-1.53m7.087.375a2.38 2.38 0 0 0-1.647-1.685 2.496 2.496 0 0 0-3.1 1.656 2.53 2.53 0 0 0 .135 1.781A2.39 2.39 0 0 0 7.99 7.6a2.47 2.47 0 0 0 2.379-3.148m-.684 3.851h-.183a3.39 3.39 0 0 1-3.014 0h-.183a2.54 2.54 0 0 0-2.542 2.542v2.59A6.96 6.96 0 0 0 7.99 14.85c1.59 0 3.053-.53 4.237-1.425v-2.58a2.54 2.54 0 0 0-2.542-2.543M15 8.543a7 7 0 0 1-1.589 3.765 3 3 0 0 1-.24.27c-.077.086-.164.173-.241.26v-.53h.029v-.693s.01-.068 0-.097v-.635a3.25 3.25 0 0 0-1.695-2.889c.26-.25.607-.395.963-.395h1.454c.607.01 1.126.395 1.319.944M3.041 10.844v1.464h.01v.53l-.27-.3c-.077-.076-.144-.153-.212-.23A6.97 6.97 0 0 1 1 8.63 1.38 1.38 0 0 1 2.348 7.6h1.415a1.4 1.4 0 0 1 .973.356 3.25 3.25 0 0 0-1.695 2.888"/></svg>', 'user-lock': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M6.5 7a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5M5 8a4 4 0 0 0-4 4 1 1 0 0 0 1 1h7v-1.5a1.5 1.5 0 0 1 1.036-1.427c.109-.63.452-1.178.938-1.553A4 4 0 0 0 9 8z"/><path fill="currentColor" fill-rule="evenodd" d="M10.5 11h.5v-.5a1.5 1.5 0 0 1 3 0v.5h.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5m2.75-.5v.5h-1.5v-.5a.75.75 0 0 1 1.5 0" clip-rule="evenodd"/></svg>', 'user-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0m-1 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-8 8a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4 1 1 0 0 1-1 1H3a1 1 0 0 1-1-1m1 0a3 3 0 0 1 3-3h4a3 3 0 0 1 3 3z" clip-rule="evenodd"/></svg>', 'user-pen-fancy-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M7.5 7a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5m0-4C6.67 3 6 3.67 6 4.5S6.67 6 7.5 6 9 5.33 9 4.5 8.33 3 7.5 3m3.62 8.46-.22.54-.3.77s-.04.09-.06.13c-.03.04-.06.07-.1.1-.05.04-.1.07-.16.08L7.52 14l-.07-.07 1.45-1.45h.13c.15 0 .27-.06.36-.16a.6.6 0 0 0 .1-.15c.01-.02.02-.04.03-.07v-.02s.01-.05.01-.08v-.03c0-.28-.23-.5-.51-.5-.28.01-.5.24-.5.51v.14l-.76.75-.14.13-.55.55-.07-.07.16-.48.1-.29.24-.71.42-1.27c.05-.16.17-.28.32-.32l1.31-.52zm3.44-3.24-2.05 1.87-.7.64-.06.05-.32.29-1.52-1.52.28-.31.06-.06.64-.7 1.88-2.04c1.16-1.31 3.11.61 1.79 1.78"/><path fill="currentColor" fill-rule="evenodd" d="M9 8H6c-2.21 0-4 1.79-4 4 0 .55.45 1 1 1h3.11l.33-1H3c0-1.66 1.34-3 3-3h3.05l.83-.9C9.6 8.03 9.3 8 9 8" clip-rule="evenodd"/></svg>', 'user-plus': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M14 3.33h-1.35V2c-.02-.18-.17-.33-.35-.33h-.65c-.18 0-.33.15-.35.33v1.33H10c-.18 0-.33.16-.33.34v.66c0 .18.15.33.33.34h1.3V6c.02.18.17.32.35.33h.65c.18 0 .33-.15.35-.33V4.67H14a.34.34 0 0 0 .32-.34v-.66a.34.34 0 0 0-.32-.34M9.28 9.77h-.2c-1.25.51-2.66.51-3.91 0H5a3.006 3.006 0 0 0-3.3 2.67v.74c.06.67.63 1.17 1.3 1.15h8.25c.69.06 1.3-.45 1.36-1.14v-.68a3 3 0 0 0-3.23-2.75h-.1zM7.13 3.7c1.46 0 2.64 1.17 2.65 2.63 0 1.46-1.17 2.64-2.63 2.65-1.46 0-2.64-1.17-2.65-2.63A2.65 2.65 0 0 1 7.13 3.7"/></svg>', 'user-question-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M5.23 11.14c.86-.66 1.01-1.9.35-2.75s-1.9-1.01-2.75-.35a1.96 1.96 0 0 0 0 3.1c-.72.42-1.16 1.2-1.16 2.03v.8c0 .2.17.37.37.37h3.98c.2 0 .37-.17.37-.37v-.8c0-.83-.44-1.61-1.16-2.03M2.81 9.59c0-.67.55-1.22 1.22-1.22s1.22.55 1.22 1.22-.55 1.22-1.22 1.22-1.22-.55-1.22-1.22m2.83 4H2.41v-.42c0-.89.72-1.62 1.62-1.62s1.62.72 1.62 1.62v.42zm7.13-11.93H8c-.86 0-1.56.7-1.56 1.56v7.16c0 .21.17.37.37.37.08 0 .16-.03.22-.07l1.49-1.12h4.25c.86 0 1.56-.7 1.56-1.56V3.22c0-.86-.7-1.56-1.56-1.56m.82 6.33c0 .45-.37.82-.82.82H8.4a.4.4 0 0 0-.22.07l-1 .75V3.22c0-.45.37-.82.82-.82h4.77c.45 0 .82.37.82.82zm-2.8-.42c0 .23-.18.41-.41.41s-.41-.18-.41-.41.18-.41.41-.41.41.18.41.41m-.41-4.34c-.83 0-1.5.67-1.5 1.5 0 .23.18.41.41.41s.41-.18.41-.41c0-.38.31-.68.69-.68s.68.31.68.69-.31.68-.68.68c-.23 0-.41.18-.41.41v.44c0 .23.18.41.41.41s.41-.18.41-.41v-.09c.8-.23 1.26-1.06 1.04-1.85-.18-.65-.77-1.09-1.44-1.09z"/></svg>', 'user-shield': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M2.676 2.768A1 1 0 0 0 2 3.714v4.799a3 3 0 0 0 .154.949l.06.177A7 7 0 0 0 5.1 13.334l2.373 1.508a1 1 0 0 0 1.074-.001l2.361-1.507a7 7 0 0 0 2.875-3.687l.062-.185c.102-.306.154-.627.154-.949V3.714a1 1 0 0 0-.676-.946l-5-1.712a1 1 0 0 0-.648 0zM8 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4m-4.22 2.627a6 6 0 0 0 1.857 1.863l2.373 1.508 2.361-1.507a6 6 0 0 0 1.85-1.862A4 4 0 0 0 9 8.999H7c-1.32 0-2.492.641-3.22 1.628" clip-rule="evenodd"/></svg>', 'user-shield-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M10 5.998a2 2 0 1 1-4 0 2 2 0 0 1 4 0m-1 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M2 3.712a1 1 0 0 1 .676-.946l5-1.712a1 1 0 0 1 .648 0l5 1.712a1 1 0 0 1 .676.946v4.799c0 .322-.052.643-.154.949l-.062.185a7 7 0 0 1-2.875 3.687l-2.36 1.507a1 1 0 0 1-1.075 0l-2.373-1.507a7 7 0 0 1-2.888-3.695l-.06-.177A3 3 0 0 1 2 8.51zm11 0v4.799q0 .324-.103.632l-.061.186a6 6 0 0 1-.614 1.298A4 4 0 0 0 9 8.997H7c-1.32 0-2.492.64-3.22 1.628a6 6 0 0 1-.618-1.304l-.06-.178A2 2 0 0 1 3 8.511V3.712L8 2zM9 9.998a3 3 0 0 1 2.582 1.47c-.355.39-.76.734-1.21 1.021L8.01 13.996l-2.373-1.508a6 6 0 0 1-1.217-1.022A3 3 0 0 1 7 9.998z" clip-rule="evenodd"/></svg>', 'users': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M7.25 3.335a2.5 2.5 0 1 0 0 4.33A3.5 3.5 0 0 1 6.5 5.5c0-.818.28-1.57.75-2.165M10 3a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5m-5 9.2A3.2 3.2 0 0 1 8.2 9h3.6a3.2 3.2 0 0 1 3.2 3.2.8.8 0 0 1-.8.8H5.8a.8.8 0 0 1-.8-.8M5.48 9H4.2A3.2 3.2 0 0 0 1 12.2a.8.8 0 0 0 .8.8h2.387A1.8 1.8 0 0 1 4 12.2 4.19 4.19 0 0 1 5.48 9"/></svg>', 'users-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M7.5 5.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0M10 7a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3" clip-rule="evenodd"/><path fill="currentColor" d="M4.2 9h1.28a4.2 4.2 0 0 0-.858 1H4.2a2.2 2.2 0 0 0-2.191 2h1.996a4 4 0 0 0-.005.2c0 .287.067.559.187.8H1.8a.8.8 0 0 1-.8-.8A3.2 3.2 0 0 1 4.2 9"/><path fill="currentColor" fill-rule="evenodd" d="M5 12.2A3.2 3.2 0 0 1 8.2 9h3.6a3.2 3.2 0 0 1 3.2 3.2.8.8 0 0 1-.8.8H5.8a.8.8 0 0 1-.8-.8m6.8-2.2a2.2 2.2 0 0 1 2.191 2H6.009A2.2 2.2 0 0 1 8.2 10z" clip-rule="evenodd"/><path fill="currentColor" d="M6 3c.455 0 .882.122 1.25.335a3.5 3.5 0 0 0-.5.865 1.5 1.5 0 1 0 0 2.6c.125.313.294.604.5.865A2.5 2.5 0 1 1 6 3"/></svg>', 'wallet': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" fill-rule="evenodd" d="M1 4a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v1a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1zm1 0h11v1H2zm9 5a1 1 0 1 1 2 0 1 1 0 0 1-2 0" clip-rule="evenodd"/></svg>', 'wallet-outline': '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><path fill="currentColor" d="M11 9a1 1 0 1 1 2 0 1 1 0 0 1-2 0"/><path fill="currentColor" fill-rule="evenodd" d="M2 13a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h11a1 1 0 0 1 1 1v1a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1zm0-9h11v1H2zm12 2H2v6h12z" clip-rule="evenodd"/></svg>' };

const mgIconCss = ".mg-u-visually-hidden{position:absolute !important;overflow:hidden !important;width:.1rem !important;height:.1rem !important;padding:0 !important;border:0 !important;margin:-0.1rem !important;clip:rect(0.1rem, 0.1rem, 0.1rem, 0.1rem) !important;clip-path:inset(50%) !important;white-space:nowrap !important}*:focus:not(:focus-visible){outline:none}@media (prefers-reduced-motion){*{animation:none !important;transition:none !important}}/*!\n * @prop --mg-c-icon-border-radius: Defines the border radius of icons. Default value is `50%`.\n */:host{display:inline-flex;vertical-align:middle}.mg-c-icon{color:currentcolor}.mg-c-icon[size=small],.mg-c-icon.mg-c-icon--size-small{width:var(--mg-b-size-12);height:var(--mg-b-size-12)}.mg-c-icon[size=small][class*=mg-c-icon--variant-]:not(.mg-c-icon--variant-style-icon),.mg-c-icon.mg-c-icon--size-small[class*=mg-c-icon--variant-]:not(.mg-c-icon--variant-style-icon){padding:calc((var(--mg-b-size-16) - var(--mg-b-size-12))/2)}.mg-c-icon[size=medium],.mg-c-icon.mg-c-icon--size-medium{width:var(--mg-b-size-16);height:var(--mg-b-size-16)}.mg-c-icon[size=medium][class*=mg-c-icon--variant-]:not(.mg-c-icon--variant-style-icon),.mg-c-icon.mg-c-icon--size-medium[class*=mg-c-icon--variant-]:not(.mg-c-icon--variant-style-icon){padding:calc((var(--mg-b-size-24) - var(--mg-b-size-16))/2)}.mg-c-icon[size=large],.mg-c-icon.mg-c-icon--size-large{width:var(--mg-b-size-20);height:var(--mg-b-size-20)}.mg-c-icon[size=large][class*=mg-c-icon--variant-]:not(.mg-c-icon--variant-style-icon),.mg-c-icon.mg-c-icon--size-large[class*=mg-c-icon--variant-]:not(.mg-c-icon--variant-style-icon){padding:calc((var(--mg-b-size-32) - var(--mg-b-size-20))/2)}.mg-c-icon[size=xlarge],.mg-c-icon.mg-c-icon--size-xlarge{width:var(--mg-b-size-24);height:var(--mg-b-size-24)}.mg-c-icon[size=xlarge][class*=mg-c-icon--variant-]:not(.mg-c-icon--variant-style-icon),.mg-c-icon.mg-c-icon--size-xlarge[class*=mg-c-icon--variant-]:not(.mg-c-icon--variant-style-icon){padding:calc((var(--mg-b-size-40) - var(--mg-b-size-24))/2)}.mg-c-icon[size=xxlarge],.mg-c-icon.mg-c-icon--size-xxlarge{width:var(--mg-b-size-32);height:var(--mg-b-size-32)}.mg-c-icon[size=xxlarge][class*=mg-c-icon--variant-]:not(.mg-c-icon--variant-style-icon),.mg-c-icon.mg-c-icon--size-xxlarge[class*=mg-c-icon--variant-]:not(.mg-c-icon--variant-style-icon){padding:calc((var(--mg-b-size-48) - var(--mg-b-size-32))/2)}.mg-c-icon.mg-c-icon--variant-app.mg-c-icon--variant-style-icon{color:var(--mg-b-color-app)}.mg-c-icon.mg-c-icon--variant-blue.mg-c-icon--variant-style-icon{color:var(--mg-b-color-blue)}.mg-c-icon.mg-c-icon--variant-80.mg-c-icon--variant-style-icon{color:var(--mg-b-color-80)}.mg-c-icon.mg-c-icon--variant-danger.mg-c-icon--variant-style-icon{color:var(--mg-b-color-danger)}.mg-c-icon.mg-c-icon--variant-info.mg-c-icon--variant-style-icon{color:var(--mg-b-color-info)}.mg-c-icon.mg-c-icon--variant-success.mg-c-icon--variant-style-icon{color:var(--mg-b-color-success)}.mg-c-icon.mg-c-icon--variant-warning.mg-c-icon--variant-style-icon{color:var(--mg-b-color-warning)}.mg-c-icon.mg-c-icon--variant-app.mg-c-icon--variant-style-background{background-color:var(--mg-b-color--20, color-mix(in srgb, var(--mg-b-color-app), white 80%))}.mg-c-icon.mg-c-icon--variant-blue.mg-c-icon--variant-style-background{background-color:var(--mg-b-color--20, color-mix(in srgb, var(--mg-b-color-blue), white 80%))}.mg-c-icon.mg-c-icon--variant-80.mg-c-icon--variant-style-background{background-color:var(--mg-b-color--20, color-mix(in srgb, var(--mg-b-color-80), white 80%))}.mg-c-icon.mg-c-icon--variant-danger.mg-c-icon--variant-style-background{background-color:var(--mg-b-color-red-20, color-mix(in srgb, var(--mg-b-color-danger), white 80%))}.mg-c-icon.mg-c-icon--variant-info.mg-c-icon--variant-style-background{background-color:var(--mg-b-color-blue-20, color-mix(in srgb, var(--mg-b-color-info), white 80%))}.mg-c-icon.mg-c-icon--variant-success.mg-c-icon--variant-style-background{background-color:var(--mg-b-color-green-20, color-mix(in srgb, var(--mg-b-color-success), white 80%))}.mg-c-icon.mg-c-icon--variant-warning.mg-c-icon--variant-style-background{background-color:var(--mg-b-color-yellow-20, color-mix(in srgb, var(--mg-b-color-warning), white 80%))}.mg-c-icon.mg-c-icon--variant-app.mg-c-icon--variant-style-full{color:var(--mg-b-color-app);background-color:var(--mg-b-color--20, color-mix(in srgb, var(--mg-b-color-app), white 80%))}.mg-c-icon.mg-c-icon--variant-blue.mg-c-icon--variant-style-full{color:var(--mg-b-color-blue);background-color:var(--mg-b-color--20, color-mix(in srgb, var(--mg-b-color-blue), white 80%))}.mg-c-icon.mg-c-icon--variant-80.mg-c-icon--variant-style-full{color:var(--mg-b-color-80);background-color:var(--mg-b-color--20, color-mix(in srgb, var(--mg-b-color-80), white 80%))}.mg-c-icon.mg-c-icon--variant-danger.mg-c-icon--variant-style-full{color:var(--mg-b-color-danger);background-color:var(--mg-b-color-red-20, color-mix(in srgb, var(--mg-b-color-danger), white 80%))}.mg-c-icon.mg-c-icon--variant-info.mg-c-icon--variant-style-full{color:var(--mg-b-color-info);background-color:var(--mg-b-color-blue-20, color-mix(in srgb, var(--mg-b-color-info), white 80%))}.mg-c-icon.mg-c-icon--variant-success.mg-c-icon--variant-style-full{color:var(--mg-b-color-success);background-color:var(--mg-b-color-green-20, color-mix(in srgb, var(--mg-b-color-success), white 80%))}.mg-c-icon.mg-c-icon--variant-warning.mg-c-icon--variant-style-full{color:var(--mg-b-color-warning);background-color:var(--mg-b-color-yellow-20, color-mix(in srgb, var(--mg-b-color-warning), white 80%))}.mg-c-icon[class*=mg-c-icon--variant-]{overflow:visible;border-radius:var(--mg-c-icon-border-radius)}.mg-c-icon--spin{animation-duration:.75s;animation-iteration-count:infinite;animation-name:rotate}@keyframes rotate{to{transform:rotate(360deg)}}";
const MgIconStyle0 = mgIconCss;

const MgIcon = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        /**
         * Define icon size
         */
        this.size = 'medium';
        /**
         * Make the icon spin
         */
        this.spin = false;
        /**
         * Component classes
         */
        this.classCollection = new Ze(['mg-c-icon']);
        /**
         * Method to set default varianStyle props
         * needeed has stencil doesn't know that props is mutated when updated in prop watcher
         */
        this.setDefaultVariantStyle = () => {
            if (this.variantStyle === undefined)
                this.variantStyle = 'background';
        };
        /**
         * Render icon in shadowroot
         * @param icon - icon to render
         */
        this.renderIcon = (icon) => {
            this.element.shadowRoot.innerHTML = icons[icon];
            this.svg = this.element.shadowRoot.querySelector('svg');
            // update svg attributes
            this.svg.setAttribute('aria-hidden', 'true');
            this.svg.setAttribute('focusable', 'false');
            this.svg.setAttribute('class', this.classCollection.join());
        };
    }
    validateIcon(newValue, oldValue) {
        if (!Object.keys(icons).includes(newValue))
            throw new Error(`<mg-icon> prop "icon" must be one of: ${Object.keys(icons).join(', ')}. Passed value: ${Ve(newValue)}.`);
        else {
            if (oldValue !== undefined)
                this.classCollection.delete(`mg-c-icon--${oldValue}`);
            this.classCollection.add(`mg-c-icon--${newValue}`);
            this.renderIcon(newValue);
        }
    }
    validateSize(newValue, oldValue) {
        if (!sizes$2.includes(newValue))
            throw new Error(`<mg-icon> prop "size" must be one of: ${sizes$2.join(', ')}. Passed value: ${Ve(newValue)}.`);
        else {
            if (oldValue !== undefined)
                this.classCollection.delete(`mg-c-icon--size-${oldValue}`);
            this.classCollection.add(`mg-c-icon--size-${newValue}`);
        }
    }
    validateVariant(newValue, oldValue) {
        if (newValue !== undefined) {
            if (!variants$2.includes(newValue))
                throw new Error(`<mg-icon> prop "variant" must be one of: ${variants$2.join(', ')}. Passed value: ${Ve(newValue)}.`);
            else {
                this.setDefaultVariantStyle();
                if (oldValue !== undefined)
                    this.classCollection.delete(`mg-c-icon--variant-${oldValue}`);
                this.classCollection.add(`mg-c-icon--variant-${newValue}`);
            }
        }
    }
    validateVariantStyle(newValue, oldValue) {
        if (newValue !== undefined) {
            if (!variantStyles$1.includes(newValue))
                throw new Error(`<mg-icon> prop "variantStyle" must be one of: ${variantStyles$1.join(', ')}. Passed value: ${Ve(newValue)}.`);
            else {
                if (oldValue !== undefined)
                    this.classCollection.delete(`mg-c-icon--variant-style-${oldValue}`);
                this.classCollection.add(`mg-c-icon--variant-style-${newValue}`);
            }
        }
    }
    handleSpin(newValue) {
        if (newValue) {
            this.classCollection.add('mg-c-icon--spin');
        }
        else {
            this.classCollection.delete('mg-c-icon--spin');
        }
    }
    /**
     * Check if props are well configured on init
     */
    componentWillLoad() {
        this.validateIcon(this.icon);
        this.validateSize(this.size);
        this.validateVariant(this.variant);
        this.validateVariantStyle(this.variantStyle);
        this.handleSpin(this.spin);
        // render icon
        this.renderIcon(this.icon);
    }
    /**
     * update html when component trigger changes
     */
    componentWillUpdate() {
        this.svg.setAttribute('class', this.classCollection.join());
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "icon": ["validateIcon"],
        "size": ["validateSize"],
        "variant": ["validateVariant"],
        "variantStyle": ["validateVariantStyle"],
        "spin": ["handleSpin"]
    }; }
};
MgIcon.style = MgIconStyle0;

/**
 * List of all possibles sizes
 */
const sizes$1 = ['small', 'medium', 'large'];
/**
 * List of all possibles directions
 */
const directions = ['vertical', 'horizontal'];

const mgIllustratedMessageCss = "/*!\n * @prop --mg-c-illustrated-message-spacing-vertical: Defines the vertical padding of the illustrated message. Default value: `--mg-b-size-40`.\n */.mg-c-illustrated-message{display:flex;max-width:calc(60*var(--mg-b-size-8));box-sizing:border-box;flex-direction:column;justify-content:center;padding:var(--mg-c-illustrated-message-spacing-vertical) var(--mg-b-size-16);margin:auto;gap:var(--mg-b-size-16) var(--mg-b-size-64);text-align:center}.mg-c-illustrated-message__illustration{max-height:calc(15*var(--mg-b-size-8))}.mg-c-illustrated-message__illustration ::slotted([slot=illustration]){width:100%;max-width:100%;height:auto;max-height:calc(15*var(--mg-b-size-8))}.mg-c-illustrated-message__slots{display:flex;flex-direction:column;gap:var(--mg-b-size-16)}.mg-c-illustrated-message__slots ::slotted([slot=title]){margin:0;font-family:var(--mg-b-font-family) !important;font-size:var(--mg-b-font-size-h2) !important;font-weight:400 !important}.mg-c-illustrated-message__slots ::slotted([slot=details]){margin:0}.mg-c-illustrated-message.mg-c-illustrated-message--size-small .mg-c-illustrated-message__illustration{max-height:var(--mg-b-size-64)}.mg-c-illustrated-message.mg-c-illustrated-message--size-small .mg-c-illustrated-message__illustration ::slotted([slot=illustration]){max-height:var(--mg-b-size-64)}.mg-c-illustrated-message.mg-c-illustrated-message--size-large .mg-c-illustrated-message__illustration{max-height:calc(23*var(--mg-b-size-8))}.mg-c-illustrated-message.mg-c-illustrated-message--size-large .mg-c-illustrated-message__illustration ::slotted([slot=illustration]){max-height:calc(23*var(--mg-b-size-8))}.mg-c-illustrated-message.mg-c-illustrated-message--direction-horizontal{max-width:unset;flex-flow:row wrap;align-items:center}.mg-c-illustrated-message.mg-c-illustrated-message--direction-horizontal .mg-c-illustrated-message__slots,.mg-c-illustrated-message.mg-c-illustrated-message--direction-horizontal .mg-c-illustrated-message__illustration{max-width:calc(60*var(--mg-b-size-8))}";
const MgIllustratedMessageStyle0 = mgIllustratedMessageCss;

const MgIllustratedMessage = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        /**
         * Define illustration size
         */
        this.size = 'medium';
        /**
         * Define component orientation
         */
        this.direction = 'vertical';
        /**
         * Component classes
         */
        this.classCollection = new Ze(['mg-c-illustrated-message']);
    }
    watchSize(newValue, oldValue) {
        if (!sizes$1.includes(newValue)) {
            throw new Error(`<mg-illustrated-message> prop "size" must be one of: ${sizes$1.join(', ')}. Passed value: ${Ve(newValue)}.`);
        }
        else {
            if (oldValue !== undefined) {
                this.classCollection.delete(`mg-c-illustrated-message--size-${oldValue}`);
            }
            this.classCollection.add(`mg-c-illustrated-message--size-${newValue}`);
        }
    }
    watchDirection(newValue, oldValue) {
        if (newValue !== undefined && !directions.includes(newValue)) {
            throw new Error(`<mg-illustrated-message> prop "direction" must be one of: ${directions.join(', ')}. Passed value: ${Ve(newValue)}.`);
        }
        else if (newValue === 'horizontal') {
            this.classCollection.add('mg-c-illustrated-message--direction-horizontal');
        }
        else if (oldValue === 'horizontal') {
            this.classCollection.delete('mg-c-illustrated-message--direction-horizontal');
        }
    }
    /***********
     * Methods *
     ***********/
    /**
     * Validate slots
     */
    validateSlots() {
        const headingTags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
        const slottedTitle = this.element.querySelector('[slot="title"]');
        const slottedIllustrations = this.element.querySelectorAll('[slot="illustration"]');
        const slottedDetails = this.element.querySelectorAll('[slot="details"]');
        if (slottedDetails.length === 0 && slottedTitle === null) {
            throw new Error('<mg-illustrated-message> Slot "title" or "details" must be present.');
        }
        else if (slottedTitle !== null && !Ke(slottedTitle, headingTags)) {
            throw new Error(`<mg-illustrated-message> Slotted title must be a heading: ${headingTags.join(', ')}.`);
        }
        else if (slottedIllustrations.length !== 1) {
            throw new Error('<mg-illustrated-message> Slotted illustration must be present and unique.');
        }
        slottedIllustrations[0].setAttribute('aria-hidden', 'true');
    }
    /*************
     * Lifecycle *
     *************/
    /**
     * Check if component props are well configured on init
     */
    componentWillLoad() {
        this.watchDirection(this.direction);
        this.watchSize(this.size);
        this.validateSlots();
    }
    /**
     * Render
     * @returns HTML Element
     */
    render() {
        return (h("div", { key: '2149de3930476c30fa95c8b117076751fff95029', class: this.classCollection.join() }, h("div", { key: '2795cb4895296c33b0aaf2ff8b2dcda464ce7f60', class: "mg-c-illustrated-message__illustration" }, h("slot", { key: 'fd9f3c1fbcd10bf220d6dd527bf5a8485c505078', name: "illustration" })), h("div", { key: '1acf58c99a54bc100b98ca4bf37ef4fd32242a5f', class: "mg-c-illustrated-message__slots" }, h("slot", { key: 'a1945bb8898198066958f06082e27c6fe3c26153', name: "title" }), h("slot", { key: '97b69594078389495397985e8ccb1e5e0dd4bc3f', name: "details" }))));
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "size": ["watchSize"],
        "direction": ["watchDirection"]
    }; }
};
MgIllustratedMessage.style = MgIllustratedMessageStyle0;

const mgInputCss = ".mg-u-visually-hidden{position:absolute !important;overflow:hidden !important;width:.1rem !important;height:.1rem !important;padding:0 !important;border:0 !important;margin:-0.1rem !important;clip:rect(0.1rem, 0.1rem, 0.1rem, 0.1rem) !important;clip-path:inset(50%) !important;white-space:nowrap !important}*:focus:not(:focus-visible){outline:none}@media (prefers-reduced-motion){*{animation:none !important;transition:none !important}}/*!\n * @prop --mg-c-input-border-width: Defines the width of the input border. Default value is `--mg-b-size-border`.\n * @prop --mg-c-input-border-radius: Defines the border radius of the input. Default value is `--mg-b-size-radius`.\n * @prop --mg-c-input-color-border: Defines the color of the input border. Default value is `rgb(181, 194, 201)`.\n * @prop --mg-c-input-placeholder-color-text: Defines the color of the placeholder text. Default value is `rgb(181, 194, 201)`.\n * @prop --mg-c-input-color-box-shadow-focus: Defines the shadow color of the input when focused. Default value is `rgba(0, 221, 255, 0.5)`.\n * @prop --mg-c-input-error-color-background: Defines the background color of the input error message. Default value is `color-mix(in srgb, var(--mg-b-color-danger), white 95%)`.\n * @prop --mg-c-input-toggle-border-radius-ratio: Defines the border radius ratio of the input toggle. Default value is `2`.\n * @prop --mg-c-input-check-size: Defines the size of the input check. Default value is `--mg-b-size-16`.\n */:host{display:block}.mg-c-input__input mg-icon,.mg-c-input__error mg-icon{display:flex}.mg-c-input{display:flex;min-height:var(--mg-b-size-min-height);align-items:flex-start}.mg-c-input__input-container{width:100%;min-height:var(--mg-b-size-min-height)}.mg-c-input__input-container mg-tooltip{display:inline-flex;width:var(--mg-b-size-16);height:var(--mg-b-size-16);margin-left:var(--mg-b-size-8)}@media print{.mg-c-input__input-container mg-tooltip{display:none}}.mg-c-input__input{display:flex;min-height:var(--mg-b-size-min-height);align-items:center;justify-content:start}.mg-c-input__input mg-tooltip{align-self:baseline;margin-top:calc((var(--mg-b-size-min-height) - var(--mg-b-size-16))/2)}.mg-c-input__input ::slotted(.mg-c-input__button-toggle:disabled){opacity:var(--mg-b-opacity-element-disabled)}.mg-c-input__title{display:flex;width:var(--mg-c-input-title-width, auto);flex-shrink:0;align-items:baseline;justify-content:flex-end;margin-top:calc((var(--mg-b-size-min-height) - var(--mg-b-font-size)*var(--mg-b-line-height))/2);margin-right:var(--mg-c-input-title-horizontal-space, var(--mg-b-size-8));text-align:right}.mg-c-input__title slot[name=label]+mg-tooltip{margin-left:var(--mg-b-size-4)}.mg-c-input__title mg-icon{display:inline-flex;vertical-align:text-bottom}.mg-c-input__error{display:inline-block;padding:var(--mg-b-size-4) var(--mg-b-size-8);border-radius:var(--mg-b-size-radius);background:var(--mg-c-input-error-color-background);color:var(--mg-b-color-danger)}.mg-c-input__error ::slotted(*),.mg-c-input__help-text ::slotted(*){font-size:var(--mg-b-font-size-small);text-align:start}:host(:not(.mg-c-input--textarea)) .mg-c-input__input+.mg-c-input__error,:host(:not(.mg-c-input--textarea)) .mg-c-input__input+.mg-c-input__help-text{margin-top:var(--mg-b-size-4)}:host(.mg-c-input.mg-c-input--readonly) .mg-c-input__input mg-tooltip{margin-top:calc((var(--mg-b-size-min-height) - var(--mg-b-font-size)*var(--mg-b-line-height))/2)}:host(.mg-c-input){display:flex;margin-bottom:var(--mg-c-input-margin-bottom, 0)}:host(.mg-c-input.mg-c-input--checkbox) .mg-c-input__input,:host(.mg-c-input.mg-c-input--radio) .mg-c-input__input{min-height:unset;align-items:flex-start}:host(.mg-c-input.mg-c-input--checkbox,.mg-c-input.mg-c-input--radio) .mg-c-input__input{min-height:unset}:host(.mg-c-input.mg-c-input--fieldset:not(.mg-c-input--checkbox-multi,.mg-c-input--readonly)) .mg-c-input__input-container mg-tooltip{margin-left:var(--mg-b-size-32)}:host(.mg-c-input.mg-c-input--label-on-top){flex-direction:column}:host(.mg-c-input.mg-c-input--label-on-top) .mg-c-input__title{width:100%;flex:0;justify-content:flex-start;margin-top:0;margin-right:0;margin-bottom:var(--mg-b-size-4);text-align:left}:host(.mg-c-input.mg-c-input--label-on-top) .mg-c-input__title ::slotted(mg-input-title){flex-shrink:1}@media screen and (max-width: 767px){:host(.mg-c-input){flex-direction:column}:host(.mg-c-input) .mg-c-input__title{width:100%;flex:0;justify-content:flex-start;margin-top:0;margin-right:0;margin-bottom:var(--mg-b-size-4);text-align:left}:host(.mg-c-input) .mg-c-input__title ::slotted(mg-input-title){flex-shrink:1}}";
const MgInputStyle0 = mgInputCss;

const MgInput = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.slotLabel = 'label';
        this.slotError = 'error';
        this.slotHelpText = 'help-text';
        // style
        this.classInput = 'mg-c-input';
        this.classHasError = 'mg-c-input--has-error';
        this.classLabelOnTop = 'mg-c-input--label-on-top';
        /**
         * Define if label is visible
         */
        this.labelHide = false;
        /**
         * Define tooltip position
         */
        this.tooltipPosition = 'input';
        /**
         * Define if input is required
         */
        this.required = false;
        /**
         * Element is fieldset
         */
        this.isFieldset = false;
        /**
         * Element is readonly
         */
        this.isReadonly = false;
        /**
         * Element is disabled
         */
        this.isDisabled = false;
        /**
         * Element is disabled
         */
        this.isVerticalList = false;
        /**
         * Get tooltip node
         * @returns mg-tooltip
         */
        this.renderTooltip = () => (h("mg-tooltip", { identifier: `${this.identifier}-tooltip`, message: this.tooltip }, h("mg-icon", { icon: "info-circle" })));
    }
    watchIdentifier(newValue) {
        if (!me(newValue)) {
            throw new Error(`<mg-input> prop "identifier" is required and must be a string. Passed value: ${Ve(newValue)}.`);
        }
        else if (!Xe(newValue)) {
            console.error(`<mg-input> prop "identifier" value is invalid. Passed value: ${Ve(newValue)}.`);
        }
        else {
            this.helpTextId = `${this.identifier}-help-text`;
            this.helpTextErrorId = `${this.identifier}-error`;
        }
    }
    watchLabelOnTop(newValue) {
        if (newValue) {
            this.element.classList.add(this.classLabelOnTop);
        }
        else {
            this.element.classList.remove(this.classLabelOnTop);
        }
    }
    watchLabelConfig() {
        if (this.labelHide && this.labelOnTop) {
            throw new Error('<mg-input> prop "labelOnTop" must not be paired with the prop "labelHide".');
        }
    }
    watchTooltipPosition(newValue) {
        if (!tooltipPositions.includes(newValue)) {
            throw new Error(`<mg-input> prop "tooltipPosition" must be one of: ${tooltipPositions.join(', ')}. Passed value: ${Ve(newValue)}.`);
        }
    }
    watchErrorMessage(newValue) {
        var _a;
        if (newValue !== undefined) {
            this.element.classList.add(this.classHasError);
            this.renderErrorMessage();
        }
        else {
            this.element.classList.remove(this.classHasError);
            (_a = this.errorMessageSlotElement) === null || _a === void 0 ? void 0 : _a.remove();
            this.errorMessageSlotElement = undefined;
        }
    }
    watchHelpText(newValue) {
        var _a;
        if (newValue && !this.isReadonly) {
            this.renderHelpText();
        }
        else {
            (_a = this.helptextMessageSlotElement) === null || _a === void 0 ? void 0 : _a.remove();
            this.helptextMessageSlotElement = undefined;
        }
    }
    watchAriaDescribedbyIDs() {
        if (this.isReadonly)
            return;
        // a11y IDs
        const ariaDescribedbyIDs = new Set(this.ariaDescribedbyIDs);
        // Help text
        if (this.helpText !== undefined) {
            this.renderHelpText();
            if (!ariaDescribedbyIDs.has(this.helpTextId))
                ariaDescribedbyIDs.add(this.helpTextId);
        }
        // Error Message
        if (this.errorMessage !== undefined) {
            this.renderErrorMessage();
            if (!ariaDescribedbyIDs.has(this.helpTextErrorId))
                ariaDescribedbyIDs.add(this.helpTextErrorId);
        }
        this.element.querySelectorAll('input,select,textarea,[role="switch"]').forEach(element => {
            if (ariaDescribedbyIDs.size)
                element.setAttribute('aria-describedby', Array.from(ariaDescribedbyIDs).join(' '));
            else
                element.removeAttribute('aria-describedby');
        });
    }
    /**
     * Component classes
     */
    // eslint-disable-next-line @stencil-community/no-unused-watch
    watchClass() {
        if (!this.element.classList.contains(this.classInput)) {
            this.element.classList.add(this.classInput);
        }
        this.isFieldset = this.element.classList.contains(classFieldset);
        this.isReadonly = this.element.classList.contains(classReadonly);
        this.isDisabled = this.element.classList.contains(classDisabled);
        this.isVerticalList = this.element.classList.contains(classVerticalList);
    }
    /**
     * Trigger label update
     */
    // eslint-disable-next-line @stencil-community/no-unused-watch
    watchLabel() {
        if (!me(this.label)) {
            throw new Error(`<mg-input> prop "label" is required and must be a string. Passed value: ${Ve(this.label)}.`);
        }
        else {
            this.watchAriaDescribedbyIDs();
            this.renderLabel();
        }
    }
    /************
     * Methods *
     ************/
    /**
     * Render input label
     */
    renderLabel() {
        let labelSlotElement = this.element.querySelector(`[slot=${this.slotLabel}]`);
        // first remove previous labelslot if exist
        labelSlotElement === null || labelSlotElement === void 0 ? void 0 : labelSlotElement.remove();
        // create title element
        labelSlotElement = document.createElement('mg-input-title');
        [
            ['slot', this.slotLabel],
            ['identifier', this.identifier],
            ['readonly', this.isReadonly.toString()],
            ['required', ((this.required && !this.isDisabled) || false).toString()],
            ['is-legend', this.isFieldset.toString()],
        ].forEach(([attr, val]) => {
            labelSlotElement.setAttribute(attr, val);
        });
        // create label element
        const label = document.createElement('span');
        label.classList.add('mg-c-input-title__text');
        label.textContent = this.label;
        labelSlotElement.appendChild(label);
        this.element.appendChild(labelSlotElement);
    }
    /**
     * Render error message
     */
    renderErrorMessage() {
        this.errorMessageSlotElement = this.element.querySelector(`[slot=${this.slotError}]`);
        if (this.errorMessageSlotElement === null) {
            this.errorMessageSlotElement = document.createElement('div');
            this.errorMessageSlotElement.setAttribute('slot', this.slotError);
            this.element.appendChild(this.errorMessageSlotElement);
        }
        this.errorMessageSlotElement.setAttribute('id', this.helpTextErrorId);
        this.errorMessageSlotElement.innerHTML = this.errorMessage;
    }
    /**
     * Render help text message
     */
    renderHelpText() {
        this.helptextMessageSlotElement = this.element.querySelector(`[slot=${this.slotHelpText}]`);
        if (this.helptextMessageSlotElement === null) {
            this.helptextMessageSlotElement = document.createElement('div');
            this.helptextMessageSlotElement.setAttribute('slot', this.slotHelpText);
            this.element.appendChild(this.helptextMessageSlotElement);
        }
        this.helptextMessageSlotElement.setAttribute('id', this.helpTextId);
        this.helptextMessageSlotElement.innerHTML = this.helpText;
    }
    /*************
     * Lifecycle *
     *************/
    /**
     * Check if component props are well configured on init
     */
    componentWillLoad() {
        this.watchIdentifier(this.identifier);
        this.watchLabel();
        this.watchClass();
        this.watchLabelOnTop(this.labelOnTop);
        this.watchLabelConfig();
        this.watchTooltipPosition(this.tooltipPosition);
        this.watchHelpText(this.helpText);
        this.watchErrorMessage(this.errorMessage);
    }
    /**
     * Validate slots
     */
    componentDidLoad() {
        this.watchAriaDescribedbyIDs();
        if (!this.isReadonly && !this.isFieldset && this.element.querySelector(`#${this.identifier}`) === null) {
            throw new Error(`<mg-input> "identifier" prop has no target for id: ${this.identifier}. Add an id to the targeted input.`);
        }
    }
    /**
     * Render
     * @returns HTML Element
     */
    render() {
        const isGroup = this.isFieldset && !this.isReadonly;
        return (h(Host, { key: '77264d2ab6e11c17aa41084e1a92a1f73ca0dfdb', class: this.element.classList.toString(), role: isGroup ? 'group' : undefined, "aria-labelledby": isGroup ? `${this.identifier}-title` : undefined }, h("div", { key: '4ad77f1659c1b89fd162a9a5c12cdedaaa6be803', class: { 'mg-c-input__title': true, 'mg-u-visually-hidden': this.labelHide } }, h("slot", { key: 'b542d2b90f48a2cc40cde20f1ee17e69770f13c6', name: this.slotLabel }), this.tooltip && (this.tooltipPosition === 'label' || this.labelOnTop) && !this.labelHide && this.renderTooltip()), h("div", { key: 'ef262dc7bfef3b06bc261b2755c317e5c8d8c710', class: "mg-c-input__input-container" }, h("div", { key: '4ec59056ceebad738164f242dd272a5bdb89aaa0', class: "mg-c-input__input" }, h("slot", { key: '1cefe1817b4c33cac440fe6cde1cb780bde52c05' }), this.tooltip && !this.labelOnTop && (this.tooltipPosition === 'input' || this.labelHide) && this.renderTooltip()), this.helptextMessageSlotElement && (h("div", { key: '568732b397b397195f123376ef1a958a8043dc28', class: "mg-c-input__help-text" }, h("slot", { key: '98092704188057b00b24815ab03d874b96d46b4c', name: this.slotHelpText }))), !this.isDisabled && this.errorMessage && (h("div", { key: 'd72f798a577b626b8b7d0de4094b68c4fd105535', class: "mg-c-input__error", "aria-live": "assertive" }, h("slot", { key: 'd258365216d2a3f1810776b06f603aa392e12808', name: this.slotError }))))));
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "identifier": ["watchIdentifier", "watchAriaDescribedbyIDs"],
        "labelOnTop": ["watchLabelOnTop", "watchLabelConfig"],
        "labelHide": ["watchLabelConfig"],
        "tooltipPosition": ["watchTooltipPosition"],
        "errorMessage": ["watchErrorMessage", "watchAriaDescribedbyIDs"],
        "helpText": ["watchHelpText", "watchAriaDescribedbyIDs"],
        "ariaDescribedbyIDs": ["watchAriaDescribedbyIDs"],
        "class": ["watchClass", "watchLabel"],
        "label": ["watchLabel"],
        "required": ["watchLabel"],
        "isReadonly": ["watchLabel"],
        "isFieldset": ["watchLabel"]
    }; }
};
MgInput.style = MgInputStyle0;

/**
 * List of all availables checkbox type
 */
const checkboxTypes = ['checkbox', 'multi'];
/**
 * mg-input-checkbox-paginated section kind value
 */
const SectionKind = {
    SELECTED: 'selected',
    NOT_SELECTED: 'not-selected',
};

/**
 * Get checkboxes list template
 * @param props - MgInputCheckboxList Interface Props
 * @returns input template
 */
const MgInputCheckboxList = (props) => (h("ul", { class: "mg-c-input__input-group-container", role: "list", "aria-describedby": props.displaySearchInput ? 'search-results' : undefined, "aria-label": props.displaySearchInput ? props.messages.searchResults : undefined, "aria-live": props.displaySearchInput ? 'polite' : undefined, id: props.id }, props.checkboxes.map(input => {
    var _a, _b;
    return (h("li", { key: input._id, class: { 'mg-c-input__input-group': true, 'mg-c-input__input-group--disabled': props.disabled || input.disabled } },
        h("input", { type: "checkbox", id: input._id, name: props.name, value: (_a = input.value) === null || _a === void 0 ? void 0 : _a.toString(), checked: Boolean(input.value), required: input.required, "aria-invalid": ((_b = props.invalid) === null || _b === void 0 ? void 0 : _b.toString()) || 'false', disabled: props.disabled || input.disabled, indeterminate: input.value === null, onInput: input._handleInput, onBlur: input._handleBlur, onKeyDown: input._handleKeydown }),
        h("label", { htmlFor: input._id }, input.title)));
})));

const mgInputCheckboxCss = ".mg-c-input__readonly-value{min-height:var(--mg-b-font-size);align-self:flex-start;margin-top:calc((var(--mg-b-size-min-height) - var(--mg-b-font-size)*var(--mg-b-line-height))/2);word-break:break-word}.mg-c-input.mg-c-input--fieldset{padding:0;border:0;margin-right:0;margin-left:0}.mg-c-input.mg-c-input--fieldset input[type=radio],.mg-c-input.mg-c-input--fieldset input[type=checkbox]{width:var(--mg-c-input-check-size);height:var(--mg-c-input-check-size);flex-shrink:0;margin:calc((var(--mg-b-font-size)*var(--mg-b-line-height) - var(--mg-c-input-check-size))/2) var(--mg-b-size-8) 0 0}.mg-c-input.mg-c-input--fieldset .mg-c-input__input-group{display:flex;align-items:start}.mg-c-input.mg-c-input--fieldset .mg-c-input__input-group-container{display:flex;flex-wrap:wrap;padding:0;margin:0;margin-top:calc((var(--mg-b-size-min-height) - var(--mg-b-font-size)*var(--mg-b-line-height))/2);gap:var(--mg-b-size-12) var(--mg-b-size-24);list-style:none}.mg-c-input.mg-c-input--fieldset .mg-c-input__input-group.mg-c-input__input-group--disabled label{opacity:var(--mg-b-opacity-element-disabled)}.mg-c-input.mg-c-input--fieldset.mg-c-input--vertical-list .mg-c-input__input-group-container,.mg-c-input.mg-c-input--fieldset.mg-c-input--checkbox-multi .mg-c-input__input-group-container{flex-direction:column}.mg-c-input.mg-c-input--fieldset.mg-c-input--label-on-top .mg-c-input__input-group-container{margin-top:var(--mg-b-size-8)}.mg-u-visually-hidden{position:absolute !important;overflow:hidden !important;width:.1rem !important;height:.1rem !important;padding:0 !important;border:0 !important;margin:-0.1rem !important;clip:rect(0.1rem, 0.1rem, 0.1rem, 0.1rem) !important;clip-path:inset(50%) !important;white-space:nowrap !important}*:focus:not(:focus-visible){outline:none}@media (prefers-reduced-motion){*{animation:none !important;transition:none !important}}.mg-c-input.mg-c-input--checkbox-multi .mg-c-input__input-group-container{padding:var(--mg-b-size-4) var(--mg-b-size-8);margin:0}.mg-c-input.mg-c-input--checkbox-multi .mg-c-input__input-container{display:flex;width:unset;flex:unset;flex-wrap:wrap;column-gap:var(--mg-b-size-8)}.mg-c-input.mg-c-input--checkbox-multi .mg-c-input__input-container-list{display:flex;flex-flow:row wrap;padding:0;margin:0;gap:var(--mg-b-size-4);list-style:none}.mg-c-input.mg-c-input--checkbox-multi .mg-c-input__sections{max-height:100%;padding-right:var(--mg-b-size-8);overflow-y:auto}.mg-c-input.mg-c-input--checkbox-multi .mg-c-input__section-header{display:flex;min-height:var(--mg-b-size-min-height);flex-wrap:wrap;flex-wrap:nowrap;align-items:center;gap:var(--mg-b-size-8);text-wrap:nowrap}.mg-c-input.mg-c-input--checkbox-multi .mg-c-input__section-header-tootlip{display:inline-block;width:auto;height:auto;margin:0}.mg-c-input.mg-c-input--checkbox-multi .mg-c-input__section-header-title{display:inline;margin:0;color:var(--mg-b-color-neutral-80)}.mg-c-input.mg-c-input--checkbox-multi .mg-c-input__section-header-title-label{font-size:var(--mg-b-font-size)}.mg-c-input.mg-c-input--checkbox-multi .mg-c-input__section-header-title--static.mg-c-input__section-header-title{margin:0 var(--mg-b-size-12)}.mg-c-input.mg-c-input--checkbox-multi .mg-c-input__input-value{display:inline-flex;min-width:var(--mg-b-size-min-height);min-height:var(--mg-b-size-min-height);box-sizing:border-box;align-items:center;justify-content:center;padding:calc((var(--mg-b-size-min-height) - 2*var(--mg-b-size-border) - var(--mg-b-font-size)*var(--mg-b-line-height))/2) var(--mg-b-size-12);border-radius:var(--mg-b-size-4);background-color:var(--mg-b-color-neutral-20);font-size:var(--mg-b-font-size)}.mg-c-input.mg-c-input--checkbox-multi .mg-c-input__input-no-result{text-align:center}.mg-c-input.mg-c-input--checkbox-multi b{margin-top:calc((var(--mg-b-size-min-height) - var(--mg-b-font-size)*var(--mg-b-line-height))/2)}.mg-c-input.mg-c-input--checkbox-multi.mg-c-input--disabled .mg-c-input__input-container b{opacity:var(--mg-b-opacity-element-disabled)}.mg-c-input.mg-c-input--checkbox-multi.mg-c-input--with-values .mg-c-input__input-container{gap:var(--mg-b-size-4)}.mg-c-input.mg-c-input--checkbox-multi.mg-c-input--search-mode .mg-c-input__content{display:flex;width:calc(var(--mg-b-size-floating-element-max-width) - var(--mg-b-size-16));height:calc(50*var(--mg-b-size-8));max-height:calc(100vh - var(--mg-b-size-32));flex-direction:column;gap:var(--mg-b-size-8)}.mg-c-input.mg-c-input--checkbox-multi:not(.mg-c-input--label-on-top) mg-tooltip:not(.mg-c-input__section-header-tootlip){margin-left:var(--mg-b-size-8)}.mg-c-input.mg-c-input--checkbox-multi mg-popover{--mg-c-card-spacing:var(--mg-b-size-8)}.mg-c-input.mg-c-input--readonly ul{display:flex;min-height:var(--mg-b-font-size);flex-flow:column wrap;padding:0;margin:calc((var(--mg-b-size-min-height) - var(--mg-b-font-size)*var(--mg-b-line-height))/2) 0 0;list-style:none;row-gap:var(--mg-b-size-8)}";
const MgInputCheckboxStyle0 = mgInputCheckboxCss;

/**
 * type CheckboxItem validation function
 * @param items - Checkbox item
 * @returns match item type
 */
const isCheckboxItems = (items) => Array.isArray(items) &&
    items.every(item => typeof item === 'object' && typeof item.title === 'string' && (item.value === null || typeof item.value === 'boolean') && item.value !== undefined);
const MgInputCheckbox = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.valueChange = createEvent(this, "value-change", 7);
        this.inputValid = createEvent(this, "input-valid", 7);
        // hasDisplayedError (triggered by blur event)
        this.hasDisplayedError = false;
        this.mode = 'custom';
        // style
        this.baseClassName = 'mg-c-input--checkbox';
        this.classTypeMulti = 'mg-c-input--checkbox-multi';
        this.classWithValues = 'mg-c-input--with-values';
        this.classSearchMode = 'mg-c-input--search-mode';
        // "multi" setup
        this.multiStart = 5;
        this.searchStart = 10;
        // popover variables
        this.hasOpenedPopover = false;
        /**
         * Define input name
         * If not set the value equals the identifier
         */
        this.name = this.identifier;
        /**
         * Define if label is visible
         */
        this.labelHide = false;
        /**
         * Define if inputs are display verticaly
         */
        this.inputVerticalList = false;
        /**
         * Define if mg-input-checkbox is required
         */
        this.required = false;
        /**
         * Define if mg-input-checkbox is readonly
         */
        this.readonly = false;
        /**
         * Define if input is disabled
         */
        this.disabled = false;
        /**
         * Define tooltip position
         */
        this.tooltipPosition = 'input';
        /**
         * Component classes
         */
        this.classCollection = new Ze([this.baseClassName, classFieldset]);
        /**
         * Formated value to display in list
         */
        this.checkboxItems = [];
        /**
         * Search value query
         */
        this.searchValue = '';
        /**
         * Search current page
         */
        this.searchResults = [];
        /**
         * Select values button text local key
         */
        this.selectValuesButtonKey = 'editButton';
        /**
         * Handle input event
         * @param event - input event
         */
        this.handleInput = (event) => {
            this.updateCheckboxItems('value', Boolean(event.target.checked), item => item._id === event.target.id);
            this.updateValues();
            this.checkValidity();
            this.setErrorMessage();
        };
        /**
         * Keyboard handler
         * @param event - to track "tab" key
         */
        this.handleKeydown = (event) => {
            var _a;
            // track "Tab" key event when popover display (is "multi" type selected)
            if (event.key === 'Tab' && ((_a = this.mgPopover) === null || _a === void 0 ? void 0 : _a.display)) {
                // when search input and do a back tab we close the popover
                if (Boolean(this.searchInput) && event.shiftKey && this.searchInput.id === event.target.id) {
                    this.mgPopover.display = false;
                    return;
                }
                const enableInputs = Array.from(this.element.shadowRoot.querySelectorAll('input'))
                    .filter(input => !input.hasAttribute('disabled'))
                    .map(({ id }) => id);
                const originInputIndex = enableInputs.findIndex(id => id === event.target.id);
                // close popover when tab trigger focus outside its DOM
                if ((originInputIndex + 1 >= enableInputs.length && !event.shiftKey) || (originInputIndex === 0 && event.shiftKey && this.searchInput === undefined))
                    this.mgPopover.display = false;
            }
        };
        /**
         * Handle blur event
         */
        this.handleBlur = () => {
            // Check validity
            this.checkValidity();
            this.setErrorMessage();
        };
        /**
         * Handle input search value-change event
         * @param event - input value-change event
         */
        this.handleSearchChange = (event) => {
            this.searchValue = event.detail;
            event.stopPropagation();
        };
        /**
         * popover display-change handler
         * @param event - mg-popover display-change custom event
         */
        this.handleMgPopoverDisplayChange = (event) => {
            // 1. update hasOpenedPopover guard with event value
            this.hasOpenedPopover = event.detail;
            // 2. update selected valued button text
            this.setButtonTextKey();
            // 3. when popover display change to hide, update reset needeed props and run checkValidity
            if (!event.detail) {
                // reset search value
                this.searchValue = '';
                // reset pagintated section current page
                Array.from(this.element.shadowRoot.querySelectorAll('mg-input-checkbox-paginated')).forEach(element => {
                    element.currentPage = 1;
                });
                this.checkValidity();
            }
        };
        /**
         * Handle select all button
         * @param event - mass action event trigger a global select/unselect on values
         */
        this.handleMassAction = (event) => {
            const displayItems = this.getDisplayItems();
            // update only displayed items
            displayItems.forEach(item => {
                item.value = event.detail !== SectionKind.SELECTED;
            });
            this.updateValues();
        };
        /**
         * Update values
         */
        this.updateValues = () => {
            this.value = this.checkboxItems.map(o => {
                delete o._handleBlur;
                delete o._handleInput;
                delete o._handleKeydown;
                delete o._id;
                return o;
            });
        };
        /**
         * has invalid input
         * @returns true if at least one input is invalid
         */
        this.hasInvalidInput = () => Array.from(this.element.shadowRoot.querySelectorAll('input[type="checkbox"]')).some((input) => !input.disabled && !input.checkValidity());
        /**
         * Method to update searchResults
         */
        this.updateSearchResults = () => {
            this.searchResults = this.checkboxItems.filter(item => tt(item.title).includes(tt(this.searchValue)));
        };
        /**
         * Method to validate if one of inputs value is checked id required
         * @returns truthy if condition is valid
         */
        this.validateRequired = () => !this.required || this.checkboxItems.some(({ value }) => value);
        /**
         * Check if input is valid
         */
        this.checkValidity = () => {
            this.setValidity(this.readonly || this.disabled || (!this.hasInvalidInput() && this.validateRequired()));
        };
        /**
         * Set button text locale key
         */
        this.setButtonTextKey = () => {
            // prevent key update while popover is openned
            if (this.hasOpenedPopover)
                return;
            let messageKey = 'editButton';
            if (this.disabled)
                messageKey = 'showButton';
            else if (this.getSelectedItems().length < 1)
                messageKey = 'selectButton';
            this.selectValuesButtonKey = messageKey;
        };
        /**
         * Get select values button message
         * @returns message to display
         */
        this.getSelectValuesButtonMessage = () => {
            if (this.selectValuesButtonKey === 'editButton' && me(this.editButtonMessage)) {
                return this.editButtonMessage;
            }
            else if (this.selectValuesButtonKey === 'showButton' && me(this.showButtonMessage)) {
                return this.showButtonMessage;
            }
            else if (this.selectValuesButtonKey === 'selectButton' && me(this.selectButtonMessage)) {
                return this.selectButtonMessage;
            }
            else {
                return this.messages.input.checkbox[this.selectValuesButtonKey];
            }
        };
        /**
         * Set input error message
         * @param displayError - dispay error condition
         * @param errorMessage - errorMessage override
         */
        this.setErrorMessage = (displayError = true, errorMessage) => {
            // Set error message
            this.errorMessage = undefined;
            if (displayError && !this.valid) {
                if (errorMessage !== undefined)
                    this.errorMessage = errorMessage;
                else if (!this.validateRequired())
                    this.errorMessage = this.messages.errors.required;
            }
        };
        /**
         * Method to get mg-popover identifier
         * @returns MgPopover identifier
         */
        this.getMgPopoverIdentifier = () => `${this.identifier}-input-mg-popover`;
        /**
         * Manage items to display depending on the search state
         * @returns items to display
         */
        this.getDisplayItems = () => (this.searchValue.length > 0 ? this.searchResults : this.checkboxItems);
        /**
         * get list of selected checkboxItems
         * @returns selected checkboxItems
         */
        this.getSelectedItems = () => this.checkboxItems.filter(({ value }) => value);
        /**
         * Renders the readonly value of the input.
         * @returns The rendered readonly value.
         */
        this.renderReadonly = (readonlyValue) => {
            return this.inputVerticalList ? (h("ul", { class: "mg-c-input__readonly-value" }, readonlyValue.map(value => (h("li", { key: value }, h("b", null, value)))))) : (h("b", { class: "mg-c-input__readonly-value" }, readonlyValue.join(', ')));
        };
        /**
         * Renders the MgInputCheckboxList component.
         * @returns The rendered MgInputCheckboxList component.
         */
        this.renderMgInputCheckboxList = () => (h(MgInputCheckboxList, { checkboxes: this.checkboxItems, displaySearchInput: this.displaySearchInput, messages: this.messages.input.checkbox, id: "checkboxes-list", disabled: this.disabled, name: this.name, invalid: this.invalid }));
    }
    validateValue(newValue) {
        if (isCheckboxItems(newValue)) {
            this.checkboxItems = newValue.map((item, index) => (Object.assign(Object.assign({}, item), { _id: `${this.identifier}_${index}`, _handleInput: this.handleInput.bind(this), _handleBlur: this.handleBlur.bind(this), _handleKeydown: this.handleKeydown.bind(this) })));
            this.valueChange.emit(newValue);
        }
        else {
            throw new Error(`<mg-input-checkbox> prop "value" is required and all values must be the same type, CheckboxItem. Passed value: ${Ve(newValue)}.`);
        }
    }
    validateType(newValue) {
        if (newValue !== undefined && !checkboxTypes.includes(newValue)) {
            throw new Error(`<mg-input-checkbox> prop "type" must be a CheckboxType. Passed value: ${Ve(newValue)}.`);
        }
        else if (newValue === undefined) {
            this.mode = 'auto';
            this.type = checkboxTypes[0];
        }
        else if (newValue === 'multi') {
            this.classCollection.add(this.classTypeMulti);
            this.element.dataset.mgPopoverGuard = this.getMgPopoverIdentifier();
        }
        else {
            this.classCollection.delete(this.classTypeMulti);
        }
    }
    watchInputVerticalList(newValue) {
        if (newValue)
            this.classCollection.add(classVerticalList);
        else
            this.classCollection.delete(classVerticalList);
    }
    watchReadonly(newValue) {
        if (newValue)
            this.classCollection.add(classReadonly);
        else
            this.classCollection.delete(classReadonly);
    }
    watchDisplaySelectedValues(newValue) {
        if (newValue)
            this.classCollection.add(this.classWithValues);
        else
            this.classCollection.delete(this.classWithValues);
    }
    handleValidityChange(newValue, _oldValue, prop) {
        if (prop !== 'readonly')
            this.updateCheckboxItems(prop, newValue);
        this.checkValidity();
        if (this.hasDisplayedError) {
            this.hasDisplayedError = prop !== 'required';
            this.setErrorMessage(this.hasDisplayedError);
        }
        this.setButtonTextKey();
    }
    validateDisabled(newValue) {
        if (newValue)
            this.classCollection.add(classDisabled);
        else
            this.classCollection.delete(classDisabled);
    }
    validateCheckboxItems(newValue) {
        // For the 'auto' mode we update the type depending on the new value's length.
        if (this.mode === 'auto')
            this.type = newValue.length > this.multiStart ? 'multi' : 'checkbox';
        // If the type is multi and the new value's length is greater than the search gauge, display the search input.
        this.displaySearchInput = this.type === 'multi' && newValue.length > this.searchStart;
        // refresh search values
        if (this.displaySearchInput)
            this.updateSearchResults();
        this.setButtonTextKey();
    }
    watchDisplaySearchInput(newValue) {
        if (newValue)
            this.classCollection.add(this.classSearchMode);
        else
            this.classCollection.delete(this.classSearchMode);
    }
    validateSearchValue() {
        // refresh search values
        this.updateSearchResults();
    }
    /**
     * Display input error if it exists.
     */
    displayError() {
        // Use `Promise` as requested for stencil method
        // Use `requestAnimationFrame` to ensure:
        // - DOM is fully updated before validation
        // - Async operations are completed
        // - No timing issues with Stencil's render cycle
        // - Keep everything in sync both inside and outside the component
        return new Promise(resolve => {
            requestAnimationFrame(() => {
                this.checkValidity();
                this.setErrorMessage();
                this.hasDisplayedError = this.invalid;
                resolve();
            });
        });
    }
    /**
     * Set an error and display a custom error message.
     * This method can be used to set the component's error state from its context by passing a boolean value to the `valid` parameter.
     * It must be paired with an error message to display for the given context.
     * When used to set validity to `false`, you should use this method again to reset the validity to `true`.
     * @param valid - value indicating the validity
     * @param errorMessage - the error message to display
     */
    async setError(valid, errorMessage) {
        if (typeof valid !== 'boolean') {
            throw new Error('<mg-input-checkbox> method "setError()" param "valid" must be a boolean.');
        }
        else if (!me(errorMessage)) {
            throw new Error('<mg-input-checkbox> method "setError()" param "errorMessage" must be a string.');
        }
        else {
            this.setValidity(valid);
            this.setErrorMessage(undefined, valid ? undefined : errorMessage);
            this.hasDisplayedError = this.invalid;
        }
    }
    /**
     * Reset value, validity and error state
     */
    async reset() {
        if (!this.readonly) {
            this.value = this.value.map(item => (Object.assign(Object.assign({}, item), { value: false })));
            this.checkValidity();
            this.errorMessage = undefined;
            this.hasDisplayedError = false;
        }
    }
    /**
     * Method to set validity values
     * @param newValue - valid new value
     */
    setValidity(newValue) {
        const oldValidValue = this.valid;
        this.valid = newValue;
        this.invalid = !this.valid;
        // We need to send valid event even if it is the same value
        if (this.valid !== oldValidValue)
            this.inputValid.emit(this.valid);
    }
    /**
     * Update ckecboxes item
     * @param key - property to update
     * @param newValue - value to update with
     * @param condition - condtion to applu change on item
     */
    updateCheckboxItems(key, newValue, condition) {
        this.checkboxItems = this.checkboxItems.map(item => {
            if ((typeof condition === 'function' && condition(item)) || condition === undefined)
                item[key] = newValue;
            return item;
        });
    }
    /*************
     * Lifecycle *
     *************/
    /**
     * Check if component props are well configured on init
     * @returns timeout
     */
    componentWillLoad() {
        // Get locales
        this.messages = initLocales(this.element).messages;
        // Validate
        // `validateType` must be done before `validateValue` because we need to set mode['auto'|'custom'] from type
        // and `validateValue` updates `this.checkboxItems` watcher which requires a defined `this.type`.
        this.validateType(this.type);
        this.validateValue(this.value);
        this.validateDisabled(this.disabled);
        this.watchReadonly(this.readonly);
        this.watchInputVerticalList(this.inputVerticalList);
        this.watchDisplaySelectedValues(this.displaySelectedValues);
        this.watchDisplaySearchInput(this.displaySearchInput);
        // Check validity when component is ready
        // return a promise to process action only in the FIRST render().
        // https://stenciljs.com/docs/component-lifecycle#componentwillload
        return setTimeout(() => {
            this.checkValidity();
        }, 0);
    }
    /**
     * add listeners and DOM attributed
     */
    componentDidLoad() {
        var _a, _b;
        if (!this.readonly) {
            this.searchInput = (_a = this.element.shadowRoot.querySelector('mg-input-text')) === null || _a === void 0 ? void 0 : _a.shadowRoot.querySelector('input');
            (_b = this.searchInput) === null || _b === void 0 ? void 0 : _b.addEventListener('keydown', this.handleKeydown);
        }
    }
    /**
     * Render checkboxes by section
     * @param checkboxes - checkboxes to render
     * @returns render sections of checkboxes
     */
    renderCheckboxBySection(checkboxes) {
        const [checkedValues, notCheckedValues] = checkboxes.reduce((acc, curr) => {
            acc[curr.value ? 0 : 1].push(curr);
            return acc;
        }, [[], []]);
        const baseSection = {
            readonly: this.readonly,
            disabled: this.disabled,
            identifier: this.identifier,
        };
        const sections = [
            Object.assign(Object.assign({}, baseSection), { checkboxes: checkedValues, messages: this.messages.input.checkbox.sections.selected }),
            Object.assign(Object.assign({}, baseSection), { checkboxes: notCheckedValues, messages: this.messages.input.checkbox.sections.notSelected }),
        ];
        return sections
            .filter(section => section.checkboxes.length)
            .map(section => h("mg-input-checkbox-paginated", Object.assign({}, section, { "onMass-action": this.handleMassAction, key: section.messages })));
    }
    /**
     * render checkbox multi element
     * @returns html element
     */
    renderCheckboxMulti() {
        const selectedValuesNb = this.getSelectedItems().length;
        const checkboxes = this.getDisplayItems();
        return (h("div", { class: "mg-c-input__input-container" }, h("mg-popover", { arrowHide: true, identifier: this.getMgPopoverIdentifier(), display: this.hasOpenedPopover, "onDisplay-change": this.handleMgPopoverDisplayChange, ref: (el) => {
                if (el !== null)
                    this.mgPopover = el;
            } }, h("mg-button", { variant: "secondary", "aria-describedby": `${this.identifier}-title` }, h("mg-icon", { icon: "list" }), this.getSelectValuesButtonMessage()), h("div", { slot: "content", class: "mg-c-input__content" }, this.displaySearchInput ? ([
            h("mg-input-text", { key: "input-search", identifier: `${this.identifier}-input-search`, icon: "magnifying-glass", type: "search", placeholder: this.messages.input.checkbox.label, label: this.messages.input.checkbox.label, mgWidth: "full", value: this.searchValue, labelHide: true, characterLeftHide: true, name: "q", "onValue-change": this.handleSearchChange, "aria-controls": "search-results items-list" }),
            h("p", { key: "search-results", role: "status", class: "mg-u-visually-hidden", id: "search-results" }, `${checkboxes.length} ${this.messages.input.checkbox[checkboxes.length > 0 ? 'results' : 'result']}`),
            h("div", { key: "sections-container", class: "mg-c-input__sections" }, this.renderCheckboxBySection(checkboxes)),
        ]) : (h(MgInputCheckboxList, { checkboxes: checkboxes, displaySearchInput: this.displaySearchInput, messages: this.messages.input.checkbox, id: "checkboxes-list", disabled: this.disabled, name: this.name, invalid: this.invalid })), this.displaySearchInput && checkboxes.length === 0 && h("p", { class: "mg-c-input__input-no-result" }, this.messages.input.checkbox.noResult))), this.displaySelectedValues ? (selectedValuesNb > 0 && (h("ul", { role: "list", class: "mg-c-input__input-container-list" }, this.getSelectedItems().map(({ title }) => (h("li", { class: "mg-c-input__input-value", key: title }, title)))))) : (h("b", null, this.messages.input.checkbox[selectedValuesNb > 1 ? 'selectedValues' : 'selectedValue'].replace('{nb}', selectedValuesNb)))));
    }
    /**
     * Render
     * @returns HTML Element
     */
    render() {
        let inputContent;
        const readonlyValue = this.value.filter(({ value }) => value).map(({ title }) => title);
        if (this.readonly) {
            inputContent = this.renderReadonly(readonlyValue);
        }
        else if (this.type === 'checkbox') {
            inputContent = this.renderMgInputCheckboxList();
        }
        else {
            inputContent = this.renderCheckboxMulti();
        }
        return (h("mg-input", { key: '29c4a52d2f3a0e3d3b2a6f55ce3374aa818cf4eb', label: this.label, identifier: this.identifier, class: this.classCollection.join(), ariaDescribedbyIDs: [], labelOnTop: this.labelOnTop, labelHide: this.labelHide, required: !this.readonly ? this.required : undefined, tooltip: this.tooltip, tooltipPosition: this.readonly && readonlyValue.length === 0 ? 'label' : this.tooltipPosition, helpText: !this.readonly ? this.helpText : undefined, errorMessage: !this.readonly ? this.errorMessage : undefined }, inputContent));
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "value": ["validateValue"],
        "type": ["validateType"],
        "inputVerticalList": ["watchInputVerticalList"],
        "readonly": ["watchReadonly", "handleValidityChange"],
        "displaySelectedValues": ["watchDisplaySelectedValues"],
        "required": ["handleValidityChange"],
        "disabled": ["handleValidityChange", "validateDisabled"],
        "checkboxItems": ["validateCheckboxItems"],
        "displaySearchInput": ["watchDisplaySearchInput"],
        "searchValue": ["validateSearchValue"]
    }; }
};
MgInputCheckbox.style = MgInputCheckboxStyle0;

const MgInputCheckboxPaginated = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.massAction = createEvent(this, "mass-action", 7);
        /*************
         * Constantes *
         *************/
        this.offset = 10;
        /**
         * Current page
         */
        this.currentPage = 1;
        /**
         * Define checkboxes to paginate
         */
        this.checkboxes = [];
        /**
         * Is checked items values expanded
         */
        this.expanded = true;
        /***********
         * Methods *
         ***********/
        /**
         * Mass action handler
         */
        this.massActionHandler = () => {
            this.massAction.emit(this.sectionKind);
        };
        /**
         * Toggle items button handler
         */
        this.handleToggleClick = () => {
            this.expanded = !this.expanded;
        };
        /**
         * Method to get a array range
         * @param from - array start index
         * @param to - array end index
         * @returns array's range
         */
        this.getArrayRange = (array, from, to) => array.slice(from, to);
        /**
         * Method to get page count from items
         * @param items - items to count
         * @returns page count from items
         */
        this.getPageCount = (items) => ((items === null || items === void 0 ? void 0 : items.length) > 0 ? Math.ceil(items.length / this.offset) : 0);
        /**
         * Handle mg-pagination current page change event
         * @param event - pagination current page change event
         */
        this.handleCurrentPageChange = (event) => {
            this.currentPage = Number(event.detail);
        };
    }
    watchCheckboxes(newValue, oldValue) {
        const pageCountNewValue = this.getPageCount(newValue);
        const pageCountOldValue = this.getPageCount(oldValue);
        // after each array.length update we reset pagination
        // when items fill on page, we set current page to 1
        if (pageCountNewValue === 1 || (pageCountNewValue !== 0 && this.currentPage === 0)) {
            this.currentPage = 1;
        }
        // when old items page numbers match the current page AND new items page number is lower than current page, we set the new last page
        else if (pageCountOldValue === this.currentPage && pageCountNewValue < this.currentPage) {
            this.currentPage--;
        }
        this.sectionKind = newValue[0].value ? SectionKind.SELECTED : SectionKind.NOT_SELECTED;
    }
    /**
     * Get from and to index
     * @returns [from,to] index
     */
    getFromToIndexes() {
        const isFirstPage = this.currentPage === 1;
        const from = isFirstPage ? 0 : (this.currentPage - 1) * this.offset;
        const to = isFirstPage ? this.offset : this.currentPage * this.offset;
        return [from, to];
    }
    /*************
     * Lifecycle *
     *************/
    /**
     * Validate props
     */
    componentWillLoad() {
        this.watchCheckboxes(this.checkboxes);
    }
    /**
     * Render
     * @returns HTML Element
     */
    render() {
        const getText = (checkboxes) => (h("em", { key: '8f20e5be81047106e04cd101385b9c6555c0c38d', class: "mg-c-input__section-header-title-label" }, `${this.messages[checkboxes.length > 1 ? 'titlePlurial' : 'title']} (${checkboxes.length})`));
        const [from, to] = this.getFromToIndexes();
        const itemsContainerId = `items-${this.sectionKind}-container`;
        return (h(Host, { key: '39d0fc41abe4b537b240bdc14e80fc42cb41033d', hidden: this.checkboxes.length < 1 }, h("div", { key: 'fec430cfffc005a217694f9a4ba68412a6a08c7b', class: "mg-c-input__section-header" }, this.sectionKind === SectionKind.SELECTED ? (h("mg-button", { variant: "flat", onClick: this.handleToggleClick, "aria-controls": itemsContainerId, "aria-expanded": this.expanded.toString() }, h("mg-icon", { icon: this.expanded ? 'chevron-up' : 'chevron-down' }), h("span", { class: "mg-c-input__section-header-title" }, getText(this.checkboxes)))) : (h("p", { class: "mg-c-input__section-header-title mg-c-input__section-header-title--static" }, getText(this.checkboxes))), ((this.sectionKind === SectionKind.SELECTED && this.expanded) || this.sectionKind === SectionKind.NOT_SELECTED) && (h("mg-tooltip", { key: 'e1b38d93875962af3024ac27e1892c040dbf9bdb', class: "mg-c-input__section-header-tootlip", message: this.messages.tooltip }, h("mg-button", { key: 'f593b3d5ca5bd8b3080253842a5c513709f16e3a', variant: "link", onClick: this.massActionHandler }, this.messages.action))), this.expanded && this.getPageCount(this.checkboxes) > 1 && (h("mg-pagination", { key: "search-pagination", totalPages: this.getPageCount(this.checkboxes), currentPage: this.currentPage, "onCurrent-page-change": this.handleCurrentPageChange, hideNavigationLabels: true, hidePageCount: true, identifier: `input-checkbox-pagination-${this.sectionKind}` }))), h("div", { key: '74c18984938188e2861cd79b56d919a94f32064f', hidden: !this.expanded, id: itemsContainerId, class: "mg-c-input__section-content" }, h(MgInputCheckboxList, { key: '15c2f6fe98d772ce5b0a0d4ec448986e91592107', checkboxes: this.getArrayRange(this.checkboxes, from, to), displaySearchInput: true, messages: this.messages, id: `items-${this.sectionKind}`, disabled: this.disabled, name: this.name, invalid: this.invalid }))));
    }
    static get watchers() { return {
        "checkboxes": ["watchCheckboxes"]
    }; }
};

const mgInputDateCss = ".mg-c-input__readonly-value{min-height:var(--mg-b-font-size);align-self:flex-start;margin-top:calc((var(--mg-b-size-min-height) - var(--mg-b-font-size)*var(--mg-b-line-height))/2);word-break:break-word}.mg-c-input__box{height:var(--mg-b-size-min-height);box-sizing:border-box;padding:calc((var(--mg-b-size-min-height) - var(--mg-b-font-size)*var(--mg-b-line-height))/2) var(--mg-b-size-8);border-width:var(--mg-c-input-border-width);border-style:solid;border-color:var(--mg-c-input-color-border);border-radius:var(--mg-c-input-border-radius);background-color:var(--mg-b-color-light);color:var(--mg-b-color-dark);font-family:inherit;font-size:var(--mg-b-font-size);text-align:var(--mg-c-input-text-align, left)}.mg-c-input__box::placeholder{color:var(--mg-c-input-placeholder-color-text);font-style:italic}.mg-c-input__box:focus{box-shadow:0 0 var(--mg-b-size-4) var(--mg-c-input-color-box-shadow-focus)}.mg-c-input__box:disabled{opacity:var(--mg-b-opacity-element-disabled)}.mg-c-input.mg-c-input--has-error .mg-c-input__box{border-color:var(--mg-b-color-danger)}.mg-c-input.mg-c-input--is-input-group-append{--mg-c-button-border-radius-top-left:0;--mg-c-button-border-radius-bottom-left:0}.mg-c-input.mg-c-input--is-input-group-append .mg-c-input__box{margin-right:calc(-1*var(--mg-b-size-border));border-bottom-right-radius:0;border-top-right-radius:0}.mg-c-input.mg-c-input--is-input-group-append .mg-c-input__box:focus-visible{outline-offset:-0.2rem;outline-style:solid;outline-width:.2rem}.mg-c-input.mg-c-input--has-buttons-group-append ::slotted([slot=append-input]){--mg-c-button-border-radius-top-right:0;--mg-c-button-border-radius-bottom-right:0}.mg-c-input.mg-c-input--has-buttons-group-append ::slotted([slot=append-input]:not(:last-of-type)){--mg-c-button-border-right-width:0}.mg-c-input.mg-c-input--has-buttons-group-append ::slotted([slot=append-input]:last-of-type){--mg-c-button-border-radius-top-right:var(--mg-c-input-border-radius);--mg-c-button-border-radius-bottom-right:var(--mg-c-input-border-radius)}.mg-c-input.mg-c-input--is-append-input-slot-content:not(.mg-c-input--readonly) ::slotted([slot=append-input]){align-self:start;padding-top:calc((var(--mg-b-size-min-height) - var(--mg-b-size-16))/2)}.mg-u-visually-hidden{position:absolute !important;overflow:hidden !important;width:.1rem !important;height:.1rem !important;padding:0 !important;border:0 !important;margin:-0.1rem !important;clip:rect(0.1rem, 0.1rem, 0.1rem, 0.1rem) !important;clip-path:inset(50%) !important;white-space:nowrap !important}*:focus:not(:focus-visible){outline:none}@media (prefers-reduced-motion){*{animation:none !important;transition:none !important}}";
const MgInputDateStyle0 = mgInputDateCss;

const MgInputDate = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.valueChange = createEvent(this, "value-change", 7);
        this.inputValid = createEvent(this, "input-valid", 7);
        // hasDisplayedError (triggered by blur event)
        this.hasDisplayedError = false;
        /**
         * Input name
         * If not set the value equals the identifier
         */
        this.name = this.identifier;
        /**
         * Define if label is visible
         */
        this.labelHide = false;
        /**
         * Define if input is required
         */
        this.required = false;
        /**
         * Define if input is readonly
         */
        this.readonly = false;
        /**
         * Define input maximum date
         * format: yyyy-mm-dd
         */
        this.max = '9999-12-31';
        /**
         * Define if input is disabled
         */
        this.disabled = false;
        /**
         * Define tooltip position
         */
        this.tooltipPosition = 'input';
        /**
         * Component classes
         */
        this.classCollection = new Ze(['mg-c-input--date']);
        /**
         * Method to validate date pattern string
         * @param value - value to test
         * @returns truthy when value match the pattern
         */
        this.isValidPattern = (value) => me(value) && we.test(value);
        /**
         * Format help text to display
         * @param helpText - help text format
         * @returns formated pattern help text. Ex: Format attendu : jj/mm/aaaa (ex : 20/12/2020)
         */
        this.formatHelpText = (helpText) => {
            const defaultHelpTextVariable = '{defaultHelpText}';
            let text = me(helpText) ? helpText : this.messages.input.date.helpText;
            if (text.includes(defaultHelpTextVariable))
                text = text.replace(defaultHelpTextVariable, this.formatHelpText(this.messages.input.date.helpText));
            return text.replace('{pattern}', this.renderPattern()).replace('{date}', ze($t(new Date('2023-12-24')), this.systemLocale));
        };
        /**
         * Handle input event
         */
        this.handleInput = () => {
            this.checkValidity();
            if (this.hasDisplayedError) {
                this.setErrorMessage();
            }
            this.value = this.input.value;
        };
        /**
         * Handle blur event
         */
        this.handleBlur = () => {
            this.handlerInProgress = 'blur';
            this.displayError().finally(() => {
                // reset guard
                this.handlerInProgress = undefined;
            });
        };
        /**
         * Handle keydown event
         * @param event - input keydown event
         */
        this.handleKeyDown = (event) => {
            // bypass the native "Delete" action wich trigger an "input" event with "checkValidty() => false" with a falsy badInput = true,
            // when we reset the field we need to test a blank value.
            if (['Delete', 'Backspace'].includes(event.key)) {
                event.preventDefault();
                this.value = null;
                this.checkValidity();
                if (this.hasDisplayedError) {
                    this.setErrorMessage();
                }
            }
        };
        /**
         * Check if input is valid
         */
        this.checkValidity = () => {
            this.setValidity(this.readonly || this.disabled || (this.input.checkValidity() && (this.value === null || this.isValidPattern(this.value))));
        };
        /**
         * get input error code
         * @returns error code
         */
        this.getInputError = () => {
            var _a;
            let inputError = null;
            // bad input or pattern
            if (this.input.validity.badInput || (this.value && !this.isValidPattern(this.value))) {
                inputError = 'badInput';
            }
            // required
            else if (this.input.validity.valueMissing) {
                inputError = 'required';
            }
            // min & max
            else if ((this.input.validity.rangeUnderflow || this.input.validity.rangeOverflow) && ((_a = this.min) === null || _a === void 0 ? void 0 : _a.length) > 0 && this.max !== '9999-12-31') {
                inputError = 'minMax';
            }
            // min
            else if (this.input.validity.rangeUnderflow) {
                inputError = 'min';
            }
            // max
            else if (this.input.validity.rangeOverflow) {
                inputError = 'max';
            }
            return inputError;
        };
        /**
         * Check input errors
         * @param errorMessage - errorMessage override
         */
        this.setErrorMessage = (errorMessage) => {
            // Set error message
            this.errorMessage = undefined;
            if (!this.valid) {
                const inputError = this.getInputError();
                if (errorMessage !== undefined) {
                    this.errorMessage = errorMessage;
                }
                // required
                else if (inputError === 'required') {
                    this.errorMessage = this.messages.errors[inputError];
                }
                // min, max & minMax
                else if (['min', 'max', 'minMax'].includes(inputError)) {
                    this.errorMessage = this.messages.errors.date[inputError]
                        .replace('{min}', ze(this.min, this.systemLocale))
                        .replace('{max}', ze(this.max, this.systemLocale));
                }
                // wrong date format
                // element.validity.badInput is default error message
                else {
                    this.errorMessage = this.messages.errors.date.badInput.replace('{pattern}', this.renderPattern());
                }
            }
        };
        /**
         * Render pattern
         * @returns translated html pattern
         */
        this.renderPattern = () => {
            let patternLocal = ft(this.systemLocale);
            for (const key in this.messages.input.date.pattern) {
                patternLocal = patternLocal.replace(key, this.messages.input.date.pattern[key]);
            }
            return `<span aria-hidden="true">${patternLocal}</span><span class="mg-u-visually-hidden">${[...patternLocal].join(' ')}</span>`;
        };
    }
    validateValue(newValue) {
        // When the input is not fully completed or has been cleared, the value becomes an empty string.
        if (['', undefined].includes(newValue)) {
            // need to force value update to `null` to prevent extra render
            // - `''` is not a valide value
            // - `undefined` is not allowed in CustomEvent['detail']
            this.value = null;
        }
        else if (newValue && !me(newValue)) {
            // check value validity
            throw new Error(`<mg-input-date> props 'value' must be a valid string. Passed value: ${Ve(newValue)}.`);
        }
        else if (newValue === null || this.isValidPattern(newValue)) {
            this.valueChange.emit(newValue);
        }
        else {
            console.error("<mg-input-date> props 'value' doesn't match pattern: 'yyyy-mm-dd'.");
        }
    }
    watchReadonly(newValue) {
        if (newValue)
            this.classCollection.add(classReadonly);
        else
            this.classCollection.delete(classReadonly);
    }
    validateMinMax(newValue) {
        if (newValue && !this.isValidPattern(newValue)) {
            throw new Error(`<mg-input-date> props 'min/max' doesn't match pattern: 'yyyy-mm-dd'. Passed value: ${Ve(newValue)}.`);
        }
    }
    handleValidityChange(newValue, _oldValue, prop) {
        if (this.input !== undefined) {
            this.input[prop] = newValue;
            this.checkValidity();
            if (this.hasDisplayedError) {
                this.setErrorMessage();
                this.hasDisplayedError = false;
            }
        }
    }
    watchDisabled(newValue) {
        if (newValue)
            this.classCollection.add(classDisabled);
        else
            this.classCollection.delete(classDisabled);
    }
    /**
     * Display input error if it exists.
     */
    displayError() {
        // Use `Promise` as requested for stencil method
        // Use `requestAnimationFrame` to ensure:
        // - DOM is fully updated before validation
        // - Async operations are completed
        // - No timing issues with Stencil's render cycle
        // - Keep everything in sync both inside and outside the component
        return new Promise(resolve => {
            requestAnimationFrame(() => {
                this.checkValidity();
                this.setErrorMessage();
                this.hasDisplayedError = this.invalid;
                resolve();
            });
        });
    }
    /**
     * Set an error and display a custom error message.
     * This method can be used to set the component's error state from its context by passing a boolean value to the `valid` parameter.
     * It must be paired with an error message to display for the given context.
     * When used to set validity to `false`, you should use this method again to reset the validity to `true`.
     * @param valid - value indicating the validity
     * @param errorMessage - the error message to display
     */
    async setError(valid, errorMessage) {
        if (typeof valid !== 'boolean') {
            throw new Error('<mg-input-date> method "setError()" param "valid" must be a boolean.');
        }
        else if (!me(errorMessage)) {
            throw new Error('<mg-input-date> method "setError()" param "errorMessage" must be a string.');
        }
        else {
            this.setValidity(valid);
            this.setErrorMessage(valid ? undefined : errorMessage);
            this.hasDisplayedError = this.invalid;
        }
    }
    /**
     * Reset value, validity and error state
     */
    async reset() {
        if (!this.readonly) {
            this.value = null;
            this.checkValidity();
            this.invalid = false;
            this.errorMessage = undefined;
            this.hasDisplayedError = false;
        }
    }
    /**
     * Method to set validity values
     * @param newValue - valid new value
     */
    setValidity(newValue) {
        const oldValidValue = this.valid;
        this.valid = newValue;
        this.invalid = !this.valid;
        // We need to send valid event even if it is the same value
        if (this.handlerInProgress === undefined || (this.handlerInProgress === 'blur' && this.valid !== oldValidValue))
            this.inputValid.emit(this.valid);
    }
    /*************
     * Lifecycle *
     *************/
    /**
     * Check if component props are well configured on init
     * @returns timeout
     */
    componentWillLoad() {
        // Get locales
        const locales = initLocales(this.element);
        this.locale = locales.locale;
        this.messages = locales.messages;
        // as a native input use the OS locale to define the date pattern
        // we need to get this locale to define the displayed pattern
        this.systemLocale = Intl.DateTimeFormat().resolvedOptions().locale;
        // Validate
        this.validateValue(this.value);
        this.validateMinMax(this.min);
        this.validateMinMax(this.max);
        this.watchReadonly(this.readonly);
        this.watchDisabled(this.disabled);
        // Check validity when component is ready
        // return a promise to process action only in the FIRST render().
        // https://stenciljs.com/docs/component-lifecycle#componentwillload
        return setTimeout(() => {
            this.checkValidity();
        }, 0);
    }
    /**
     * Render
     * @returns HTML Element
     */
    render() {
        return (h("mg-input", { key: '78d4b2b8adb5aa39757e9e077a3d597d72b5c61b', label: this.label, identifier: this.identifier, class: this.classCollection.join(), ariaDescribedbyIDs: [], labelOnTop: this.labelOnTop, labelHide: this.labelHide, required: this.required, tooltip: this.tooltip, tooltipPosition: this.readonly && this.value === null ? 'label' : this.tooltipPosition, helpText: this.formatHelpText(this.helpText), errorMessage: this.errorMessage }, this.readonly ? (this.value && h("b", { class: "mg-c-input__readonly-value" }, ze(this.value, this.locale))) : (h("input", { type: "date", class: "mg-c-input__box", min: this.min, max: this.max, value: this.value, id: this.identifier, name: this.name, disabled: this.disabled, required: this.required, "aria-invalid": (this.invalid === true).toString(), onInput: this.handleInput, onBlur: this.handleBlur, onKeyDown: this.handleKeyDown, ref: (el) => {
                if (el !== null)
                    this.input = el;
            } }))));
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "value": ["validateValue"],
        "readonly": ["watchReadonly", "handleValidityChange"],
        "min": ["validateMinMax", "handleValidityChange"],
        "max": ["validateMinMax", "handleValidityChange"],
        "required": ["handleValidityChange"],
        "disabled": ["handleValidityChange", "watchDisabled"]
    }; }
};
MgInputDate.style = MgInputDateStyle0;

/**
 * List of all possibles types
 */
const types = ['decimal', 'integer'];
const formats = ['none', 'number', 'currency', 'percent', 'unit'];

const mgInputNumericCss = ".mg-c-input__box{height:var(--mg-b-size-min-height);box-sizing:border-box;padding:calc((var(--mg-b-size-min-height) - var(--mg-b-font-size)*var(--mg-b-line-height))/2) var(--mg-b-size-8);border-width:var(--mg-c-input-border-width);border-style:solid;border-color:var(--mg-c-input-color-border);border-radius:var(--mg-c-input-border-radius);background-color:var(--mg-b-color-light);color:var(--mg-b-color-dark);font-family:inherit;font-size:var(--mg-b-font-size);text-align:var(--mg-c-input-text-align, left)}.mg-c-input__box::placeholder{color:var(--mg-c-input-placeholder-color-text);font-style:italic}.mg-c-input__box:focus{box-shadow:0 0 var(--mg-b-size-4) var(--mg-c-input-color-box-shadow-focus)}.mg-c-input__box:disabled{opacity:var(--mg-b-opacity-element-disabled)}.mg-c-input.mg-c-input--has-error .mg-c-input__box{border-color:var(--mg-b-color-danger)}.mg-c-input.mg-c-input--is-input-group-append{--mg-c-button-border-radius-top-left:0;--mg-c-button-border-radius-bottom-left:0}.mg-c-input.mg-c-input--is-input-group-append .mg-c-input__box{margin-right:calc(-1*var(--mg-b-size-border));border-bottom-right-radius:0;border-top-right-radius:0}.mg-c-input.mg-c-input--is-input-group-append .mg-c-input__box:focus-visible{outline-offset:-0.2rem;outline-style:solid;outline-width:.2rem}.mg-c-input.mg-c-input--has-buttons-group-append ::slotted([slot=append-input]){--mg-c-button-border-radius-top-right:0;--mg-c-button-border-radius-bottom-right:0}.mg-c-input.mg-c-input--has-buttons-group-append ::slotted([slot=append-input]:not(:last-of-type)){--mg-c-button-border-right-width:0}.mg-c-input.mg-c-input--has-buttons-group-append ::slotted([slot=append-input]:last-of-type){--mg-c-button-border-radius-top-right:var(--mg-c-input-border-radius);--mg-c-button-border-radius-bottom-right:var(--mg-c-input-border-radius)}.mg-c-input.mg-c-input--is-append-input-slot-content:not(.mg-c-input--readonly) ::slotted([slot=append-input]){align-self:start;padding-top:calc((var(--mg-b-size-min-height) - var(--mg-b-size-16))/2)}.mg-c-input__readonly-value{min-height:var(--mg-b-font-size);align-self:flex-start;margin-top:calc((var(--mg-b-size-min-height) - var(--mg-b-font-size)*var(--mg-b-line-height))/2);word-break:break-word}.mg-c-input__input-container{width:100%;flex:1 auto}.mg-c-input.mg-c-input--width-full .mg-c-input__box{width:100%}.mg-c-input.mg-c-input--width-2 .mg-c-input__with-character-left,.mg-c-input.mg-c-input--width-4 .mg-c-input__with-character-left,.mg-c-input.mg-c-input--width-16 .mg-c-input__with-character-left{width:max-content}.mg-c-input.mg-c-input--width-2 .mg-c-input__with-character-left:has(textarea),.mg-c-input.mg-c-input--width-4 .mg-c-input__with-character-left:has(textarea),.mg-c-input.mg-c-input--width-16 .mg-c-input__with-character-left:has(textarea){flex-grow:inherit}.mg-c-input.mg-c-input--width-2 .mg-c-input__box{width:var(--mg-b-size-48)}.mg-c-input.mg-c-input--width-2 .mg-c-input__with-character-left:not(:has(textarea)) .mg-c-input__box{width:calc(var(--mg-b-size-48) + var(--mg-c-character-left-message-length)*(.35ch + .3rem))}.mg-c-input.mg-c-input--width-4 .mg-c-input__box{width:var(--mg-b-size-72)}.mg-c-input.mg-c-input--width-4 .mg-c-input__with-character-left:not(:has(textarea)) .mg-c-input__box{width:calc(var(--mg-b-size-72) + var(--mg-c-character-left-message-length)*(.35ch + .3rem))}.mg-c-input.mg-c-input--width-16 .mg-c-input__box{width:calc(26*var(--mg-b-size-8))}.mg-c-input.mg-c-input--width-16 .mg-c-input__with-character-left:not(:has(textarea)) .mg-c-input__box{width:calc(calc(26 * var(--mg-b-size-8)) + var(--mg-c-character-left-message-length)*(.35ch + .3rem))}.mg-c-input.mg-c-input--width-full:not(.mg-c-input--label-on-top){justify-content:stretch}.mg-c-input.mg-c-input--is-input-group-append ::slotted([slot=append-input]),.mg-c-input.mg-c-input--is-append-input-slot-content ::slotted([slot=append-input]){width:auto}:host(.mg-c-input.mg-c-input--width-full) ::slotted(*:not(mg-input-title)){width:100%;max-width:100%}.mg-u-visually-hidden{position:absolute !important;overflow:hidden !important;width:.1rem !important;height:.1rem !important;padding:0 !important;border:0 !important;margin:-0.1rem !important;clip:rect(0.1rem, 0.1rem, 0.1rem, 0.1rem) !important;clip-path:inset(50%) !important;white-space:nowrap !important}*:focus:not(:focus-visible){outline:none}@media (prefers-reduced-motion){*{animation:none !important;transition:none !important}}.mg-c-input .mg-c-input__box{width:auto;text-align:var(--mg-c-input-text-align, right)}";
const MgInputNumericStyle0 = mgInputNumericCss;

const MgInputNumeric = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.valueChange = createEvent(this, "value-change", 7);
        this.inputValid = createEvent(this, "input-valid", 7);
        // hasDisplayedError (triggered by blur event)
        this.hasDisplayedError = false;
        /**
         * Input name
         * If not set the value equals the identifier
         */
        this.name = this.identifier;
        /**
         * Define if label is visible
         */
        this.labelHide = false;
        /**
         * Define if input is required
         */
        this.required = false;
        /**
         * Define if input is readonly
         */
        this.readonly = false;
        /**
         * Define if input is disabled
         */
        this.disabled = false;
        /**
         * Define tooltip position
         */
        this.tooltipPosition = 'input';
        /**
         * Define numeric type
         */
        this.type = 'decimal';
        /**
         * Set local formatting.
         * Numbers are formatted based on the locale.
         */
        this.format = 'number';
        /**
         * Define currency
         */
        this.currency = 'EUR';
        /**
         * Define unit display format ('short', 'long', 'narrow')
         */
        this.unitDisplay = 'short';
        /**
         * Override integer length
         * integer is the number before the decimal point
         */
        this.integerLength = 13;
        /**
         * Override decimal length
         * decimal is the number after the decimal point
         */
        this.decimalLength = 2;
        /**
         * Component classes
         */
        this.classCollection = new Ze(['mg-c-input--numeric']);
        /**
         * Handle input event
         */
        this.handleInput = () => {
            // Check validity
            this.checkValidity();
            if (this.hasDisplayedError) {
                this.setErrorMessage();
            }
            this.value = this.input.value;
        };
        /**
         * Handle focus event
         */
        this.handleFocus = () => {
            this.hasFocus = true;
        };
        /**
         * Handle blur event
         */
        this.handleBlur = () => {
            if (this.value === '-')
                this.value = '';
            // Display Error
            this.handlerInProgress = 'blur';
            this.displayError().finally(() => {
                // reset guard
                this.handlerInProgress = undefined;
                this.hasFocus = false;
            });
        };
        /**
         * Check if input is valid
         */
        this.checkValidity = () => {
            this.setValidity(this.readonly || this.disabled || this.getInputError() === null);
        };
        /**
         * Format min/max value for error message
         * @param value - value to format
         * @returns formatted value according to locale
         */
        this.formatErrorValue = (value) => dt(value, this.locale, !Number.isInteger(value) && this.type === 'decimal' ? this.decimalLength : 0);
        /**
         * Set input error message
         * @param errorMessage - errorMessage override
         */
        this.setErrorMessage = (errorMessage) => {
            // Set error message
            this.errorMessage = undefined;
            if (!this.valid) {
                const inputError = this.getInputError();
                if (errorMessage !== undefined) {
                    this.errorMessage = errorMessage;
                }
                else if (inputError === 'required') {
                    this.errorMessage = this.messages.errors[inputError];
                }
                else {
                    const formattedMin = this.formatErrorValue(this.min);
                    const formattedMax = this.formatErrorValue(this.max);
                    this.errorMessage = this.messages.errors.numeric[inputError].replace('{min}', formattedMin).replace('{max}', formattedMax);
                }
            }
        };
        /**
         * Get input error code
         * @returns error code
         */
        this.getInputError = () => {
            let inputError = null;
            const hasNotEmptyValues = (toControl) => !toControl.some(value => [null, undefined].includes(value));
            // required
            if (!this.input.checkValidity() && this.input.validity.valueMissing) {
                inputError = 'required';
            }
            // Min & Max
            else if (hasNotEmptyValues([this.min, this.numericValue]) && this.numericValue < this.min && this.max === undefined) {
                // Only a min value is set
                inputError = 'min';
            }
            else if (hasNotEmptyValues([this.max, this.numericValue]) && this.numericValue > this.max && this.min === undefined) {
                // Only a max value is set
                inputError = 'max';
            }
            else if (hasNotEmptyValues([this.min, this.max, this.numericValue]) && (this.numericValue < this.min || this.numericValue > this.max)) {
                // both min and max values are set
                inputError = 'minMax';
            }
            return inputError;
        };
        /**
         * Format value based on type
         * @param value - value to format
         * @returns formated local value
         */
        this.formatValue = (value) => {
            switch (this.format) {
                case 'number':
                    return dt(value, this.locale, this.type === 'decimal' ? this.decimalLength : undefined);
                case 'currency':
                    return ut(value, this.locale, this.currency);
                case 'percent':
                    return gt(value / 100, this.locale, this.type === 'decimal' ? this.decimalLength : undefined);
                case 'unit':
                    return pt(value, this.locale, this.unit, this.unitDisplay, this.type === 'decimal' ? this.decimalLength : undefined);
                case 'none':
                    return value.toString();
            }
        };
        /**
         * Validate append slot
         */
        this.validateAppendSlot = () => {
            const slotAppendInput = this.element.querySelector('[slot="append-input"]');
            if (slotAppendInput !== null) {
                if (slotAppendInput.nodeName === 'MG-BUTTON') {
                    this.classCollection.add('mg-c-input--is-input-group-append');
                }
                else {
                    this.classCollection.add('mg-c-input--is-append-input-slot-content');
                    this.slotContent = slotAppendInput.textContent;
                }
            }
        };
        /**
         * Renders the readonly content of the input component.
         * @returns The readonly content element.
         */
        this.renderReadonly = () => {
            return this.slotContent !== undefined ? (h("span", { class: "mg-c-input__readonly-value" }, h("b", null, this.readonlyValue), this.slotContent)) : (h("b", { class: "mg-c-input__readonly-value" }, this.readonlyValue));
        };
    }
    validateValue(newValue) {
        // has input value is always render as string we get a stringified value or a '' for nullish value, so we test string type
        if (typeof newValue === 'string') {
            // Split number and decimal
            const [integer, decimal = ''] = newValue.replace('-', '').split(/[.,]/);
            // Regex
            const regex = this.type === 'integer' ? /^-?\d+$/ : /^-?\d+(?:[.,]\d*)?$/;
            // Filter input
            if (this.isValidValue(newValue, regex, integer, decimal)) {
                this.storedValue = newValue;
            }
            else {
                newValue = this.handleInvalidValue();
            }
            // Set value and input value
            this.updateValues(newValue);
        }
    }
    watchReadonly(newValue) {
        if (newValue)
            this.classCollection.add(classReadonly);
        else
            this.classCollection.delete(classReadonly);
    }
    handleValidityChange(newValue, _oldValue, prop) {
        if (this.input !== undefined) {
            this.input[prop] = newValue;
            this.checkValidity();
            if (this.hasDisplayedError) {
                this.setErrorMessage();
                this.hasDisplayedError = false;
            }
        }
    }
    watchDisabled(newValue) {
        if (newValue)
            this.classCollection.add(classDisabled);
        else
            this.classCollection.delete(classDisabled);
    }
    watchMgWidth(newValue) {
        // reset width class
        widths.forEach(width => {
            this.classCollection.delete(`mg-c-input--width-${width}`);
        });
        // apply new width
        if (newValue !== undefined)
            this.classCollection.add(`mg-c-input--width-${this.mgWidth}`);
    }
    validateType(newValue) {
        if (!types.includes(newValue)) {
            throw new Error(`<mg-input-numeric> prop "type" must be one of: ${types.join(', ')}. Passed value: ${Ve(newValue)}.`);
        }
    }
    watchFormat(newValue) {
        if (!formats.includes(newValue)) {
            throw new Error(`<mg-input-numeric> prop "format" must be one of: ${formats.join(', ')}. Passed value: ${Ve(newValue)}.`);
        }
    }
    validateIntegerLength(newValue) {
        if (newValue < 1) {
            throw new Error(`<mg-input-numeric> prop "integer-length" must be a positive number. Passed value: ${Ve(newValue)}.`);
        }
    }
    validateDecimalLength(newValue) {
        if (newValue < 1) {
            throw new Error(`<mg-input-numeric> prop "decimal-length" must be a positive number, consider using prop "type" to "integer" instead. Passed value: ${Ve(newValue)}.`);
        }
    }
    /**
     * Display input error if it exists.
     */
    displayError() {
        // Use `Promise` as requested for stencil method
        // Use `requestAnimationFrame` to ensure:
        // - DOM is fully updated before validation
        // - Async operations are completed
        // - No timing issues with Stencil's render cycle
        // - Keep everything in sync both inside and outside the component
        return new Promise(resolve => {
            requestAnimationFrame(() => {
                this.checkValidity();
                this.setErrorMessage();
                this.hasDisplayedError = this.invalid;
                resolve();
            });
        });
    }
    /**
     * Set an error and display a custom error message.
     * This method can be used to set the component's error state from its context by passing a boolean value to the `valid` parameter.
     * It must be paired with an error message to display for the given context.
     * When used to set validity to `false`, you should use this method again to reset the validity to `true`.
     * @param valid - value indicating the validity
     * @param errorMessage - the error message to display
     */
    async setError(valid, errorMessage) {
        if (typeof valid !== 'boolean') {
            throw new Error('<mg-input-numeric> method "setError()" param "valid" must be a boolean.');
        }
        else if (!me(errorMessage)) {
            throw new Error('<mg-input-numeric> method "setError()" param "errorMessage" must be a string.');
        }
        else {
            this.setValidity(valid);
            this.setErrorMessage(valid ? undefined : errorMessage);
            this.hasDisplayedError = this.invalid;
        }
    }
    /**
     * Reset value, validity and error state
     */
    async reset() {
        if (!this.readonly) {
            this.value = '';
            this.checkValidity();
            this.errorMessage = undefined;
            this.hasDisplayedError = false;
        }
    }
    /**
     * Method to set validity values
     * @param newValue - valid new value
     */
    setValidity(newValue) {
        const oldValidValue = this.valid;
        this.valid = newValue;
        this.invalid = !this.valid;
        // We need to send valid event even if it is the same value
        if (this.handlerInProgress === undefined || (this.handlerInProgress === 'blur' && this.valid !== oldValidValue))
            this.inputValid.emit(this.valid);
    }
    /**
     * Checks if the given value is valid according to the defined rules.
     * @param value - The input value to validate.
     * @param regex - The regular expression for validation.
     * @param integer - The integer part of the value.
     * @param decimal - The decimal part of the value.
     * @returns Returns true if the value is valid, otherwise false.
     */
    isValidValue(value, regex, integer, decimal) {
        return (['', '-'].includes(value) || (regex.exec(value) !== null && integer.length <= this.integerLength && decimal.length <= (this.type === 'integer' ? 0 : this.decimalLength)));
    }
    /**
     * Handles invalid input values and returns a corrected value.
     * @returns The corrected value.
     */
    handleInvalidValue() {
        var _a;
        return (_a = this.storedValue) !== null && _a !== void 0 ? _a : null;
    }
    /**
     * Updates the component values based on the validated input value.
     * @param newValue - The validated input value.
     */
    updateValues(newValue) {
        this.value = newValue;
        if (this.input !== undefined)
            this.input.value = this.value;
        this.numericValue = !['', null].includes(this.value) ? parseFloat(this.value.replace(',', '.')) : null;
        this.valueChange.emit(this.numericValue);
        this.readonlyValue = this.numericValue !== null ? this.formatValue(this.numericValue) : '';
    }
    /**
     * Displayed value in input
     * Change on focus/blur
     * @returns display value
     */
    displayValue() {
        return this.hasFocus ? this.value : this.readonlyValue;
    }
    /*************
     * Lifecycle *
     *************/
    /**
     * Check if component props are well configured on init
     * @returns timeout
     */
    componentWillLoad() {
        // Get locales
        const locales = initLocales(this.element);
        this.locale = locales.locale;
        this.messages = locales.messages;
        // Validate component config
        this.watchFormat(this.format);
        this.validateType(this.type);
        this.validateIntegerLength(this.integerLength);
        this.validateDecimalLength(this.decimalLength);
        // validate value
        this.validateValue(this.value);
        this.validateAppendSlot();
        this.watchReadonly(this.readonly);
        this.watchDisabled(this.disabled);
        this.watchMgWidth(this.mgWidth);
        // Check validity when component is ready
        // return a promise to process action only in the FIRST render().
        // https://stenciljs.com/docs/component-lifecycle#componentwillload
        return setTimeout(() => {
            this.checkValidity();
        }, 0);
    }
    /**
     * Render
     * @returns HTML Element
     */
    render() {
        return (h("mg-input", { key: '1607a9811037ae2e3a5c1f444f6ec05da38b990b', label: this.label, identifier: this.identifier, class: this.classCollection.join(), ariaDescribedbyIDs: [], labelOnTop: this.labelOnTop, labelHide: this.labelHide, required: this.required, tooltip: this.tooltip, tooltipPosition: this.readonly && this.value === undefined ? 'label' : this.tooltipPosition, helpText: this.helpText, errorMessage: this.errorMessage }, this.readonly
            ? this.readonlyValue && this.renderReadonly()
            : [
                h("input", { key: "input", type: "text", class: "mg-c-input__box mg-c-input__box--width", value: this.displayValue(), id: this.identifier, name: this.name, placeholder: this.placeholder, title: this.placeholder, disabled: this.disabled, required: this.required, autocomplete: "off", "aria-invalid": (this.invalid === true).toString(), onInput: this.handleInput, onFocus: this.handleFocus, onBlur: this.handleBlur, ref: (el) => {
                        if (el !== null)
                            this.input = el;
                    } }),
                h("slot", { key: "slot", name: "append-input" }),
            ]));
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "value": ["validateValue"],
        "readonly": ["watchReadonly", "handleValidityChange"],
        "required": ["handleValidityChange"],
        "disabled": ["handleValidityChange", "watchDisabled"],
        "min": ["handleValidityChange"],
        "max": ["handleValidityChange"],
        "mgWidth": ["watchMgWidth"],
        "type": ["validateType"],
        "format": ["watchFormat"],
        "integerLength": ["validateIntegerLength"],
        "decimalLength": ["validateDecimalLength"]
    }; }
};
MgInputNumeric.style = MgInputNumericStyle0;

const mgInputPasswordCss = ".mg-c-input__box{height:var(--mg-b-size-min-height);box-sizing:border-box;padding:calc((var(--mg-b-size-min-height) - var(--mg-b-font-size)*var(--mg-b-line-height))/2) var(--mg-b-size-8);border-width:var(--mg-c-input-border-width);border-style:solid;border-color:var(--mg-c-input-color-border);border-radius:var(--mg-c-input-border-radius);background-color:var(--mg-b-color-light);color:var(--mg-b-color-dark);font-family:inherit;font-size:var(--mg-b-font-size);text-align:var(--mg-c-input-text-align, left)}.mg-c-input__box::placeholder{color:var(--mg-c-input-placeholder-color-text);font-style:italic}.mg-c-input__box:focus{box-shadow:0 0 var(--mg-b-size-4) var(--mg-c-input-color-box-shadow-focus)}.mg-c-input__box:disabled{opacity:var(--mg-b-opacity-element-disabled)}.mg-c-input.mg-c-input--has-error .mg-c-input__box{border-color:var(--mg-b-color-danger)}.mg-c-input.mg-c-input--is-input-group-append{--mg-c-button-border-radius-top-left:0;--mg-c-button-border-radius-bottom-left:0}.mg-c-input.mg-c-input--is-input-group-append .mg-c-input__box{margin-right:calc(-1*var(--mg-b-size-border));border-bottom-right-radius:0;border-top-right-radius:0}.mg-c-input.mg-c-input--is-input-group-append .mg-c-input__box:focus-visible{outline-offset:-0.2rem;outline-style:solid;outline-width:.2rem}.mg-c-input.mg-c-input--has-buttons-group-append ::slotted([slot=append-input]){--mg-c-button-border-radius-top-right:0;--mg-c-button-border-radius-bottom-right:0}.mg-c-input.mg-c-input--has-buttons-group-append ::slotted([slot=append-input]:not(:last-of-type)){--mg-c-button-border-right-width:0}.mg-c-input.mg-c-input--has-buttons-group-append ::slotted([slot=append-input]:last-of-type){--mg-c-button-border-radius-top-right:var(--mg-c-input-border-radius);--mg-c-button-border-radius-bottom-right:var(--mg-c-input-border-radius)}.mg-c-input.mg-c-input--is-append-input-slot-content:not(.mg-c-input--readonly) ::slotted([slot=append-input]){align-self:start;padding-top:calc((var(--mg-b-size-min-height) - var(--mg-b-size-16))/2)}.mg-c-input__readonly-value{min-height:var(--mg-b-font-size);align-self:flex-start;margin-top:calc((var(--mg-b-size-min-height) - var(--mg-b-font-size)*var(--mg-b-line-height))/2);word-break:break-word}.mg-c-input__input-container{width:100%;flex:1 auto}.mg-c-input.mg-c-input--width-full .mg-c-input__box{width:100%}.mg-c-input.mg-c-input--width-2 .mg-c-input__with-character-left,.mg-c-input.mg-c-input--width-4 .mg-c-input__with-character-left,.mg-c-input.mg-c-input--width-16 .mg-c-input__with-character-left{width:max-content}.mg-c-input.mg-c-input--width-2 .mg-c-input__with-character-left:has(textarea),.mg-c-input.mg-c-input--width-4 .mg-c-input__with-character-left:has(textarea),.mg-c-input.mg-c-input--width-16 .mg-c-input__with-character-left:has(textarea){flex-grow:inherit}.mg-c-input.mg-c-input--width-2 .mg-c-input__box{width:var(--mg-b-size-48)}.mg-c-input.mg-c-input--width-2 .mg-c-input__with-character-left:not(:has(textarea)) .mg-c-input__box{width:calc(var(--mg-b-size-48) + var(--mg-c-character-left-message-length)*(.35ch + .3rem))}.mg-c-input.mg-c-input--width-4 .mg-c-input__box{width:var(--mg-b-size-72)}.mg-c-input.mg-c-input--width-4 .mg-c-input__with-character-left:not(:has(textarea)) .mg-c-input__box{width:calc(var(--mg-b-size-72) + var(--mg-c-character-left-message-length)*(.35ch + .3rem))}.mg-c-input.mg-c-input--width-16 .mg-c-input__box{width:calc(26*var(--mg-b-size-8))}.mg-c-input.mg-c-input--width-16 .mg-c-input__with-character-left:not(:has(textarea)) .mg-c-input__box{width:calc(calc(26 * var(--mg-b-size-8)) + var(--mg-c-character-left-message-length)*(.35ch + .3rem))}.mg-c-input.mg-c-input--width-full:not(.mg-c-input--label-on-top){justify-content:stretch}.mg-c-input.mg-c-input--is-input-group-append ::slotted([slot=append-input]),.mg-c-input.mg-c-input--is-append-input-slot-content ::slotted([slot=append-input]){width:auto}:host(.mg-c-input.mg-c-input--width-full) ::slotted(*:not(mg-input-title)){width:100%;max-width:100%}.mg-u-visually-hidden{position:absolute !important;overflow:hidden !important;width:.1rem !important;height:.1rem !important;padding:0 !important;border:0 !important;margin:-0.1rem !important;clip:rect(0.1rem, 0.1rem, 0.1rem, 0.1rem) !important;clip-path:inset(50%) !important;white-space:nowrap !important}*:focus:not(:focus-visible){outline:none}@media (prefers-reduced-motion){*{animation:none !important;transition:none !important}}.mg-c-input.mg-c-input--password .mg-c-input__input-icon{color:var(--mg-b-color-dark)}.mg-c-input.mg-c-input--password .mg-c-input__input-group{position:relative;flex-grow:1}.mg-c-input.mg-c-input--password .mg-c-input__append-button{position:absolute;right:0}.mg-c-input.mg-c-input--password .mg-c-input__box{padding-right:calc(var(--mg-b-size-min-height) + var(--mg-b-size-8))}.mg-c-input.mg-c-input--password .mg-c-input__box::-ms-reveal{display:none}";
const MgInputPasswordStyle0 = mgInputPasswordCss;

const MgInputPassword = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.valueChange = createEvent(this, "value-change", 7);
        this.inputValid = createEvent(this, "input-valid", 7);
        // hasDisplayedError (triggered by blur event)
        this.hasDisplayedError = false;
        /**
         * Input name
         * If not set the value equals the identifier
         */
        this.name = this.identifier;
        /**
         * Define if label is visible
         */
        this.labelHide = false;
        /**
         * Define if input is required
         */
        this.required = false;
        /**
         * Define if input is readonly
         */
        this.readonly = false;
        /**
         * Define if input is disabled
         */
        this.disabled = false;
        /**
         * Define input width
         */
        this.mgWidth = 'full';
        /**
         * Define tooltip position
         */
        this.tooltipPosition = 'input';
        /**
         * Component classes
         */
        this.classCollection = new Ze(['mg-c-input--password']);
        /**
         * Indicates if password is displayed or not
         */
        this.displayPassword = false;
        /**
         * Handle input event
         */
        this.handleInput = () => {
            this.checkValidity();
            if (this.hasDisplayedError) {
                this.setErrorMessage();
            }
            this.value = this.input.value;
        };
        /**
         * Handle blur event
         */
        this.handleBlur = () => {
            this.handlerInProgress = 'blur';
            this.displayError().finally(() => {
                // reset guard
                this.handlerInProgress = undefined;
            });
        };
        /**
         * Toggle display-pasword value
         */
        this.toggleDisplayPassword = () => {
            this.displayPassword = !this.displayPassword;
        };
        /**
         * Check if input is valid
         */
        this.checkValidity = () => {
            this.setValidity(this.readonly || this.disabled || this.input.checkValidity());
        };
        /**
         * Set input error message
         * @param errorMessage - errorMessage override
         */
        this.setErrorMessage = (errorMessage) => {
            // Set error message
            this.errorMessage = undefined;
            if (!this.valid) {
                if (errorMessage !== undefined) {
                    this.errorMessage = errorMessage;
                }
                // required
                else if (this.input.validity.valueMissing) {
                    this.errorMessage = this.messages.errors.required;
                }
            }
        };
    }
    handleValue(newValue) {
        this.valueChange.emit(newValue);
    }
    watchReadonly(newValue) {
        if (newValue)
            this.classCollection.add(classReadonly);
        else
            this.classCollection.delete(classReadonly);
    }
    handleValidityChange(newValue, _oldValue, prop) {
        if (this.input !== undefined) {
            this.input[prop] = newValue;
            this.checkValidity();
            if (this.hasDisplayedError) {
                this.setErrorMessage();
                this.hasDisplayedError = false;
            }
        }
    }
    watchDisabled(newValue) {
        if (newValue)
            this.classCollection.add(classDisabled);
        else
            this.classCollection.delete(classDisabled);
    }
    watchMgWidth(newValue) {
        // reset width class
        widths.forEach(width => {
            this.classCollection.delete(`mg-c-input--width-${width}`);
        });
        // apply new width
        if (newValue !== undefined)
            this.classCollection.add(`mg-c-input--width-${this.mgWidth}`);
    }
    /**
     * Display input error if it exists.
     */
    displayError() {
        // Use `Promise` as requested for stencil method
        // Use `requestAnimationFrame` to ensure:
        // - DOM is fully updated before validation
        // - Async operations are completed
        // - No timing issues with Stencil's render cycle
        // - Keep everything in sync both inside and outside the component
        return new Promise(resolve => {
            requestAnimationFrame(() => {
                this.checkValidity();
                this.setErrorMessage();
                this.hasDisplayedError = this.invalid;
                resolve();
            });
        });
    }
    /**
     * Set an error and display a custom error message.
     * This method can be used to set the component's error state from its context by passing a boolean value to the `valid` parameter.
     * It must be paired with an error message to display for the given context.
     * When used to set validity to `false`, you should use this method again to reset the validity to `true`.
     * @param valid - value indicating the validity
     * @param errorMessage - the error message to display
     */
    async setError(valid, errorMessage) {
        if (typeof valid !== 'boolean') {
            throw new Error('<mg-input-password> method "setError()" param "valid" must be a boolean.');
        }
        else if (!me(errorMessage)) {
            throw new Error('<mg-input-password> method "setError()" param "errorMessage" must be a string.');
        }
        else {
            this.setValidity(valid);
            this.setErrorMessage(valid ? undefined : errorMessage);
            this.hasDisplayedError = this.invalid;
        }
    }
    /**
     * Reset value, validity and error state
     */
    async reset() {
        if (!this.readonly) {
            this.value = '';
            this.checkValidity();
            this.errorMessage = undefined;
            this.hasDisplayedError = false;
        }
    }
    /**
     * Method to set validity values
     * @param newValue - valid new value
     */
    setValidity(newValue) {
        const oldValidValue = this.valid;
        this.valid = newValue;
        this.invalid = !this.valid;
        // We need to send valid event even if it is the same value
        if (this.handlerInProgress === undefined || (this.handlerInProgress === 'blur' && this.valid !== oldValidValue))
            this.inputValid.emit(this.valid);
    }
    /*************
     * Lifecycle *
     *************/
    /**
     * Check if component props are well configured on init
     * @returns timeout
     */
    componentWillLoad() {
        // Get locales
        this.messages = initLocales(this.element).messages;
        this.watchReadonly(this.readonly);
        this.watchDisabled(this.disabled);
        this.watchMgWidth(this.mgWidth);
        // Check validity when component is ready
        // return a promise to process action only in the FIRST render().
        // https://stenciljs.com/docs/component-lifecycle#componentwillload
        return setTimeout(() => {
            this.checkValidity();
        }, 0);
    }
    /**
     * Render
     * @returns HTML Element
     */
    render() {
        return (h("mg-input", { key: '041b674ecb4d2750c5f404d7862756bb56dbd8f7', label: this.label, identifier: this.identifier, class: this.classCollection.join(), ariaDescribedbyIDs: [], labelOnTop: this.labelOnTop, labelHide: this.labelHide, required: this.required, tooltip: this.tooltip, tooltipPosition: this.readonly && this.value === undefined ? 'label' : this.tooltipPosition, helpText: this.helpText, errorMessage: this.errorMessage }, this.readonly ? (this.value !== undefined && h("b", { class: "mg-c-input__readonly-value" }, '•'.repeat(this.value.length))) : (h("span", { class: "mg-c-input__input-group" }, h("input", { type: this.displayPassword ? 'text' : 'password', class: "mg-c-input__box mg-c-input__box--width", value: this.value, id: this.identifier, name: this.name, placeholder: this.placeholder, title: this.placeholder, disabled: this.disabled, required: this.required, maxlength: this.maxlength, "aria-invalid": (this.invalid === true).toString(), onInput: this.handleInput, onBlur: this.handleBlur, ref: (el) => {
                if (el !== null)
                    this.input = el;
            } }), h("mg-button", { label: this.messages.input.password[this.displayPassword ? 'hide' : 'display'], disabled: this.disabled, variant: "flat", class: "mg-c-input__append-button", "is-icon": true, onClick: this.toggleDisplayPassword, "aria-controls": this.identifier }, h("mg-icon", { class: "mg-c-input__input-icon", icon: this.displayPassword ? 'eye-slash' : 'eye' }))))));
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "value": ["handleValue"],
        "readonly": ["watchReadonly", "handleValidityChange"],
        "required": ["handleValidityChange"],
        "disabled": ["handleValidityChange", "watchDisabled"],
        "mgWidth": ["watchMgWidth"]
    }; }
};
MgInputPassword.style = MgInputPasswordStyle0;

const mgInputRadioCss = ".mg-c-input__readonly-value{min-height:var(--mg-b-font-size);align-self:flex-start;margin-top:calc((var(--mg-b-size-min-height) - var(--mg-b-font-size)*var(--mg-b-line-height))/2);word-break:break-word}.mg-c-input.mg-c-input--fieldset{padding:0;border:0;margin-right:0;margin-left:0}.mg-c-input.mg-c-input--fieldset input[type=radio],.mg-c-input.mg-c-input--fieldset input[type=checkbox]{width:var(--mg-c-input-check-size);height:var(--mg-c-input-check-size);flex-shrink:0;margin:calc((var(--mg-b-font-size)*var(--mg-b-line-height) - var(--mg-c-input-check-size))/2) var(--mg-b-size-8) 0 0}.mg-c-input.mg-c-input--fieldset .mg-c-input__input-group{display:flex;align-items:start}.mg-c-input.mg-c-input--fieldset .mg-c-input__input-group-container{display:flex;flex-wrap:wrap;padding:0;margin:0;margin-top:calc((var(--mg-b-size-min-height) - var(--mg-b-font-size)*var(--mg-b-line-height))/2);gap:var(--mg-b-size-12) var(--mg-b-size-24);list-style:none}.mg-c-input.mg-c-input--fieldset .mg-c-input__input-group.mg-c-input__input-group--disabled label{opacity:var(--mg-b-opacity-element-disabled)}.mg-c-input.mg-c-input--fieldset.mg-c-input--vertical-list .mg-c-input__input-group-container,.mg-c-input.mg-c-input--fieldset.mg-c-input--checkbox-multi .mg-c-input__input-group-container{flex-direction:column}.mg-c-input.mg-c-input--fieldset.mg-c-input--label-on-top .mg-c-input__input-group-container{margin-top:var(--mg-b-size-8)}.mg-u-visually-hidden{position:absolute !important;overflow:hidden !important;width:.1rem !important;height:.1rem !important;padding:0 !important;border:0 !important;margin:-0.1rem !important;clip:rect(0.1rem, 0.1rem, 0.1rem, 0.1rem) !important;clip-path:inset(50%) !important;white-space:nowrap !important}*:focus:not(:focus-visible){outline:none}@media (prefers-reduced-motion){*{animation:none !important;transition:none !important}}";
const MgInputRadioStyle0 = mgInputRadioCss;

/**
 * type Option validation function
 * @param option - radio option
 * @returns radio option type is valid
 */
const isOption$3 = (option) => typeof option === 'object' && typeof option.title === 'string' && option.value !== undefined;
const MgInputRadio = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.valueChange = createEvent(this, "value-change", 7);
        this.inputValid = createEvent(this, "input-valid", 7);
        /************
         * Internal *
         ************/
        // HTML selector
        this.inputs = [];
        // classes
        this.classVerticalList = 'mg-c-input--vertical-list';
        // hasDisplayedError (triggered by blur event)
        this.hasDisplayedError = false;
        /**
         * Input name
         * If not set the value equals the identifier
         */
        this.name = this.identifier;
        /**
         * Define if label is displayed on top
         */
        this.labelOnTop = false;
        /**
         * Define if label is visible
         */
        this.labelHide = false;
        /**
         * Define if inputs are display verticaly
         */
        this.inputVerticalList = false;
        /**
         * Define if input is required
         */
        this.required = false;
        /**
         * Define if input is readonly
         */
        this.readonly = false;
        /**
         * Define if input is disabled
         */
        this.disabled = false;
        /**
         * Define tooltip position
         */
        this.tooltipPosition = 'input';
        /**
         * Component classes
         */
        this.classCollection = new Ze(['mg-c-input--radio', classFieldset]);
        /**
         * Handle input event
         * @param event - input event
         */
        this.handleInput = (event) => {
            this.checkValidity();
            this.value = this.options[event.target.value].value;
        };
        /**
         * Handle blur event
         */
        this.handleBlur = () => {
            this.handlerInProgress = 'blur';
            this.checkValidity();
            this.setErrorMessage();
            // reset guard
            this.handlerInProgress = undefined;
        };
        /**
         * Check if input is valid
         */
        this.checkValidity = () => {
            this.setValidity(this.readonly || this.disabled || this.getInvalidElement() === undefined);
        };
        /**
         * Set input error message
         * @param errorMessage - errorMessage override
         */
        this.setErrorMessage = (errorMessage) => {
            const invalidElement = this.getInvalidElement();
            // Set error message
            this.errorMessage = undefined;
            if (!this.valid) {
                if (errorMessage !== undefined) {
                    this.errorMessage = errorMessage;
                }
                else if (invalidElement.validity.valueMissing) {
                    this.errorMessage = this.messages.errors.required;
                }
            }
        };
        /**
         * get invalid element
         * @returns element
         */
        this.getInvalidElement = () => this.inputs.find((input) => !input.disabled && !input.readOnly && !input.checkValidity());
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    watchValue(newValue) {
        var _a;
        if (Je(this.items) && typeof newValue === 'string') {
            this.readonlyValue = newValue;
        }
        else if (Array.isArray(this.items) && this.items.every(isOption$3)) {
            this.readonlyValue = (_a = this.items.find(item => item.value === newValue)) === null || _a === void 0 ? void 0 : _a.title;
        }
        else {
            this.readonlyValue = null;
        }
        this.valueChange.emit(newValue);
    }
    validateItems(newValue) {
        // Validate if items have required min length
        if (typeof newValue === 'object' && newValue.length < 2) {
            throw new Error(`<mg-input-radio> prop "items" require at least 2 items. Passed value: ${Ve(newValue)}.`);
        }
        // String array
        else if (Je(newValue)) {
            this.options = newValue.map(item => ({ title: item, value: item, disabled: this.disabled }));
        }
        // Object array
        else if (newValue && newValue.every(item => isOption$3(item))) {
            this.options = newValue;
        }
        else {
            throw new Error(`<mg-input-radio> prop "items" is required and all items must be the same type, string or RadioOption. Passed value: ${Ve(newValue)}.`);
        }
    }
    watchInputVerticalList(newValue) {
        if (newValue)
            this.classCollection.add(this.classVerticalList);
        else
            this.classCollection.delete(this.classVerticalList);
    }
    watchReadonly(newValue) {
        if (newValue)
            this.classCollection.add(classReadonly);
        else
            this.classCollection.delete(classReadonly);
    }
    handleValidityChange(newValue, _oldValue, prop) {
        this.inputs.forEach(input => {
            input[prop] = newValue;
        });
        this.checkValidity();
        if (this.hasDisplayedError) {
            this.setErrorMessage();
            this.hasDisplayedError = false;
        }
    }
    watchDisabled(newValue) {
        if (newValue)
            this.classCollection.add(classDisabled);
        else
            this.classCollection.delete(classDisabled);
    }
    /**
     * Display input error if it exists.
     */
    displayError() {
        // Use `Promise` as requested for stencil method
        // Use `requestAnimationFrame` to ensure:
        // - DOM is fully updated before validation
        // - Async operations are completed
        // - No timing issues with Stencil's render cycle
        // - Keep everything in sync both inside and outside the component
        return new Promise(resolve => {
            requestAnimationFrame(() => {
                this.checkValidity();
                this.setErrorMessage();
                this.hasDisplayedError = this.invalid;
                resolve();
            });
        });
    }
    /**
     * Set an error and display a custom error message.
     * This method can be used to set the component's error state from its context by passing a boolean value to the `valid` parameter.
     * It must be paired with an error message to display for the given context.
     * When used to set validity to `false`, you should use this method again to reset the validity to `true`.
     * @param valid - value indicating the validity
     * @param errorMessage - the error message to display
     */
    async setError(valid, errorMessage) {
        if (typeof valid !== 'boolean') {
            throw new Error('<mg-input-radio> method "setError()" param "valid" must be a boolean.');
        }
        else if (!me(errorMessage)) {
            throw new Error('<mg-input-radio> method "setError()" param "errorMessage" must be a string.');
        }
        else {
            this.setValidity(valid);
            this.setErrorMessage(valid ? undefined : errorMessage);
            this.hasDisplayedError = this.invalid;
        }
    }
    /**
     * Reset value, validity and error state
     */
    async reset() {
        if (!this.readonly) {
            this.value = undefined;
            this.checkValidity();
            this.errorMessage = undefined;
            this.hasDisplayedError = false;
        }
    }
    /**
     * Method to set validity values
     * @param newValue - valid new value
     */
    setValidity(newValue) {
        const oldValidValue = this.valid;
        this.valid = newValue;
        this.invalid = !this.valid;
        // We need to send valid event even if it is the same value
        if (this.handlerInProgress === undefined || (this.handlerInProgress === 'blur' && this.valid !== oldValidValue))
            this.inputValid.emit(this.valid);
    }
    /*************
     * Lifecycle *
     *************/
    /**
     * Check if component props are well configured on init
     * @returns timeout
     */
    componentWillLoad() {
        // Get locales
        this.messages = initLocales(this.element).messages;
        // Validate
        this.validateItems(this.items);
        this.watchInputVerticalList(this.inputVerticalList);
        this.watchReadonly(this.readonly);
        this.watchDisabled(this.disabled);
        this.watchValue(this.value);
        // Check validity when component is ready
        // return a promise to process action only in the FIRST render().
        // https://stenciljs.com/docs/component-lifecycle#componentwillload
        return setTimeout(() => {
            this.checkValidity();
        }, 0);
    }
    /**
     * Render
     * @returns HTML Element
     */
    render() {
        return (h("mg-input", { key: 'd03651917d40124900adbcfd6d5e8bdb44ba340d', label: this.label, identifier: this.identifier, class: this.classCollection.join(), ariaDescribedbyIDs: [], labelOnTop: this.labelOnTop, labelHide: this.labelHide, required: this.required, tooltip: this.tooltip, tooltipPosition: this.readonly && !this.value ? 'label' : this.tooltipPosition, helpText: this.helpText, errorMessage: this.errorMessage }, this.readonly ? (this.readonlyValue && h("b", { class: "mg-c-input__readonly-value" }, this.readonlyValue)) : (h("ul", { class: "mg-c-input__input-group-container", role: "list" }, this.options.map((input, index) => (h("li", { key: input.title, class: { 'mg-c-input__input-group': true, 'mg-c-input__input-group--disabled': this.disabled || input.disabled } }, h("input", { type: "radio", id: this.identifier + '_' + index, name: this.identifier, value: index, checked: JSON.stringify(this.value) === JSON.stringify(this.options[index].value), disabled: this.disabled || input.disabled, required: this.required, onBlur: this.handleBlur, onInput: this.handleInput, ref: (el) => {
                if (el !== null)
                    this.inputs[index] = el;
            } }), h("label", { htmlFor: this.identifier + '_' + index }, input.title))))))));
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "value": ["watchValue"],
        "items": ["validateItems"],
        "inputVerticalList": ["watchInputVerticalList"],
        "readonly": ["watchReadonly", "handleValidityChange"],
        "required": ["handleValidityChange"],
        "disabled": ["handleValidityChange", "watchDisabled"]
    }; }
};
MgInputRadio.style = MgInputRadioStyle0;

const mgInputSelectCss = ".mg-c-input__box{height:var(--mg-b-size-min-height);box-sizing:border-box;padding:calc((var(--mg-b-size-min-height) - var(--mg-b-font-size)*var(--mg-b-line-height))/2) var(--mg-b-size-8);border-width:var(--mg-c-input-border-width);border-style:solid;border-color:var(--mg-c-input-color-border);border-radius:var(--mg-c-input-border-radius);background-color:var(--mg-b-color-light);color:var(--mg-b-color-dark);font-family:inherit;font-size:var(--mg-b-font-size);text-align:var(--mg-c-input-text-align, left)}.mg-c-input__box::placeholder{color:var(--mg-c-input-placeholder-color-text);font-style:italic}.mg-c-input__box:focus{box-shadow:0 0 var(--mg-b-size-4) var(--mg-c-input-color-box-shadow-focus)}.mg-c-input__box:disabled{opacity:var(--mg-b-opacity-element-disabled)}.mg-c-input.mg-c-input--has-error .mg-c-input__box{border-color:var(--mg-b-color-danger)}.mg-c-input.mg-c-input--is-input-group-append{--mg-c-button-border-radius-top-left:0;--mg-c-button-border-radius-bottom-left:0}.mg-c-input.mg-c-input--is-input-group-append .mg-c-input__box{margin-right:calc(-1*var(--mg-b-size-border));border-bottom-right-radius:0;border-top-right-radius:0}.mg-c-input.mg-c-input--is-input-group-append .mg-c-input__box:focus-visible{outline-offset:-0.2rem;outline-style:solid;outline-width:.2rem}.mg-c-input.mg-c-input--has-buttons-group-append ::slotted([slot=append-input]){--mg-c-button-border-radius-top-right:0;--mg-c-button-border-radius-bottom-right:0}.mg-c-input.mg-c-input--has-buttons-group-append ::slotted([slot=append-input]:not(:last-of-type)){--mg-c-button-border-right-width:0}.mg-c-input.mg-c-input--has-buttons-group-append ::slotted([slot=append-input]:last-of-type){--mg-c-button-border-radius-top-right:var(--mg-c-input-border-radius);--mg-c-button-border-radius-bottom-right:var(--mg-c-input-border-radius)}.mg-c-input.mg-c-input--is-append-input-slot-content:not(.mg-c-input--readonly) ::slotted([slot=append-input]){align-self:start;padding-top:calc((var(--mg-b-size-min-height) - var(--mg-b-size-16))/2)}.mg-c-input__readonly-value{min-height:var(--mg-b-font-size);align-self:flex-start;margin-top:calc((var(--mg-b-size-min-height) - var(--mg-b-font-size)*var(--mg-b-line-height))/2);word-break:break-word}.mg-c-input__input-container{width:100%;flex:1 auto}.mg-c-input.mg-c-input--width-full .mg-c-input__box{width:100%}.mg-c-input.mg-c-input--width-2 .mg-c-input__with-character-left,.mg-c-input.mg-c-input--width-4 .mg-c-input__with-character-left,.mg-c-input.mg-c-input--width-16 .mg-c-input__with-character-left{width:max-content}.mg-c-input.mg-c-input--width-2 .mg-c-input__with-character-left:has(textarea),.mg-c-input.mg-c-input--width-4 .mg-c-input__with-character-left:has(textarea),.mg-c-input.mg-c-input--width-16 .mg-c-input__with-character-left:has(textarea){flex-grow:inherit}.mg-c-input.mg-c-input--width-2 .mg-c-input__box{width:var(--mg-b-size-48)}.mg-c-input.mg-c-input--width-2 .mg-c-input__with-character-left:not(:has(textarea)) .mg-c-input__box{width:calc(var(--mg-b-size-48) + var(--mg-c-character-left-message-length)*(.35ch + .3rem))}.mg-c-input.mg-c-input--width-4 .mg-c-input__box{width:var(--mg-b-size-72)}.mg-c-input.mg-c-input--width-4 .mg-c-input__with-character-left:not(:has(textarea)) .mg-c-input__box{width:calc(var(--mg-b-size-72) + var(--mg-c-character-left-message-length)*(.35ch + .3rem))}.mg-c-input.mg-c-input--width-16 .mg-c-input__box{width:calc(26*var(--mg-b-size-8))}.mg-c-input.mg-c-input--width-16 .mg-c-input__with-character-left:not(:has(textarea)) .mg-c-input__box{width:calc(calc(26 * var(--mg-b-size-8)) + var(--mg-c-character-left-message-length)*(.35ch + .3rem))}.mg-c-input.mg-c-input--width-full:not(.mg-c-input--label-on-top){justify-content:stretch}.mg-c-input.mg-c-input--is-input-group-append ::slotted([slot=append-input]),.mg-c-input.mg-c-input--is-append-input-slot-content ::slotted([slot=append-input]){width:auto}:host(.mg-c-input.mg-c-input--width-full) ::slotted(*:not(mg-input-title)){width:100%;max-width:100%}.mg-u-visually-hidden{position:absolute !important;overflow:hidden !important;width:.1rem !important;height:.1rem !important;padding:0 !important;border:0 !important;margin:-0.1rem !important;clip:rect(0.1rem, 0.1rem, 0.1rem, 0.1rem) !important;clip-path:inset(50%) !important;white-space:nowrap !important}*:focus:not(:focus-visible){outline:none}@media (prefers-reduced-motion){*{animation:none !important;transition:none !important}}.mg-c-input__box{padding-top:0;padding-right:var(--mg-b-size-8);padding-bottom:0}@media screen and (max-width: 767px){.mg-c-input__box{width:100%}}";
const MgInputSelectStyle0 = mgInputSelectCss;

/**
 * Check if item is a well configured option
 * @param option - select option
 * @returns select option type is valid
 */
const isOption$2 = (option) => typeof option === 'object' && typeof option.title === 'string';
/**
 * Check if items[] is SelectOption
 * @param items - select option
 * @returns select option array type is valid
 */
const allItemsAreOptions = (items) => Array.isArray(items) && items.every(item => isOption$2(item));
/**
 * Check if item is a well configured optgroup
 * @param optgroup - select option
 * @returns select optgroup type is valid
 */
const isOptGroup = (optgroup) => typeof optgroup === 'object' && typeof optgroup.group === 'string' && allItemsAreOptions(optgroup.options);
/**
 * Group options
 * @param acc - reduce accumulator
 * @param item - item to add
 * @returns grouped options
 */
const groupOptions = (acc, { group, title, value, disabled }) => {
    if (group !== undefined) {
        // Check if group is already created
        const optGroup = acc.find(grp => grp.group === group);
        // Add to group
        if (optGroup !== undefined) {
            optGroup.options.push({ title, value, disabled });
        }
        // Create group
        else {
            acc.push({ group, options: [{ title, value, disabled }] });
        }
    }
    else {
        acc.push({ title, value, disabled });
    }
    return acc;
};
const MgInputSelect = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.valueChange = createEvent(this, "value-change", 7);
        this.inputValid = createEvent(this, "input-valid", 7);
        // hasDisplayedError (triggered by blur event)
        this.hasDisplayedError = false;
        /**
         * Input name
         * If not set the value equals the identifier
         */
        this.name = this.identifier;
        /**
         * Define if label is visible
         */
        this.labelHide = false;
        /**
         * Option to remove placeholder
         */
        this.placeholderHide = false;
        /**
         * Option to disable placeholder
         */
        this.placeholderDisabled = false;
        /**
         * Define if input is required
         */
        this.required = false;
        /**
         * Define if input is readonly
         */
        this.readonly = false;
        /**
         * Define if input is disabled
         */
        this.disabled = false;
        /**
         * Define tooltip position
         */
        this.tooltipPosition = 'input';
        /**
         * Component classes
         */
        this.classCollection = new Ze(['mg-c-input--select']);
        /**
         * Handle input event
         */
        this.handleInput = () => {
            this.updateValue();
            if (this.hasDisplayedError)
                this.setErrorMessage();
        };
        /**
         * Method to compare item.title with input.value
         * @param item - item to compare with
         * @returns truthy if input.value is an item
         */
        this.isInputValue = (item) => { var _a; return item.title === ((_a = this.input) === null || _a === void 0 ? void 0 : _a.value); };
        /**
         * value props setter
         * @param newValue - value to update with
         */
        this.setValue = (newValue) => {
            this.checkValidity();
            this.value = newValue;
        };
        /**
         * Update value from input.value
         */
        this.updateValue = () => {
            if (this.input.value === '') {
                this.setValue(null);
            }
            else if (Je(this.items) && this.items.includes(this.input.value)) {
                this.setValue(this.input.value);
            }
            else if (allItemsAreOptions(this.items) && typeof this.input.value === 'string' && this.items.some(this.isInputValue)) {
                this.setValue(this.items.find(this.isInputValue).value);
            }
            else {
                // before set newValue with push to options[] the unknown input.value with a disable satus
                this.options.push({ title: this.input.value, value: this.input.value, disabled: true });
                this.setValue(this.input.value);
            }
        };
        /**
         * Handle blur event
         */
        this.handleBlur = () => {
            this.handlerInProgress = 'blur';
            this.displayError().finally(() => {
                // reset guard
                this.handlerInProgress = undefined;
            });
        };
        /**
         * Input value is disabled
         * @returns truthy if input value is disabled
         */
        this.isDisabledValue = () => { var _a; return allItemsAreOptions(this.options) && ((_a = this.options.find(this.isInputValue)) === null || _a === void 0 ? void 0 : _a.disabled) === true; };
        /**
         * Check if input is valid
         */
        this.checkValidity = () => {
            this.setValidity(!this.isDisabledValue() && (this.readonly || this.disabled || this.input.checkValidity()));
        };
        /**
         * Set input error message
         * @param errorMessage - errorMessage override
         */
        this.setErrorMessage = (errorMessage) => {
            // Set error message
            this.errorMessage = undefined;
            if (!this.valid) {
                if (errorMessage !== undefined) {
                    this.errorMessage = errorMessage;
                }
                else if (this.input.validity.valueMissing) {
                    this.errorMessage = this.messages.errors.required;
                }
            }
        };
        /**
         * Render option
         * @param option - to render
         * @returns render option
         */
        this.renderOption = (option) => (h("option", { key: option.title, value: option.title, selected: JSON.stringify(this.value) === JSON.stringify(option.value), disabled: option.disabled }, option.title));
    }
    validateValue(newValue) {
        var _a, _b;
        if (Je(this.items) && typeof newValue === 'string') {
            this.readonlyValue = ((_a = this.input) === null || _a === void 0 ? void 0 : _a.value) !== undefined ? this.input.value : newValue;
        }
        else if (allItemsAreOptions(this.items)) {
            this.readonlyValue = (_b = this.items.find(item => item.value === newValue)) === null || _b === void 0 ? void 0 : _b.title;
        }
        else {
            this.readonlyValue = null;
        }
        this.valueChange.emit(newValue);
    }
    validateItems(newValue) {
        // Empty options
        if (newValue.length === 0) {
            this.options = [];
        }
        // String array
        else if (Je(newValue)) {
            if (typeof this.value === 'string')
                this.valueExist = newValue.includes(this.value);
            this.options = newValue.map(item => ({ title: item, value: item }));
        }
        // Object array
        else if (allItemsAreOptions(newValue)) {
            this.valueExist = newValue.map(item => item.value).includes(this.value);
            // Grouped object options
            if (newValue.some(item => Boolean(item.group))) {
                this.options = newValue.reduce(groupOptions, []);
            }
            // Standart object options
            else {
                this.options = newValue;
            }
        }
        else {
            throw new Error(`<mg-input-select> prop "items" is required, can be an empty Array or all items must be the same type: string or Option. Passed value: ${Ve(newValue)}.`);
        }
    }
    watchReadonly(newValue) {
        if (newValue)
            this.classCollection.add(classReadonly);
        else
            this.classCollection.delete(classReadonly);
    }
    handleValidityChange(newValue, _oldValue, prop) {
        if (this.input !== undefined) {
            this.input[prop] = newValue;
            this.checkValidity();
            if (this.hasDisplayedError) {
                this.setErrorMessage();
                this.hasDisplayedError = false;
            }
        }
    }
    watchDisabled(newValue) {
        if (newValue)
            this.classCollection.add(classDisabled);
        else
            this.classCollection.delete(classDisabled);
    }
    watchMgWidth(newValue) {
        // reset width class
        widths.forEach(width => {
            this.classCollection.delete(`mg-c-input--width-${width}`);
        });
        // apply new width
        if (newValue !== undefined)
            this.classCollection.add(`mg-c-input--width-${this.mgWidth}`);
    }
    /**
     * Display input error if it exists.
     */
    displayError() {
        // Use `Promise` as requested for stencil method
        // Use `requestAnimationFrame` to ensure:
        // - DOM is fully updated before validation
        // - Async operations are completed
        // - No timing issues with Stencil's render cycle
        // - Keep everything in sync both inside and outside the component
        return new Promise(resolve => {
            requestAnimationFrame(() => {
                this.checkValidity();
                this.setErrorMessage();
                this.hasDisplayedError = this.invalid;
                resolve();
            });
        });
    }
    /**
     * Set an error and display a custom error message.
     * This method can be used to set the component's error state from its context by passing a boolean value to the `valid` parameter.
     * It must be paired with an error message to display for the given context.
     * When used to set validity to `false`, you should use this method again to reset the validity to `true`.
     * @param valid - value indicating the validity
     * @param errorMessage - the error message to display
     */
    async setError(valid, errorMessage) {
        if (typeof valid !== 'boolean') {
            throw new Error('<mg-input-select> method "setError()" param "valid" must be a boolean.');
        }
        else if (!me(errorMessage)) {
            throw new Error('<mg-input-select> method "setError()" param "errorMessage" must be a string.');
        }
        else {
            this.setValidity(valid);
            this.setErrorMessage(valid ? undefined : errorMessage);
            this.hasDisplayedError = this.invalid;
        }
    }
    /**
     * Reset value, validity and error state
     */
    async reset() {
        if (!this.readonly) {
            this.value = null;
            this.checkValidity();
            this.errorMessage = undefined;
            this.hasDisplayedError = false;
        }
    }
    /**
     * Method to set validity values
     * @param newValue - valid new value
     */
    setValidity(newValue) {
        const oldValidValue = this.valid;
        this.valid = newValue;
        this.invalid = !this.valid;
        // We need to send valid event even if it is the same value
        if (this.handlerInProgress === undefined || (this.handlerInProgress === 'blur' && this.valid !== oldValidValue))
            this.inputValid.emit(this.valid);
    }
    /*************
     * Lifecycle *
     *************/
    /**
     * Check if component props are well configured on init
     * @returns timeout
     */
    componentWillLoad() {
        // Get locales
        this.messages = initLocales(this.element).messages;
        // Validate
        this.validateItems(this.items);
        this.validateValue(this.value);
        this.watchMgWidth(this.mgWidth);
        this.watchReadonly(this.readonly);
        this.watchDisabled(this.disabled);
        // Set default placeholder
        if (this.placeholder === undefined || this.placeholder === '') {
            this.placeholder = this.messages.input.select.placeholder;
        }
        // Check validity when component is ready
        // return a promise to process action only in the FIRST render().
        // https://stenciljs.com/docs/component-lifecycle#componentwillload
        return setTimeout(() => {
            this.checkValidity();
        }, 0);
    }
    /**
     * Render
     * @returns HTML Element
     */
    render() {
        return (h("mg-input", { key: 'ac2d857a179ea42d762dee655df5c6d073c920f0', label: this.label, identifier: this.identifier, class: this.classCollection.join(), ariaDescribedbyIDs: [], labelOnTop: this.labelOnTop, labelHide: this.labelHide, required: this.required, tooltip: this.tooltip, tooltipPosition: this.readonly && this.readonlyValue === null ? 'label' : this.tooltipPosition, helpText: this.helpText, errorMessage: this.errorMessage }, this.readonly ? (this.readonlyValue && h("b", { class: "mg-c-input__readonly-value" }, this.readonlyValue)) : (h("select", { class: "mg-c-input__box", id: this.identifier, name: this.name, title: this.placeholder, disabled: this.disabled, required: this.required, "aria-invalid": (this.invalid === true).toString(), onInput: this.handleInput, onBlur: this.handleBlur, ref: (el) => {
                if (el !== null)
                    this.input = el;
            } }, (!this.placeholderHide || !this.valueExist) && ( // In case passed value does not match any option we display the placeholder
        h("option", { value: "", disabled: this.placeholderDisabled && this.valueExist }, this.placeholder)), this.options.map(option => isOptGroup(option) ? (h("optgroup", { label: option.group, key: option.group }, option.options.map(this.renderOption))) : (isOption$2(option) && this.renderOption(option)))))));
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "value": ["validateValue"],
        "items": ["validateItems"],
        "readonly": ["watchReadonly", "handleValidityChange"],
        "required": ["handleValidityChange"],
        "disabled": ["handleValidityChange", "watchDisabled"],
        "mgWidth": ["watchMgWidth"]
    }; }
};
MgInputSelect.style = MgInputSelectStyle0;

const mgInputTextCss = ".mg-c-input__box{height:var(--mg-b-size-min-height);box-sizing:border-box;padding:calc((var(--mg-b-size-min-height) - var(--mg-b-font-size)*var(--mg-b-line-height))/2) var(--mg-b-size-8);border-width:var(--mg-c-input-border-width);border-style:solid;border-color:var(--mg-c-input-color-border);border-radius:var(--mg-c-input-border-radius);background-color:var(--mg-b-color-light);color:var(--mg-b-color-dark);font-family:inherit;font-size:var(--mg-b-font-size);text-align:var(--mg-c-input-text-align, left)}.mg-c-input__box::placeholder{color:var(--mg-c-input-placeholder-color-text);font-style:italic}.mg-c-input__box:focus{box-shadow:0 0 var(--mg-b-size-4) var(--mg-c-input-color-box-shadow-focus)}.mg-c-input__box:disabled{opacity:var(--mg-b-opacity-element-disabled)}.mg-c-input.mg-c-input--has-error .mg-c-input__box{border-color:var(--mg-b-color-danger)}.mg-c-input.mg-c-input--is-input-group-append{--mg-c-button-border-radius-top-left:0;--mg-c-button-border-radius-bottom-left:0}.mg-c-input.mg-c-input--is-input-group-append .mg-c-input__box{margin-right:calc(-1*var(--mg-b-size-border));border-bottom-right-radius:0;border-top-right-radius:0}.mg-c-input.mg-c-input--is-input-group-append .mg-c-input__box:focus-visible{outline-offset:-0.2rem;outline-style:solid;outline-width:.2rem}.mg-c-input.mg-c-input--has-buttons-group-append ::slotted([slot=append-input]){--mg-c-button-border-radius-top-right:0;--mg-c-button-border-radius-bottom-right:0}.mg-c-input.mg-c-input--has-buttons-group-append ::slotted([slot=append-input]:not(:last-of-type)){--mg-c-button-border-right-width:0}.mg-c-input.mg-c-input--has-buttons-group-append ::slotted([slot=append-input]:last-of-type){--mg-c-button-border-radius-top-right:var(--mg-c-input-border-radius);--mg-c-button-border-radius-bottom-right:var(--mg-c-input-border-radius)}.mg-c-input.mg-c-input--is-append-input-slot-content:not(.mg-c-input--readonly) ::slotted([slot=append-input]){align-self:start;padding-top:calc((var(--mg-b-size-min-height) - var(--mg-b-size-16))/2)}.mg-c-input__input-container{width:100%;flex:1 auto}.mg-c-input.mg-c-input--width-full .mg-c-input__box{width:100%}.mg-c-input.mg-c-input--width-2 .mg-c-input__with-character-left,.mg-c-input.mg-c-input--width-4 .mg-c-input__with-character-left,.mg-c-input.mg-c-input--width-16 .mg-c-input__with-character-left{width:max-content}.mg-c-input.mg-c-input--width-2 .mg-c-input__with-character-left:has(textarea),.mg-c-input.mg-c-input--width-4 .mg-c-input__with-character-left:has(textarea),.mg-c-input.mg-c-input--width-16 .mg-c-input__with-character-left:has(textarea){flex-grow:inherit}.mg-c-input.mg-c-input--width-2 .mg-c-input__box{width:var(--mg-b-size-48)}.mg-c-input.mg-c-input--width-2 .mg-c-input__with-character-left:not(:has(textarea)) .mg-c-input__box{width:calc(var(--mg-b-size-48) + var(--mg-c-character-left-message-length)*(.35ch + .3rem))}.mg-c-input.mg-c-input--width-4 .mg-c-input__box{width:var(--mg-b-size-72)}.mg-c-input.mg-c-input--width-4 .mg-c-input__with-character-left:not(:has(textarea)) .mg-c-input__box{width:calc(var(--mg-b-size-72) + var(--mg-c-character-left-message-length)*(.35ch + .3rem))}.mg-c-input.mg-c-input--width-16 .mg-c-input__box{width:calc(26*var(--mg-b-size-8))}.mg-c-input.mg-c-input--width-16 .mg-c-input__with-character-left:not(:has(textarea)) .mg-c-input__box{width:calc(calc(26 * var(--mg-b-size-8)) + var(--mg-c-character-left-message-length)*(.35ch + .3rem))}.mg-c-input.mg-c-input--width-full:not(.mg-c-input--label-on-top){justify-content:stretch}.mg-c-input.mg-c-input--is-input-group-append ::slotted([slot=append-input]),.mg-c-input.mg-c-input--is-append-input-slot-content ::slotted([slot=append-input]){width:auto}:host(.mg-c-input.mg-c-input--width-full) ::slotted(*:not(mg-input-title)){width:100%;max-width:100%}.mg-c-input__readonly-value{min-height:var(--mg-b-font-size);align-self:flex-start;margin-top:calc((var(--mg-b-size-min-height) - var(--mg-b-font-size)*var(--mg-b-line-height))/2);word-break:break-word}.mg-c-input.mg-c-input--display-character-left mg-character-left{font-size:var(--mg-b-font-size-small);opacity:.6}.mg-c-input.mg-c-input--display-character-left .mg-c-input__input+.mg-c-input__help-text ::slotted(*),.mg-c-input.mg-c-input--display-character-left .mg-c-input__input+.mg-c-input__error ::slotted(*){margin-top:0}.mg-u-visually-hidden{position:absolute !important;overflow:hidden !important;width:.1rem !important;height:.1rem !important;padding:0 !important;border:0 !important;margin:-0.1rem !important;clip:rect(0.1rem, 0.1rem, 0.1rem, 0.1rem) !important;clip-path:inset(50%) !important;white-space:nowrap !important}*:focus:not(:focus-visible){outline:none}@media (prefers-reduced-motion){*{animation:none !important;transition:none !important}}.mg-c-input__with-character-left{position:relative;width:100%}.mg-c-input.mg-u-is-focused .mg-c-input__with-character-left .mg-c-input__box{padding-right:max(var(--mg-c-character-left-message-length)*(.35ch + .3rem) + var(--mg-b-size-16)*clamp(0,var(--mg-c-character-left-message-length),1),var(--mg-b-size-8))}.mg-c-input__with-character-left mg-character-left{position:absolute;top:50%;right:var(--mg-b-size-8);display:none;font-size:var(--mg-b-font-size-small);opacity:.6;transform:translateY(-50%)}.mg-c-input.mg-u-is-focused .mg-c-input__with-character-left mg-character-left{display:block}.mg-c-input.mg-c-input--readonly b{min-height:var(--mg-b-font-size);margin-top:calc((var(--mg-b-size-min-height) - var(--mg-b-font-size)*var(--mg-b-line-height))/2)}.mg-c-input.mg-c-input--has-icon .mg-c-input__with-character-left>mg-icon{position:absolute;top:50%;left:var(--mg-b-size-8);color:var(--mg-c-input-color-icon);transform:translateY(-50%)}.mg-c-input.mg-c-input--has-icon .mg-c-input__with-character-left .mg-c-input__box{padding-left:calc(var(--mg-b-size-16) + var(--mg-b-size-8)*2)}";
const MgInputTextStyle0 = mgInputTextCss;

/**
 * Check if object is an option
 * @param option - object to validate
 * @returns true id object is an option
 */
const isOption$1 = (option) => typeof option === 'object' && typeof option.title === 'string' && option.value !== undefined;
/**
 * Check if datalist options are well structured.
 * @param options - Datalist options to check.
 * @returns True if datalist is well structured.
 */
const isDatalistOptions = (options) => Je(options) || (Array.isArray(options) && options.every(isOption$1));
const MgInputText = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.valueChange = createEvent(this, "value-change", 7);
        this.inputValid = createEvent(this, "input-valid", 7);
        /************
         * Internal *
         ************/
        // Classes
        this.classFocus = 'mg-u-is-focused';
        this.classIsInputGroupAppend = 'mg-c-input--is-input-group-append';
        this.classHasIcon = 'mg-c-input--has-icon';
        this.classHasButtonsGroupAppend = 'mg-c-input--has-buttons-group-append';
        this.classIsAppendInputSlotContent = 'mg-c-input--is-append-input-slot-content';
        // hasDisplayedError (triggered by blur event)
        this.hasDisplayedError = false;
        /**
         * Input name
         * If not set the value equals the identifier
         */
        this.name = this.identifier;
        /**
         * Input type
         */
        this.type = 'text';
        /**
         * Define if label is visible
         */
        this.labelHide = false;
        /**
         * Input max length
         */
        this.maxlength = 400;
        /**
         * Define if input is required
         */
        this.required = false;
        /**
         * Define if input is readonly
         */
        this.readonly = false;
        /**
         * Define if input is disabled
         */
        this.disabled = false;
        /**
         * Define input width
         */
        this.mgWidth = 'full';
        /**
         * Define tooltip position
         */
        this.tooltipPosition = 'input';
        /**
         * Define if component should display character left
         */
        this.characterLeftHide = false;
        /**
         * Component classes
         */
        this.classCollection = new Ze(['mg-c-input--text']);
        /**
         * Handle input event
         */
        this.handleInput = () => {
            this.checkValidity();
            if (this.hasDisplayedError) {
                this.setErrorMessage();
            }
            this.value = this.input.value;
        };
        /**
         * Handle focus event
         */
        this.handleFocus = () => {
            this.classCollection.add(this.classFocus);
            this.classCollection = new Ze(this.classCollection.classes);
        };
        /**
         * Handle blur event
         */
        this.handleBlur = () => {
            // Manage focus
            this.classCollection.delete(this.classFocus);
            this.classCollection = new Ze(this.classCollection.classes);
            // Display Error
            this.handlerInProgress = 'blur';
            this.displayError().finally(() => {
                // reset guard
                this.handlerInProgress = undefined;
            });
        };
        /**
         * Check if input is valid
         */
        this.checkValidity = () => {
            this.setValidity(this.readonly || this.disabled || this.input.checkValidity());
        };
        /**
         * Set input error message
         * @param errorMessage - errorMessage override
         */
        this.setErrorMessage = (errorMessage) => {
            // Set error message
            this.errorMessage = undefined;
            // Does have a custom error message
            if (!this.valid && errorMessage !== undefined) {
                this.errorMessage = errorMessage;
            }
            // Does not match pattern
            else if (!this.valid && this.input.validity.patternMismatch) {
                this.errorMessage = this.patternErrorMessage;
            }
            // required
            else if (!this.valid && this.input.validity.valueMissing) {
                this.errorMessage = this.messages.errors.required;
            }
        };
        /**
         * Validate append slot
         */
        this.validateAppendSlot = () => {
            const slotAppendInput = Array.from(this.element.querySelectorAll('[slot="append-input"]'));
            if (slotAppendInput.length === 1) {
                if (slotAppendInput[0].nodeName === 'MG-BUTTON') {
                    this.classCollection.add(this.classIsInputGroupAppend);
                }
                else {
                    this.classCollection.add(this.classIsAppendInputSlotContent);
                    this.slotContent = slotAppendInput[0].textContent;
                }
            }
            else if (slotAppendInput.filter(slot => slot.nodeName === 'MG-BUTTON').length > 1) {
                this.classCollection.add(this.classIsInputGroupAppend);
                this.classCollection.add(this.classHasButtonsGroupAppend);
            }
        };
        /**
         * Method to control datalist display condition
         * @returns true if display condition success
         */
        this.hasDatalist = () => isDatalistOptions(this.datalistoptions) && this.datalistoptions.length > 0;
        /**
         * Renders the readonly content of the input component.
         * @returns The readonly content element.
         */
        this.renderReadonly = () => {
            return this.slotContent !== undefined ? (h("span", { class: "mg-c-input__readonly-value" }, h("b", null, this.value), this.slotContent)) : (h("b", { class: "mg-c-input__readonly-value" }, this.value));
        };
    }
    handleValue(newValue) {
        var _a, _b;
        if ((_a = this.datalistoptions) === null || _a === void 0 ? void 0 : _a.every(isOption$1)) {
            this.valueChange.emit(((_b = this.datalistoptions.find(option => option.title === newValue)) === null || _b === void 0 ? void 0 : _b.value) || newValue);
        }
        else {
            this.valueChange.emit(newValue);
        }
    }
    validateIcon(newValue) {
        if (newValue !== undefined) {
            this.classCollection.add(this.classHasIcon);
        }
        else {
            this.classCollection.delete(this.classHasIcon);
        }
    }
    validateDatalistoptions(newValue) {
        if (Boolean(newValue) && !isDatalistOptions(newValue)) {
            throw new Error(`<mg-input-text> prop "datalistoptions" values must be the same type, string or OptionType. Passed value: ${Ve(newValue)}.`);
        }
    }
    watchReadonly(newValue) {
        if (newValue)
            this.classCollection.add(classReadonly);
        else
            this.classCollection.delete(classReadonly);
    }
    handleValidityChange(newValue, _oldValue, prop) {
        if (this.input !== undefined) {
            this.input[prop] = newValue;
            this.checkValidity();
            if (this.hasDisplayedError) {
                this.setErrorMessage();
                this.hasDisplayedError = false;
            }
        }
    }
    watchDisabled(newValue) {
        if (newValue)
            this.classCollection.add(classDisabled);
        else
            this.classCollection.delete(classDisabled);
    }
    watchMgWidth(newValue) {
        // reset width class
        widths.forEach(width => {
            this.classCollection.delete(`mg-c-input--width-${width}`);
        });
        // apply new width
        if (newValue !== undefined)
            this.classCollection.add(`mg-c-input--width-${this.mgWidth}`);
    }
    validatePattern(newValue) {
        if (newValue !== undefined && !(me(this.pattern) && me(this.patternErrorMessage))) {
            throw new Error(`<mg-input-text> props "pattern" and "patternErrorMessage" must be non-empty string and paired. Passed value: "pattern='${Ve(this.pattern)}'" and "patternErrorMessage='${Ve(this.patternErrorMessage)}'".`);
        }
    }
    /**
     * Public method to play input focus
     */
    async setFocus() {
        this.input.focus();
    }
    /**
     * Display input error if it exists.
     */
    displayError() {
        // Use `Promise` as requested for stencil method
        // Use `requestAnimationFrame` to ensure:
        // - DOM is fully updated before validation
        // - Async operations are completed
        // - No timing issues with Stencil's render cycle
        // - Keep everything in sync both inside and outside the component
        return new Promise(resolve => {
            requestAnimationFrame(() => {
                this.checkValidity();
                this.setErrorMessage();
                this.hasDisplayedError = this.invalid;
                resolve();
            });
        });
    }
    /**
     * Set an error and display a custom error message.
     * This method can be used to set the component's error state from its context by passing a boolean value to the `valid` parameter.
     * It must be paired with an error message to display for the given context.
     * When used to set validity to `false`, you should use this method again to reset the validity to `true`.
     * @param valid - value indicating the validity
     * @param errorMessage - the error message to display
     */
    async setError(valid, errorMessage) {
        if (typeof valid !== 'boolean') {
            throw new Error('<mg-input-text> method "setError()" param "valid" must be a boolean.');
        }
        else if (!me(errorMessage)) {
            throw new Error('<mg-input-text> method "setError()" param "errorMessage" must be a string.');
        }
        else {
            this.setValidity(valid);
            this.setErrorMessage(valid ? undefined : errorMessage);
            this.hasDisplayedError = this.invalid;
        }
    }
    /**
     * Reset value, validity and error state
     */
    async reset() {
        if (!this.readonly) {
            this.value = '';
            this.checkValidity();
            this.errorMessage = undefined;
            this.hasDisplayedError = false;
        }
    }
    /**
     * Method to set validity values
     * @param newValue - valid new value
     */
    setValidity(newValue) {
        const oldValidValue = this.valid;
        this.valid = newValue;
        this.invalid = !this.valid;
        // We need to send valid event even if it is the same value
        if (this.handlerInProgress === undefined || (this.handlerInProgress === 'blur' && this.valid !== oldValidValue))
            this.inputValid.emit(this.valid);
    }
    /*************
     * Lifecycle *
     *************/
    /**
     * Check if component props are well configured on init
     * @returns timeout
     */
    componentWillLoad() {
        // Get locales
        this.messages = initLocales(this.element).messages;
        this.characterLeftId = `${this.identifier}-character-left`;
        this.datalistId = `${this.identifier}-datalist`;
        // Validate
        this.validateIcon(this.icon);
        this.validateDatalistoptions(this.datalistoptions);
        this.validatePattern(this.pattern);
        this.validatePattern(this.patternErrorMessage);
        this.validateAppendSlot();
        this.watchMgWidth(this.mgWidth);
        this.watchReadonly(this.readonly);
        this.watchDisabled(this.disabled);
        // Check validity when component is ready
        // return a promise to process action only in the FIRST render().
        // https://stenciljs.com/docs/component-lifecycle#componentwillload
        return setTimeout(() => {
            this.checkValidity();
        }, 0);
    }
    /**
     * Render
     * @returns HTML Element
     */
    render() {
        return (h("mg-input", { key: '3677b48b65765727f36e9379af1282d5a8f3762c', label: this.label, identifier: this.identifier, class: this.classCollection.join(), ariaDescribedbyIDs: [this.characterLeftId], labelOnTop: this.labelOnTop, labelHide: this.labelHide, required: this.required, tooltip: this.tooltip, tooltipPosition: this.readonly && this.value === undefined ? 'label' : this.tooltipPosition, helpText: this.helpText, errorMessage: this.errorMessage }, this.readonly
            ? this.value && this.renderReadonly()
            : [
                h("div", { key: "input", class: "mg-c-input__with-character-left", style: {
                        '--mg-c-character-left-message-length': (!this.characterLeftHide ? this.maxlength.toString().length * 2 + 1 : 0).toString(),
                    } }, this.icon !== undefined && h("mg-icon", { icon: this.icon }), h("input", { type: this.type, class: "mg-c-input__box mg-c-input__box--width", value: this.value, id: this.identifier, list: this.hasDatalist() ? this.datalistId : undefined, autocomplete: this.hasDatalist() ? 'off' : undefined, name: this.name, placeholder: this.placeholder, title: this.placeholder, maxlength: this.maxlength, disabled: this.disabled, required: this.required, "aria-invalid": (this.invalid === true).toString(), pattern: this.pattern, onInput: this.handleInput, onFocus: this.handleFocus, onBlur: this.handleBlur, ref: (el) => {
                        if (el !== null)
                            this.input = el;
                    } }), this.hasDatalist() && (h("datalist", { id: this.datalistId }, this.datalistoptions.map(option => (h("option", { value: isOption$1(option) ? option.title : option, key: option }))))), !this.characterLeftHide && this.maxlength > 0 && (h("mg-character-left", { identifier: this.characterLeftId, characters: this.value, maxlength: this.maxlength }))),
                h("slot", { key: "slot", name: "append-input" }),
            ]));
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "value": ["handleValue"],
        "icon": ["validateIcon"],
        "datalistoptions": ["validateDatalistoptions"],
        "readonly": ["watchReadonly", "handleValidityChange"],
        "required": ["handleValidityChange"],
        "disabled": ["handleValidityChange", "watchDisabled"],
        "mgWidth": ["watchMgWidth"],
        "pattern": ["validatePattern"],
        "patternErrorMessage": ["validatePattern"]
    }; }
};
MgInputText.style = MgInputTextStyle0;

const mgInputTextareaCss = ".mg-c-input__box{height:var(--mg-b-size-min-height);box-sizing:border-box;padding:calc((var(--mg-b-size-min-height) - var(--mg-b-font-size)*var(--mg-b-line-height))/2) var(--mg-b-size-8);border-width:var(--mg-c-input-border-width);border-style:solid;border-color:var(--mg-c-input-color-border);border-radius:var(--mg-c-input-border-radius);background-color:var(--mg-b-color-light);color:var(--mg-b-color-dark);font-family:inherit;font-size:var(--mg-b-font-size);text-align:var(--mg-c-input-text-align, left)}.mg-c-input__box::placeholder{color:var(--mg-c-input-placeholder-color-text);font-style:italic}.mg-c-input__box:focus{box-shadow:0 0 var(--mg-b-size-4) var(--mg-c-input-color-box-shadow-focus)}.mg-c-input__box:disabled{opacity:var(--mg-b-opacity-element-disabled)}.mg-c-input.mg-c-input--has-error .mg-c-input__box{border-color:var(--mg-b-color-danger)}.mg-c-input.mg-c-input--is-input-group-append{--mg-c-button-border-radius-top-left:0;--mg-c-button-border-radius-bottom-left:0}.mg-c-input.mg-c-input--is-input-group-append .mg-c-input__box{margin-right:calc(-1*var(--mg-b-size-border));border-bottom-right-radius:0;border-top-right-radius:0}.mg-c-input.mg-c-input--is-input-group-append .mg-c-input__box:focus-visible{outline-offset:-0.2rem;outline-style:solid;outline-width:.2rem}.mg-c-input.mg-c-input--has-buttons-group-append ::slotted([slot=append-input]){--mg-c-button-border-radius-top-right:0;--mg-c-button-border-radius-bottom-right:0}.mg-c-input.mg-c-input--has-buttons-group-append ::slotted([slot=append-input]:not(:last-of-type)){--mg-c-button-border-right-width:0}.mg-c-input.mg-c-input--has-buttons-group-append ::slotted([slot=append-input]:last-of-type){--mg-c-button-border-radius-top-right:var(--mg-c-input-border-radius);--mg-c-button-border-radius-bottom-right:var(--mg-c-input-border-radius)}.mg-c-input.mg-c-input--is-append-input-slot-content:not(.mg-c-input--readonly) ::slotted([slot=append-input]){align-self:start;padding-top:calc((var(--mg-b-size-min-height) - var(--mg-b-size-16))/2)}.mg-c-input__input-container{width:100%;flex:1 auto}.mg-c-input.mg-c-input--width-full .mg-c-input__box{width:100%}.mg-c-input.mg-c-input--width-2 .mg-c-input__with-character-left,.mg-c-input.mg-c-input--width-4 .mg-c-input__with-character-left,.mg-c-input.mg-c-input--width-16 .mg-c-input__with-character-left{width:max-content}.mg-c-input.mg-c-input--width-2 .mg-c-input__with-character-left:has(textarea),.mg-c-input.mg-c-input--width-4 .mg-c-input__with-character-left:has(textarea),.mg-c-input.mg-c-input--width-16 .mg-c-input__with-character-left:has(textarea){flex-grow:inherit}.mg-c-input.mg-c-input--width-2 .mg-c-input__box{width:var(--mg-b-size-48)}.mg-c-input.mg-c-input--width-2 .mg-c-input__with-character-left:not(:has(textarea)) .mg-c-input__box{width:calc(var(--mg-b-size-48) + var(--mg-c-character-left-message-length)*(.35ch + .3rem))}.mg-c-input.mg-c-input--width-4 .mg-c-input__box{width:var(--mg-b-size-72)}.mg-c-input.mg-c-input--width-4 .mg-c-input__with-character-left:not(:has(textarea)) .mg-c-input__box{width:calc(var(--mg-b-size-72) + var(--mg-c-character-left-message-length)*(.35ch + .3rem))}.mg-c-input.mg-c-input--width-16 .mg-c-input__box{width:calc(26*var(--mg-b-size-8))}.mg-c-input.mg-c-input--width-16 .mg-c-input__with-character-left:not(:has(textarea)) .mg-c-input__box{width:calc(calc(26 * var(--mg-b-size-8)) + var(--mg-c-character-left-message-length)*(.35ch + .3rem))}.mg-c-input.mg-c-input--width-full:not(.mg-c-input--label-on-top){justify-content:stretch}.mg-c-input.mg-c-input--is-input-group-append ::slotted([slot=append-input]),.mg-c-input.mg-c-input--is-append-input-slot-content ::slotted([slot=append-input]){width:auto}:host(.mg-c-input.mg-c-input--width-full) ::slotted(*:not(mg-input-title)){width:100%;max-width:100%}.mg-c-input__readonly-value{min-height:var(--mg-b-font-size);align-self:flex-start;margin-top:calc((var(--mg-b-size-min-height) - var(--mg-b-font-size)*var(--mg-b-line-height))/2);word-break:break-word}.mg-c-input.mg-c-input--display-character-left mg-character-left{font-size:var(--mg-b-font-size-small);opacity:.6}.mg-c-input.mg-c-input--display-character-left .mg-c-input__input+.mg-c-input__help-text ::slotted(*),.mg-c-input.mg-c-input--display-character-left .mg-c-input__input+.mg-c-input__error ::slotted(*){margin-top:0}.mg-u-visually-hidden{position:absolute !important;overflow:hidden !important;width:.1rem !important;height:.1rem !important;padding:0 !important;border:0 !important;margin:-0.1rem !important;clip:rect(0.1rem, 0.1rem, 0.1rem, 0.1rem) !important;clip-path:inset(50%) !important;white-space:nowrap !important}*:focus:not(:focus-visible){outline:none}@media (prefers-reduced-motion){*{animation:none !important;transition:none !important}}.mg-c-input__input{align-items:start}.mg-c-input__box{display:block;height:auto;resize:none}.mg-c-input__box.mg-c-input__box--resizable{resize:both}.mg-c-input__box.mg-c-input__box--resizable-horizontal{resize:horizontal}.mg-c-input__box.mg-c-input__box--resizable-vertical{resize:vertical}.mg-c-input__readonly-value{white-space:pre-line}.mg-c-input__with-character-left{flex-grow:1}.mg-c-input__with-character-left mg-character-left{display:block;text-align:end;visibility:hidden}.mg-c-input.mg-u-is-focused .mg-c-input__with-character-left mg-character-left{visibility:visible}@-moz-document url-prefix(){.mg-c-input__box{overflow-x:hidden}}";
const MgInputTextareaStyle0 = mgInputTextareaCss;

const MgInputTextarea = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.valueChange = createEvent(this, "value-change", 7);
        this.inputValid = createEvent(this, "input-valid", 7);
        /************
         * Internal *
         ************/
        // Classes
        this.classFocus = 'mg-u-is-focused';
        this.classDisplayCharacterLeft = 'mg-c-input--display-character-left';
        // hasDisplayedError (triggered by blur event)
        this.hasDisplayedError = false;
        /**
         * Input name
         * If not set the value equals the identifier
         */
        this.name = this.identifier;
        /**
         * Define if label is visible
         */
        this.labelHide = false;
        /**
         * Input max length
         */
        this.maxlength = 4000;
        /**
         * Define if input is required
         */
        this.required = false;
        /**
         * Define if input is readonly
         */
        this.readonly = false;
        /**
         * Define if input is disabled
         */
        this.disabled = false;
        /**
         * Define input width
         */
        this.mgWidth = 'full';
        /**
         * Define the number of visible text lines for the control
         */
        this.rows = 3;
        /**
         * Define tooltip position
         */
        this.tooltipPosition = 'input';
        /**
         * Define if component should display character left
         */
        this.characterLeftHide = false;
        /**
         * Define if input is resizable
         */
        this.resizable = 'none';
        /**
         * Component classes
         */
        this.classCollection = new Ze(['mg-c-input--textarea']);
        /**
         * Handle input event
         */
        this.handleInput = () => {
            if (this.hasDisplayedError) {
                this.checkValidity();
                this.setErrorMessage();
            }
            this.value = this.input.value;
        };
        /**
         * Handle focus event
         */
        this.handleFocus = () => {
            this.classCollection.add(this.classFocus);
            this.classCollection = new Ze(this.classCollection.classes);
        };
        /**
         * Handle blur event
         */
        this.handleBlur = () => {
            // Manage focus
            this.classCollection.delete(this.classFocus);
            this.classCollection = new Ze(this.classCollection.classes);
            // Display Error
            this.handlerInProgress = 'blur';
            this.displayError().finally(() => {
                // reset guard
                this.handlerInProgress = undefined;
            });
        };
        /**
         * Get pattern validity
         * Pattern is not defined on textarea field: https://developer.mozilla.org/fr/docs/Web/HTML/Element/Textarea
         * @returns is pattern valid
         */
        this.getPatternValidity = () => this.pattern === undefined || new RegExp(`^${this.pattern}$`, 'u').test(this.value);
        /**
         * Check if input is valid
         */
        this.checkValidity = () => {
            this.setValidity(this.readonly || this.disabled || (this.input.checkValidity() && this.getPatternValidity()));
        };
        /**
         * Set input error message
         * @param errorMessage - errorMessage override
         */
        this.setErrorMessage = (errorMessage) => {
            // Set error message
            this.errorMessage = undefined;
            // Does not match pattern
            if (!this.valid) {
                if (errorMessage !== undefined) {
                    this.errorMessage = errorMessage;
                }
                else if (!this.getPatternValidity()) {
                    this.errorMessage = this.patternErrorMessage;
                }
                // required
                else if (this.input.validity.valueMissing) {
                    this.errorMessage = this.messages.errors.required;
                }
            }
        };
    }
    handleValue(newValue) {
        this.checkValidity();
        this.valueChange.emit(newValue);
    }
    watchReadonly(newValue) {
        if (newValue)
            this.classCollection.add(classReadonly);
        else
            this.classCollection.delete(classReadonly);
    }
    handleValidityChange(newValue, _oldValue, prop) {
        if (this.input !== undefined) {
            this.input[prop] = newValue;
            this.checkValidity();
            if (this.hasDisplayedError) {
                this.setErrorMessage();
                this.hasDisplayedError = false;
            }
        }
    }
    validateDisabled(newValue) {
        if (newValue)
            this.classCollection.add(classDisabled);
        else
            this.classCollection.delete(classDisabled);
    }
    watchMgWidth(newValue) {
        // reset width class
        widths.forEach(width => {
            this.classCollection.delete(`mg-c-input--width-${width}`);
        });
        // apply new width
        if (newValue !== undefined)
            this.classCollection.add(`mg-c-input--width-${this.mgWidth}`);
    }
    validatePattern(newValue) {
        if (newValue !== undefined && !(me(this.pattern) && me(this.patternErrorMessage))) {
            throw new Error(`<mg-input-textarea> props "pattern" and "patternErrorMessage" must be non-empty string and paired. Passed value: "pattern='${Ve(this.pattern)}'" and "patternErrorMessage='${Ve(this.patternErrorMessage)}'".`);
        }
    }
    validatecharacterLeftHide(newValue) {
        if (newValue) {
            this.classCollection.delete(this.classDisplayCharacterLeft);
        }
        else {
            this.classCollection.add(this.classDisplayCharacterLeft);
        }
    }
    /**
     * Display input error if it exists.
     */
    displayError() {
        // Use `Promise` as requested for stencil method
        // Use `requestAnimationFrame` to ensure:
        // - DOM is fully updated before validation
        // - Async operations are completed
        // - No timing issues with Stencil's render cycle
        // - Keep everything in sync both inside and outside the component
        return new Promise(resolve => {
            requestAnimationFrame(() => {
                this.checkValidity();
                this.setErrorMessage();
                this.hasDisplayedError = this.invalid;
                resolve();
            });
        });
    }
    /**
     * Set an error and display a custom error message.
     * This method can be used to set the component's error state from its context by passing a boolean value to the `valid` parameter.
     * It must be paired with an error message to display for the given context.
     * When used to set validity to `false`, you should use this method again to reset the validity to `true`.
     * @param valid - value indicating the validity
     * @param errorMessage - the error message to display
     */
    async setError(valid, errorMessage) {
        if (typeof valid !== 'boolean') {
            throw new Error('<mg-input-textarea> method "setError()" param "valid" must be a boolean.');
        }
        else if (!me(errorMessage)) {
            throw new Error('<mg-input-textarea> method "setError()" param "errorMessage" must be a string.');
        }
        else {
            this.setValidity(valid);
            this.setErrorMessage(valid ? undefined : errorMessage);
            this.hasDisplayedError = this.invalid;
        }
    }
    /**
     * Reset value, validity and error state
     */
    async reset() {
        if (!this.readonly) {
            this.value = '';
            this.checkValidity();
            this.errorMessage = undefined;
            this.hasDisplayedError = false;
        }
    }
    /**
     * Method to set validity values
     * @param newValue - valid new value
     */
    setValidity(newValue) {
        const oldValidValue = this.valid;
        this.valid = newValue;
        this.invalid = !this.valid;
        // We need to send valid event even if it is the same value
        if (this.handlerInProgress === undefined || (this.handlerInProgress === 'blur' && this.valid !== oldValidValue))
            this.inputValid.emit(this.valid);
    }
    /*************
     * Lifecycle *
     *************/
    /**
     * Check if component props are well configured on init
     * @returns timeout
     */
    componentWillLoad() {
        // Get locales
        this.messages = initLocales(this.element).messages;
        this.characterLeftId = `${this.identifier}-character-left`;
        // Validate
        this.validatecharacterLeftHide(this.characterLeftHide);
        this.validatePattern(this.pattern);
        this.validatePattern(this.patternErrorMessage);
        this.watchMgWidth(this.mgWidth);
        this.watchReadonly(this.readonly);
        this.validateDisabled(this.disabled);
        // Check validity when component is ready
        // return a promise to process action only in the FIRST render().
        // https://stenciljs.com/docs/component-lifecycle#componentwillload
        return setTimeout(() => {
            this.checkValidity();
        }, 0);
    }
    /**
     * Render
     * @returns HTML Element
     */
    render() {
        return (h("mg-input", { key: '02f06e7eb60af078d6ddba8d998cd57132cbf7f0', label: this.label, identifier: this.identifier, class: this.classCollection.join(), ariaDescribedbyIDs: [this.characterLeftId], labelOnTop: this.labelOnTop, labelHide: this.labelHide, required: this.required, tooltip: this.tooltip, tooltipPosition: this.readonly && this.value === undefined ? 'label' : this.tooltipPosition, helpText: this.helpText, errorMessage: this.errorMessage }, this.readonly ? (this.value && h("b", { class: "mg-c-input__readonly-value" }, this.value)) : (h("div", { class: "mg-c-input__with-character-left" }, h("textarea", { class: {
                'mg-c-input__box': true,
                'mg-c-input__box--width': true,
                'mg-c-input__box--resizable': this.resizable === 'both',
                'mg-c-input__box--resizable-horizontal': this.resizable === 'horizontal',
                'mg-c-input__box--resizable-vertical': this.resizable === 'vertical',
            }, value: this.value, id: this.identifier, name: this.name, placeholder: this.placeholder, title: this.placeholder, rows: this.rows, maxlength: this.maxlength, disabled: this.disabled, required: this.required, "aria-invalid": (this.invalid === true).toString(), onInput: this.handleInput, onFocus: this.handleFocus, onBlur: this.handleBlur, ref: (el) => {
                if (el !== null)
                    this.input = el;
            } }), !this.characterLeftHide && this.maxlength > 0 && (h("mg-character-left", { identifier: this.characterLeftId, characters: this.value, maxlength: this.maxlength }))))));
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "value": ["handleValue"],
        "readonly": ["watchReadonly", "handleValidityChange"],
        "required": ["handleValidityChange"],
        "disabled": ["handleValidityChange", "validateDisabled"],
        "mgWidth": ["watchMgWidth"],
        "pattern": ["validatePattern"],
        "patternErrorMessage": ["validatePattern"],
        "characterLeftHide": ["validatecharacterLeftHide"]
    }; }
};
MgInputTextarea.style = MgInputTextareaStyle0;

const mgInputTitleCss = ".mg-u-form-legacy.sc-mg-input-title{--mg-c-form-inputs-title-width:calc(100% / 3 - 20px)}.mg-u-is-asterisk.sc-mg-input-title{color:var(--mg-b-color-danger)}legend.mg-c-input-title.sc-mg-input-title{padding-right:0;padding-left:0}.mg-c-input-title__required.sc-mg-input-title{display:var(--mg-c-input-title-display, unset)}";
const MgInputTitleStyle0 = mgInputTitleCss;

const MgInputTitle = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        /**
         * Switch from label to fieldset sementic
         */
        this.isLegend = false;
        /**
         * Component parent tagname
         */
        this.tagName = 'label';
    }
    validateIdentifier(newValue) {
        if (!me(newValue)) {
            throw new Error('<mg-input-title> prop "identifier" is required.');
        }
        else if (!Xe(newValue)) {
            console.error(`<mg-input-title> prop "identifier" value is invalid. Passed value: ${Ve(newValue)}.`);
        }
    }
    validateIsLegend(newValue) {
        this.tagName = newValue ? 'legend' : 'label';
    }
    /*************
     * Lifecycle *
     *************/
    /**
     * Init tag name
     */
    componentWillLoad() {
        this.validateIdentifier(this.identifier);
        this.validateIsLegend(this.isLegend);
    }
    /**
     * Render
     * @returns HTML element
     */
    render() {
        const TagName = this.readonly ? 'span' : this.tagName;
        // \u00A0 represent a &nbsp;
        return (h(TagName, { key: 'f8f8baaeb87e7c2cc77e71781f4d33ea5a63f760', class: "mg-c-input-title", htmlFor: !this.isLegend && this.identifier, id: this.isLegend ? `${this.identifier}-title` : undefined }, h("slot", { key: '7f6c0f451dfe789d924e9f608813e03bc72ad88a' }), this.required && !this.readonly && (h("span", { key: 'a78c5191995399e3e2ad346fec8546277581ca9d', class: "mg-c-input-title__required" }, "\u00A0", h("span", { key: 'ae8df5f13d54a1b8419d0d01048ff91dda601ab6', class: "mg-u-is-asterisk" }, "*")))));
    }
    static get watchers() { return {
        "identifier": ["validateIdentifier"],
        "isLegend": ["validateIsLegend"]
    }; }
};
MgInputTitle.style = MgInputTitleStyle0;

const mgInputToggleCss = ".mg-c-input__readonly-value{min-height:var(--mg-b-font-size);align-self:flex-start;margin-top:calc((var(--mg-b-size-min-height) - var(--mg-b-font-size)*var(--mg-b-line-height))/2);word-break:break-word}.mg-u-visually-hidden{position:absolute !important;overflow:hidden !important;width:.1rem !important;height:.1rem !important;padding:0 !important;border:0 !important;margin:-0.1rem !important;clip:rect(0.1rem, 0.1rem, 0.1rem, 0.1rem) !important;clip-path:inset(50%) !important;white-space:nowrap !important}*:focus:not(:focus-visible){outline:none}@media (prefers-reduced-motion){*{animation:none !important;transition:none !important}}.mg-c-input__toggle-item-container{overflow:hidden;box-sizing:border-box;padding:var(--mg-b-size-4) var(--mg-b-size-8);border:0;border-radius:calc((var(--mg-b-font-size)*var(--mg-b-line-height) + 2*var(--mg-b-size-4))/var(--mg-c-input-toggle-border-radius-ratio));background-color:unset;color:var(--mg-b-color-dark);font-weight:unset;text-overflow:ellipsis;white-space:nowrap}.mg-c-input__toggle-item-container:first-of-type{background-color:color-mix(in srgb, var(--mg-b-color-app), white 80%);color:var(--mg-b-color-app);font-weight:600}.mg-c-input__button-toggle{display:flex;min-width:0;padding:var(--mg-b-size-4);border-width:var(--mg-c-input-border-width);border-style:solid;border-color:var(--mg-c-input-color-border);border-radius:calc((var(--mg-b-font-size)*var(--mg-b-line-height) + 2*(var(--mg-b-size-4) + var(--mg-b-size-4) + var(--mg-c-input-border-width)))/var(--mg-c-input-toggle-border-radius-ratio));background-color:var(--mg-b-color-light);cursor:pointer;font-family:var(--mg-b-font-family);font-size:inherit;line-height:inherit}.mg-c-input__button-toggle:disabled{cursor:default}.mg-c-input.mg-c-input--toggle .mg-c-input__input-container{min-width:0;flex:auto}.mg-c-input.mg-c-input--toggle-is-active .mg-c-input__toggle-item-container:first-of-type{background-color:unset;color:var(--mg-b-color-dark);font-weight:unset}.mg-c-input.mg-c-input--toggle-is-active .mg-c-input__toggle-item-container:last-of-type{background-color:color-mix(in srgb, var(--mg-b-color-app), white 80%);color:var(--mg-b-color-info);font-weight:600}.mg-c-input.mg-c-input--toggle-icon .mg-c-input__toggle-item-container{display:flex;width:calc(var(--mg-b-font-size)*var(--mg-b-line-height) + 2*var(--mg-b-size-4));height:calc(var(--mg-b-font-size)*var(--mg-b-line-height) + 2*var(--mg-b-size-4));align-items:center;justify-content:center;padding:0;visibility:hidden}.mg-c-input.mg-c-input--toggle-icon .mg-c-input__toggle-item-container:first-of-type{visibility:visible}.mg-c-input.mg-c-input--toggle-icon .mg-c-input__toggle-item-container ::slotted(mg-icon){display:flex}.mg-c-input.mg-c-input--toggle-icon.mg-c-input--toggle-is-active .mg-c-input__toggle-item-container:first-of-type{visibility:hidden}.mg-c-input.mg-c-input--toggle-icon.mg-c-input--toggle-is-active .mg-c-input__toggle-item-container:last-of-type{visibility:visible}.mg-c-input.mg-c-input--toggle-on-off .mg-c-input__toggle-item-container:first-of-type{background-color:var(--mg-b-color-neutral-30);color:var(--mg-b-color-dark);font-weight:600}.mg-c-input.mg-c-input--toggle-on-off.mg-c-input--toggle-is-active .mg-c-input__toggle-item-container:first-of-type{background-color:unset;color:var(--mg-b-color-dark);font-weight:unset}";
const MgInputToggleStyle0 = mgInputToggleCss;

/**
 * type Option validation function
 * @param option - radio option
 * @returns toggle option type is valid
 */
const isOption = (option) => typeof option === 'object' && typeof option.title === 'string' && option.value !== undefined;
const MgInputToggle = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.valueChange = createEvent(this, "value-change", 7);
        this.inputValid = createEvent(this, "input-valid", 7);
        /************
         * Internal *
         ************/
        // Classes
        this.classIsActive = 'mg-c-input--toggle-is-active';
        this.classOnOff = 'mg-c-input--toggle-on-off';
        this.classIcon = 'mg-c-input--toggle-icon';
        /**
         * Input name
         * If not set the value equals the identifier
         */
        this.name = this.identifier;
        /**
         * Define if label is visible
         */
        this.labelHide = false;
        /**
         * Define if toggle have on/off style
         */
        this.isOnOff = false;
        /**
         * Define if toggle display icon
         */
        this.isIcon = false;
        /**
         * Define if input is readonly
         */
        this.readonly = false;
        /**
         * Define if input is disabled
         */
        this.disabled = false;
        /**
         * Define tooltip position
         */
        this.tooltipPosition = 'input';
        /**
         * Component classes
         */
        this.classCollection = new Ze(['mg-c-input--toggle']);
        /**
         * Checked internal value
         */
        this.checked = false;
        /**
         * Set input error message
         * @param errorMessage - errorMessage override
         */
        this.setErrorMessage = (errorMessage) => {
            // Set error message
            this.errorMessage = undefined;
            // Does have a custom error message
            if (!this.valid && errorMessage !== undefined) {
                this.errorMessage = errorMessage;
            }
        };
        /**
         * Change checked value
         */
        this.toggleChecked = () => {
            this.checked = !this.checked;
        };
        /**
         * Slots validation
         */
        this.validateSlots = () => {
            const slots = Array.from(this.element.children);
            if (slots.length !== 2) {
                throw new Error('<mg-input-toggle> 2 slots are required.');
            }
            else if (!this.isIcon) {
                // Due to text-overflow set to ellipsis
                // we need to ensure that slot element have title to display value on mouse over
                slots.forEach(slot => slot.setAttribute('title', slot.textContent));
            }
        };
        /**
         * Get checked item
         * @param checked - checked item
         * @returns toggle value
         */
        this.getCheckedItem = (checked) => {
            var _a;
            if (((_a = this.options) === null || _a === void 0 ? void 0 : _a.length) === 2) {
                return this.options[checked ? 1 : 0];
            }
            else {
                return null;
            }
        };
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    handleValue(newValue) {
        // Swich to the right option
        this.setChecked();
        // Emit value-change event
        this.valueChange.emit(newValue);
    }
    validateItems(newValue) {
        if (typeof newValue === 'object' && this.items.length !== 2) {
            throw new Error(`<mg-input-toggle> prop "items" require 2 items. Passed value: ${Ve(newValue)}.`);
        }
        // String array
        else if (Je(newValue)) {
            this.options = newValue.map(item => ({ title: item, value: item }));
        }
        // Object array
        else if (Array.isArray(newValue) && newValue.every(isOption)) {
            this.options = newValue;
        }
        else {
            throw new Error(`<mg-input-toggle> prop "items" is required and all items must be the same type: ToggleValue. Passed value: ${Ve(newValue)}.`);
        }
    }
    watchIsOnOff(newValue) {
        if (newValue)
            this.classCollection.add(this.classOnOff);
        else
            this.classCollection.delete(this.classOnOff);
    }
    watchIsIcon(newValue) {
        if (newValue)
            this.classCollection.add(this.classIcon);
        else
            this.classCollection.delete(this.classIcon);
    }
    watchReadonly(newValue) {
        if (newValue)
            this.classCollection.add(classReadonly);
        else
            this.classCollection.delete(classReadonly);
    }
    watchDisabled(newValue) {
        if (newValue)
            this.classCollection.add(classDisabled);
        else
            this.classCollection.delete(classDisabled);
    }
    handleChecked(newValue) {
        // style
        if (newValue)
            this.classCollection.add(this.classIsActive);
        else
            this.classCollection.delete(this.classIsActive);
        // update value
        this.value = this.getCheckedItem(newValue).value;
    }
    /**
     * Set an error and display a custom error message.
     * This method can be used to set the component's error state from its context by passing a boolean value to the `valid` parameter.
     * It must be paired with an error message to display for the given context.
     * When used to set validity to `false`, you should use this method again to reset the validity to `true`.
     * @param valid - value indicating the validity
     * @param errorMessage - the error message to display
     */
    async setError(valid, errorMessage) {
        if (typeof valid !== 'boolean') {
            throw new Error('<mg-input-toggle> method "setError()" param "valid" must be a boolean.');
        }
        else if (!me(errorMessage)) {
            throw new Error('<mg-input-toggle> method "setError()" param "errorMessage" must be a string.');
        }
        else {
            this.valid = valid;
            this.inputValid.emit(valid);
            this.setErrorMessage(valid ? undefined : errorMessage);
        }
    }
    /**
     * Reset value, validity, error and visual state
     */
    async reset() {
        if (!this.readonly) {
            this.value = this.options[0].value;
            this.errorMessage = undefined;
            this.valid = undefined;
            this.setChecked();
        }
    }
    /**
     * set checked state
     */
    setChecked() {
        const optionTrueValueIndex = this.options.map(option => option.value).findIndex(value => value === true);
        if ([0, 1].includes(optionTrueValueIndex)) {
            // has "value" props type is not a boolean, it is bind/render as an attributes/props
            // true props will be represent by "true" string so we convert it has boolean
            // true attribute will be represent by "" string so we convert it has boolean
            // https://stenciljs.com/docs/properties
            if (['', 'true'].includes(this.value) && this.options.find(option => option.value) !== undefined) {
                this.value = true;
            }
            // when options are boolean values and ordered as [true,false] instead [false,true]
            // we need to reversed the checked value logic
            const selectedValue = this.value === this.options[optionTrueValueIndex].value;
            this.checked = optionTrueValueIndex === 0 ? !selectedValue : selectedValue;
        }
        else {
            this.checked = this.value === this.options[1].value;
        }
    }
    /*************
     * Lifecycle *
     *************/
    /**
     * Check if component props are well configured on init
     */
    componentWillLoad() {
        // Check items format
        this.validateItems(this.items);
        // Check slots
        this.validateSlots();
        // init checked value
        this.setChecked();
        // apply handler
        this.watchIsIcon(this.isIcon);
        this.watchIsOnOff(this.isOnOff);
        this.watchReadonly(this.readonly);
        this.watchDisabled(this.disabled);
    }
    /**
     * Render
     * @returns HTML Element
     */
    render() {
        const checkedItem = this.getCheckedItem(this.checked);
        return (h("mg-input", { key: 'cb5b7d47c6c0550d4c413894fda26e3e1dfd360a', label: this.label, helpText: this.helpText, identifier: this.identifier, class: this.classCollection.join(), ariaDescribedbyIDs: [], labelOnTop: this.labelOnTop, labelHide: this.labelHide, required: undefined, tooltip: this.tooltip, tooltipPosition: this.tooltipPosition, errorMessage: this.errorMessage }, this.readonly ? (checkedItem && h("b", { class: "mg-c-input__readonly-value" }, checkedItem.title)) : (h("button", { type: "button", role: "switch", "aria-checked": this.checked.toString(), "aria-readonly": this.disabled || this.readonly, id: this.identifier, class: "mg-c-input__button-toggle", disabled: this.disabled || this.readonly, onClick: this.toggleChecked }, h("span", { "aria-hidden": "true", class: "mg-c-input__toggle-item-container" }, h("slot", { name: "item-1" })), h("span", { "aria-hidden": "true", class: "mg-c-input__toggle-item-container" }, h("slot", { name: "item-2" }))))));
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "value": ["handleValue"],
        "items": ["validateItems"],
        "isOnOff": ["watchIsOnOff"],
        "isIcon": ["watchIsIcon"],
        "readonly": ["watchReadonly"],
        "disabled": ["watchDisabled"],
        "checked": ["handleChecked"]
    }; }
};
MgInputToggle.style = MgInputToggleStyle0;

/**
 *
 */
class OverflowBehavior {
    constructor(parentElement, itemMoreElement, itemMoreContainerElement) {
        this.parentElement = parentElement;
        this.itemMoreElement = itemMoreElement;
        this.itemMoreContainerElement = itemMoreContainerElement;
        /**********
         * Public *
         **********/
        /**
         * Disconnect ResizeObserver
         */
        this.disconnect = () => {
            this._resizeObserver.disconnect();
        };
        /************
         * Internal *
         ************/
        /**
         * Utility method to know if element is HTMLMgItemMoreElement
         * @param element - element to match with 'MORE' element
         * @returns truthy if element is the 'MORE' element
         */
        this.isMoreElement = (element) => element === this.itemMoreElement;
        /**
         * Utility method to know if item overflow partialy or totaly in the container
         * @param cumulateWidth - previous sibling elements cumulate width + item width
         * @param item - item HTML element
         * @returns truthy if element is overflow
         */
        this.isOverflowElement = (cumulateWidth, item) => {
            const displayMgItemMore = this.itemMoreContainerElement.children.length > 0;
            if (!this.isMoreElement(item)) {
                if (item.nextElementSibling.nodeName !== 'MG-ITEM-MORE' && !displayMgItemMore)
                    return cumulateWidth + this.itemMoreElement.offsetWidth > this._availableWidth;
                else
                    return cumulateWidth > this._availableWidth;
            }
            else
                return !displayMgItemMore;
        };
        /**
         * Toogle item from isHidden condition
         * @param item - item to update
         * @param isHidden - item is hidden
         */
        this.toggleItem = (item, isHidden) => {
            if (this.isMoreElement(item) && isHidden)
                item.setAttribute('hidden', '');
            else if (this.isMoreElement(item) && !isHidden)
                item.removeAttribute('hidden');
            else if (!this.isMoreElement(item) && isHidden)
                this.itemMoreContainerElement.appendChild(item);
            else if (!this.isMoreElement(item) && item.parentElement !== this.parentElement)
                this.parentElement.insertBefore(item, this.itemMoreElement);
        };
        if (!this.parentElement || !this.itemMoreElement || !this.itemMoreContainerElement) {
            throw new Error('OverflowBehavior - all construtor params are required');
        }
        const items = Array.from(this.parentElement.children);
        this._resizeObserver = new ResizeObserver(entries => {
            this._availableWidth = entries
                .map(entry => entry.contentRect.width)
                .sort((a, b) => a - b)
                .shift();
            // reset items
            items.forEach(item => this.toggleItem(item, false));
            let accWidth = 0;
            items.forEach((item, index) => {
                accWidth += item.offsetWidth;
                if (index)
                    this.toggleItem(item, this.isOverflowElement(accWidth, item));
            });
        });
        this._resizeObserver.observe(this.parentElement);
    }
}

const mgItemMoreCss = ".mg-u-visually-hidden{position:absolute !important;overflow:hidden !important;width:.1rem !important;height:.1rem !important;padding:0 !important;border:0 !important;margin:-0.1rem !important;clip:rect(0.1rem, 0.1rem, 0.1rem, 0.1rem) !important;clip-path:inset(50%) !important;white-space:nowrap !important}*:focus:not(:focus-visible){outline:none}@media (prefers-reduced-motion){*{animation:none !important;transition:none !important}}:host:not([hidden]){display:flex}";
const MgItemMoreStyle0 = mgItemMoreCss;

const MgItemMore = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        /************
         * Internal *
         ************/
        this.name = 'mg-item-more';
        /**
         * Define icon
         */
        this.icon = { icon: 'ellipsis-vertical' };
        /**
         * Define slot label element
         */
        this.slotlabel = { display: false };
    }
    validateIcon(newValue) {
        if (typeof newValue !== 'object' || (typeof newValue === 'object' && typeof newValue.icon !== 'string'))
            throw new Error(`<${this.name}> prop "icon" must match MgItemMore['icon'] type. Passed value: ${Ve(newValue)}.`);
    }
    validateSlotLabel(newValue) {
        if (typeof newValue !== 'object' || (typeof newValue === 'object' && typeof newValue.display !== 'boolean'))
            throw new Error(`<${this.name}> prop "slotlabel" must match MgItemMore['slotlabel'] type. Passed value: ${Ve(newValue)}.`);
        else if (typeof newValue.label !== 'string')
            this.slotlabel.label = this.messages.menuLabel;
    }
    validateSize(newValue) {
        if (newValue && !sizes$4.includes(newValue))
            throw new Error(`<${this.name}> prop "size" must match MgItemMore['size'] type. Passed value: ${Ve(newValue)}.`);
    }
    /*************
     * Lifecycle *
     *************/
    /**
     * Set variables and validate props
     */
    componentWillLoad() {
        // init variables
        this.messages = initLocales(this.element).messages.itemMore;
        // validate props
        this.validateIcon(this.icon);
        this.validateSlotLabel(this.slotlabel);
        this.validateSize(this.size);
    }
    /**
     * Ensure parent DOM is fully rendered with timeout method before parse elements
     * @returns timeout
     */
    componentDidLoad() {
        // ensure parent menu is fully rendered
        return setTimeout(() => {
            this.parentMenu = this.element.closest('mg-menu');
        });
    }
    /**
     * Set OverflowBehavior when parentMenu state is upate AND defined
     */
    componentDidUpdate() {
        if (this.parentMenu && this.overflowBehavior === undefined) {
            this.overflowBehavior = new OverflowBehavior(this.parentMenu, this.element, this.itemMoreContainer);
        }
    }
    /**
     * Disconnect overflow ResizeObserver
     */
    disconnectedCallback() {
        var _a;
        (_a = this.overflowBehavior) === null || _a === void 0 ? void 0 : _a.disconnect();
    }
    /**
     * Render
     * @returns HTML Element
     */
    render() {
        const menuItemIdentifier = 'mg-item-more';
        return (h(Host, { key: 'e6f29a59e69c25c27a8425b528e041b2dd11fb61', role: "listitem", "data-mg-popover-guard": `${menuItemIdentifier}-popover` }, this.parentMenu && (h("mg-menu-item", { key: 'b3d6550e2f99f95ae61551acfc63ee3c3a84c384', "data-overflow-more": true, "data-size": this.parentMenu.size, "data-style-direction": directions$1.HORIZONTAL, identifier: menuItemIdentifier }, h("mg-icon", { key: 'a4e720eb9c2c330f3df51cd2ace470c60e567cef', icon: this.icon.icon, size: this.size, slot: "image" }), h("span", { key: 'd5e59b95acea1676289fe54dc9382bedccb3d1ff', class: { 'mg-u-visually-hidden': !this.slotlabel.display }, slot: "label" }, this.slotlabel.label), h("mg-menu", { key: '8424b294a7570b99b6e044e7080c34896384bf14', direction: directions$1.VERTICAL, label: this.messages.menuLabel, size: this.size, ref: ref => {
                if (ref !== null)
                    this.itemMoreContainer = ref;
            } })))));
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "icon": ["validateIcon"],
        "slotlabel": ["validateSlotLabel"],
        "size": ["validateSize"]
    }; }
};
MgItemMore.style = MgItemMoreStyle0;

const mgMenuCss = ".mg-u-visually-hidden{position:absolute !important;overflow:hidden !important;width:.1rem !important;height:.1rem !important;padding:0 !important;border:0 !important;margin:-0.1rem !important;clip:rect(0.1rem, 0.1rem, 0.1rem, 0.1rem) !important;clip-path:inset(50%) !important;white-space:nowrap !important}*:focus:not(:focus-visible){outline:none}@media (prefers-reduced-motion){*{animation:none !important;transition:none !important}}/*!\n * @prop --mg-c-menu-color-background: Defines the background color of the menu. Unset by default, fallback on `--mg-b-color-light`.\n */:host{display:inline-flex;width:100%;min-width:0;background-color:var(--mg-c-menu-color-background, var(--mg-b-color-light))}:host([direction=vertical]){display:flex;height:100%;flex-direction:column;overflow-y:auto}";
const MgMenuStyle0 = mgMenuCss;

const MgMenu = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        /************
         * Internal *
         ************/
        this.name = 'mg-menu';
        /**
         * Component display direction.
         */
        this.direction = directions$1.HORIZONTAL;
        /**
         * Define mg-menu size
         */
        this.size = 'medium';
        /*************
         * Methods *
         *************/
        /**
         * Test if menu is a child menu
         * @returns truthy if menu is a child menu
         */
        this.isChildMenu = () => this.element.closest('mg-menu-item') !== null;
        /**
         * Get menu children items
         * @returns menu children mg-menu-item
         */
        this.getMenuItems = (menu = this.element) => {
            var _a, _b;
            const menuItems = Array.from(menu.children).filter(child => child.nodeName === 'MG-MENU-ITEM');
            const itemMoreMenuItem = (_b = (_a = menu.querySelector('mg-item-more')) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.querySelector('mg-menu-item');
            if (itemMoreMenuItem) {
                menuItems.push(itemMoreMenuItem);
            }
            return menuItems;
        };
        /**
         * Update menu items
         */
        this.updateMenuItems = () => {
            this.getMenuItems().forEach(item => {
                item.dataset.styleDirection = this.direction;
            });
            // render mg-item-more to manage OverflowBehavior
            this.renderMgItemMore();
        };
        /**
         * render mg-item-more
         */
        this.renderMgItemMore = () => {
            var _a;
            if (this.direction === directions$1.VERTICAL || (this.direction === directions$1.HORIZONTAL && this.isChildMenu()) || this.element.children.length <= 1) {
                return;
            }
            // Insert mg-item-more outside the mg-menu shadowdom
            let itemMoreElement = this.element.querySelector('mg-item-more');
            if (itemMoreElement === null) {
                itemMoreElement = document.createElement('mg-item-more');
                this.element.appendChild(itemMoreElement);
            }
            // update mg-item-more props
            for (const propertie in this.itemmore) {
                itemMoreElement[propertie] = this.itemmore[propertie];
            }
            if (((_a = this.itemmore) === null || _a === void 0 ? void 0 : _a.size) === undefined)
                itemMoreElement.size = this.size;
        };
    }
    validateLabel(newValue) {
        if (newValue === undefined && !this.element.hasAttribute('aria-label')) {
            throw new Error(`<${this.name}> prop "label" is required. Passed value: ${Ve(newValue)}.`);
        }
    }
    validateDirection(newValue) {
        if (![directions$1.VERTICAL, directions$1.HORIZONTAL].includes(newValue)) {
            throw new Error(`<${this.name}> prop "direction" must be one of: ${directions$1.HORIZONTAL}, ${directions$1.VERTICAL}. Passed value: ${Ve(newValue)}.`);
        }
        else {
            this.updateMenuItems();
        }
    }
    validateItemMore(newValue) {
        if (newValue !== undefined && this.direction !== directions$1.HORIZONTAL) {
            throw new Error(`<${this.name}> prop "itemmore" must be paired with direction ${directions$1.HORIZONTAL}.`);
        }
        else if (newValue !== undefined) {
            this.renderMgItemMore();
        }
    }
    validateSize(newValue) {
        if (!sizes$4.includes(newValue)) {
            throw new Error(`<${this.name}> prop "size" must be one of: ${sizes$4.join(', ')}. Passed value: ${Ve(newValue)}.`);
        }
    }
    /**
     * Define mg-menu-item listener when they are loaded
     * @param event - mg-item-loaded "item-loaded" custom event
     */
    updateItemListener(event) {
        const itemToWatch = event.target.nodeName === 'MG-ITEM-MORE' ? event.target.shadowRoot.querySelector('mg-menu-item') : event.target;
        ['click', 'focus'].forEach(trigger => {
            itemToWatch.addEventListener(trigger, () => {
                const focusedItem = event.target.closest('mg-menu').querySelector('[data-has-focus]');
                // exit process if new focused item in the current menu children
                if (focusedItem === itemToWatch)
                    return;
                // reset expanded on previous active menu item
                if (focusedItem)
                    focusedItem.removeAttribute('data-has-focus');
                // update focusedMenuItem with new value
                itemToWatch.setAttribute('data-has-focus', 'true');
            });
        });
    }
    /*************
     * Lifecycle *
     *************/
    /**
     * Validate props
     */
    componentWillLoad() {
        this.validateDirection(this.direction);
        this.validateLabel(this.label);
        this.validateItemMore(this.itemmore);
        this.validateSize(this.size);
    }
    /**
     * Check if component slots configuration
     */
    componentDidLoad() {
        // set menu-items
        this.updateMenuItems();
        // add listener to close main menu when focus leave it
        if (!this.isChildMenu() && this.direction === directions$1.HORIZONTAL) {
            document.addEventListener('focusin', (event) => {
                const isElementChild = (element) => {
                    if (element === this.element)
                        return true;
                    else if (!element.parentElement)
                        return false;
                    else
                        return isElementChild(element.parentElement);
                };
                if (!event.target.closest('mg-menu') || !isElementChild(event.target)) {
                    const focusedItem = this.element.querySelector('[data-has-focus]');
                    // reset expanded on previous active menu item
                    if (focusedItem)
                        focusedItem.removeAttribute('data-has-focus');
                }
            });
        }
        // add mutation observer to improve global reactivity
        new MutationObserver(this.updateMenuItems).observe(this.element, { childList: true });
    }
    /**
     * Render
     * @returns HTML Element
     */
    render() {
        return (h(Host, { key: '90442ca5c29abf5c94004374d20558f8b4752e6e', role: "list", "aria-label": this.label }, h("slot", { key: 'cfef557986ef4f545eca4542f7ee6e984052a198' })));
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "label": ["validateLabel"],
        "direction": ["validateDirection"],
        "itemmore": ["validateItemMore"],
        "size": ["validateSize"]
    }; }
};
MgMenu.style = MgMenuStyle0;

const mgMenuItemCss = ".mg-u-visually-hidden{position:absolute !important;overflow:hidden !important;width:.1rem !important;height:.1rem !important;padding:0 !important;border:0 !important;margin:-0.1rem !important;clip:rect(0.1rem, 0.1rem, 0.1rem, 0.1rem) !important;clip-path:inset(50%) !important;white-space:nowrap !important}*:focus:not(:focus-visible){outline:none}@media (prefers-reduced-motion){*{animation:none !important;transition:none !important}}/*!\n * @prop --mg-c-menu-item-color: Defines menu item global color, used for bottom line and active tabs. Default value: `--mg-b-color-app`.\n * @prop --mg-c-menu-item-color-text: Defines the color of the menu item. Unset by default, fallback on `--mg-b-color-dark`.\n * @prop --mg-c-menu-item-navigation-button-max-width: Defines the max-width property for the navigation button. Unset by default.\n */.mg-c-menu-item.mg-c-menu-item--size-medium .mg-c-menu-item__navigation-button,.mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--size-medium{height:var(--mg-b-size-40);padding:var(--mg-b-size-12) var(--mg-b-size-16)}.mg-c-menu-item.mg-c-menu-item--size-medium .mg-c-menu-item__navigation-button,.mg-c-menu-item.mg-c-menu-item--size-medium .mg-c-menu-item__navigation-button ::slotted([slot=label]),.mg-c-menu-item.mg-c-menu-item--size-medium .mg-c-menu-item__navigation-button ::slotted([slot=metadata]),.mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--size-medium,.mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--size-medium ::slotted([slot=label]),.mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--size-medium ::slotted([slot=metadata]){font-size:var(--mg-b-font-size)}.mg-c-menu-item.mg-c-menu-item--size-medium .mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--horizontal,.mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--size-medium.mg-c-menu-item__navigation-button--horizontal{padding-bottom:var(--mg-b-size-12)}.mg-c-menu-item.mg-c-menu-item--size-medium .mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--vertical,.mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--size-medium.mg-c-menu-item__navigation-button--vertical{padding-left:var(--mg-b-size-16)}.mg-c-menu-item.mg-c-menu-item--size-large .mg-c-menu-item__navigation-button,.mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--size-large{height:var(--mg-b-size-48);padding:var(--mg-b-size-12) var(--mg-b-size-32)}.mg-c-menu-item.mg-c-menu-item--size-large .mg-c-menu-item__navigation-button,.mg-c-menu-item.mg-c-menu-item--size-large .mg-c-menu-item__navigation-button ::slotted([slot=label]),.mg-c-menu-item.mg-c-menu-item--size-large .mg-c-menu-item__navigation-button ::slotted([slot=metadata]),.mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--size-large,.mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--size-large ::slotted([slot=label]),.mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--size-large ::slotted([slot=metadata]){font-size:var(--mg-b-font-size-h4)}.mg-c-menu-item.mg-c-menu-item--size-large .mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--horizontal,.mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--size-large.mg-c-menu-item__navigation-button--horizontal{padding-bottom:var(--mg-b-size-12)}.mg-c-menu-item.mg-c-menu-item--size-large .mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--vertical,.mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--size-large.mg-c-menu-item__navigation-button--vertical{padding-left:var(--mg-b-size-32)}.mg-c-menu-item.mg-c-menu-item--size-xlarge .mg-c-menu-item__navigation-button,.mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--size-xlarge{height:var(--mg-b-size-72);padding:var(--mg-b-size-12) var(--mg-b-size-40)}.mg-c-menu-item.mg-c-menu-item--size-xlarge .mg-c-menu-item__navigation-button,.mg-c-menu-item.mg-c-menu-item--size-xlarge .mg-c-menu-item__navigation-button ::slotted([slot=label]),.mg-c-menu-item.mg-c-menu-item--size-xlarge .mg-c-menu-item__navigation-button ::slotted([slot=metadata]),.mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--size-xlarge,.mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--size-xlarge ::slotted([slot=label]),.mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--size-xlarge ::slotted([slot=metadata]){font-size:var(--mg-b-font-size-h4)}.mg-c-menu-item.mg-c-menu-item--size-xlarge .mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--horizontal,.mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--size-xlarge.mg-c-menu-item__navigation-button--horizontal{padding-bottom:var(--mg-b-size-12)}.mg-c-menu-item.mg-c-menu-item--size-xlarge .mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--vertical,.mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--size-xlarge.mg-c-menu-item__navigation-button--vertical{padding-left:var(--mg-b-size-40)}.mg-c-menu-item__navigation-button{display:flex;box-sizing:border-box;align-items:center;border:none;background-color:unset;color:var(--mg-c-menu-item-color-text, var(--mg-b-color-dark));column-gap:var(--mg-c-menu-item-navigation-button-column-gap, var(--mg-b-size-8));cursor:pointer;font-family:var(--mg-b-font-family);font-weight:400;line-height:var(--mg-b-line-height);text-decoration:none;white-space:nowrap}.mg-c-menu-item__navigation-button:disabled,.mg-c-menu-item__navigation-button--disabled{cursor:default;opacity:var(--mg-b-opacity-element-disabled)}.mg-c-menu-item__navigation-button:focus-visible{z-index:10}.mg-c-menu-item__navigation-button:hover:not(.mg-c-menu-item__navigation-button--disabled),.mg-c-menu-item__navigation-button:focus-visible:not(.mg-c-menu-item__navigation-button--disabled){background-color:color-mix(in srgb, var(--mg-c-menu-item-color), transparent 90%)}.mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--active{color:var(--mg-c-menu-item-color);font-weight:600}.mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--active.mg-c-menu-item__navigation-button--horizontal{box-shadow:inset 0 calc(-1*var(--mg-b-size-4)) var(--mg-c-menu-item-color)}.mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--active.mg-c-menu-item__navigation-button--vertical{box-shadow:inset var(--mg-b-size-4) 0 var(--mg-c-menu-item-color)}.mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--hidden{display:none}:host([data-style-direction=vertical][data-level=\"1\"]) .mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--size-medium{padding-left:calc(1*var(--mg-b-size-16))}:host([data-level=\"1\"]) .mg-c-menu-item__collapse-container{z-index:10}:host([data-style-direction=vertical][data-level=\"2\"]) .mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--size-medium{padding-left:calc(2*var(--mg-b-size-16))}:host([data-level=\"2\"]) .mg-c-menu-item__collapse-container{z-index:20}:host([data-style-direction=vertical][data-level=\"3\"]) .mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--size-medium{padding-left:calc(3*var(--mg-b-size-16))}:host([data-level=\"3\"]) .mg-c-menu-item__collapse-container{z-index:30}:host([data-style-direction=vertical][data-level=\"4\"]) .mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--size-medium{padding-left:calc(4*var(--mg-b-size-16))}:host([data-level=\"4\"]) .mg-c-menu-item__collapse-container{z-index:40}:host([data-style-direction=vertical][data-level=\"5\"]) .mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--size-medium{padding-left:calc(5*var(--mg-b-size-16))}:host([data-level=\"5\"]) .mg-c-menu-item__collapse-container{z-index:50}:host([data-style-direction=vertical][data-level=\"6\"]) .mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--size-medium{padding-left:calc(6*var(--mg-b-size-16))}:host([data-level=\"6\"]) .mg-c-menu-item__collapse-container{z-index:60}:host([data-style-direction=vertical][data-level=\"1\"]) .mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--size-large{padding-left:calc(1*var(--mg-b-size-32))}:host([data-level=\"1\"]) .mg-c-menu-item__collapse-container{z-index:10}:host([data-style-direction=vertical][data-level=\"2\"]) .mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--size-large{padding-left:calc(2*var(--mg-b-size-32))}:host([data-level=\"2\"]) .mg-c-menu-item__collapse-container{z-index:20}:host([data-style-direction=vertical][data-level=\"3\"]) .mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--size-large{padding-left:calc(3*var(--mg-b-size-32))}:host([data-level=\"3\"]) .mg-c-menu-item__collapse-container{z-index:30}:host([data-style-direction=vertical][data-level=\"4\"]) .mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--size-large{padding-left:calc(4*var(--mg-b-size-32))}:host([data-level=\"4\"]) .mg-c-menu-item__collapse-container{z-index:40}:host([data-style-direction=vertical][data-level=\"5\"]) .mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--size-large{padding-left:calc(5*var(--mg-b-size-32))}:host([data-level=\"5\"]) .mg-c-menu-item__collapse-container{z-index:50}:host([data-style-direction=vertical][data-level=\"6\"]) .mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--size-large{padding-left:calc(6*var(--mg-b-size-32))}:host([data-level=\"6\"]) .mg-c-menu-item__collapse-container{z-index:60}:host([data-style-direction=vertical][data-level=\"1\"]) .mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--size-xlarge{padding-left:calc(1*var(--mg-b-size-40))}:host([data-level=\"1\"]) .mg-c-menu-item__collapse-container{z-index:10}:host([data-style-direction=vertical][data-level=\"2\"]) .mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--size-xlarge{padding-left:calc(2*var(--mg-b-size-40))}:host([data-level=\"2\"]) .mg-c-menu-item__collapse-container{z-index:20}:host([data-style-direction=vertical][data-level=\"3\"]) .mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--size-xlarge{padding-left:calc(3*var(--mg-b-size-40))}:host([data-level=\"3\"]) .mg-c-menu-item__collapse-container{z-index:30}:host([data-style-direction=vertical][data-level=\"4\"]) .mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--size-xlarge{padding-left:calc(4*var(--mg-b-size-40))}:host([data-level=\"4\"]) .mg-c-menu-item__collapse-container{z-index:40}:host([data-style-direction=vertical][data-level=\"5\"]) .mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--size-xlarge{padding-left:calc(5*var(--mg-b-size-40))}:host([data-level=\"5\"]) .mg-c-menu-item__collapse-container{z-index:50}:host([data-style-direction=vertical][data-level=\"6\"]) .mg-c-menu-item__navigation-button.mg-c-menu-item__navigation-button--size-xlarge{padding-left:calc(6*var(--mg-b-size-40))}:host([data-level=\"6\"]) .mg-c-menu-item__collapse-container{z-index:60}.mg-c-menu-item{max-width:var(--mg-c-menu-item-navigation-button-max-width)}.mg-c-menu-item__collapse-container{z-index:10;width:max-content}.mg-c-menu-item__navigation-button-center{min-width:0}.mg-c-menu-item__navigation-button-text-content{display:flex;width:100%;align-items:center}.mg-c-menu-item__navigation-button-text-content-notification,.mg-c-menu-item__navigation-button-text-content ::slotted([slot=information]){margin-left:var(--mg-b-size-8);font-size:var(--mg-b-font-size)}.mg-c-menu-item__navigation-button-new-tab{margin-left:var(--mg-b-size-4)}.mg-c-menu-item__navigation-button-chevron{display:var(--mg-c-menu-item-chevron-display);margin-left:auto;transition:200ms}.mg-c-menu-item__navigation-button-chevron--rotate.mg-c-menu-item__navigation-button-chevron{transform:rotate(180deg)}:host{position:relative;display:flex;--mg-c-popover-padding-vertical:0;--mg-c-popover-padding-horizontal:0;--mg-c-popover-max-width:unset}:host([data-style-direction=vertical]){flex-direction:column}:host([data-style-direction=vertical]) .mg-c-menu-item__navigation-button{width:100%}:host([data-style-direction=vertical]) .mg-c-menu-item__collapse-container{position:unset;top:unset;left:unset;width:unset}:host([data-style-direction=vertical]) .mg-c-menu-item-chevron{margin-left:auto}:host([data-overflow-more]){--mg-c-menu-item-navigation-button-column-gap:0}:host([data-overflow-more]) .mg-c-menu-item__navigation-button-chevron{--mg-c-menu-item-chevron-display:none}:host([data-overflow-more]) .mg-c-menu-item__navigation-button-text-content ::slotted([slot=information]){margin-left:0}:host([data-overflow-more]) ::slotted(mg-menu){--mg-c-menu-item-navigation-button-column-gap:var(--mg-b-size-8)}:host([data-style-direction=horizontal]) .mg-c-menu-item__collapse-container.mg-c-menu-item__collapse-container--first-level,:host([data-overflow-more]) .mg-c-menu-item__collapse-container.mg-c-menu-item__collapse-container--first-level{background-color:var(--mg-b-color-light)}:host([data-style-direction=horizontal]) .mg-c-menu-item__collapse-container.mg-c-menu-item__collapse-container--first-level ::slotted(mg-menu),:host([data-overflow-more]) .mg-c-menu-item__collapse-container.mg-c-menu-item__collapse-container--first-level ::slotted(mg-menu){padding:var(--mg-b-size-8) 0}::slotted([slot=label]),::slotted([slot=metadata]){display:block;overflow:hidden;text-align:left;text-overflow:ellipsis;white-space:nowrap}::slotted(*){display:flex;flex-direction:column}:host([status=disabled]){pointer-events:none}:host([hidden]){display:none}";
const MgMenuItemStyle0 = mgMenuItemCss;

const MgMenuItem = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.itemLoaded = createEvent(this, "item-loaded", 7);
        this.itemUpdated = createEvent(this, "item-updated", 7);
        /************
         * Internal *
         ************/
        this.name = 'mg-menu-item';
        this.navigationButton = 'mg-c-menu-item__navigation-button';
        /************
         * Props *
         ************/
        /**
         * Identifier is used to control mg-popover
         */
        this.identifier = Ge('mg-menu-item');
        /**
         * Define menu-item status.
         */
        this.status = Status$1.VISIBLE;
        /**
         * Define menu-item content expanded.
         */
        this.expanded = false;
        /**********
         * States *
         *********/
        /**
         * Define menu-item size.
         */
        this.size = 'medium';
        /**
         * Component button classes
         */
        this.navigationButtonClassList = new Ze([this.navigationButton]);
        /**
         * Does component have children.
         */
        this.hasChildren = false;
        /***********
         * Methods *
         **********/
        /**
         * Get parent menu
         * @returns parent menu
         */
        this.getParentMenu = () => this.element.closest('mg-menu');
        /**
         * Does an Element have given Status
         * @param mgMenuItemElement - to parse
         * @param status - to check
         * @returns true if element with status is found
         */
        this.hasStatus = (mgMenuItemElement, status) => mgMenuItemElement.status === status;
        /**
         * Condition to know if component should display a mg-popover
         * @returns truthy if component display popover
         */
        this.hasPopover = () => this.isDirection(directions$1.HORIZONTAL) &&
            ((this.isInMainMenu() && Array.from(this.element.children).some(element => !element.querySelector('[slot]'))) || this.isItemMore) &&
            this.href === undefined;
        /**
         * Method to control if one of component children have active status
         * @returns truthy if component has active child
         */
        this.hasActiveChild = () => {
            var _a;
            return Array.from(((_a = this.element.querySelector('mg-menu')) === null || _a === void 0 ? void 0 : _a.children) || []).some((element) => element.nodeName === 'MG-MENU-ITEM' && this.hasStatus(element, Status$1.ACTIVE) && !element.hasAttribute('hidden'));
        };
        /**
         * Is component an interactive item
         * @returns truthy if element is clickable
         */
        this.isInteractiveItem = () => this.hasChildren || !me(this.href);
        /**
         * Is component contextual direction match the given direction
         * @param direction - in parent menu
         * @param compareWith - direction to compare with. Default: `this.direction`
         * @returns true is direction match the direction propertie
         */
        this.isDirection = (direction, compareWith = this.direction) => direction === compareWith;
        /**
         * Does component is in main menu
         * @returns true if component is in main menu
         */
        this.isInMainMenu = () => this.getParentMenu() !== null && this.element.parentElement.closest('mg-menu-item') === null;
        /**
         * Update displayNotificationBadge
         * current component notification badge have priority over the slot badge when submenu contain badge
         */
        this.updateDisplayNotificationBadge = () => {
            const childMenu = this.element.querySelector('mg-menu');
            this.displayNotificationBadge =
                childMenu !== null && Array.from(childMenu.children).some((subItem) => subItem.querySelector('mg-badge') !== null && !subItem.hasAttribute('hidden'));
        };
        /**
         * Update expanded prop
         * @param newValue - expanded new value
         */
        this.updateExpanded = (newValue) => {
            if (this.isInteractiveItem()) {
                // item is always expanded in vertical menu when has active child
                this.expanded = (this.isDirection(directions$1.VERTICAL) && this.hasActiveChild()) || newValue;
            }
        };
        /**
         * Update status
         * @param guard - status to exclude from process in addition to [Status.HIDDEN, Status.DISABLED] . Default: [].
         */
        this.updateStatus = (guard = []) => {
            if (![Status$1.HIDDEN, Status$1.DISABLED, ...guard].includes(this.status)) {
                this.status = this.hasActiveChild() ? Status$1.ACTIVE : Status$1.VISIBLE;
            }
        };
        /**
         * Update slots
         * @param guard - prevent action with guard. Default: false.
         */
        this.updateSlot = (guard = false) => {
            // slot title AND metadata validation
            // add title on label AND metada slots due to text-overflow on these element
            if (Array.from(this.element.children).find(child => child.getAttribute('slot') === 'label') === undefined) {
                throw new Error(`<${this.name}> slot "label" is required.`);
            }
            ['label', 'metadata'].forEach(slot => {
                Array.from(this.element.querySelectorAll(`[slot="${slot}"]`)).forEach(element => {
                    if (!me(element.textContent))
                        throw new Error(`<${this.name}> slot "${slot}" must have text content.`);
                    if ((guard && !element.hasAttribute('title')) || !guard)
                        element.setAttribute('title', element.textContent);
                });
            });
        };
        /**
         * Update menu item
         * @param guard - prevent action with guard
         */
        this.updateItem = (guard) => {
            const menu = this.getParentMenu();
            // define element size
            if ((menu === null || menu === void 0 ? void 0 : menu.size) !== undefined && !this.isItemMore)
                this.size = menu.size;
            else if (this.isItemMore)
                this.size = this.element.dataset.size;
            // when vertical main menu item contain an active item we force expanded
            this.updateExpanded(this.expanded);
            this.updateStatus(guard);
            this.updatePopoverGuard();
            this.updateDisplayNotificationBadge();
        };
        /************
         * Handlers *
         ************/
        /**
         * Handle interacrtive element click
         * @param event - click on element
         */
        this.handleElementCLick = (event) => {
            if (this.status === Status$1.DISABLED) {
                event.preventDefault();
                event.stopPropagation();
            }
            // for non "poperized" menu-item we toggle expanded manualy
            this.updateExpanded(!this.expanded);
            // when item is the last clickable item we close the parent popover
            if (!this.isInteractiveItem()) {
                const closePopover = (element) => {
                    if (!element)
                        return;
                    else if (element !== this.element && element.expanded && element.shadowRoot.querySelector('mg-popover') !== null) {
                        element.expanded = false;
                    }
                    else {
                        closePopover(element.parentElement.closest('mg-menu-item'));
                    }
                };
                closePopover(this.element);
            }
        };
        /**
         * Handle popover element display-change event
         * @param event - popover display event
         */
        this.handlePopoverDisplay = (event) => {
            this.updateExpanded(event.detail);
        };
        /**
         * Render slot
         * @returns HTML Element
         */
        this.renderSlot = () => h("slot", null);
    }
    watchIdentifier(newValue) {
        if (!Xe(newValue)) {
            console.error(`<mg-menu-item> prop "identifier" value is invalid. Passed value: ${Ve(newValue)}.`);
        }
        else {
            this.popoverIdentifier = `${this.identifier}-popover`;
        }
    }
    watchTarget(newValue) {
        if (newValue && !targets.includes(newValue)) {
            throw new Error(`<mg-link> prop "target" must be one of: ${targets.join(', ')}. Passed value: ${Ve(newValue)}.`);
        }
    }
    watchStatus(newValue, oldValue) {
        if (oldValue !== undefined)
            this.navigationButtonClassList.delete(`${this.navigationButton}--${oldValue}`);
        this.navigationButtonClassList.add(`${this.navigationButton}--${newValue}`);
    }
    watchExpanded(newValue) {
        if (typeof newValue !== 'boolean') {
            throw new Error(`<${this.name}> prop "expanded" must be a boolean. Passed value: ${Ve(newValue)}.`);
        }
        else {
            this.updateExpanded(newValue);
            // when expanded all actives sub-items need to be expanded and non active closed
            Array.from(this.element.querySelectorAll('mg-menu-item')).forEach(item => {
                if (item !== this.element)
                    item.expanded = newValue ? this.hasStatus(item, Status$1.ACTIVE) : false;
            });
        }
    }
    watchSize(newValue, oldValue) {
        if (oldValue !== undefined)
            this.navigationButtonClassList.delete(`${this.navigationButton}--size-${oldValue}`);
        this.navigationButtonClassList.add(`${this.navigationButton}--size-${newValue}`);
    }
    validateDirection(newValue, oldValue) {
        if (oldValue !== undefined)
            this.navigationButtonClassList.delete(`${this.navigationButton}--${oldValue}`);
        this.navigationButtonClassList.add(`${this.navigationButton}--${newValue}`);
        // manage all sub levels child menu-items level with data-level attribut
        Array.from(this.element.querySelectorAll('mg-menu-item')).forEach(item => {
            if (this.isDirection(directions$1.VERTICAL, newValue)) {
                item.dataset.level = `${(Number(item.dataset.level) || 1) + 1}`;
            }
            else {
                delete item.dataset.level;
            }
        });
    }
    validateHasChildren(newValue) {
        if (newValue && this.element.href !== undefined) {
            throw new Error(`<${this.name}> prop "href" is unauthorizied when element is a parent.`);
        }
    }
    /**
     * direction value in dataset
     * @param newValue - new direction value
     */
    // eslint-disable-next-line @stencil-community/no-unused-watch
    watchDataStyleDirection(newValue) {
        this.direction = newValue;
    }
    /**
     * has focus value in dataset
     * @param newValue - new direction value
     */
    // eslint-disable-next-line @stencil-community/no-unused-watch
    watchDataHasFocus(newValue) {
        if (!newValue)
            this.updateExpanded(Boolean(newValue));
    }
    /**
     * Render popover clickoutside guard for content slot
     */
    updatePopoverGuard() {
        const subItem = this.element.querySelector('*:not([slot])');
        if (!subItem)
            return;
        if (this.hasPopover())
            subItem.dataset.mgPopoverGuard = this.popoverIdentifier;
        else
            delete subItem.dataset.mgPopoverGuard;
    }
    /*************
     * Lifecycle *
     *************/
    /**
     * Validate props
     */
    componentWillLoad() {
        // has children items that is NOT [slot='image' | 'information' | 'label' | 'metadata'] element
        // we store only matching elements
        this.hasChildren = Array.from(this.element.children).some(child => !['image', 'information', 'label', 'metadata'].includes(child.getAttribute('slot')));
        this.messages = initLocales(this.element).messages.menuItem;
        this.isItemMore = this.element.dataset.overflowMore !== undefined;
        // watchers
        this.watchStatus(this.status);
        this.watchExpanded(this.expanded);
        this.watchTarget(this.target);
        this.watchIdentifier(this.identifier);
        this.watchSize(this.size);
    }
    /**
     * Check if component slots configuration
     * @returns timeout
     */
    componentDidLoad() {
        // validation
        this.updateSlot(true);
        // update props and states after componentDidLoad hook
        // return a promise to process action only in the FIRST render().
        // https://stenciljs.com/docs/component-lifecycle#componentwillload
        return setTimeout(() => {
            this.watchDataStyleDirection(this.element.dataset.styleDirection);
            this.watchDataHasFocus(this.element.dataset.hasFocus);
            this.updateItem([Status$1.ACTIVE]);
            // emit loaded event when component is fully loaded
            this.itemLoaded.emit();
            new MutationObserver(mutationsList => {
                if (mutationsList.some(mutation => ['hidden', 'status'].includes(mutation.attributeName)))
                    this.updateStatus(this.hasChildren ? undefined : [Status$1.ACTIVE]);
                if (mutationsList.some(mutation => mutation.type === 'characterData'))
                    this.updateSlot();
                if (mutationsList.some(mutation => mutation.type === 'childList'))
                    this.updateItem();
                this.itemUpdated.emit();
            }).observe(this.element, { attributes: true, childList: true, characterData: true, subtree: true });
        }, 0);
    }
    /**
     * Emit event when component is updated
     * @returns promise process wich emit the 'item-updated' event
     */
    componentShouldUpdate() {
        return st(() => {
            this.itemUpdated.emit();
        });
    }
    /**
     * Render ineractive element
     * @returns HTML Element
     */
    renderInteractiveElement() {
        const TagName = this.href !== undefined ? 'a' : 'button';
        return (h(TagName, { href: this.href, class: this.navigationButtonClassList.join(), tabindex: [Status$1.DISABLED, Status$1.HIDDEN].includes(this.status) ? -1 : undefined, disabled: this.status === Status$1.DISABLED, hidden: this.status === Status$1.HIDDEN, target: this.href !== undefined && this.target !== undefined ? this.target : undefined, "aria-expanded": this.hasChildren && this.expanded.toString(), "aria-current": this.status === Status$1.ACTIVE && 'page', onClick: this.handleElementCLick }, h("slot", { name: "image" }), h("div", { class: `${this.navigationButton}-center` }, h("div", { class: `${this.navigationButton}-text-content` }, h("slot", { name: "label" }), !this.displayNotificationBadge && h("slot", { name: "information" }), this.displayNotificationBadge && (h("span", { class: `${this.navigationButton}-text-content-notification` }, h("mg-badge", { label: this.messages.badgeLabel, value: "!", variant: "text-color", slot: "information" }))), this.target === '_blank' && [
            h("mg-icon", { key: "icon-new-tab", class: `${this.navigationButton}-new-tab`, icon: "arrow-up-right-square" }),
            h("span", { key: "a11y-new-tab", class: "mg-u-visually-hidden" }, this.messages.openNewTab),
        ]), this.size !== 'medium' && h("slot", { name: "metadata" })), this.hasChildren && this.href === undefined && (h("span", { class: {
                [`${this.navigationButton}-chevron`]: true,
                [`${this.navigationButton}-chevron--rotate`]: this.expanded === true,
            } }, h("mg-icon", { icon: "chevron-down" })))));
    }
    /**
     * Render
     * @returns HTML Element
     */
    render() {
        const getContainerClasses = () => ({
            ['mg-c-menu-item__collapse-container']: true,
            ['mg-c-menu-item__collapse-container--first-level']: (this.isInMainMenu() || this.isItemMore) && this.isDirection(directions$1.HORIZONTAL),
        });
        return (h(Host, { key: 'cea7dac5e51bf47c5a9a1ae060f634ef455ac1b3', role: this.isItemMore ? 'presentation' : 'listitem' }, this.hasPopover() ? (h("mg-popover", { display: this.expanded, placement: "bottom-start", arrowHide: true, "onDisplay-change": this.handlePopoverDisplay, identifier: this.popoverIdentifier, "data-fallback-placement": "bottom-end" // use for the last element of the menu if it is placed on the right side
        }, this.renderInteractiveElement(), h("div", { class: getContainerClasses(), slot: "content" }, this.renderSlot()))) : ([
            this.renderInteractiveElement(),
            h("div", { key: "vertical-container", class: getContainerClasses(), hidden: !this.expanded }, this.renderSlot()),
        ])));
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "identifier": ["watchIdentifier"],
        "target": ["watchTarget"],
        "status": ["watchStatus"],
        "expanded": ["watchExpanded"],
        "size": ["watchSize"],
        "direction": ["validateDirection"],
        "hasChildren": ["validateHasChildren"],
        "data-style-direction": ["watchDataStyleDirection"],
        "data-has-focus": ["watchDataHasFocus"]
    }; }
};
MgMenuItem.style = MgMenuItemStyle0;

/**
 * List available variants
 */
const variants$1 = ['info', 'warning', 'success', 'danger'];
/**
 * List available variant styles
 */
const variantStyles = ['bar-left', 'background'];

const mgMessageCss = "/*!\n * @prop --mg-c-message-border-radius: Defines the border radius of the message. Default value: `--mg-b-size-radius`.\n */:host{--mg-c-card-spacing:0;--mg-c-card-border-radius:var(--mg-c-message-border-radius);--mg-c-card-border:none;--mg-c-card-overflow:hidden}.mg-c-message{display:inline-block;min-height:var(--mg-b-size-min-height)}.mg-c-message.mg-c-message--danger .mg-c-message__icon{color:var(--mg-b-color-danger)}.mg-c-message.mg-c-message--danger.mg-c-message--bar-left .mg-c-message__bar{background-color:var(--mg-b-color-danger)}.mg-c-message.mg-c-message--danger.mg-c-message--background{--mg-c-card-color-background:var(--mg-b-color-red-20, color-mix(in srgb, var(--mg-b-color-danger), white 80%))}.mg-c-message.mg-c-message--info .mg-c-message__icon{color:var(--mg-b-color-info)}.mg-c-message.mg-c-message--info.mg-c-message--bar-left .mg-c-message__bar{background-color:var(--mg-b-color-info)}.mg-c-message.mg-c-message--info.mg-c-message--background{--mg-c-card-color-background:var(--mg-b-color-blue-20, color-mix(in srgb, var(--mg-b-color-info), white 80%))}.mg-c-message.mg-c-message--success .mg-c-message__icon{color:var(--mg-b-color-success)}.mg-c-message.mg-c-message--success.mg-c-message--bar-left .mg-c-message__bar{background-color:var(--mg-b-color-success)}.mg-c-message.mg-c-message--success.mg-c-message--background{--mg-c-card-color-background:var(--mg-b-color-green-20, color-mix(in srgb, var(--mg-b-color-success), white 80%))}.mg-c-message.mg-c-message--warning .mg-c-message__icon{color:var(--mg-b-color-warning)}.mg-c-message.mg-c-message--warning.mg-c-message--bar-left .mg-c-message__bar{background-color:var(--mg-b-color-warning)}.mg-c-message.mg-c-message--warning.mg-c-message--background{--mg-c-card-color-background:var(--mg-b-color-yellow-20, color-mix(in srgb, var(--mg-b-color-warning), white 80%))}.mg-c-message ::slotted(*){padding:0;margin:0}.mg-c-message__icon{position:absolute;top:calc((var(--mg-b-size-min-height) - var(--mg-b-size-16))/2);left:calc(var(--mg-b-size-4) + var(--mg-b-size-8));line-height:1}.mg-c-message__content{display:flex;flex-wrap:wrap;padding:0 var(--mg-b-size-8) 0 calc(var(--mg-b-size-4) + var(--mg-b-size-8) + var(--mg-b-size-16) + var(--mg-b-size-8));place-content:stretch flex-end}.mg-c-message__content-slot{flex-grow:1;margin:var(--mg-b-size-8) 0}.mg-c-message__content-separator{display:inline-block;width:var(--mg-b-size-40);height:0}.mg-c-message__content-actions-slot{padding:var(--mg-b-size-8) 0;text-align:right}.mg-c-message__bar{position:absolute;top:0;left:0;width:var(--mg-b-size-4);height:100%}.mg-c-message ::slotted(*:not(mg-panel,mg-message,mg-modal)){--mg-c-card-border:var(--mg-c-card-border-default);--mg-c-card-spacing:var(--mg-c-card-spacing-default);--mg-c-card-border-radius:var(--mg-c-card-border-radius-default);--mg-c-card-color-background:var(--mg-c-card-color-background-default);--mg-c-card-box-shadow:var(--mg-c-card-box-shadow-default);--mg-c-card-max-width:unset;--mg-c-card-min-width:unset}.mg-c-message,.mg-c-message mg-message{max-width:100%}";
const MgMessageStyle0 = mgMessageCss;

const MgMessage = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        /************
         * Internal *
         ************/
        this.classBase = 'mg-c-message';
        /**
         * Define variant
         */
        this.variant = 'info';
        /**
         * Define variant style
         */
        this.variantStyle = 'bar-left';
        /**
         * Component classes
         */
        this.classCollection = new Ze(['mg-c-message']);
        /**
         * Define if component is using actions slot
         */
        this.hasActions = false;
        /**
         * Get icon corresponding to variant
         * @returns icon
         */
        this.getIcon = () => {
            switch (this.variant) {
                case 'info':
                    return 'info-circle';
                case 'warning':
                    return 'exclamation-triangle';
                case 'success':
                    return 'check-circle';
                case 'danger':
                    return 'exclamation-circle';
            }
        };
    }
    watchVariant(newValue, oldValue) {
        if (!variants$1.includes(newValue)) {
            throw new Error(`<mg-message> prop "variant" must be one of: ${variants$1.join(', ')}. Passed value: ${Ve(newValue)}.`);
        }
        else {
            if (newValue !== undefined)
                this.classCollection.add(`${this.classBase}--${newValue}`);
            if (oldValue !== undefined)
                this.classCollection.delete(`${this.classBase}--${oldValue}`);
        }
    }
    watchVariantStyle(newValue, oldValue) {
        if (!variantStyles.includes(newValue)) {
            throw new Error(`<mg-message> prop "variantStyle" must be one of: ${variantStyles.join(', ')}. Passed value: ${Ve(newValue)}.`);
        }
        else {
            if (newValue !== undefined)
                this.classCollection.add(`${this.classBase}--${newValue}`);
            if (oldValue !== undefined)
                this.classCollection.delete(`${this.classBase}--${oldValue}`);
        }
    }
    /*************
     * Lifecycle *
     *************/
    /**
     * Check if component props are well configured on init
     */
    componentWillLoad() {
        // Validate
        this.watchVariant(this.variant);
        this.watchVariantStyle(this.variantStyle);
        // Check if component has actions slot
        this.hasActions = this.element.querySelector('[slot="actions"]') !== null;
    }
    /**
     * Render
     * @returns HTML Element
     */
    render() {
        return (h("div", { key: 'd0a2c215951c0ef62588b5c1d13879a1ff9f8d1f', class: this.classCollection.join() }, h("mg-card", { key: '171d1c0452561a4a2729aea0a32d47e6831b1f50' }, this.variantStyle === 'bar-left' && h("span", { key: '482d2e6c2f51aafa1b434b24aab0fe9c3cb8141e', class: "mg-c-message__bar" }), h("span", { key: 'd6ec954a4eb499458bbdd0c7ba5fb5686c3afc0b', class: "mg-c-message__icon" }, h("mg-icon", { key: '32daba88c0c32cea0012ee6e80b97445aed3533c', icon: this.getIcon() })), h("div", { key: 'fc77d6745f2ae8d0c8de393598dad8d4c3b7f074', class: "mg-c-message__content" }, h("span", { key: 'e73d7327e259c457c66b2faf2ff26b3ca07bf24d', class: "mg-c-message__content-slot" }, h("slot", { key: 'c15d52b9cf7b4f974f0d92c7eceaeecba7708f37' })), this.hasActions && [
            h("span", { class: "mg-c-message__content-separator", key: "content-separator" }),
            h("span", { class: "mg-c-message__content-actions-slot", key: "content-actions-slot" }, h("slot", { key: '0ebf36c9be1bed739bede04f4cf8352f0580f53f', name: "actions" })),
        ]))));
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "variant": ["watchVariant"],
        "variantStyle": ["watchVariantStyle"]
    }; }
};
MgMessage.style = MgMessageStyle0;

/**
 * List of all possibles dialog roles
 */
const dialogRoles = ['dialog', 'alertdialog'];

const mgModalCss = "/*!\n * @prop --mg-c-modal-border-radius: Defines the border radius of the modal. Default value: `--mg-b-size-radius`.\n * @prop --mg-c-modal-title-font-size: Defines the font size of the modal title. Default value: `--mg-b-font-size-h3`.\n */:host{--mg-c-card-border-radius:var(--mg-c-modal-border-radius);--mg-c-card-spacing:var(--mg-b-size-16) var(--mg-b-size-24);--mg-c-card-border:none}.mg-c-modal{border:none;background:none;color:inherit}.mg-c-modal[open]{display:flex;padding:var(--mg-b-size-24) var(--mg-b-size-8)}.mg-c-modal::backdrop{background-color:var(--mg-b-color-light);opacity:.85}.mg-c-modal mg-card{display:flex;width:calc(75*var(--mg-b-size-8));max-width:100%;max-height:100%}.mg-c-modal__dialog{position:relative;display:flex;height:fit-content;max-height:100%;flex-direction:column;align-self:center;row-gap:var(--mg-b-size-24)}.mg-c-modal__title{margin:0;font-family:var(--mg-b-font-family-heading);font-size:var(--mg-c-modal-title-font-size);font-weight:600}.mg-c-modal__close-button{height:var(--mg-c-modal-title-font-size);margin-top:calc((var(--mg-b-size-min-height) - var(--mg-c-modal-title-font-size)*var(--mg-b-line-height))/2*-1);margin-right:calc((var(--mg-b-size-min-height) - var(--mg-b-size-16))/2*-1);margin-left:var(--mg-b-size-16);float:right}.mg-c-modal__content{padding:var(--mg-b-size-16);margin:calc(var(--mg-b-size-16)*-1);overflow-y:auto}.mg-c-modal ::slotted(*:not(mg-panel,mg-message,mg-modal)){--mg-c-card-border:var(--mg-c-card-border-default);--mg-c-card-spacing:var(--mg-c-card-spacing-default);--mg-c-card-border-radius:var(--mg-c-card-border-radius-default);--mg-c-card-color-background:var(--mg-c-card-color-background-default);--mg-c-card-box-shadow:var(--mg-c-card-box-shadow-default);--mg-c-card-max-width:unset;--mg-c-card-min-width:unset}";
const MgModalStyle0 = mgModalCss;

const MgModal = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.componentShow = createEvent(this, "component-show", 7);
        this.componentHide = createEvent(this, "component-hide", 7);
        this.componentClose = createEvent(this, "component-close", 7);
        // IDs
        this.titleId = '';
        /**
         * Identifier is used for the element ID (id is a reserved prop in Stencil.js)
         * If not set, it will be created.
         */
        this.identifier = Ge('mg-modal');
        /**
         * Modal dialog role.
         */
        this.dialogRole = dialogRoles[0];
        /**
         * Define if modal has a cross button
         */
        this.closeButton = false;
        /**
         * Define if modal is open
         */
        this.open = false;
        /**
         * Define if component is using actions slot
         */
        this.hasActions = false;
        /**
         * Component classes
         */
        this.classCollection = new Ze(['mg-c-modal']);
        /***********
         * Handles *
         ***********/
        /**
         * Closes the modal.
         */
        this.handleClose = () => {
            this.open = false;
            this.componentClose.emit();
        };
    }
    watchIdentifier(newValue) {
        if (!Xe(newValue)) {
            throw new Error(`<mg-modal> prop "identifier" value is invalid. Passed value: ${Ve(newValue)}.`);
        }
    }
    validateDialogRole(newValue) {
        if (!dialogRoles.includes(newValue))
            throw new Error(`<mg-modal> prop "dialogRole" must be one of: ${dialogRoles.join(', ')}. Passed value: ${Ve(newValue)}.`);
    }
    validateModalTitle(newValue) {
        if (!me(newValue)) {
            throw new Error(`<mg-modal> prop "modalTitle" is required. Passed value: ${Ve(newValue)}.`);
        }
    }
    watchOpen(newValue) {
        if (newValue) {
            this.dialog.showModal();
            this.componentShow.emit();
            document.body.style.overflow = 'hidden';
        }
        else {
            this.dialog.close();
            this.componentHide.emit();
            document.body.style.overflow = this.bodyOverflow;
        }
    }
    /*************
     * Lifecycle *
     *************/
    /**
     * Check if component props are well configured on init
     */
    componentWillLoad() {
        // Store body overflow
        this.bodyOverflow = document.body.style.overflow;
        // Get locales
        this.messages = initLocales(this.element).messages;
        // Validate
        this.hasActions = this.element.querySelector('[slot="actions"]') !== null;
        this.titleId = `${this.identifier}-title`;
        this.watchIdentifier(this.identifier);
        this.validateModalTitle(this.modalTitle);
        this.validateDialogRole(this.dialogRole);
    }
    /**
     * Define open state on component load
     */
    componentDidLoad() {
        this.watchOpen(this.open);
        // update open prop when use escape key
        this.dialog.addEventListener('close', () => {
            this.open = false;
            this.componentClose.emit();
        });
    }
    /**
     * Render
     * @returns HTML Element
     */
    render() {
        return (h("dialog", { key: 'd9bc9c48122e4a607122ad62afb1229061860e70', role: this.dialogRole, id: this.identifier, class: this.classCollection.join(), "aria-labelledby": this.titleId, ref: (el) => {
                if (el !== null) {
                    this.dialog = el;
                }
            } }, h("mg-card", { key: 'fdddd50b0d87d50025eb65297ffdde890db84daa' }, h("div", { key: 'a168d0ec2be896b381ed6079f2f50f0e06fbef0c', class: "mg-c-modal__dialog" }, h("header", { key: 'f6c902fb1c424d14a0cf36fbe6904137e1f25a77', class: "mg-c-modal__header" }, this.closeButton && (h("span", { key: '3bfd0399c679cd4695b7ec6baf93852f551f500f', class: "mg-c-modal__close-button" }, h("mg-button", { key: '65d9a1001c74869bde17c5b10e4d7f6d40927d5c', "is-icon": true, variant: "flat", label: this.messages.modal.closeButton, onClick: this.handleClose }, h("mg-icon", { key: '4afd89c06bb4667d03dc8f57cafc2de937989539', icon: "cross" })))), h("h1", { key: '0e8714311653249fc9f567072bb83a82f40be657', class: "mg-c-modal__title", id: this.titleId }, this.modalTitle)), h("article", { key: '8bea86261d774672f59161b8356d88bb8ce6934f', class: "mg-c-modal__content" }, h("slot", { key: 'e1be91919ea7c4c6564bdab5fd4637a1f70670af' })), this.hasActions && (h("footer", { key: 'ed52ba51f38a5638e8ab525863631304ec32e4f8', class: "mg-c-modal__footer" }, h("slot", { key: '2ea047455de5f22876a0fc97e95321360aa55b33', name: "actions" })))))));
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "identifier": ["watchIdentifier"],
        "dialogRole": ["validateDialogRole"],
        "modalTitle": ["validateModalTitle"],
        "open": ["watchOpen"]
    }; }
};
MgModal.style = MgModalStyle0;

const NavigationAction = {
    NEXT: 'next',
    PREVIOUS: 'previous',
};

const mgPaginationCss = ".mg-u-visually-hidden{position:absolute !important;overflow:hidden !important;width:.1rem !important;height:.1rem !important;padding:0 !important;border:0 !important;margin:-0.1rem !important;clip:rect(0.1rem, 0.1rem, 0.1rem, 0.1rem) !important;clip-path:inset(50%) !important;white-space:nowrap !important}*:focus:not(:focus-visible){outline:none}@media (prefers-reduced-motion){*{animation:none !important;transition:none !important}}.mg-c-pagination{display:flex;align-items:center;gap:var(--mg-b-spacing-actions)}.mg-c-pagination__page-count{display:flex;align-items:center;gap:var(--mg-b-size-4)}.mg-c-pagination.mg-c-pagination--hide-page-count{gap:0}";
const MgPaginationStyle0 = mgPaginationCss;

/**
 * Range generator
 *
 * ```
 * start by get the range length, add "+ 1" to include last value, ex: Math.ceil((3 + 1 - 1) / 1) => 3
 * then with Array(Math.ceil...) we get the final array with empty values, ex: Array(Math.ceil(2 + 1 - 1) / 1)) => [empty, empty, empty]
 * then with Array(Math.ceil...).keys() we get the Array Iterator from empty values
 * then with Array.from(Array(...)) we get the complete array with "index" values instead of "empty" values
 * ex: Array.from(Array(Math.ceil((2 + 1 - 1) / 1) || 1).keys()) => [0, 1, 2]
 * finaly we map values from "start" range and apply the "step" coefficiant,
 * ex: Array.from(Array(Math.ceil((2 + 1 - 1) / 1) || 1).keys()).map(x => 1 + x * 1) => [1, 2, 3]
 * ```
 *
 * range(1, 1) = [1]
 * range(1, 5) = [1, 2, 3, 4, 5]
 * range(10, 20, 2) = [10, 12, 14, 16, 18, 20]
 * @param start - start range
 * @param end - start end
 * @param step - step size
 * @returns range numbers
 */
const range = (start, end, step = 1) => Array.from(Array(Math.ceil((end + 1 - start) / step)).keys()).map(x => start + x * step);
const MgPagination = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.currentPageChange = createEvent(this, "current-page-change", 7);
        /**
         * Identifier is used for the element ID (id is a reserved prop in Stencil.js)
         * If not set, it will be created.
         */
        this.identifier = Ge('mg-pagination');
        /**
         * Component total pages
         */
        this.totalPages = 1;
        /**
         * Component current page
         */
        this.currentPage = 1;
        /**
         * Change current page from target
         * @param target - target page
         */
        this.goToPage = (target) => {
            this.currentPage = target;
        };
        /************
         * Handlers *
         ************/
        /**
         * select handler
         * @param event - value change event
         */
        this.handleSelect = (event) => {
            const to = Number(event.target.value);
            this.goToPage(to > 0 ? to : 1);
        };
        /**
         * Go to 'previous/next' page button handler
         * @param action - navigation action
         * @param disabled - button disable state
         */
        this.handleGoToPage = (action, disabled) => {
            !disabled && this.goToPage(action === NavigationAction.NEXT ? this.currentPage + 1 : this.currentPage - 1);
        };
    }
    watchIdentifier(newValue) {
        if (!Xe(newValue)) {
            console.error(`<mg-pagination> prop "identifier" value is invalid. Passed value: ${Ve(newValue)}.`);
        }
    }
    validateTotalPages(newValue) {
        if (newValue < 1) {
            throw new Error(`<mg-pagination> prop "totalPages" must be greater than 0. Passed value: ${Ve(newValue)}.`);
        }
    }
    validateCurrentPage(newValue) {
        if (newValue < 1) {
            throw new Error(`<mg-pagination> prop "currentPage" must be greater than 0. Passed value: ${Ve(newValue)}.`);
        }
        else if (newValue > this.totalPages) {
            throw new Error('<mg-pagination> prop "currentPage" can not be greater than total page.');
        }
        this.currentPageChange.emit(newValue);
    }
    /*************
     * Lifecycle *
     *************/
    /**
     * Check if props are well configured on init
     */
    componentWillLoad() {
        // Get locales
        this.messages = initLocales(this.element).messages;
        // Validate
        this.watchIdentifier(this.identifier);
        this.validateTotalPages(this.totalPages);
        this.validateCurrentPage(this.currentPage);
        // Set default label
        if (this.label === undefined || this.label === '') {
            this.label = this.messages.pagination.label;
        }
    }
    /**
     * Render
     * @returns HTML Element
     */
    render() {
        const navigationActionButton = (disabled, action) => (h("mg-button", { key: 'adf311f317e6d071e73e6ee11f323f2957a6c7c5', label: this.messages.pagination[`${action}Page`],
            // eslint-disable-next-line react/jsx-no-bind
            onClick: () => this.handleGoToPage(action, disabled), disabled: disabled, variant: "flat", isIcon: this.hideNavigationLabels }, action === NavigationAction.PREVIOUS && h("mg-icon", { key: '23cd025ff4d5085f60a762ca02bec7ea4d08b47a', icon: "chevron-left" }), !this.hideNavigationLabels && this.messages.general[action], action === NavigationAction.NEXT && h("mg-icon", { key: '5e178d7571d840b691349999a0dc9986ea9a97d1', icon: "chevron-right" })));
        return (h(Host, { key: '549c2a5e08db08ff4db40f283dc941e3c918aa48', hidden: this.totalPages < 2 }, h("nav", { key: '6dad6fcdc86313bd8a89a253bf8b34417b5d7a9b', role: "navigation", "aria-label": this.label, id: this.identifier, class: { 'mg-c-pagination': true, 'mg-c-pagination--hide-page-count': this.hidePageCount } }, navigationActionButton(this.currentPage <= 1, NavigationAction.PREVIOUS), !this.hidePageCount && (h("div", { key: '779c725432c4e35c82a25c9b48619b30d94aa3fd', class: "mg-c-pagination__page-count" }, h("mg-input-select", { key: '9ebbb2eb315ceb906b87c1866a2230a07fc456eb', identifier: `${this.identifier}-select`, items: range(1, this.totalPages).map(page => page.toString()), label: this.messages.pagination.selectPage, "label-hide": true, "on-value-change": this.handleSelect, value: this.currentPage.toString(), "placeholder-hide": true }), h("span", { key: '562ef9a11ec557bf498ac4d62be095cbc4c71d22', class: "mg-u-visually-hidden" }, this.messages.pagination.page, " ", this.currentPage), "/ ", this.totalPages, " ", this.totalPages > 1 ? this.messages.pagination.pages : this.messages.pagination.page)), navigationActionButton(this.currentPage >= this.totalPages, NavigationAction.NEXT))));
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "identifier": ["watchIdentifier"],
        "totalPages": ["validateTotalPages"],
        "currentPage": ["validateCurrentPage"]
    }; }
};
MgPagination.style = MgPaginationStyle0;

/**
 * Available expand toggle display options
 */
const expandToggleDisplays = ['text', 'icon'];
/**
 * Available title positions
 */
const titlePositions = ['left', 'right'];

const mgPanelCss = "/*!\n * @prop --mg-c-panel-border-radius: Defines the border radius of the panel. Default value: `--mg-b-size-radius`.\n * @prop --mg-c-panel-color-background: Defines the background of the panel. Default value: `color-mix(in srgb, var(--mg-b-color-info), white 97%)`.\n * @prop --mg-c-panel-box-shadow: Defines the box shadow of the panel. Default value: `--mg-b-box-shadow`.\n * @prop --mg-c-panel-content-spacing: Defines the padding of the panel content. Default value: `--mg-b-size-16`.\n */:host{--mg-c-card-border:none;--mg-c-card-spacing:0;--mg-c-card-border-radius:var(--mg-c-panel-border-radius);--mg-c-card-color-background:var(--mg-c-panel-color-background);--mg-c-card-box-shadow:var(--mg-c-panel-box-shadow)}.mg-c-panel__header{display:flex;flex-wrap:wrap;align-items:flex-start;justify-content:space-between;padding:0 var(--mg-b-size-4)}.mg-c-panel__header-title,.mg-c-panel__header-content{display:flex;margin:var(--mg-b-size-4) 0}.mg-c-panel__header-content{min-height:var(--mg-b-size-min-height);flex:1 auto;align-items:center;padding-left:var(--mg-b-size-4)}.mg-c-panel__header-title mg-input-text{flex-grow:1;margin-left:var(--mg-b-size-4)}.mg-c-panel__header-title mg-button+mg-button:not([slot=append-input]){margin-left:var(--mg-b-size-4)}.mg-c-panel__header-title.mg-c-panel__header-title--full{flex:1 1 auto}.mg-c-panel__collapse-button-content{--mg-b-font-size:var(--mg-b-font-size-h5);--mg-c-button-font-weight:600}.mg-c-panel__collapse-button-icon.mg-c-panel__collapse-button-icon--reverse{transform:rotate(180deg)}.mg-c-panel__content{padding:var(--mg-c-panel-content-spacing)}.mg-c-panel ::slotted([slot=header-right]){display:flex;flex-wrap:wrap;margin-left:auto;gap:var(--mg-b-spacing-actions)}.mg-c-panel ::slotted(*:not(mg-panel,mg-message,mg-modal)){--mg-c-card-border:var(--mg-c-card-border-default);--mg-c-card-spacing:var(--mg-c-card-spacing-default);--mg-c-card-border-radius:var(--mg-c-card-border-radius-default);--mg-c-card-color-background:var(--mg-c-card-color-background-default);--mg-c-card-box-shadow:var(--mg-c-card-box-shadow-default);--mg-c-card-max-width:unset;--mg-c-card-min-width:unset}";
const MgPanelStyle0 = mgPanelCss;

const MgPanel = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.titleChange = createEvent(this, "title-change", 7);
        this.expandedChange = createEvent(this, "expanded-change", 7);
        /**
         * Identifier is used for the element ID (id is a reserved prop in Stencil.js)
         * If not set, it will be created.
         */
        this.identifier = Ge('mg-panel');
        /**
         * Define if panel title is editable
         */
        this.titleEditable = false;
        /**
         * Define title position
         */
        this.titlePosition = titlePositions[0];
        /**
         * Panel is opened
         */
        this.expanded = false;
        /**
         * Define expand toggle button display
         */
        this.expandToggleDisplay = expandToggleDisplays[0];
        /**
         * Component classes
         */
        this.classCollection = new Ze(['mg-c-panel']);
        /**
         * Title is in edition mode
         */
        this.isEditing = false;
        /************
         * Methods *
         ************/
        /**
         * Toggle is editing state
         */
        this.toggleIsEditing = () => {
            this.isEditing = !this.isEditing;
        };
        /************
         * Handlers *
         ************/
        /**
         * Collapse button click handler
         */
        this.handleCollapseButton = () => {
            if (!this.expandToggleDisabled)
                this.expanded = !this.expanded;
        };
        /**
         * Edit button click handler
         */
        this.handleEditButton = () => {
            this.toggleIsEditing();
        };
        /**
         * Update title handler
         * @param event - input value change event
         */
        this.handleUpdateTitle = (event) => {
            this.updatedPanelTitle = event.detail;
        };
        /**
         * Cancel edition button handler
         */
        this.handleCancelEditButton = () => {
            this.updatedPanelTitle = undefined;
            this.toggleIsEditing();
        };
        /**
         * Validate edition button handler
         */
        this.handleValidateEditButton = () => {
            if (!this.editInputElement.valid)
                return;
            if (this.updatedPanelTitle !== undefined)
                this.panelTitle = this.updatedPanelTitle;
            this.toggleIsEditing();
        };
        /*************
         * Render *
         *************/
        /**
         * Render collapse button
         * @returns collpase button
         */
        this.renderCollapseButton = () => (h("mg-button", { onClick: this.handleCollapseButton, variant: "flat", "aria-expanded": this.expanded.toString(), "aria-controls": `${this.identifier}-content`, disabled: this.expandToggleDisabled, isIcon: this.expandToggleDisplay === 'icon', label: this.panelTitle }, h("span", { class: "mg-c-panel__collapse-button-content" }, h("mg-icon", { icon: "chevron-up", class: { 'mg-c-panel__collapse-button-icon': true, 'mg-c-panel__collapse-button-icon--reverse': !this.expanded } }), !this.isEditing && this.expandToggleDisplay !== 'icon' && this.panelTitle)));
        /**
         * Render edit button
         * @returns edit Button
         */
        this.renderEditButton = () => (h("mg-button", { key: "edit-button", "is-icon": true, variant: "flat", label: this.messages.panel.editLabel, onClick: this.handleEditButton }, h("mg-icon", { icon: "pen" })));
        /**
         * Render input button
         * @returns edit title input
         */
        this.renderEditInput = () => (h("mg-input-text", { key: "edition-input", label: this.messages.panel.editLabel, "label-hide": true, value: this.panelTitle, "onValue-change": this.handleUpdateTitle, characterLeftHide: true, pattern: this.titlePattern, "pattern-error-message": this.titlePatternErrorMessage, identifier: `${this.identifier}-edition-input`, ref: (el) => (this.editInputElement = el) }, h("mg-button", { slot: "append-input", label: this.messages.general.cancel, "is-icon": true, variant: "secondary", onClick: this.handleCancelEditButton }, h("mg-icon", { icon: "cross" })), h("mg-button", { slot: "append-input", label: this.messages.general.confirm, "is-icon": true, variant: "secondary", onClick: this.handleValidateEditButton }, h("mg-icon", { icon: "check" }))));
        /**
         * Render title
         * @returns title element
         */
        this.renderTitle = () => {
            const elementsToRender = [this.renderCollapseButton()];
            if (this.titleEditable) {
                if (!this.isEditing)
                    elementsToRender.push(this.renderEditButton());
                else
                    elementsToRender.push(this.renderEditInput());
            }
            return this.titlePosition === 'right' ? elementsToRender.reverse() : elementsToRender;
        };
        /**
         * Render header children
         * @returns header child
         */
        this.renderHeaderChildren = () => {
            const children = [
                h("div", { class: { 'mg-c-panel__header-title': true, 'mg-c-panel__header-title--full': this.isEditing, 'mg-c-panel__header-title--reverse': this.titlePosition === 'right' }, key: this.panelTitle }, this.renderTitle()),
                h("div", { class: "mg-c-panel__header-content", key: "slot-header" }, h("slot", { name: "header-right" })),
            ];
            return this.titlePosition === 'right' ? children.reverse() : children;
        };
    }
    watchIdentifier(newValue) {
        if (!Xe(newValue)) {
            console.error(`<mg-panel> prop "identifier" value is invalid. Passed value: ${Ve(newValue)}.`);
        }
    }
    validatePanelTitle(newValue) {
        if (!me(newValue))
            throw new Error(`<mg-panel> prop "panelTitle" is required and must be a string. Passed value: ${Ve(newValue)}.`);
        this.titleChange.emit(newValue);
    }
    validateTitlePattern(newValue) {
        if (newValue !== undefined && !this.titleEditable)
            throw new Error(`<mg-panel> prop "titleEditable" must be set to "true".`);
    }
    validateTitlePosition(newValue) {
        if (!titlePositions.includes(newValue))
            throw new Error(`<mg-panel> prop "titlePosition" must be one of: ${titlePositions.join(', ')}. Passed value: ${Ve(newValue)}.`);
    }
    handleExpanded(newValue) {
        this.expandedChange.emit(newValue);
    }
    validateExpandToggleDisplay(newValue) {
        if (!expandToggleDisplays.includes(newValue))
            throw new Error(`<mg-panel> prop "expandToggleDisplay" must be one of: ${expandToggleDisplays.join(', ')}. Passed value: ${Ve(newValue)}.`);
        if (newValue === 'icon' && this.titleEditable)
            this.titleEditable = false;
    }
    /*************
     * Lifecycle *
     *************/
    /**
     * Check if props are well configured on init
     */
    componentWillLoad() {
        // Get locales
        this.messages = initLocales(this.element).messages;
        // Validate
        this.watchIdentifier(this.identifier);
        this.validateTitlePattern(this.titlePattern);
        this.validateTitlePattern(this.titlePatternErrorMessage);
        this.validatePanelTitle(this.panelTitle);
        this.validateExpandToggleDisplay(this.expandToggleDisplay);
        this.validateTitlePosition(this.titlePosition);
    }
    /**
     * Edit DOM after render
     */
    componentDidRender() {
        // when we are editing we get focus on edition input
        if (this.isEditing)
            this.editInputElement.setFocus();
    }
    /**
     * Render component
     * @returns rendered component
     */
    render() {
        const headerId = `${this.identifier}-header`;
        return (h("section", { key: 'ffe1c2453e1247f8a5a3c439f6f87fc1ceefe06b', class: this.classCollection.join(), id: this.identifier }, h("mg-card", { key: '77dfb890d2090af6eca0f332aaff07f737946f50' }, h("header", { key: '2c20eab45a175c8f176dd7c003fc336b4f98d058', class: { 'mg-c-panel__header': true, 'mg-c-panel__header--reverse': this.titlePosition === 'right' }, id: headerId }, this.renderHeaderChildren()), h("article", { key: '2c359205023c9b25c2b88ae6aad404663330d3a5', class: "mg-c-panel__content", id: `${this.identifier}-content`, "aria-labelledby": headerId, hidden: !this.expanded }, h("slot", { key: 'f4c5ce16b3709529d5808a51c1d1f7a0677d82f2' })))));
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "identifier": ["watchIdentifier"],
        "panelTitle": ["validatePanelTitle"],
        "titlePattern": ["validateTitlePattern"],
        "titlePatternErrorMessage": ["validateTitlePattern"],
        "titlePosition": ["validateTitlePosition"],
        "expanded": ["handleExpanded"],
        "expandToggleDisplay": ["validateExpandToggleDisplay"]
    }; }
};
MgPanel.style = MgPanelStyle0;

/**
 * Custom positioning reference element.
 * @see https://floating-ui.com/docs/virtual-elements
 */

const sides$1 = ['top', 'right', 'bottom', 'left'];
const alignments = ['start', 'end'];
const placements$1 = /*#__PURE__*/sides$1.reduce((acc, side) => acc.concat(side, side + "-" + alignments[0], side + "-" + alignments[1]), []);
const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = v => ({
  x: v,
  y: v
});
const oppositeSideMap = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
const oppositeAlignmentMap = {
  start: 'end',
  end: 'start'
};
function clamp(start, value, end) {
  return max(start, min(value, end));
}
function evaluate(value, param) {
  return typeof value === 'function' ? value(param) : value;
}
function getSide(placement) {
  return placement.split('-')[0];
}
function getAlignment(placement) {
  return placement.split('-')[1];
}
function getOppositeAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}
function getAxisLength(axis) {
  return axis === 'y' ? 'height' : 'width';
}
function getSideAxis(placement) {
  return ['top', 'bottom'].includes(getSide(placement)) ? 'y' : 'x';
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, alignment => oppositeAlignmentMap[alignment]);
}
function getSideList(side, isStart, rtl) {
  const lr = ['left', 'right'];
  const rl = ['right', 'left'];
  const tb = ['top', 'bottom'];
  const bt = ['bottom', 'top'];
  switch (side) {
    case 'top':
    case 'bottom':
      if (rtl) return isStart ? rl : lr;
      return isStart ? lr : rl;
    case 'left':
    case 'right':
      return isStart ? tb : bt;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list = getSideList(getSide(placement), direction === 'start', rtl);
  if (alignment) {
    list = list.map(side => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, side => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function getPaddingObject(padding) {
  return typeof padding !== 'number' ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  const {
    x,
    y,
    width,
    height
  } = rect;
  return {
    width,
    height,
    top: y,
    left: x,
    right: x + width,
    bottom: y + height,
    x,
    y
  };
}

function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide(placement);
  const isVertical = sideAxis === 'y';
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case 'top':
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case 'bottom':
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case 'right':
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case 'left':
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (getAlignment(placement)) {
    case 'start':
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case 'end':
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 *
 * This export does not have any `platform` interface logic. You will need to
 * write one for the platform you are using Floating UI with.
 */
const computePosition$1 = async (reference, floating, config) => {
  const {
    placement = 'bottom',
    strategy = 'absolute',
    middleware = [],
    platform
  } = config;
  const validMiddleware = middleware.filter(Boolean);
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
  let rects = await platform.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x,
    y
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i = 0; i < validMiddleware.length; i++) {
    const {
      name,
      fn
    } = validMiddleware[i];
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn({
      x,
      y,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform,
      elements: {
        reference,
        floating
      }
    });
    x = nextX != null ? nextX : x;
    y = nextY != null ? nextY : y;
    middlewareData = {
      ...middlewareData,
      [name]: {
        ...middlewareData[name],
        ...data
      }
    };
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === 'object') {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x,
          y
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i = -1;
    }
  }
  return {
    x,
    y,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};

/**
 * Resolves with an object of overflow side offsets that determine how much the
 * element is overflowing a given clipping boundary on each side.
 * - positive = overflowing the boundary by that number of pixels
 * - negative = how many pixels left before it will overflow
 * - 0 = lies flush with the boundary
 * @see https://floating-ui.com/docs/detectOverflow
 */
async function detectOverflow(state, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x,
    y,
    platform,
    rects,
    elements,
    strategy
  } = state;
  const {
    boundary = 'clippingAncestors',
    rootBoundary = 'viewport',
    elementContext = 'floating',
    altBoundary = false,
    padding = 0
  } = evaluate(options, state);
  const paddingObject = getPaddingObject(padding);
  const altContext = elementContext === 'floating' ? 'reference' : 'floating';
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(await platform.getClippingRect({
    element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || (await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating))),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === 'floating' ? {
    x,
    y,
    width: rects.floating.width,
    height: rects.floating.height
  } : rects.reference;
  const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
  const offsetScale = (await (platform.isElement == null ? void 0 : platform.isElement(offsetParent))) ? (await (platform.getScale == null ? void 0 : platform.getScale(offsetParent))) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements,
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow$1 = options => ({
  name: 'arrow',
  options,
  async fn(state) {
    const {
      x,
      y,
      placement,
      rects,
      platform,
      elements,
      middlewareData
    } = state;
    // Since `element` is required, we don't Partial<> the type.
    const {
      element,
      padding = 0
    } = evaluate(options, state) || {};
    if (element == null) {
      return {};
    }
    const paddingObject = getPaddingObject(padding);
    const coords = {
      x,
      y
    };
    const axis = getAlignmentAxis(placement);
    const length = getAxisLength(axis);
    const arrowDimensions = await platform.getDimensions(element);
    const isYAxis = axis === 'y';
    const minProp = isYAxis ? 'top' : 'left';
    const maxProp = isYAxis ? 'bottom' : 'right';
    const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
    const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
    let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;

    // DOM platform can return `window` as the `offsetParent`.
    if (!clientSize || !(await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent)))) {
      clientSize = elements.floating[clientProp] || rects.floating[length];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;

    // If the padding is large enough that it causes the arrow to no longer be
    // centered, modify the padding so that it is centered.
    const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
    const minPadding = min(paddingObject[minProp], largestPossiblePadding);
    const maxPadding = min(paddingObject[maxProp], largestPossiblePadding);

    // Make sure the arrow doesn't overflow the floating element if the center
    // point is outside the floating element's bounds.
    const min$1 = minPadding;
    const max = clientSize - arrowDimensions[length] - maxPadding;
    const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
    const offset = clamp(min$1, center, max);

    // If the reference is small enough that the arrow's padding causes it to
    // to point to nothing for an aligned placement, adjust the offset of the
    // floating element itself. To ensure `shift()` continues to take action,
    // a single reset is performed when this is true.
    const shouldAddOffset = !middlewareData.arrow && getAlignment(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
    const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
    return {
      [axis]: coords[axis] + alignmentOffset,
      data: {
        [axis]: offset,
        centerOffset: center - offset - alignmentOffset,
        ...(shouldAddOffset && {
          alignmentOffset
        })
      },
      reset: shouldAddOffset
    };
  }
});

function getPlacementList(alignment, autoAlignment, allowedPlacements) {
  const allowedPlacementsSortedByAlignment = alignment ? [...allowedPlacements.filter(placement => getAlignment(placement) === alignment), ...allowedPlacements.filter(placement => getAlignment(placement) !== alignment)] : allowedPlacements.filter(placement => getSide(placement) === placement);
  return allowedPlacementsSortedByAlignment.filter(placement => {
    if (alignment) {
      return getAlignment(placement) === alignment || (autoAlignment ? getOppositeAlignmentPlacement(placement) !== placement : false);
    }
    return true;
  });
}
/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */
const autoPlacement = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'autoPlacement',
    options,
    async fn(state) {
      var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
      const {
        rects,
        middlewareData,
        placement,
        platform,
        elements
      } = state;
      const {
        crossAxis = false,
        alignment,
        allowedPlacements = placements$1,
        autoAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);
      const placements$1$1 = alignment !== undefined || allowedPlacements === placements$1 ? getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
      const currentPlacement = placements$1$1[currentIndex];
      if (currentPlacement == null) {
        return {};
      }
      const alignmentSides = getAlignmentSides(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));

      // Make `computeCoords` start from the right place.
      if (placement !== currentPlacement) {
        return {
          reset: {
            placement: placements$1$1[0]
          }
        };
      }
      const currentOverflows = [overflow[getSide(currentPlacement)], overflow[alignmentSides[0]], overflow[alignmentSides[1]]];
      const allOverflows = [...(((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || []), {
        placement: currentPlacement,
        overflows: currentOverflows
      }];
      const nextPlacement = placements$1$1[currentIndex + 1];

      // There are more placements to check.
      if (nextPlacement) {
        return {
          data: {
            index: currentIndex + 1,
            overflows: allOverflows
          },
          reset: {
            placement: nextPlacement
          }
        };
      }
      const placementsSortedByMostSpace = allOverflows.map(d => {
        const alignment = getAlignment(d.placement);
        return [d.placement, alignment && crossAxis ?
        // Check along the mainAxis and main crossAxis side.
        d.overflows.slice(0, 2).reduce((acc, v) => acc + v, 0) :
        // Check only the mainAxis.
        d.overflows[0], d.overflows];
      }).sort((a, b) => a[1] - b[1]);
      const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter(d => d[2].slice(0,
      // Aligned placements should not check their opposite crossAxis
      // side.
      getAlignment(d[0]) ? 2 : 3).every(v => v <= 0));
      const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
      if (resetPlacement !== placement) {
        return {
          data: {
            index: currentIndex + 1,
            overflows: allOverflows
          },
          reset: {
            placement: resetPlacement
          }
        };
      }
      return {};
    }
  };
};

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const flip$1 = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'flip',
    options,
    async fn(state) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform,
        elements
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = 'bestFit',
        fallbackAxisSideDirection = 'none',
        flipAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state);

      // If a reset by the arrow was caused due to an alignment offset being
      // added, we should skip any logic now since `flip()` has already done its
      // work.
      // https://github.com/floating-ui/floating-ui/issues/2549#issuecomment-1719601643
      if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      const side = getSide(placement);
      const initialSideAxis = getSideAxis(initialPlacement);
      const isBasePlacement = getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
      if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides = getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides[0]], overflow[sides[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];

      // One or more sides is overflowing.
      if (!overflows.every(side => side <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements[nextIndex];
        if (nextPlacement) {
          // Try next placement and re-run the lifecycle.
          return {
            data: {
              index: nextIndex,
              overflows: overflowsData
            },
            reset: {
              placement: nextPlacement
            }
          };
        }

        // First, find the candidates that fit on the mainAxis side of overflow,
        // then find the placement that fits the best on the main crossAxis side.
        let resetPlacement = (_overflowsData$filter = overflowsData.filter(d => d.overflows[0] <= 0).sort((a, b) => a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;

        // Otherwise fallback.
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case 'bestFit':
              {
                var _overflowsData$filter2;
                const placement = (_overflowsData$filter2 = overflowsData.filter(d => {
                  if (hasFallbackAxisSideDirection) {
                    const currentSideAxis = getSideAxis(d.placement);
                    return currentSideAxis === initialSideAxis ||
                    // Create a bias to the `y` side axis due to horizontal
                    // reading directions favoring greater width.
                    currentSideAxis === 'y';
                  }
                  return true;
                }).map(d => [d.placement, d.overflows.filter(overflow => overflow > 0).reduce((acc, overflow) => acc + overflow, 0)]).sort((a, b) => a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                if (placement) {
                  resetPlacement = placement;
                }
                break;
              }
            case 'initialPlacement':
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};

function getSideOffsets(overflow, rect) {
  return {
    top: overflow.top - rect.height,
    right: overflow.right - rect.width,
    bottom: overflow.bottom - rect.height,
    left: overflow.left - rect.width
  };
}
function isAnySideFullyClipped(overflow) {
  return sides$1.some(side => overflow[side] >= 0);
}
/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */
const hide = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'hide',
    options,
    async fn(state) {
      const {
        rects
      } = state;
      const {
        strategy = 'referenceHidden',
        ...detectOverflowOptions
      } = evaluate(options, state);
      switch (strategy) {
        case 'referenceHidden':
          {
            const overflow = await detectOverflow(state, {
              ...detectOverflowOptions,
              elementContext: 'reference'
            });
            const offsets = getSideOffsets(overflow, rects.reference);
            return {
              data: {
                referenceHiddenOffsets: offsets,
                referenceHidden: isAnySideFullyClipped(offsets)
              }
            };
          }
        case 'escaped':
          {
            const overflow = await detectOverflow(state, {
              ...detectOverflowOptions,
              altBoundary: true
            });
            const offsets = getSideOffsets(overflow, rects.floating);
            return {
              data: {
                escapedOffsets: offsets,
                escaped: isAnySideFullyClipped(offsets)
              }
            };
          }
        default:
          {
            return {};
          }
      }
    }
  };
};

function getBoundingRect(rects) {
  const minX = min(...rects.map(rect => rect.left));
  const minY = min(...rects.map(rect => rect.top));
  const maxX = max(...rects.map(rect => rect.right));
  const maxY = max(...rects.map(rect => rect.bottom));
  return {
    x: minX,
    y: minY,
    width: maxX - minX,
    height: maxY - minY
  };
}
function getRectsByLine(rects) {
  const sortedRects = rects.slice().sort((a, b) => a.y - b.y);
  const groups = [];
  let prevRect = null;
  for (let i = 0; i < sortedRects.length; i++) {
    const rect = sortedRects[i];
    if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) {
      groups.push([rect]);
    } else {
      groups[groups.length - 1].push(rect);
    }
    prevRect = rect;
  }
  return groups.map(rect => rectToClientRect(getBoundingRect(rect)));
}
/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */
const inline = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'inline',
    options,
    async fn(state) {
      const {
        placement,
        elements,
        rects,
        platform,
        strategy
      } = state;
      // A MouseEvent's client{X,Y} coords can be up to 2 pixels off a
      // ClientRect's bounds, despite the event listener being triggered. A
      // padding of 2 seems to handle this issue.
      const {
        padding = 2,
        x,
        y
      } = evaluate(options, state);
      const nativeClientRects = Array.from((await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference))) || []);
      const clientRects = getRectsByLine(nativeClientRects);
      const fallback = rectToClientRect(getBoundingRect(nativeClientRects));
      const paddingObject = getPaddingObject(padding);
      function getBoundingClientRect() {
        // There are two rects and they are disjoined.
        if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) {
          // Find the first rect in which the point is fully inside.
          return clientRects.find(rect => x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
        }

        // There are 2 or more connected rects.
        if (clientRects.length >= 2) {
          if (getSideAxis(placement) === 'y') {
            const firstRect = clientRects[0];
            const lastRect = clientRects[clientRects.length - 1];
            const isTop = getSide(placement) === 'top';
            const top = firstRect.top;
            const bottom = lastRect.bottom;
            const left = isTop ? firstRect.left : lastRect.left;
            const right = isTop ? firstRect.right : lastRect.right;
            const width = right - left;
            const height = bottom - top;
            return {
              top,
              bottom,
              left,
              right,
              width,
              height,
              x: left,
              y: top
            };
          }
          const isLeftSide = getSide(placement) === 'left';
          const maxRight = max(...clientRects.map(rect => rect.right));
          const minLeft = min(...clientRects.map(rect => rect.left));
          const measureRects = clientRects.filter(rect => isLeftSide ? rect.left === minLeft : rect.right === maxRight);
          const top = measureRects[0].top;
          const bottom = measureRects[measureRects.length - 1].bottom;
          const left = minLeft;
          const right = maxRight;
          const width = right - left;
          const height = bottom - top;
          return {
            top,
            bottom,
            left,
            right,
            width,
            height,
            x: left,
            y: top
          };
        }
        return fallback;
      }
      const resetRects = await platform.getElementRects({
        reference: {
          getBoundingClientRect
        },
        floating: elements.floating,
        strategy
      });
      if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) {
        return {
          reset: {
            rects: resetRects
          }
        };
      }
      return {};
    }
  };
};

// For type backwards-compatibility, the `OffsetOptions` type was also
// Derivable.

async function convertValueToCoords(state, options) {
  const {
    placement,
    platform,
    elements
  } = state;
  const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
  const side = getSide(placement);
  const alignment = getAlignment(placement);
  const isVertical = getSideAxis(placement) === 'y';
  const mainAxisMulti = ['left', 'top'].includes(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = evaluate(options, state);

  // eslint-disable-next-line prefer-const
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === 'number' ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: rawValue.mainAxis || 0,
    crossAxis: rawValue.crossAxis || 0,
    alignmentAxis: rawValue.alignmentAxis
  };
  if (alignment && typeof alignmentAxis === 'number') {
    crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}

/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */
const offset$1 = function (options) {
  if (options === void 0) {
    options = 0;
  }
  return {
    name: 'offset',
    options,
    async fn(state) {
      var _middlewareData$offse, _middlewareData$arrow;
      const {
        x,
        y,
        placement,
        middlewareData
      } = state;
      const diffCoords = await convertValueToCoords(state, options);

      // If the placement is the same and the arrow caused an alignment offset
      // then we don't need to change the positioning coordinates.
      if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      return {
        x: x + diffCoords.x,
        y: y + diffCoords.y,
        data: {
          ...diffCoords,
          placement
        }
      };
    }
  };
};

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const shift$1 = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'shift',
    options,
    async fn(state) {
      const {
        x,
        y,
        placement
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: _ref => {
            let {
              x,
              y
            } = _ref;
            return {
              x,
              y
            };
          }
        },
        ...detectOverflowOptions
      } = evaluate(options, state);
      const coords = {
        x,
        y
      };
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const crossAxis = getSideAxis(getSide(placement));
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === 'y' ? 'top' : 'left';
        const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
        const min = mainAxisCoord + overflow[minSide];
        const max = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = clamp(min, mainAxisCoord, max);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === 'y' ? 'top' : 'left';
        const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
        const min = crossAxisCoord + overflow[minSide];
        const max = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = clamp(min, crossAxisCoord, max);
      }
      const limitedCoords = limiter.fn({
        ...state,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x,
          y: limitedCoords.y - y,
          enabled: {
            [mainAxis]: checkMainAxis,
            [crossAxis]: checkCrossAxis
          }
        }
      };
    }
  };
};
/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */
const limitShift$1 = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    options,
    fn(state) {
      const {
        x,
        y,
        placement,
        rects,
        middlewareData
      } = state;
      const {
        offset = 0,
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true
      } = evaluate(options, state);
      const coords = {
        x,
        y
      };
      const crossAxis = getSideAxis(placement);
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      const rawOffset = evaluate(offset, state);
      const computedOffset = typeof rawOffset === 'number' ? {
        mainAxis: rawOffset,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...rawOffset
      };
      if (checkMainAxis) {
        const len = mainAxis === 'y' ? 'height' : 'width';
        const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
        const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
        if (mainAxisCoord < limitMin) {
          mainAxisCoord = limitMin;
        } else if (mainAxisCoord > limitMax) {
          mainAxisCoord = limitMax;
        }
      }
      if (checkCrossAxis) {
        var _middlewareData$offse, _middlewareData$offse2;
        const len = mainAxis === 'y' ? 'width' : 'height';
        const isOriginSide = ['top', 'left'].includes(getSide(placement));
        const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
        const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
        if (crossAxisCoord < limitMin) {
          crossAxisCoord = limitMin;
        } else if (crossAxisCoord > limitMax) {
          crossAxisCoord = limitMax;
        }
      }
      return {
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      };
    }
  };
};

/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */
const size = function (options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: 'size',
    options,
    async fn(state) {
      var _state$middlewareData, _state$middlewareData2;
      const {
        placement,
        rects,
        platform,
        elements
      } = state;
      const {
        apply = () => {},
        ...detectOverflowOptions
      } = evaluate(options, state);
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const side = getSide(placement);
      const alignment = getAlignment(placement);
      const isYAxis = getSideAxis(placement) === 'y';
      const {
        width,
        height
      } = rects.floating;
      let heightSide;
      let widthSide;
      if (side === 'top' || side === 'bottom') {
        heightSide = side;
        widthSide = alignment === ((await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating))) ? 'start' : 'end') ? 'left' : 'right';
      } else {
        widthSide = side;
        heightSide = alignment === 'end' ? 'top' : 'bottom';
      }
      const maximumClippingHeight = height - overflow.top - overflow.bottom;
      const maximumClippingWidth = width - overflow.left - overflow.right;
      const overflowAvailableHeight = min(height - overflow[heightSide], maximumClippingHeight);
      const overflowAvailableWidth = min(width - overflow[widthSide], maximumClippingWidth);
      const noShift = !state.middlewareData.shift;
      let availableHeight = overflowAvailableHeight;
      let availableWidth = overflowAvailableWidth;
      if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) {
        availableWidth = maximumClippingWidth;
      }
      if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) {
        availableHeight = maximumClippingHeight;
      }
      if (noShift && !alignment) {
        const xMin = max(overflow.left, 0);
        const xMax = max(overflow.right, 0);
        const yMin = max(overflow.top, 0);
        const yMax = max(overflow.bottom, 0);
        if (isYAxis) {
          availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : max(overflow.left, overflow.right));
        } else {
          availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : max(overflow.top, overflow.bottom));
        }
      }
      await apply({
        ...state,
        availableWidth,
        availableHeight
      });
      const nextDimensions = await platform.getDimensions(elements.floating);
      if (width !== nextDimensions.width || height !== nextDimensions.height) {
        return {
          reset: {
            rects: true
          }
        };
      }
      return {};
    }
  };
};

function hasWindow() {
  return typeof window !== 'undefined';
}
function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || '').toLowerCase();
  }
  // Mocked nodes in testing environments may not be instances of Node. By
  // returning `#document` an infinite loop won't occur.
  // https://github.com/floating-ui/floating-ui/issues/2317
  return '#document';
}
function getWindow(node) {
  var _node$ownerDocument;
  return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  if (!hasWindow() || typeof ShadowRoot === 'undefined') {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !['inline', 'contents'].includes(display);
}
function isTableElement(element) {
  return ['table', 'td', 'th'].includes(getNodeName(element));
}
function isTopLayer(element) {
  return [':popover-open', ':modal'].some(selector => {
    try {
      return element.matches(selector);
    } catch (e) {
      return false;
    }
  });
}
function isContainingBlock(elementOrCss) {
  const webkit = isWebKit();
  const css = isElement(elementOrCss) ? getComputedStyle(elementOrCss) : elementOrCss;

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  // https://drafts.csswg.org/css-transforms-2/#individual-transforms
  return ['transform', 'translate', 'scale', 'rotate', 'perspective'].some(value => css[value] ? css[value] !== 'none' : false) || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || ['transform', 'translate', 'scale', 'rotate', 'perspective', 'filter'].some(value => (css.willChange || '').includes(value)) || ['paint', 'layout', 'strict', 'content'].some(value => (css.contain || '').includes(value));
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else if (isTopLayer(currentNode)) {
      return null;
    }
    currentNode = getParentNode(currentNode);
  }
  return null;
}
function isWebKit() {
  if (typeof CSS === 'undefined' || !CSS.supports) return false;
  return CSS.supports('-webkit-backdrop-filter', 'none');
}
function isLastTraversableNode(node) {
  return ['html', 'body', '#document'].includes(getNodeName(node));
}
function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}
function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.scrollX,
    scrollTop: element.scrollY
  };
}
function getParentNode(node) {
  if (getNodeName(node) === 'html') {
    return node;
  }
  const result =
  // Step into the shadow DOM of the parent of a slotted node.
  node.assignedSlot ||
  // DOM Element detected.
  node.parentNode ||
  // ShadowRoot detected.
  isShadowRoot(node) && node.host ||
  // Fallback.
  getDocumentElement(node);
  return isShadowRoot(result) ? result.host : result;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list, traverseIframes) {
  var _node$ownerDocument2;
  if (list === void 0) {
    list = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    const frameElement = getFrameElement(win);
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getFrameElement(win) {
  return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}

function getCssDimensions(element) {
  const css = getComputedStyle(element);
  // In testing environments, the `width` and `height` properties are empty
  // strings for SVG elements, returning NaN. Fallback to `0` in this case.
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement(element);
  const offsetWidth = hasOffset ? element.offsetWidth : width;
  const offsetHeight = hasOffset ? element.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}

function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}

function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $
  } = getCssDimensions(domElement);
  let x = ($ ? round(rect.width) : rect.width) / width;
  let y = ($ ? round(rect.height) : rect.height) / height;

  // 0, NaN, or Infinity should always fallback to 1.

  if (!x || !Number.isFinite(x)) {
    x = 1;
  }
  if (!y || !Number.isFinite(y)) {
    y = 1;
  }
  return {
    x,
    y
  };
}

const noOffsets = /*#__PURE__*/createCoords(0);
function getVisualOffsets(element) {
  const win = getWindow(element);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow(element)) {
    return false;
  }
  return isFixed;
}

function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x = (clientRect.left + visualOffsets.x) / scale.x;
  let y = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow(domElement);
    const offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
    let currentWin = win;
    let currentIFrame = getFrameElement(currentWin);
    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = getComputedStyle(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x *= iframeScale.x;
      y *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x += left;
      y += top;
      currentWin = getWindow(currentIFrame);
      currentIFrame = getFrameElement(currentWin);
    }
  }
  return rectToClientRect({
    width,
    height,
    x,
    y
  });
}

// If <html> has a CSS width greater than the viewport, then this will be
// incorrect for RTL.
function getWindowScrollBarX(element, rect) {
  const leftScroll = getNodeScroll(element).scrollLeft;
  if (!rect) {
    return getBoundingClientRect(getDocumentElement(element)).left + leftScroll;
  }
  return rect.left + leftScroll;
}

function getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
  if (ignoreScrollbarX === void 0) {
    ignoreScrollbarX = false;
  }
  const htmlRect = documentElement.getBoundingClientRect();
  const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 :
  // RTL <body> scrollbar.
  getWindowScrollBarX(documentElement, htmlRect));
  const y = htmlRect.top + scroll.scrollTop;
  return {
    x,
    y
  };
}

function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    elements,
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isFixed = strategy === 'fixed';
  const documentElement = getDocumentElement(offsetParent);
  const topLayer = elements ? isTopLayer(elements.floating) : false;
  if (offsetParent === documentElement || topLayer && isFixed) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll, true) : createCoords(0);
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
  };
}

function getClientRects(element) {
  return Array.from(element.getClientRects());
}

// Gets the entire size of the scrollable document area, even extending outside
// of the `<html>` and `<body>` rect bounds if horizontally scrollable.
function getDocumentRect(element) {
  const html = getDocumentElement(element);
  const scroll = getNodeScroll(element);
  const body = element.ownerDocument.body;
  const width = max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y = -scroll.scrollTop;
  if (getComputedStyle(body).direction === 'rtl') {
    x += max(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x,
    y
  };
}

function getViewportRect(element, strategy) {
  const win = getWindow(element);
  const html = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x = 0;
  let y = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x,
    y
  };
}

// Returns the inner client rect, subtracting scrollbars if present.
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === 'fixed');
  const top = clientRect.top + element.clientTop;
  const left = clientRect.left + element.clientLeft;
  const scale = isHTMLElement(element) ? getScale(element) : createCoords(1);
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x = left * scale.x;
  const y = top * scale.y;
  return {
    width,
    height,
    x,
    y
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === 'viewport') {
    rect = getViewportRect(element, strategy);
  } else if (clippingAncestor === 'document') {
    rect = getDocumentRect(getDocumentElement(element));
  } else if (isElement(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element);
    rect = {
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y,
      width: clippingAncestor.width,
      height: clippingAncestor.height
    };
  }
  return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element, stopNode) {
  const parentNode = getParentNode(element);
  if (parentNode === stopNode || !isElement(parentNode) || isLastTraversableNode(parentNode)) {
    return false;
  }
  return getComputedStyle(parentNode).position === 'fixed' || hasFixedPositionAncestor(parentNode, stopNode);
}

// A "clipping ancestor" is an `overflow` element with the characteristic of
// clipping (or hiding) child elements. This returns all clipping ancestors
// of the given element up the tree.
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result = getOverflowAncestors(element, [], false).filter(el => isElement(el) && getNodeName(el) !== 'body');
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle(element).position === 'fixed';
  let currentNode = elementIsFixed ? getParentNode(element) : element;

  // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
  while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === 'fixed') {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && ['absolute', 'fixed'].includes(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element, currentNode);
    if (shouldDropCurrentNode) {
      // Drop non-containing blocks.
      result = result.filter(ancestor => ancestor !== currentNode);
    } else {
      // Record last containing block for next iteration.
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache.set(element, result);
  return result;
}

// Gets the maximum area that the element is visible in due to any number of
// clipping ancestors.
function getClippingRect(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === 'clippingAncestors' ? isTopLayer(element) ? [] : getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}

function getDimensions(element) {
  const {
    width,
    height
  } = getCssDimensions(element);
  return {
    width,
    height
  };
}

function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const isFixed = strategy === 'fixed';
  const rect = getBoundingClientRect(element, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      // If the <body> scrollbar appears on the left (e.g. RTL systems). Use
      // Firefox with layout.scrollbar.side = 3 in about:config to test this.
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : createCoords(0);
  const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
  const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
  return {
    x,
    y,
    width: rect.width,
    height: rect.height
  };
}

function isStaticPositioned(element) {
  return getComputedStyle(element).position === 'static';
}

function getTrueOffsetParent(element, polyfill) {
  if (!isHTMLElement(element) || getComputedStyle(element).position === 'fixed') {
    return null;
  }
  if (polyfill) {
    return polyfill(element);
  }
  let rawOffsetParent = element.offsetParent;

  // Firefox returns the <html> element as the offsetParent if it's non-static,
  // while Chrome and Safari return the <body> element. The <body> element must
  // be used to perform the correct calculations even if the <html> element is
  // non-static.
  if (getDocumentElement(element) === rawOffsetParent) {
    rawOffsetParent = rawOffsetParent.ownerDocument.body;
  }
  return rawOffsetParent;
}

// Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.
function getOffsetParent(element, polyfill) {
  const win = getWindow(element);
  if (isTopLayer(element)) {
    return win;
  }
  if (!isHTMLElement(element)) {
    let svgOffsetParent = getParentNode(element);
    while (svgOffsetParent && !isLastTraversableNode(svgOffsetParent)) {
      if (isElement(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) {
        return svgOffsetParent;
      }
      svgOffsetParent = getParentNode(svgOffsetParent);
    }
    return win;
  }
  let offsetParent = getTrueOffsetParent(element, polyfill);
  while (offsetParent && isTableElement(offsetParent) && isStaticPositioned(offsetParent)) {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && isLastTraversableNode(offsetParent) && isStaticPositioned(offsetParent) && !isContainingBlock(offsetParent)) {
    return win;
  }
  return offsetParent || getContainingBlock(element) || win;
}

const getElementRects = async function (data) {
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  const floatingDimensions = await getDimensionsFn(data.floating);
  return {
    reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
    floating: {
      x: 0,
      y: 0,
      width: floatingDimensions.width,
      height: floatingDimensions.height
    }
  };
};

function isRTL(element) {
  return getComputedStyle(element).direction === 'rtl';
}

const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement,
  isRTL
};

function rectsAreEqual(a, b) {
  return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
}

// https://samthor.au/2021/observing-dom/
function observeMove(element, onMove) {
  let io = null;
  let timeoutId;
  const root = getDocumentElement(element);
  function cleanup() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io) == null || _io.disconnect();
    io = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const elementRectForRootMargin = element.getBoundingClientRect();
    const {
      left,
      top,
      width,
      height
    } = elementRectForRootMargin;
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor(top);
    const insetRight = floor(root.clientWidth - (left + width));
    const insetBottom = floor(root.clientHeight - (top + height));
    const insetLeft = floor(left);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options = {
      rootMargin,
      threshold: max(0, min(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          // If the reference is clipped, the ratio is 0. Throttle the refresh
          // to prevent an infinite loop of updates.
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 1000);
        } else {
          refresh(false, ratio);
        }
      }
      if (ratio === 1 && !rectsAreEqual(elementRectForRootMargin, element.getBoundingClientRect())) {
        // It's possible that even though the ratio is reported as 1, the
        // element is not actually fully within the IntersectionObserver's root
        // area anymore. This can happen under performance constraints. This may
        // be a bug in the browser's IntersectionObserver implementation. To
        // work around this, we compare the element's bounding rect now with
        // what it was at the time we created the IntersectionObserver. If they
        // are not equal then the element moved, so we refresh.
        refresh();
      }
      isFirstUpdate = false;
    }

    // Older browsers don't support a `document` as the root and will throw an
    // error.
    try {
      io = new IntersectionObserver(handleObserve, {
        ...options,
        // Handle <iframe>s
        root: root.ownerDocument
      });
    } catch (e) {
      io = new IntersectionObserver(handleObserve, options);
    }
    io.observe(element);
  }
  refresh(true);
  return cleanup;
}

/**
 * Automatically updates the position of the floating element when necessary.
 * Should only be called when the floating element is mounted on the DOM or
 * visible on the screen.
 * @returns cleanup function that should be invoked when the floating element is
 * removed from the DOM or hidden from the screen.
 * @see https://floating-ui.com/docs/autoUpdate
 */
function autoUpdate(reference, floating, update, options) {
  if (options === void 0) {
    options = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === 'function',
    layoutShift = typeof IntersectionObserver === 'function',
    animationFrame = false
  } = options;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...(referenceEl ? getOverflowAncestors(referenceEl) : []), ...getOverflowAncestors(floating)] : [];
  ancestors.forEach(ancestor => {
    ancestorScroll && ancestor.addEventListener('scroll', update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener('resize', update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver(_ref => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        // Prevent update loops when using the `size` middleware.
        // https://github.com/floating-ui/floating-ui/issues/1740
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    resizeObserver.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && !rectsAreEqual(prevRefRect, nextRefRect)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _resizeObserver2;
    ancestors.forEach(ancestor => {
      ancestorScroll && ancestor.removeEventListener('scroll', update);
      ancestorResize && ancestor.removeEventListener('resize', update);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}

/**
 * Modifies the placement by translating the floating element along the
 * specified axes.
 * A number (shorthand for `mainAxis` or distance), or an axes configuration
 * object may be passed.
 * @see https://floating-ui.com/docs/offset
 */
const offset = offset$1;

/**
 * Optimizes the visibility of the floating element by choosing the placement
 * that has the most space available automatically, without needing to specify a
 * preferred placement. Alternative to `flip`.
 * @see https://floating-ui.com/docs/autoPlacement
 */
autoPlacement;

/**
 * Optimizes the visibility of the floating element by shifting it in order to
 * keep it in view when it will overflow the clipping boundary.
 * @see https://floating-ui.com/docs/shift
 */
const shift = shift$1;

/**
 * Optimizes the visibility of the floating element by flipping the `placement`
 * in order to keep it in view when the preferred placement(s) will overflow the
 * clipping boundary. Alternative to `autoPlacement`.
 * @see https://floating-ui.com/docs/flip
 */
const flip = flip$1;

/**
 * Provides data that allows you to change the size of the floating element —
 * for instance, prevent it from overflowing the clipping boundary or match the
 * width of the reference element.
 * @see https://floating-ui.com/docs/size
 */
size;

/**
 * Provides data to hide the floating element in applicable situations, such as
 * when it is not in the same clipping context as the reference element.
 * @see https://floating-ui.com/docs/hide
 */
hide;

/**
 * Provides data to position an inner element of the floating element so that it
 * appears centered to the reference element.
 * @see https://floating-ui.com/docs/arrow
 */
const arrow = arrow$1;

/**
 * Provides improved positioning for inline reference elements that can span
 * over multiple lines, such as hyperlinks or range selections.
 * @see https://floating-ui.com/docs/inline
 */
inline;

/**
 * Built-in `limiter` that will stop `shift()` at a certain point.
 */
const limitShift = limitShift$1;

/**
 * Computes the `x` and `y` coordinates that will place the floating element
 * next to a given reference element.
 */
const computePosition = (reference, floating, options) => {
  // This caches the expensive `getClippingElementAncestors` function so that
  // multiple lifecycle resets re-use the same result. It only lives for a
  // single call. If other functions become expensive, we can add them as well.
  const cache = new Map();
  const mergedOptions = {
    platform,
    ...options
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition$1(reference, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};

/**
 * List of all possibles sides
 */
const sides = ['top', 'right', 'bottom', 'left'];
/**
 * List of all possibles placements
 */
const placements = [
    ...sides,
    'auto',
    'auto-start',
    'auto-end',
    'top-start',
    'top-end',
    'bottom-start',
    'bottom-end',
    'right-start',
    'right-end',
    'left-start',
    'left-end',
];
/**
 * FloatingUI Placement type guard
 * @param placement - value to check
 * @returns truthy if placement is valid
 */
const isFloatingUIPlacement = (placement) => placements.filter(p => !p.includes('auto')).includes(placement);

const mgPopoverCss = "/*!\n * @prop --mg-c-popover-color-background: Defines the background color of the popover. Default value: `--mg-b-color-light`.\n * @prop --mg-c-popover-color-text: Defines the font color of the popover. Default value: `--mg-b-color-font-dark`.\n * @prop --mg-c-popover-title-font-size: Defines the font size of the popover title. Default value: `--mg-b-font-size-h5`.\n * @prop --mg-c-popover-padding-vertical: Defines the vertical padding of the popover. Default value: `unset`, fallback to `--mg-b-size-16`.\n * @prop --mg-c-popover-padding-horizontal: Defines the horizontal padding of the popover. Default value: `unset`, fallback to `--mg-b-size-16`.\n * @prop --mg-c-popover-max-width: Defines the max-width of the popover. Default value: `--mg-b-size-floating-element-max-width`.\n * @prop --mg-c-popover-min-width: Defines the min-width of the popover. Default value: `unset`.\n */:host{--mg-c-card-spacing:var(--mg-c-popover-padding-vertical, var(--mg-b-size-16)) var(--mg-c-popover-padding-horizontal, var(--mg-b-size-16));--mg-c-card-border:none;--mg-c-card-border-radius:var(--mg-b-size-radius);--mg-c-card-color-background:var(--mg-c-popover-color-background);position:relative;display:contents}:host::slotted(*){display:inline-block}";
const MgPopoverStyle0 = mgPopoverCss;

const MgPopover = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.displayChange = createEvent(this, "display-change", 7);
        this.componentClose = createEvent(this, "component-close", 7);
        /**
         * Sets an `id` attribute.
         * Needed by the input for accessibility `aria-decribedby`.
         */
        this.identifier = Ge('mg-popover');
        /**
         * Popover placement
         */
        this.placement = 'bottom';
        /**
         * Hide popover arrow
         */
        this.arrowHide = false;
        /**
         * Define if popover has a cross button
         */
        this.closeButton = false;
        /**
         * Display popover
         */
        this.display = false;
        /**
         * Disable popover
         */
        this.disabled = false;
        /**
         * Check if clicked outside of component
         * @param event - mouse event
         */
        this.clickOutside = (event) => {
            if (!this.disabled && event.target.closest('mg-popover') !== this.element && event.target.closest(`[data-mg-popover-guard="${this.identifier}"]`) === null) {
                this.display = false;
            }
        };
        /**
         * Show popover
         */
        this.show = () => {
            // Make the popover visible
            this.mgPopover.dataset.show = '';
            // hide when click outside
            // setTimeout is used to prevent event to trigger after creation
            setTimeout(() => {
                this.manageClickOutsideListeners('addEventListener');
            });
        };
        /**
         * Hide popover
         */
        this.hide = () => {
            // Hide the popover
            this.mgPopover.removeAttribute('data-show');
            // Remove event listener
            this.manageClickOutsideListeners('removeEventListener');
        };
        /**
         * Manage all clickOustside listeners
         * @param action - top process on elements listeners
         */
        this.manageClickOutsideListeners = (action) => {
            var _a, _b;
            // clickOutside listeners need to bind windows
            // AND as shawdowDom content is not include on windows listeners `event.target` we need to include popover guard content DOM if it's a web-component
            // by doing this we can get and parse all needeed document DOM elements in clickOutside callback event.details.
            // This result in the givern junction :
            // Windows > document > [data-mg-popover-guard] + [data-mg-popover-guard] > shadowRoot =  Windows > document > [data-mg-popover-guard] > shadowRoot
            const guardChildren = Array.from(((_b = (_a = document.querySelector(`[data-mg-popover-guard="${this.identifier}"]`)) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.children) || new Set());
            [...guardChildren, ...this.windows].forEach((element) => {
                if (element !== null) {
                    element[action]('click', this.clickOutside, false);
                }
            });
        };
        /**
         * Handle content hide event
         */
        this.handleHideContent = () => {
            this.display = false;
            this.componentClose.emit();
        };
        /**
         * Render popover content element
         */
        this.renderPopoverContent = () => {
            const mgPopoverContent = this.element.querySelector('mg-popover-content');
            if (mgPopoverContent === null) {
                this.mgPopoverContent = document.createElement('mg-popover-content');
                this.mgPopoverContent.setAttribute('slot', 'content');
                this.mgPopoverContent.setAttribute('id', this.identifier);
                this.mgPopoverContent.addEventListener('hide-content', this.handleHideContent);
                const arrow = document.createElement('div');
                arrow.setAttribute('slot', 'arrow');
                arrow.dataset.floatingArrow = '';
                this.mgPopoverContent.appendChild(arrow);
                // insert elements in DOM
                ['[slot="title"]', '[slot="content"]:not(mg-popover-content)'].forEach(slotType => {
                    Array.from(this.element.querySelectorAll(slotType)).forEach(slot => {
                        this.mgPopoverContent.appendChild(slot);
                    });
                });
                this.element.appendChild(this.mgPopoverContent);
            }
            else {
                mgPopoverContent.setAttribute('id', this.identifier);
            }
        };
        /**
         * Set up Floating UI positioning and arrow behavior
         * @param interactiveElement - Element that triggers the popover
         */
        this.setFloatingUI = (interactiveElement) => {
            const fallbackPlacements = (this.element.dataset.fallbackPlacement || '').split(',').map(t => t.trim());
            this.floatingUICleanup = autoUpdate(interactiveElement, this.mgPopover, () => {
                computePosition(interactiveElement, this.mgPopover, {
                    placement: this.placement,
                    strategy: 'fixed',
                    middleware: [
                        offset(0),
                        flip({
                            fallbackPlacements: Array.from(new Set([...fallbackPlacements, ...sides]).values()).filter(isFloatingUIPlacement), // simulate "auto" placement with default fallback values
                        }),
                        shift({
                            limiter: limitShift(),
                        }),
                        arrow({
                            element: this.mgPopover.querySelector('[data-floating-arrow]'),
                        }),
                    ],
                }).then(({ x, y, placement, middlewareData }) => {
                    Object.assign(this.mgPopover.style, {
                        position: 'fixed',
                        top: '0',
                        left: '0',
                        transform: `translate(${Math.round(x)}px, ${Math.round(y)}px)`,
                    });
                    // Update arrow style
                    const staticSide = {
                        top: 'bottom',
                        right: 'left',
                        bottom: 'top',
                        left: 'right',
                    }[placement.split('-')[0]];
                    const arrowElement = this.mgPopover.querySelector('[data-floating-arrow]');
                    const { x: arrowX, y: arrowY } = middlewareData.arrow;
                    // https://floating-ui.com/docs/arrow
                    // Unlike the floating element, which has both coordinates defined at all times, the arrow only has one defined.
                    // Due to this, either x or y will be undefined, depending on the side of placement.
                    // The above code uses `isNaN` to check for null and undefined simultaneously.
                    // Don’t remove `isNaN`, because either value can be falsy (0), causing a bug!
                    const numberToPx = (number) => (!isNaN(number) ? `${number}px` : '');
                    if (arrowElement !== null)
                        Object.assign(arrowElement.style, {
                            position: 'absolute',
                            left: numberToPx(arrowX),
                            top: numberToPx(arrowY),
                            [staticSide]: '1px',
                        });
                    this.mgPopover.setAttribute('data-placement', placement);
                });
            });
        };
    }
    validateIdentifier(newValue) {
        if (!Xe(newValue)) {
            throw new Error(`<mg-popover> prop "identifier" value is invalid. Passed value: ${Ve(newValue)}.`);
        }
        // use renderPopoverContent to update popover-content id
        this.renderPopoverContent();
    }
    watchPlacement(newValue) {
        if (!isFloatingUIPlacement(newValue))
            this.placement = 'bottom';
    }
    validateArrowHide(newValue) {
        if (newValue)
            this.mgPopoverContent.dataset.arrowHide = '';
        else
            delete this.mgPopoverContent.dataset.arrowHide;
    }
    validateCloseButton(newValue) {
        this.mgPopoverContent.closeButton = newValue;
    }
    handleDisplay(newValue) {
        if (newValue) {
            this.show();
        }
        else {
            this.hide();
        }
        this.displayChange.emit(newValue);
    }
    /*************
     * Lifecycle *
     *************/
    /**
     * update popper position after props change on component did update hook to benefit from render ended
     */
    componentDidUpdate() {
        this.floatingUICleanup();
    }
    /**
     * Check if component props are well configured on init
     */
    componentWillLoad() {
        // Get windows to attach events
        this.windows = Ye(window);
        // render mg-popover-content slot
        this.renderPopoverContent();
        this.validateCloseButton(this.closeButton);
        this.validateIdentifier(this.identifier);
        this.validateArrowHide(this.arrowHide);
        this.watchPlacement(this.placement);
    }
    /**
     * Check if component props are well configured on init
     */
    componentDidLoad() {
        // Get popover content
        this.mgPopover = this.element.querySelector(`#${this.identifier}`);
        // Get interactive element (first element without slot attribute)
        const interactiveElement = this.element.querySelector(':not([slot])');
        // Add aria attributes
        interactiveElement.setAttribute('aria-controls', this.identifier);
        interactiveElement.setAttribute('aria-expanded', `${this.display}`);
        // Initial styles configuration
        Object.assign(this.mgPopover.style, {
            position: 'fixed',
        });
        // Create Floating UI instance
        this.setFloatingUI(interactiveElement);
        // Add resize observer
        [interactiveElement, this.mgPopoverContent].forEach(element => {
            new ResizeObserver(() => {
                this.floatingUICleanup();
                this.setFloatingUI(interactiveElement);
            }).observe(element);
        });
        // Add events to toggle display
        interactiveElement.addEventListener('click', () => {
            if (!this.disabled)
                this.display = !this.display;
        });
        this.element.addEventListener('click', (event) => {
            const target = event.target.closest('[popovertargetaction]');
            if (this.display === true && target !== null && target.getAttribute('popovertargetaction') === 'hide') {
                this.display = false;
            }
        });
        // Add events to hide popover
        this.element.addEventListener('keydown', e => {
            if (!this.disabled && e.code === 'Escape') {
                this.display = false;
                this.componentClose.emit();
                interactiveElement.focus();
            }
        });
        this.handleDisplay(this.display);
    }
    /**
     * Cleanup when component is disconnected
     */
    disconnectedCallback() {
        // Cleanup Floating UI instance
        this.floatingUICleanup();
    }
    /**
     * Render
     * @returns HTML Element
     */
    render() {
        return (h(Host, { key: '726e360b49d1148572db27898037c1d2cfd1755f' }, h("slot", { key: '4700d3d58fde644274827866ee8f230c077399b7' }), h("slot", { key: '35d20ddd547b3383dd1de655fac2c35e83fb48af', name: "content" })));
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "identifier": ["validateIdentifier"],
        "placement": ["watchPlacement"],
        "arrowHide": ["validateArrowHide"],
        "closeButton": ["validateCloseButton"],
        "display": ["handleDisplay"]
    }; }
};
MgPopover.style = MgPopoverStyle0;

const mgPopoverContentCss = ":host{position:relative;z-index:2000;display:none;padding:var(--mg-b-size-8);color:var(--mg-c-popover-color-text)}:host([data-show]){display:block}:host([data-placement^=left-start]),:host([data-placement^=left-end]),:host([data-placement^=right-start]),:host([data-placement^=right-end]){padding:0 var(--mg-b-size-8)}.mg-c-popover-content{--mg-c-card-max-width:var(--mg-c-popover-max-width);--mg-c-card-min-width:var(--mg-c-popover-min-width)}.mg-c-popover-content mg-button{margin-top:calc(-1*(var(--mg-b-size-min-height) - var(--mg-c-popover-title-font-size)*var(--mg-b-line-height))/2);margin-right:calc(-1*(var(--mg-b-size-min-height) - var(--mg-b-size-16))/2);margin-left:var(--mg-b-size-32);float:right}.mg-c-popover-content__title ::slotted([slot=title]){margin:0 0 var(--mg-b-size-8) !important;font-size:var(--mg-c-popover-title-font-size) !important;font-weight:600 !important}.mg-c-popover-content ::slotted(*:not(mg-panel,mg-message,mg-modal)){--mg-c-card-border:var(--mg-c-card-border-default);--mg-c-card-spacing:var(--mg-c-card-spacing-default);--mg-c-card-border-radius:var(--mg-c-card-border-radius-default);--mg-c-card-color-background:var(--mg-c-card-color-background-default);--mg-c-card-box-shadow:var(--mg-c-card-box-shadow-default);--mg-c-card-max-width:unset;--mg-c-card-min-width:unset}:host([data-placement^=top][data-arrow-hide]){padding-bottom:0}:host([data-placement^=bottom][data-arrow-hide]){padding-top:0}:host([data-placement$=end][data-arrow-hide]),:host([data-placement^=left][data-arrow-hide]){padding-right:0}:host([data-placement$=start][data-arrow-hide]),:host([data-placement^=right][data-arrow-hide]){padding-left:0}::slotted([slot=arrow]){position:absolute;width:calc(var(--mg-b-size-24) + 2*var(--mg-c-card-border-radius) + 2*var(--mg-b-size-8));height:calc(var(--mg-b-size-24) + 2*var(--mg-c-card-border-radius) + 2*var(--mg-b-size-8));visibility:hidden}::slotted([slot=arrow])::before{position:absolute;content:\"\";visibility:visible}:host([data-arrow-hide]) ::slotted([slot=arrow]){display:none}:host([data-placement^=top]) ::slotted([slot=arrow]),:host([data-placement^=bottom]) ::slotted([slot=arrow]){height:var(--mg-b-size-8)}:host([data-placement^=top]) ::slotted([slot=arrow])::before,:host([data-placement^=bottom]) ::slotted([slot=arrow])::before{left:calc(var(--mg-c-card-border-radius) + var(--mg-b-size-8));border-right:calc(var(--mg-b-size-24)/2) solid rgba(0,0,0,0);border-left:calc(var(--mg-b-size-24)/2) solid rgba(0,0,0,0)}:host([data-placement^=top]) ::slotted([slot=arrow]){bottom:var(--mg-b-size-border);filter:drop-shadow(0 0.5rem 0.25rem color-mix(in srgb, var(--mg-b-color-dark), transparent 85%))}:host([data-placement^=top]) ::slotted([slot=arrow])::before{border-top:var(--mg-b-size-8) solid var(--mg-c-popover-color-background)}:host([data-placement^=bottom]) ::slotted([slot=arrow]){top:var(--mg-b-size-border);filter:drop-shadow(0 -0.5rem 0.25rem color-mix(in srgb, var(--mg-b-color-dark), transparent 85%))}:host([data-placement^=bottom]) ::slotted([slot=arrow])::before{border-bottom:var(--mg-b-size-8) solid var(--mg-c-popover-color-background)}:host([data-placement^=left]) ::slotted([slot=arrow]),:host([data-placement^=right]) ::slotted([slot=arrow]){width:var(--mg-b-size-8)}:host([data-placement^=left]) ::slotted([slot=arrow])::before,:host([data-placement^=right]) ::slotted([slot=arrow])::before{top:calc(var(--mg-c-card-border-radius) + var(--mg-b-size-8));border-top:calc(var(--mg-b-size-24)/2) solid rgba(0,0,0,0);border-bottom:calc(var(--mg-b-size-24)/2) solid rgba(0,0,0,0)}:host([data-placement^=left]) ::slotted([slot=arrow]){right:var(--mg-b-size-border);filter:drop-shadow(0.5rem 0 0.25rem color-mix(in srgb, var(--mg-b-color-dark), transparent 85%))}:host([data-placement^=left]) ::slotted([slot=arrow])::before{border-left:var(--mg-b-size-8) solid var(--mg-c-popover-color-background)}:host([data-placement^=right]) ::slotted([slot=arrow]){left:var(--mg-b-size-border);filter:drop-shadow(-0.5rem 0 0.25rem color-mix(in srgb, var(--mg-b-color-dark), transparent 85%))}:host([data-placement^=right]) ::slotted([slot=arrow])::before{border-right:var(--mg-b-size-8) solid var(--mg-c-popover-color-background)}:host([data-placement^=left-start]) ::slotted([slot=arrow]),:host([data-placement^=left-end]) ::slotted([slot=arrow]),:host([data-placement^=right-start]) ::slotted([slot=arrow]),:host([data-placement^=right-end]) ::slotted([slot=arrow]){height:calc(var(--mg-b-size-24) + 2*var(--mg-c-card-border-radius))}:host([data-placement^=left-start]) ::slotted([slot=arrow])::before,:host([data-placement^=left-end]) ::slotted([slot=arrow])::before,:host([data-placement^=right-start]) ::slotted([slot=arrow])::before,:host([data-placement^=right-end]) ::slotted([slot=arrow])::before{top:var(--mg-c-card-border-radius)}";
const MgPopoverContentStyle0 = mgPopoverContentCss;

const MgPopoverContent = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.hideContent = createEvent(this, "hide-content", 7);
        /**
         * Define if popover has a cross button
         */
        this.closeButton = false;
        /**
         * Component classes
         */
        this.classCollection = new Ze(['mg-c-popover-content']);
        /**
         * Handle action for close button
         */
        this.handleCloseButton = () => {
            this.hideContent.emit();
        };
    }
    /*************
     * Lifecycle *
     *************/
    /**
     * Check if component props are valide
     */
    componentWillLoad() {
        // Get locales
        this.messages = initLocales(this.element).messages;
    }
    /**
     * Check if component slots are valide
     */
    componentDidLoad() {
        const headingTags = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
        const slottedTitleElement = this.element.querySelector('[slot="title"]');
        if (slottedTitleElement && !Ke(slottedTitleElement, headingTags)) {
            throw new Error(`<mg-popover> Slotted title must be a heading: ${headingTags.join(', ')}.`);
        }
    }
    /**
     * Render
     * @returns HTML Element
     */
    render() {
        return (h(Host, { key: '44aa95d34a4c4beeb5c6d1a59e7e7df999393e52' }, h("mg-card", { key: '483195ec364eaaf78df768993706129cb0ce268e', class: this.classCollection.join() }, this.closeButton && (h("mg-button", { key: '4e2b4f7b563c591120ba208e74c501b0bee7497b', "is-icon": true, variant: "flat", label: this.messages.general.close, onClick: this.handleCloseButton }, h("mg-icon", { key: '58a678df3947e4dbfb718c588ccdc97e611915b9', icon: "cross" }))), h("div", { key: 'e7a9debe373ea8947cde108732f635f39b5305a6', class: "mg-c-popover-content__title" }, h("slot", { key: '15fb949256a5f31e8776cdbd7465f46a73db4876', name: "title" })), h("slot", { key: 'ee914630e089763ec3a059cdd6b4c3eba0c2cfa0', name: "content" })), h("slot", { key: '9c25549d1543a77b3cc459caf8bd8df0b279a036', name: "arrow" })));
    }
    get element() { return getElement(this); }
};
MgPopoverContent.style = MgPopoverContentStyle0;

const mgSkipLinksCss = ".mg-c-skip-links{position:absolute;display:flex;min-height:var(--mg-b-size-56);align-items:center;background:var(--mg-b-color-light);opacity:0;transform:translateY(-100%)}.mg-c-skip-links:focus-within{position:relative;opacity:1;transform:translateY(0)}.mg-c-skip-links__list{display:flex;flex-wrap:wrap;align-items:center;padding:0 var(--mg-b-size-16);margin:0;gap:var(--mg-b-spacing-actions);list-style:none}.mg-c-skip-links__link{display:inline-block;padding:var(--mg-b-size-8) var(--mg-b-size-16);color:var(--mg-b-color-dark)}.mg-c-skip-links__link:hover{background:hsl(var(--mg-b-color-dark-h), var(--mg-b-color-dark-s), var(--mg-b-color-dark-l), 10%)}";
const MgSkipLinksStyle0 = mgSkipLinksCss;

const MgSkipLinks = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.goToAnchor = createEvent(this, "go-to-anchor", 7);
        /***********
         * Methods *
         **********/
        /**
         * Handle link click and emit go-to-anchor event
         * @param event - mouse event
         */
        this.handleLinkCLick = (event) => {
            event.currentTarget.blur();
            this.goToAnchor.emit(event.currentTarget.getAttribute('href'));
        };
    }
    validateLinks(links) {
        if (links === undefined || links.length === 0 || links.some(link => !me(link.href) || !link.href.startsWith('#') || !me(link.label))) {
            throw new Error(`<mg-skip-links> prop "links": Cannot be empty and each link must contains an href starting with a "#" and a non empty label attributes.`);
        }
    }
    /*************
     * Lifecycle *
     *************/
    /**
     * Check if props are well configured on init
     */
    componentWillLoad() {
        this.validateLinks(this.links);
        this.messages = initLocales(this.element).messages;
    }
    /**
     * Render
     * @returns HTML Element
     */
    render() {
        return (h("nav", { key: '4c0d14ec373d8e987c876ed89923e754af312bfb', class: "mg-c-skip-links", role: "navigation", "aria-label": this.messages.skipLinks.navLabel }, h("ul", { key: '52117cbae84014f7e59fbcebc6489d73f28dd68d', class: "mg-c-skip-links__list", role: "list" }, this.links.map(link => (h("li", { key: link.href }, h("a", { class: "mg-c-skip-links__link", href: link.href, onClick: this.handleLinkCLick }, link.label)))))));
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "links": ["validateLinks"]
    }; }
};
MgSkipLinks.style = MgSkipLinksStyle0;

/**
 * Available tabs items status
 */
const Status = {
    VISIBLE: 'visible',
    HIDDEN: 'hidden',
    DISABLED: 'disabled',
    ACTIVE: 'active',
};
/**
 * List of all possibles sizes
 */
const sizes = ['medium', 'large'];

const mgTabsCss = "/*!\n * @prop --mg-c-tabs-color: Defines tabs global color, used for bottom line and active tabs. Default value: `--mg-b-color-app`.\n * @prop --mg-c-tabs-color-text: Defines tabs text color. Unset by default, fallback on `--mg-b-color-dark`.\n */.mg-c-tabs.mg-c-tabs--size-medium .mg-c-tabs__navigation-button,.mg-c-tabs__navigation-button.mg-c-tabs__navigation-button--size-medium{padding:var(--mg-b-size-12) var(--mg-b-size-16)}.mg-c-tabs.mg-c-tabs--size-medium .mg-c-tabs__navigation-button,.mg-c-tabs.mg-c-tabs--size-medium .mg-c-tabs__navigation-button ::slotted([slot=label]),.mg-c-tabs.mg-c-tabs--size-medium .mg-c-tabs__navigation-button ::slotted([slot=metadata]),.mg-c-tabs__navigation-button.mg-c-tabs__navigation-button--size-medium,.mg-c-tabs__navigation-button.mg-c-tabs__navigation-button--size-medium ::slotted([slot=label]),.mg-c-tabs__navigation-button.mg-c-tabs__navigation-button--size-medium ::slotted([slot=metadata]){font-size:var(--mg-b-font-size)}.mg-c-tabs.mg-c-tabs--size-medium .mg-c-tabs__navigation-button.mg-c-tabs__navigation-button--horizontal,.mg-c-tabs__navigation-button.mg-c-tabs__navigation-button--size-medium.mg-c-tabs__navigation-button--horizontal{padding-bottom:var(--mg-b-size-12)}.mg-c-tabs.mg-c-tabs--size-medium .mg-c-tabs__navigation-button.mg-c-tabs__navigation-button--vertical,.mg-c-tabs__navigation-button.mg-c-tabs__navigation-button--size-medium.mg-c-tabs__navigation-button--vertical{padding-left:var(--mg-b-size-16)}.mg-c-tabs.mg-c-tabs--size-large .mg-c-tabs__navigation-button,.mg-c-tabs__navigation-button.mg-c-tabs__navigation-button--size-large{padding:var(--mg-b-size-16) var(--mg-b-size-32)}.mg-c-tabs.mg-c-tabs--size-large .mg-c-tabs__navigation-button,.mg-c-tabs.mg-c-tabs--size-large .mg-c-tabs__navigation-button ::slotted([slot=label]),.mg-c-tabs.mg-c-tabs--size-large .mg-c-tabs__navigation-button ::slotted([slot=metadata]),.mg-c-tabs__navigation-button.mg-c-tabs__navigation-button--size-large,.mg-c-tabs__navigation-button.mg-c-tabs__navigation-button--size-large ::slotted([slot=label]),.mg-c-tabs__navigation-button.mg-c-tabs__navigation-button--size-large ::slotted([slot=metadata]){font-size:var(--mg-b-font-size-h4)}.mg-c-tabs.mg-c-tabs--size-large .mg-c-tabs__navigation-button.mg-c-tabs__navigation-button--horizontal,.mg-c-tabs__navigation-button.mg-c-tabs__navigation-button--size-large.mg-c-tabs__navigation-button--horizontal{padding-bottom:var(--mg-b-size-16)}.mg-c-tabs.mg-c-tabs--size-large .mg-c-tabs__navigation-button.mg-c-tabs__navigation-button--vertical,.mg-c-tabs__navigation-button.mg-c-tabs__navigation-button--size-large.mg-c-tabs__navigation-button--vertical{padding-left:var(--mg-b-size-32)}.mg-c-tabs__navigation-button{display:flex;box-sizing:border-box;align-items:center;border:none;background-color:unset;color:var(--mg-c-tabs-color-text, var(--mg-b-color-dark));column-gap:var(--mg-c-tabs-navigation-button-column-gap, var(--mg-b-size-8));cursor:pointer;font-family:var(--mg-b-font-family);font-weight:400;line-height:var(--mg-b-line-height);text-decoration:none;white-space:nowrap}.mg-c-tabs__navigation-button:disabled,.mg-c-tabs__navigation-button--disabled{cursor:default;opacity:var(--mg-b-opacity-element-disabled)}.mg-c-tabs__navigation-button:focus-visible{z-index:10}.mg-c-tabs__navigation-button:hover:not(.mg-c-tabs__navigation-button--disabled),.mg-c-tabs__navigation-button:focus-visible:not(.mg-c-tabs__navigation-button--disabled){background-color:color-mix(in srgb, var(--mg-c-tabs-color), transparent 90%)}.mg-c-tabs__navigation-button.mg-c-tabs__navigation-button--active{color:var(--mg-c-tabs-color);font-weight:600}.mg-c-tabs__navigation-button.mg-c-tabs__navigation-button--active.mg-c-tabs__navigation-button--horizontal{box-shadow:inset 0 calc(-1*var(--mg-b-size-4)) var(--mg-c-tabs-color)}.mg-c-tabs__navigation-button.mg-c-tabs__navigation-button--active.mg-c-tabs__navigation-button--vertical{box-shadow:inset var(--mg-b-size-4) 0 var(--mg-c-tabs-color)}.mg-c-tabs__navigation-button.mg-c-tabs__navigation-button--hidden{display:none}.mg-c-tabs__header{display:flex;flex-flow:row wrap;border-bottom:var(--mg-b-size-border) solid color-mix(in srgb, var(--mg-c-tabs-color), transparent 90%)}.mg-c-tabs__content-container:focus-visible{outline:none}.mg-c-tabs__navigation-button-text{flex:0 0 content}";
const MgTabsStyle0 = mgTabsCss;

/**
 * type TabItem validation function
 * @param tab - tab item
 * @returns tab item type is valid
 */
const isTabItem = (tab) => typeof tab === 'object' && typeof tab.label === 'string';
const MgTabs = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.activeTabChange = createEvent(this, "active-tab-change", 7);
        /************
         * Internal *
         ************/
        // classes
        this.tabPanel = 'panel';
        this.buttonTabBaseClass = 'mg-c-tabs__navigation-button';
        this.startIndex = 1;
        /**
         * Identifier is used for the element ID (id is a reserved prop in Stencil.js)
         * If not set, it will be created.
         */
        this.identifier = Ge('mg-tabs');
        /**
         * Define tabs size
         */
        this.size = 'medium';
        /**
         * Component tabs
         */
        this.tabs = [];
        /**
         * Component classes
         */
        this.classCollection = new Ze(['mg-c-tabs']);
        /**
         * Validate that new tab status can be `Status.ACTIVE`
         * @param tab - tab item
         * @returns true when tab match condition to get a `Status.ACTIVE`
         */
        this.isActivableTab = (tab) => [undefined, Status.ACTIVE, Status.VISIBLE].includes(tab.status);
        /**
         * Method to know if given tab has the given status
         * @param tab - item tab key to set to ACTIVE status
         * @param status - status to valide
         * @returns status comparaison
         */
        this.tabHasStatus = (tab, status) => tab.status === status;
        /**
         * Method to get element id from index
         * @param element - to get id
         * @param index - to generate id
         * @returns generated element id
         */
        this.getElementId = (element, index) => `${element}-${this.getTabItemIndex(index)}`;
        /**
         * Method to get tab item index
         * @param index - to get
         * @returns index
         */
        this.getTabItemIndex = (index) => index + this.startIndex;
        /**
         * Handle click events on tabs
         * @param event - mouse event
         */
        this.handleClick = (event) => {
            const tabId = event.currentTarget.dataset.index;
            if (!this.isActivableTab(this.tabs[Number(tabId) - this.startIndex])) {
                event.preventDefault();
            }
            else {
                this.activeTab = Number(tabId);
                this.tabFocus = undefined;
            }
        };
        /**
         * get navigation button class from given status
         * @param status - button tab status
         * @returns button class/selector variant
         */
        this.getNavigationButtonClass = (status) => `${this.buttonTabBaseClass}--${status}`;
        /**
         * Handle keyboard event on tabs
         * @param event - mouse event
         */
        this.handleKeydown = (event) => {
            const parent = event.target.parentElement;
            if (['ArrowRight', 'ArrowLeft'].includes(event.key)) {
                this.tabFocus = Number(event.target.dataset.index);
                parent.querySelector(`[data-index="${this.tabFocus}"]`).setAttribute('tabindex', '-1');
                // Move right
                if (event.key === 'ArrowRight') {
                    this.tabFocus++;
                    // If we're at the end, go to the start
                    if (this.tabFocus > this.tabs.length)
                        this.tabFocus = this.startIndex;
                    // Move left
                }
                else if (event.key === 'ArrowLeft') {
                    this.tabFocus--;
                    // If we're at the start, move to the end
                    if (this.tabFocus < this.startIndex)
                        this.tabFocus = this.tabs.length;
                }
                const parentButtonElement = parent.querySelector(`[data-index="${this.tabFocus}"]`);
                // if focus item is ['hidden'] we recursively repeat action
                if (this.tabHasStatus(this.tabs[this.tabFocus - 1], Status.HIDDEN)) {
                    parentButtonElement.dispatchEvent(new KeyboardEvent('keydown', { key: event.key, bubbles: true }));
                    // else run focus methods on tabFocus element
                }
                else {
                    parentButtonElement.setAttribute('tabindex', '0');
                    parentButtonElement.focus();
                }
            }
            else if (event.key === 'Tab') {
                this.resetFocus();
            }
        };
        /**
         * Reset focus on document click
         * @param event - mouse event
         */
        this.handleDocumentClick = (event) => {
            if (event.target.closest('mg-tabs') !== this.element)
                this.resetFocus();
        };
        /**
         * Method to reset focus behavior
         */
        this.resetFocus = () => {
            // update asynchronously tabindex to prevent get focus on new tabindex at then end of event process
            st(() => {
                this.tabFocus = undefined;
                Array.from(this.element.shadowRoot.querySelectorAll('[data-index]')).forEach((tab, index) => {
                    tab.setAttribute('tabindex', this.activeTab - this.startIndex !== index ? '-1' : '0');
                });
            });
        };
        /**
         * Validate slots setting
         */
        this.validateSlots = () => {
            const slots = Array.from(this.element.children).filter(slot => { var _a; return (_a = slot.getAttribute('slot')) === null || _a === void 0 ? void 0 : _a.includes('tab_content-'); });
            if (slots.length !== this.tabs.length)
                throw new Error('<mg-tabs> Must have slots counts equal to tabs count.');
        };
    }
    watchIdentifier(newValue) {
        if (!Xe(newValue)) {
            console.error(`<mg-tabs> prop "identifier" value is invalid. Passed value: ${Ve(newValue)}.`);
        }
    }
    validateLabel(newValue) {
        if (!me(newValue)) {
            throw new Error(`<mg-tabs> prop "label" is required and must be a string. Passed value: ${Ve(newValue)}.`);
        }
    }
    validateSize(newValue) {
        if (!sizes.includes(newValue)) {
            throw new Error(`<mg-tabs> prop "size" must be one of: ${sizes.join(', ')}. Passed value: ${Ve(newValue)}.`);
        }
        this.classCollection.add(`mg-c-tabs--size-${this.size}`);
    }
    validateItems(newValue) {
        // String array
        if (Je(newValue))
            this.tabs = newValue.map(item => ({ label: item, status: Status.VISIBLE }));
        // Object array
        else if (Array.isArray(newValue) && newValue.length > 0 && newValue.every(isTabItem))
            this.tabs = newValue;
        else
            throw new Error(`<mg-tabs> prop "items" is required and all items must be the same type: TabItem. Passed value: ${Ve(newValue)}.`);
    }
    validateActiveTab(newValue) {
        // when `active-tab` is undefined we set default value by searching an item with `Status.ACTIVE` or we use the `startIndex` has fallback value
        // after setting new value to `active-tab` the validate will be triggered again with the updated value and process the tab update
        if (newValue === undefined) {
            this.activeTab = this.tabs.some(tab => this.tabHasStatus(tab, Status.ACTIVE))
                ? this.getTabItemIndex(this.tabs.findIndex(tab => this.tabHasStatus(tab, Status.ACTIVE)))
                : this.startIndex;
        }
        else if (typeof newValue === 'number' && newValue >= this.startIndex && newValue <= this.tabs.length && this.isActivableTab(this.tabs[newValue - this.startIndex])) {
            // if new 'active-tab' is activable we update tab status to ACTIVE and toggle past ACTIVE to VISIBLE
            this.tabs.forEach((tab, index) => {
                const isNewActiveTab = index === newValue - this.startIndex;
                // reset active tabs
                if (this.tabHasStatus(tab, Status.ACTIVE) && !isNewActiveTab)
                    tab.status = Status.VISIBLE;
                // set active tab from given tab key
                else if (this.isActivableTab(tab) && isNewActiveTab)
                    tab.status = Status.ACTIVE;
            });
            // emit change active tab key event
            this.activeTabChange.emit(newValue);
        }
        else {
            throw new Error(`<mg-tabs> prop "activeTab" must be a number between ${this.startIndex} and ${this.tabs.length} and new value must be "activable". Passed value: ${Ve(newValue)}.`);
        }
    }
    /*************
     * Lifecycle *
     *************/
    /**
     * Check if component props are well configured on init
     */
    componentWillLoad() {
        // Check tabs format
        this.watchIdentifier(this.identifier);
        this.validateLabel(this.label);
        this.validateItems(this.items);
        this.validateActiveTab(this.activeTab);
        this.validateSize(this.size);
        this.validateSlots();
    }
    /**
     * add listners
     */
    componentDidLoad() {
        document.addEventListener('click', this.handleDocumentClick, false);
    }
    /**
     * remove listeners
     */
    disconnectedCallback() {
        document.removeEventListener('keydown', this.handleDocumentClick);
    }
    /**
     * Render
     * @returns HTML Element
     */
    render() {
        return (h("div", { key: 'e4b89ce00f76cc556f72acbfd4b08ef90fd50a9c', class: this.classCollection.join() }, h("header", { key: 'c9c3434335e28103c1128f4bef926602e182cf14', role: "tablist", "aria-label": this.label, class: "mg-c-tabs__header" }, this.tabs.map((tab, index) => (h("button", { key: tab.label, role: "tab", id: this.getElementId(this.identifier, index), class: {
                [`${this.buttonTabBaseClass}`]: true,
                [`${this.buttonTabBaseClass}--horizontal`]: true,
                [`${this.getNavigationButtonClass(Status.ACTIVE)}`]: this.tabHasStatus(tab, Status.ACTIVE),
                [`${this.getNavigationButtonClass(Status.DISABLED)}`]: this.tabHasStatus(tab, Status.DISABLED),
                [`${this.getNavigationButtonClass(Status.HIDDEN)}`]: this.tabHasStatus(tab, Status.HIDDEN),
            }, tabindex: this.tabHasStatus(tab, Status.ACTIVE) ? 0 : -1, "aria-selected": this.tabHasStatus(tab, Status.ACTIVE).toString(), "aria-controls": this.getElementId(this.tabPanel, index), "aria-disabled": this.tabHasStatus(tab, Status.DISABLED), onClick: this.handleClick, onKeyDown: this.handleKeydown, "data-index": this.getTabItemIndex(index) }, tab.icon !== undefined && h("mg-icon", { icon: tab.icon }), tab.label, tab.badge !== undefined && h("mg-badge", { variant: "text-color", value: tab.badge.value, label: tab.badge.label, outline: tab.badge.role === 'information' }))))), this.tabs.map((tab, index) => (h("article", { key: tab.label, role: "tabpanel", id: this.getElementId(this.tabPanel, index), hidden: !this.tabHasStatus(tab, Status.ACTIVE), "aria-labelledby": this.getElementId(this.identifier, index), tabindex: this.tabHasStatus(tab, Status.ACTIVE) ? 0 : -1, class: "mg-c-tabs__content-container" }, h("slot", { name: this.getElementId('tab_content', index) }))))));
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "identifier": ["watchIdentifier"],
        "label": ["validateLabel"],
        "size": ["validateSize"],
        "items": ["validateItems"],
        "activeTab": ["validateActiveTab"]
    }; }
};
MgTabs.style = MgTabsStyle0;

/**
 * List of all possibles variants
 */
const variants = ['primary', 'secondary', 'success', 'warning', 'danger', 'info'];

const mgTagCss = "/*!\n * @prop --mg-c-tag-height: Defines the height of the tag. Default value is `--mg-b-size-24`.\n * @prop --mg-c-tag-border-radius: Defines the border radius of the tag. Default value is `--mg-b-size-radius`.\n * @prop --mg-c-tag-font-size: Defines the font size of the tag. Default value is `--mg-b-font-size-small`.\n */:host{display:inline-block}.mg-c-tag{display:inline-flex;min-height:var(--mg-c-tag-height);box-sizing:border-box;align-items:center;padding:calc((var(--mg-c-tag-height) - 2*var(--mg-b-size-border) - var(--mg-c-tag-font-size)*var(--mg-b-line-height))/2) calc(var(--mg-b-size-8) - var(--mg-b-size-border));border:var(--mg-b-size-border) solid;border-radius:var(--mg-c-tag-border-radius);font-size:var(--mg-c-tag-font-size);font-weight:600;text-align:center;vertical-align:middle}.mg-c-tag.mg-c-tag--primary{border-color:var(--mg-b-color-neutral-110);background-color:var(--mg-b-color-neutral-110);color:var(--mg-b-color-text-on-primary)}.mg-c-tag.mg-c-tag--primary.mg-c-tag--outline{background-color:rgba(0,0,0,0);color:var(--mg-b-color-neutral-110)}.mg-c-tag.mg-c-tag--primary.mg-c-tag--soft{border-color:var(--mg-b-color-neutral-20);background-color:var(--mg-b-color-neutral-20);color:var(--mg-b-color-dark);font-weight:400}.mg-c-tag.mg-c-tag--primary.mg-c-tag--soft ::slotted(mg-icon){color:var(--mg-b-color-neutral-110)}.mg-c-tag.mg-c-tag--secondary{border-color:var(--mg-b-color-neutral-10);background-color:var(--mg-b-color-neutral-10);color:var(--mg-b-color-text-on-secondary)}.mg-c-tag.mg-c-tag--secondary.mg-c-tag--outline{background-color:rgba(0,0,0,0);color:var(--mg-b-color-neutral-10)}.mg-c-tag.mg-c-tag--secondary.mg-c-tag--soft{border-color:var(--mg-b-color-neutral-20);background-color:var(--mg-b-color-neutral-20);color:var(--mg-b-color-dark);font-weight:400}.mg-c-tag.mg-c-tag--secondary.mg-c-tag--soft ::slotted(mg-icon){color:var(--mg-b-color-text-on-secondary)}.mg-c-tag.mg-c-tag--danger{border-color:var(--mg-b-color-danger);background-color:var(--mg-b-color-danger);color:var(--mg-b-color-text-on-danger)}.mg-c-tag.mg-c-tag--danger.mg-c-tag--outline{background-color:rgba(0,0,0,0);color:var(--mg-b-color-danger)}.mg-c-tag.mg-c-tag--danger.mg-c-tag--soft{border-color:var(--mg-b-color-red-20);background-color:var(--mg-b-color-red-20);color:var(--mg-b-color-dark);font-weight:400}.mg-c-tag.mg-c-tag--danger.mg-c-tag--soft ::slotted(mg-icon){color:var(--mg-b-color-danger)}.mg-c-tag.mg-c-tag--info{border-color:var(--mg-b-color-info);background-color:var(--mg-b-color-info);color:var(--mg-b-color-text-on-info)}.mg-c-tag.mg-c-tag--info.mg-c-tag--outline{background-color:rgba(0,0,0,0);color:var(--mg-b-color-info)}.mg-c-tag.mg-c-tag--info.mg-c-tag--soft{border-color:var(--mg-b-color-blue-20);background-color:var(--mg-b-color-blue-20);color:var(--mg-b-color-dark);font-weight:400}.mg-c-tag.mg-c-tag--info.mg-c-tag--soft ::slotted(mg-icon){color:var(--mg-b-color-info)}.mg-c-tag.mg-c-tag--success{border-color:var(--mg-b-color-success);background-color:var(--mg-b-color-success);color:var(--mg-b-color-text-on-success)}.mg-c-tag.mg-c-tag--success.mg-c-tag--outline{background-color:rgba(0,0,0,0);color:var(--mg-b-color-success)}.mg-c-tag.mg-c-tag--success.mg-c-tag--soft{border-color:var(--mg-b-color-green-20);background-color:var(--mg-b-color-green-20);color:var(--mg-b-color-dark);font-weight:400}.mg-c-tag.mg-c-tag--success.mg-c-tag--soft ::slotted(mg-icon){color:var(--mg-b-color-success)}.mg-c-tag.mg-c-tag--warning{border-color:var(--mg-b-color-warning);background-color:var(--mg-b-color-warning);color:var(--mg-b-color-text-on-warning)}.mg-c-tag.mg-c-tag--warning.mg-c-tag--outline{background-color:rgba(0,0,0,0);color:var(--mg-b-color-warning)}.mg-c-tag.mg-c-tag--warning.mg-c-tag--soft{border-color:var(--mg-b-color-yellow-20);background-color:var(--mg-b-color-yellow-20);color:var(--mg-b-color-dark);font-weight:400}.mg-c-tag.mg-c-tag--warning.mg-c-tag--soft ::slotted(mg-icon){color:var(--mg-b-color-warning)}::slotted(mg-icon){margin-right:var(--mg-b-size-4)}slot{display:inline-flex;align-items:center}";
const MgTagStyle0 = mgTagCss;

const MgTag = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        /************
         * Internal *
         ************/
        // Classes
        this.classOutline = 'mg-c-tag--outline';
        this.classSoft = 'mg-c-tag--soft';
        /**
         * Define tag variant
         */
        this.variant = variants[0]; // primary
        /**
         * Component classes
         */
        this.classCollection = new Ze(['mg-c-tag']);
    }
    validateVariant(newValue, oldValue) {
        if (!variants.includes(newValue)) {
            throw new Error(`<mg-tag> prop "variant" must be one of: ${variants.join(', ')}. Passed value: ${Ve(newValue)}.`);
        }
        else {
            if (oldValue !== undefined) {
                this.classCollection.delete(`mg-c-tag--${oldValue}`);
            }
            this.classCollection.add(`mg-c-tag--${newValue}`);
        }
    }
    validateOutline(newValue) {
        if (newValue)
            this.classCollection.add(this.classOutline);
        else
            this.classCollection.delete(this.classOutline);
    }
    validateSoft(newValue) {
        // usage validation
        if (newValue && this.outline)
            throw new Error('<mg-tag> prop "soft" can NOT be used with prop "outline".');
        // apply class
        if (newValue)
            this.classCollection.add(this.classSoft);
        else
            this.classCollection.delete(this.classSoft);
    }
    /*************
     * Methods *
     *************/
    /**
     * Validate the given textContent
     * @param textContent - html element textContent property
     */
    validateTextContent(textContent) {
        if (!me(textContent))
            throw new Error('<mg-tag> slot must contain a text content.');
    }
    /*************
     * Lifecycle *
     *************/
    /**
     * Check if props are well configured on init
     */
    componentWillLoad() {
        this.validateVariant(this.variant);
        this.validateOutline(this.outline);
        this.validateSoft(this.soft);
        this.validateTextContent(this.element.textContent);
    }
    /**
     * Render
     * @returns HTML Element
     */
    render() {
        return (h("span", { key: 'b3269e3baec3a281bdbe65f8b62636b7ea2fa84c', class: this.classCollection.join() }, h("slot", { key: 'bcca2d8653dbcd6a96d322055a4e2773d85ca87d' })));
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "variant": ["validateVariant"],
        "outline": ["validateOutline"],
        "soft": ["validateSoft"]
    }; }
};
MgTag.style = MgTagStyle0;

const Guard = {
    FOCUS: 'focus',
    HOVER_TOOLTIP_ELEMENT: 'hoverTooltip',
    HOVER_TOOLTIPED_ELEMENT: 'hoverTooltiped',
    DISABLE_ON_CLICK: 'disableOnClick',
};

const mgTooltipCss = "/*!\n * @prop --mg-c-tooltip-border-radius: Defines the border radius of the tooltip. Default value: `--mg-b-size-radius`.\n * @prop --mg-c-tooltip-color-background: Defines the background color of the tooltip. Default value: `--mg-b-color-dark`.\n * @prop --mg-c-tooltip-color-text: Defines the font color of the tooltip. Default value: `--mg-b-color-light`.\n */:host{display:inline-block}";
const MgTooltipStyle0 = mgTooltipCss;

/**
 * HTMLMgButtonElement type guard
 * @param element - element to check
 * @returns return true if type is HTMLMgButtonElement
 */
const isButton = (element) => typeof element === 'object' && ['MG-BUTTON', 'BUTTON'].includes(element.tagName);
const MgTooltip = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        /**
         * Sets an `id` attribute.
         * Needed by the input for accessibility `aria-decribedby`.
         */
        this.identifier = Ge('mg-tooltip');
        /**
         * Tooltip placement
         */
        this.placement = 'bottom';
        /**
         * Display tooltip
         */
        this.display = false;
        /**
         * Disable tooltip
         */
        this.disabled = false;
        /**
         * Show tooltip
         */
        this.show = () => {
            // Make the tooltip visible
            this.mgTooltipContent.dataset.show = '';
            // hide when click outside on nextTick to prevent event to trigger after creation
            st(() => {
                this.windows.forEach((localWindow) => {
                    localWindow.addEventListener('click', this.handleClickOutside, false);
                    localWindow.addEventListener('keydown', this.handlePressEscape, false);
                });
            });
        };
        /**
         * Hide tooltip
         */
        this.hide = () => {
            // Hide the tooltip
            this.mgTooltipContent.removeAttribute('data-show');
            // Remove event listener
            this.windows.forEach((localWindow) => {
                localWindow.removeEventListener('click', this.handleClickOutside, false);
                localWindow.removeEventListener('keyboard', this.handlePressEscape, false);
            });
        };
        /**
         * Check if clicked outside of component and hide tooltip
         * @param event - mouse event
         */
        this.handleClickOutside = (event) => {
            if (event.target.closest('mg-tooltip') !== this.element)
                this.setDisplay(false);
        };
        /**
         * Check if 'Escape' key is pressed of component and hide tooltip
         * @param event - keyboard event
         */
        this.handlePressEscape = (event) => {
            if (event.code === 'Escape') {
                this.setDisplay(false);
                this.resetGuard();
            }
        };
        /**
         * Method to set display prop
         * @param newValue - display prop new value
         * @param condition - additionnal condition to apply display prop newValue
         */
        this.setDisplay = (newValue, condition = true) => {
            if (!this.disabled && condition)
                this.display = newValue;
        };
        /**
         * Action for tooltip element and tooltiped element mouse listener
         * @param elementGuard -  tooltip element guard
         * @param eventName - event name
         * @param conditionalGuard - guard condition
         */
        this.tooltipMouseListenerAction = (elementGuard, eventName, conditionalGuard) => {
            // active FOCUS guard cancel process
            if ([Guard.FOCUS, Guard.DISABLE_ON_CLICK].includes(this.guard)) {
                return;
            }
            // Update guard by element guard
            this.guard = elementGuard;
            if (eventName !== 'mouseenter') {
                // process action in the next event loop macro task
                setTimeout(() => {
                    this.setDisplay(false, this.guard !== conditionalGuard);
                    this.resetGuard();
                }, 100);
            }
            else if (this.guard === Guard.HOVER_TOOLTIPED_ELEMENT) {
                this.setDisplay(true);
            }
        };
        /**
         * Method to reset guard value
         */
        this.resetGuard = () => {
            this.guard = undefined;
        };
        /**
         * Update slot content when it is a mg-button
         * @param mgButton - slotted mg-button
         */
        this.setMgButtonWrapper = (mgButton) => {
            const buttonWrapperClass = 'mg-c-tooltip__mg-button-wrapper';
            const hasButtonWrapper = mgButton.parentElement.classList.contains(buttonWrapperClass);
            // For disabled mg-button, we need to wrap it in a new element
            // We bind handlers to this new element to keep listener features as workaround to disabled mg-button `pointer-events: none`
            // AND to prevent multiple nested wrappers from rendering when a new render is called with a disabled mg-button
            if (mgButton.disabled && !hasButtonWrapper) {
                // wrap mg-button in a div
                const div = document.createElement('div');
                div.classList.add(buttonWrapperClass);
                mgButton.parentNode.insertBefore(div, mgButton);
                div.appendChild(mgButton);
                // update tooltipElement
                this.setTooltipedElement(div);
            }
            else if (!mgButton.disabled && hasButtonWrapper) {
                this.element.firstElementChild.replaceWith(mgButton);
                // update tooltipElement
                this.setTooltipedElement(mgButton);
            }
        };
        /**
         * Set Floating UI instance
         * @param strategy - Floating UI strategy to apply on instance
         */
        this.setFloatingUI = (strategy) => {
            // Initial styles configuration
            Object.assign(this.mgTooltipContent.style, {
                position: strategy,
                top: '0',
                left: '0',
                transform: 'translate(0, 0)',
            });
            // Create Floating UI instance with autoUpdate
            this.floatingUICleanup = autoUpdate(this.tooltipedElement, this.mgTooltipContent, () => {
                computePosition(this.tooltipedElement, this.mgTooltipContent, {
                    placement: this.placement,
                    strategy,
                    middleware: [offset(8), flip(), shift({ limiter: limitShift() }), arrow({ element: this.mgTooltipContent.querySelector('[data-floating-arrow]') })],
                }).then(({ x, y, placement, middlewareData }) => {
                    Object.assign(this.mgTooltipContent.style, {
                        transform: !isNaN(x) && !isNaN(y) ? `translate(${x}px, ${y}px)` : undefined,
                    });
                    // Update arrow style
                    const { x: arrowX, y: arrowY } = middlewareData.arrow;
                    const staticSide = {
                        top: 'bottom',
                        right: 'left',
                        bottom: 'top',
                        left: 'right',
                    }[placement.split('-')[0]];
                    const arrowElement = this.mgTooltipContent.querySelector('[data-floating-arrow]');
                    // https://floating-ui.com/docs/arrow
                    // Unlike the floating element, which has both coordinates defined at all times, the arrow only has one defined.
                    // Due to this, either x or y will be undefined, depending on the side of placement.
                    // The above code uses `isNaN` to check for null and undefined simultaneously.
                    // Don’t remove `isNaN`, because either value can be falsy (0), causing a bug!
                    const numberToPx = (number) => (!isNaN(number) ? `${number}px` : '');
                    Object.assign(arrowElement.style, {
                        left: numberToPx(arrowX),
                        top: numberToPx(arrowY),
                        [staticSide]: '-4px',
                        position: 'absolute',
                    });
                    this.mgTooltipContent.setAttribute('data-placement', placement);
                });
            });
        };
        /**
         * Define selected element to become tooltip selector and init listeners
         * @param element - tooltiped element
         */
        this.setTooltipedElement = (element) => {
            this.tooltipedElement = element;
            // Manage tooltipedElement focus events
            this.tooltipedElement.addEventListener('focus', () => {
                this.guard = Guard.FOCUS;
                this.setDisplay(true);
            });
            // as `click` event is the composition of `mousedown` and `mouseup` event,
            // and `click` event trigger `focus` event after a success `mousedown` wich set the `guard` to `Guard.FOCUS`
            // we reset the guard on `mouseup` event to unlock tooltip
            this.tooltipedElement.addEventListener('mouseup', () => {
                this.resetGuard();
            });
            this.tooltipedElement.addEventListener('blur', () => {
                this.resetGuard();
                this.setDisplay(false);
            });
            // manage tooltipElement & tooltipedElement mouseenter/mouseleave events
            this.tooltipedElement.addEventListener('mouseenter', () => {
                this.tooltipMouseListenerAction(Guard.HOVER_TOOLTIPED_ELEMENT, 'mouseenter', Guard.HOVER_TOOLTIP_ELEMENT);
            });
            this.tooltipedElement.addEventListener('mouseleave', () => {
                this.tooltipMouseListenerAction(Guard.HOVER_TOOLTIPED_ELEMENT, 'mouseleave', Guard.HOVER_TOOLTIP_ELEMENT);
            });
        };
        /**
         * Set button mutation observer
         * @param mgButton - mg-button to observe
         */
        this.setMgButtonMutationObserver = (mgButton) => {
            new MutationObserver(mutationList => {
                // stop process when none of mutations attributed is disabled
                if (!mutationList.some(mutation => ['aria-disabled', 'disabled'].includes(mutation.attributeName)))
                    return;
                // set guard when one of mutations is for a disabled with disabled-on-click
                if (mutationList.some((mutation) => mutation.target.disabled && mutation.target.disableOnClick)) {
                    this.guard = Guard.DISABLE_ON_CLICK;
                }
                // when the disabled-on-click guard is running we stop process
                if (this.guard === Guard.DISABLE_ON_CLICK)
                    return;
                // update button wrapper
                this.setMgButtonWrapper(mgButton);
                // Since Firefox doesn't trigger a "blur" event when the "disabled" attribute is added or removed from a button
                // we have to manually unlock the guard because the "blur" handler of the tooltipedElement won't do it.
                this.resetGuard();
                // update Floating UI instance
                this.floatingUICleanup();
                this.setFloatingUI(this.element.closest('mg-popover') !== null ? 'absolute' : 'fixed');
            }).observe(mgButton, { attributes: true });
        };
        /**
         * Set tooltiped element aria-describedby
         * @param element - element to update
         */
        this.setAriaDescribedby = (element) => {
            // Set aria-describedby
            if (!element.hasAttribute('aria-describedby')) {
                this.tooltipedElement.setAttribute('aria-describedby', this.identifier);
            }
            else {
                // We ensure to have uniq ids
                element.setAttribute('aria-describedby', `${[...new Set([...element.getAttribute('aria-describedby').split(' '), this.identifier])].join(' ')}`);
            }
        };
    }
    watchIdentifier(newValue) {
        if (!Xe(newValue)) {
            throw new Error(`<mg-tooltip> prop "identifier" value is invalid. Passed value: ${Ve(newValue)}.`);
        }
        // use renderTooltipContent to update tooltip-content id
        this.renderTooltipContent();
    }
    watchMessage(newValue) {
        if (!me(newValue)) {
            throw new Error(`<mg-tooltip> prop "message" is required and must be a string. Passed value: ${Ve(newValue)}.`);
        }
        if (this.mgTooltipContent !== undefined)
            this.mgTooltipContent.message = newValue;
    }
    watchPlacement(newValue) {
        if (!isFloatingUIPlacement(newValue))
            this.placement = 'bottom';
    }
    watchDisplay(newValue) {
        if (newValue) {
            this.show();
        }
        else {
            this.hide();
        }
    }
    watchDisabled(newValue) {
        if (this.hasCustomTabIndex) {
            if (newValue)
                this.tooltipedElement.removeAttribute('tabindex');
            else if (!this.tooltipedElement.hasAttribute('tabindex'))
                this.tooltipedElement.setAttribute('tabindex', '0');
        }
    }
    /**
     * Render tooltip content element and init listeners
     */
    renderTooltipContent() {
        if (this.mgTooltipContent !== undefined) {
            this.mgTooltipContent.setAttribute('id', this.identifier);
        }
        else {
            this.mgTooltipContent = document.createElement('mg-tooltip-content');
            this.mgTooltipContent.setAttribute('slot', 'content');
            this.mgTooltipContent.setAttribute('id', this.identifier);
            const arrow = document.createElement('div');
            arrow.setAttribute('slot', 'arrow');
            arrow.dataset.floatingArrow = '';
            this.mgTooltipContent.appendChild(arrow);
            // manage tooltipElement & tooltipedElement mouseenter/mouseleave events
            this.mgTooltipContent.addEventListener('mouseenter', () => {
                this.tooltipMouseListenerAction(Guard.HOVER_TOOLTIP_ELEMENT, 'mouseenter', Guard.HOVER_TOOLTIPED_ELEMENT);
            });
            this.mgTooltipContent.addEventListener('mouseleave', () => {
                this.tooltipMouseListenerAction(Guard.HOVER_TOOLTIP_ELEMENT, 'mouseleave', Guard.HOVER_TOOLTIPED_ELEMENT);
            });
            // append tooltip element to component
            this.element.appendChild(this.mgTooltipContent);
        }
    }
    /*************
     * Lifecycle *
     *************/
    /**
     * set variables
     */
    componentWillLoad() {
        // Get windows to attach events
        this.windows = Ye(window);
        // Get tooltip element
        this.renderTooltipContent();
        //validate properties
        this.watchPlacement(this.placement);
        this.watchDisabled(this.disabled);
        this.watchMessage(this.message);
        this.watchIdentifier(this.identifier);
    }
    /**
     * Get slotted element
     * Check if it already contain an interactive element, if not we need to add a tabIndex attribute
     * We need to attach the focused element to the tooltip (aria-describedby)
     */
    componentDidLoad() {
        var _a;
        // get slotted element wich is not the tooltip
        const slotElement = this.element.querySelector(`*:not(#${this.identifier})`);
        // Get interactive element
        const interactiveElement = slotElement.matches(Qe) ? slotElement : (_a = slotElement.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector(Qe);
        this.setTooltipedElement(interactiveElement || slotElement);
        // Check if slotted element is a disabled mg-button
        // In this case we wrap the mg-button into a div to enable the tooltip
        if (isButton(slotElement)) {
            this.setMgButtonMutationObserver(slotElement);
            this.setMgButtonWrapper(slotElement);
        }
        // Add tabindex to slotted element if we can't find any interactive element
        if (!this.disabled && [undefined, null].includes(interactiveElement)) {
            this.hasCustomTabIndex = true;
            slotElement.tabIndex = 0;
            // Add role on non-interactive element to work with "aria-describedby" for screen readers
            slotElement.setAttribute('role', 'button');
        }
        // apply a11y aria
        this.setAriaDescribedby(slotElement);
        // set Tooltip
        this.setFloatingUI(this.element.closest('mg-popover') !== null ? 'absolute' : 'fixed');
        // add document keyboard handler
        document.addEventListener('keydown', this.handlePressEscape);
        // check props
        this.watchDisplay(this.display);
    }
    /**
     * update popper position after props change on component did update hook to benefit from render ended
     */
    componentDidUpdate() {
        this.floatingUICleanup();
        this.setFloatingUI(this.element.closest('mg-popover') !== null ? 'absolute' : 'fixed');
    }
    /**
     * remove listeners
     */
    disconnectedCallback() {
        var _a;
        document.removeEventListener('keydown', this.handlePressEscape);
        (_a = this.windows) === null || _a === void 0 ? void 0 : _a.forEach((localWindow) => {
            localWindow.removeEventListener('click', this.handleClickOutside, false);
            localWindow.removeEventListener('keydown', this.handlePressEscape, false);
        });
        // cleanup Floating UI
        this.floatingUICleanup();
    }
    /**
     * Render
     * @returns HTML Element
     */
    render() {
        return (h(Host, { key: '38823340f62287af2769d7dee3313dc83405fd87' }, h("slot", { key: '598ed57134a1163630f036328139572acb467f41' }), h("slot", { key: '8da7b05b4675b00a4b5e90a3e9b8c0532b1afac1', name: "content" })));
    }
    get element() { return getElement(this); }
    static get watchers() { return {
        "identifier": ["watchIdentifier"],
        "message": ["watchMessage"],
        "placement": ["watchPlacement"],
        "display": ["watchDisplay"],
        "disabled": ["watchDisabled"]
    }; }
};
MgTooltip.style = MgTooltipStyle0;

const mgTooltipContentCss = ":host{z-index:1000;display:none;max-width:var(--mg-b-size-floating-element-max-width);box-sizing:border-box;padding:var(--mg-b-size-4) var(--mg-b-size-8);border-radius:var(--mg-c-tooltip-border-radius);background-color:var(--mg-c-tooltip-color-background);color:var(--mg-c-tooltip-color-text);font-family:var(--mg-b-font-family);font-size:var(--mg-b-font-size);font-weight:400;text-align:start}:host([data-show]){display:block}::slotted([slot=arrow]){visibility:hidden}::slotted([slot=arrow])::before{content:\"\";transform:rotate(45deg);visibility:visible}::slotted([slot=arrow]),::slotted([slot=arrow])::before{position:absolute;z-index:9999;width:var(--mg-b-size-8);height:var(--mg-b-size-8);background-color:var(--mg-c-tooltip-color-background)}:host([data-placement^=top])>::slotted([slot=arrow]){bottom:calc(-1*var(--mg-b-size-4))}:host([data-placement^=bottom])>::slotted([slot=arrow]){top:calc(-1*var(--mg-b-size-4))}:host([data-placement^=left])>::slotted([slot=arrow]){right:calc(-1*var(--mg-b-size-4))}:host([data-placement^=right])>::slotted([slot=arrow]){left:calc(-1*var(--mg-b-size-4))}";
const MgTooltipContentStyle0 = mgTooltipContentCss;

const MgTooltipContent = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
    }
    /*************
     * Lifecycle *
     *************/
    /**
     * Render
     * @returns HTML Element
     */
    render() {
        return (h(Host, { key: '2221de3ca0ef7c9d6e46e24b19c69007fababf81', role: "tooltip" }, h("span", { key: '9e14f7f5b3f5e5060ed9f42e8d7259b17575168e', innerHTML: this.message, class: "mg-tooltip-content__message" }), h("slot", { key: 'bc083567d77e8f4ffccee98b96036ba8ac494fb6', name: "arrow" })));
    }
};
MgTooltipContent.style = MgTooltipContentStyle0;

export { MgActionMore as mg_action_more, MgBadge as mg_badge, MgButton as mg_button, MgCard as mg_card, MgCharacterLeft as mg_character_left, MgDetails as mg_details, MgDivider as mg_divider, MgForm as mg_form, MgIcon as mg_icon, MgIllustratedMessage as mg_illustrated_message, MgInput as mg_input, MgInputCheckbox as mg_input_checkbox, MgInputCheckboxPaginated as mg_input_checkbox_paginated, MgInputDate as mg_input_date, MgInputNumeric as mg_input_numeric, MgInputPassword as mg_input_password, MgInputRadio as mg_input_radio, MgInputSelect as mg_input_select, MgInputText as mg_input_text, MgInputTextarea as mg_input_textarea, MgInputTitle as mg_input_title, MgInputToggle as mg_input_toggle, MgItemMore as mg_item_more, MgMenu as mg_menu, MgMenuItem as mg_menu_item, MgMessage as mg_message, MgModal as mg_modal, MgPagination as mg_pagination, MgPanel as mg_panel, MgPopover as mg_popover, MgPopoverContent as mg_popover_content, MgSkipLinks as mg_skip_links, MgTabs as mg_tabs, MgTag as mg_tag, MgTooltip as mg_tooltip, MgTooltipContent as mg_tooltip_content };

//# sourceMappingURL=mg-action-more_36.entry.js.map